export type Language = 'tr' | 'en';

export const translations = {
  tr: {
    // Login Page
    'login.systemDescription': 'Kurumsal IT Yönetim Sistemi',
    'login.emailLabel': 'E-posta Adresi',
    'login.emailPlaceholder': 'ornek@company.com',
    'login.passwordLabel': 'Parola',
    'login.passwordPlaceholder': 'Parolanızı girin',
    'login.twoFactorLabel': '2FA Kodu',
    'login.twoFactorHint': "Google Authenticator'dan 6 haneli kodu girin",
    'login.loginButton': 'Giriş Yap',
    'login.loggingIn': 'Giriş yapılıyor...',
    'login.accountBlocked': 'Hesap Engellendi',
    'login.forgotPassword': 'Parolamı Unuttum',
    'login.copyright': '© 2021 IT Toolbox by Devkit. Tüm hakları saklıdır.',
    'login.failedAttempts': '{count}/5 başarısız deneme. {remaining} hakkınız kaldı.',
    'login.blockedMessage': 'Hesabınız engellendi. {time} sonra tekrar deneyin.',
    'login.tooManyAttempts': 'Çok fazla başarısız giriş denemesi. {time} sonra tekrar deneyin.',
    'login.emailRequired': 'E-posta ve parola gereklidir',
    'login.turnstileRequired': 'Lütfen güvenlik doğrulamasını tamamlayın',
    'login.loginFailed': 'Giriş başarısız',
    'login.loginError': 'Giriş Hatası',
    'login.ok': 'Tamam',
    'login.success': 'Başarılı',
    'login.loggedIn': 'Giriş yapıldı!',
    // Forgot Password
    'forgot.title': 'Parolamı Unuttum',
    'forgot.description': 'E-posta adresinizi girin, size parola sıfırlama bağlantısı gönderelim',
    'forgot.emailLabel': 'E-posta Adresi',
    'forgot.submitButton': 'Parola Sıfırlama Bağlantısı Gönder',
    'forgot.sending': 'Gönderiliyor...',
    'forgot.backToLogin': 'Giriş sayfasına dön',
    'forgot.error': 'Parola sıfırlama talebi işlenirken hata oluştu',
    'forgot.sendError': 'Parola sıfırlama talebi gönderilirken hata oluştu',
    // Version Update Modal
    'update.title': 'Yeni Güncelleme Mevcut!',
    'update.description': 'Uygulamanın yeni bir versiyonu yayınlandı. En iyi deneyim için güncelleyin.',
    'update.current': 'Mevcut:',
    'update.new': 'Yeni:',
    'update.later': 'Daha Sonra',
    'update.update': 'Güncelle',
    // Header
    'header.systemUpToDate': 'Sistem Güncel',
    'header.upToDate': 'Güncel',
    'header.updateAvailable': 'Güncelleme Mevcut',
    'header.update': 'Güncelleme',
    'header.announcements': 'Duyurular',
    'header.notifications': 'Bildirimler',
    'header.language': 'Dil',
    // Sidebar
    'sidebar.expand': 'Genişlet',
    'sidebar.collapse': 'Daralt',
    'sidebar.search': 'Arama yapın...',
    'sidebar.menuLoadError': 'Menüler yüklenirken hata oluştu',
    'sidebar.noMenuAccess': 'Erişim izniniz olan menü bulunmuyor',
    'sidebar.version': 'Versiyon:',
    // UserMenu
    'usermenu.logout_confirm': 'Çıkış yapmak istediğinizden emin misiniz?',
    'usermenu.online': 'Çevrimiçi',
    'usermenu.last_login': '· Son giriş:',
    'usermenu.profile': 'Profilim',
    'usermenu.notification_settings': 'Bildirim Ayarları',
    'usermenu.user_activities': 'Kullanıcı Aktiviteleri',
    'usermenu.logout': 'Çıkış Yap',
    'usermenu.role.teknisyen': 'Teknisyen',
    'usermenu.role.calisan': 'Çalışan',
    // NotificationCenter
    'notif.title': 'Bildirim Merkezi',
    'notif.unread': '{count} okunmamış bildirim',
    'notif.mark_all_read': 'Tümünü Okundu İşaretle',
    'notif.clear_all': 'Tümünü Temizle',
    'notif.confirm_clear': 'Tüm bildirimleri temizlemek istediğinizden emin misiniz?',
    'notif.search': 'Bildirim ara...',
    'notif.filter.all_types': 'Tüm Tipler',
    'notif.filter.info': 'Bilgi',
    'notif.filter.success': 'Başarılı',
    'notif.filter.warning': 'Uyarı',
    'notif.filter.error': 'Hata',
    'notif.filter.system': 'Sistem',
    'notif.category.all': 'Tüm Kategoriler',
    'notif.category.order': 'Siparişler',
    'notif.category.service': 'Teknik Servis',
    'notif.category.system': 'Sistem',
    'notif.category.backup': 'Yedekleme',
    'notif.category.security': 'Güvenlik',
    'notif.category.user': 'Kullanıcı',
    'notif.unread_only': 'Sadece okunmamış',
    'notif.loading': 'Bildirimler yükleniyor...',
    'notif.not_found': 'Bildirim Bulunamadı',
    'notif.no_match': 'Seçilen kriterlere uygun bildirim bulunmuyor.',
    'notif.showing': '{count} bildirim gösteriliyor',
    'notif.settings': 'Bildirim Ayarları',
    'notif.priority.urgent': 'Acil',
    'notif.priority.high': 'Yüksek',
    'notif.priority.normal': 'Normal',
    'notif.priority.low': 'Düşük',
    'notif.dismiss': 'Bildirimi Kapat',
    // AnnouncementPopup
    'announcement.title': 'Okunmamış Duyurular',
    'announcement.count': '{count} yeni duyuru',
    'announcement.empty': 'Okunmamış duyuru bulunmuyor',
    'announcement.high_priority': 'Yüksek Öncelik',
    'announcement.view': 'Görüntüle',
    'announcement.close': 'Kapat',
    'announcement.dismiss': 'Duyuruyu Kapat',
    // GlobalSearch
    'search.searching': 'Aranıyor...',
    'search.no_results': 'Sonuç bulunamadı',
    'search.no_match': '"{query}" için eşleşen kayıt yok',
    'search.results_found': '{count} sonuç bulundu',
    'search.records': '{count} kayıt',
    'search.navigate_hint': '↑↓ Gezin · Enter Seç · Esc Kapat',
    'search.tips_title': 'Hızlı İpuçları',
    'search.tip.gsm': 'GSM numarası ara',
    'search.tip.imei': 'IMEI numarası ara',
    'search.tip.serial': 'Seri no veya envanter numarası ara',
    'search.tip.user': 'Kullanıcı adı veya e-posta ara',
    'search.min_chars': 'En az 2 karakter girin',
    'search.placeholder': 'Arama yapın... (Ctrl+K)',
    'search.mobile_placeholder': 'Ne aramak istiyorsunuz?',
    'search.cancel': 'İptal',
    'search.categories_title': 'Ne arayabilirsiniz?',
    'search.cat.gsm': 'GSM Hatları',
    'search.cat.gsm_sub': 'Telefon numarasıyla',
    'search.cat.mobile': 'Cep Telefonları',
    'search.cat.mobile_sub': 'IMEI, numara',
    'search.cat.computers': 'Bilgisayarlar',
    'search.cat.computers_sub': 'Envanter, seri no',
    'search.cat.users': 'Kullanıcılar',
    'search.cat.users_sub': 'Ad, e-posta',
    'search.cat.companies': 'Firmalar',
    'search.cat.companies_sub': 'Ad, vergi no',
    'search.cat.orders': 'Siparişler',
    'search.cat.orders_sub': 'Sipariş numarası',
    // Search result module labels
    'search.module.gsm-lines': 'GSM Hatları',
    'search.module.mobile-phones': 'Cep Telefonları',
    'search.module.computers': 'Bilgisayarlar',
    'search.module.monitors': 'Monitörler',
    'search.module.printers': 'Yazıcılar',
    'search.module.users': 'Kullanıcılar',
    'search.module.companies': 'Firmalar',
    'search.module.orders': 'Siparişler',
    'search.module.locations': 'Lokasyonlar',
    'search.module.suppliers': 'Tedarikçiler',
    'search.module.equipment': 'Ekipman',
    'search.module.notepad': 'Not Defteri',
    'search.module.cameras': 'Kameralar',
    'search.module.nvrs': 'NVR\'lar',
    'search.module.storage-units': 'Depolama Üniteleri',
    'search.module.physical-servers': 'Fiziksel Sunucular',
    'search.module.virtual-servers': 'Sanal Sunucular',
    'search.module.network-switches': 'Network Switch',
    'search.module.capex': 'CAPEX',
    // Badge statuses
    'badge.active': 'Aktif',
    'badge.inactive': 'Pasif',
    'badge.damaged': 'Hasarlı',
    'badge.lost': 'Kayıp',
    'badge.suspended': 'Askıda',
    'badge.available': 'Boşta',
    'badge.beklemede': 'Bekliyor',
    'badge.onaylandi': 'Onaylandı',
    'badge.teslim-edildi': 'Teslim',
    'badge.siparis-verildi': 'Sipariş Verildi',
    'badge.maintenance': 'Bakımda',
    'badge.offline': 'Çevrimdışı',
    'badge.decommissioned': 'Hizmet Dışı',
    'badge.running': 'Çalışıyor',
    'badge.stopped': 'Durdu',
    'badge.approved': 'Onaylandı',
    'badge.rejected': 'Reddedildi',
    'badge.pending': 'Bekliyor',
    'badge.completed': 'Tamamlandı',
    // MobileNavigation
    'mobile.dashboard': 'Ana Sayfa',
    'mobile.orders': 'Siparişler',
    'mobile.service': 'Servis',
    'mobile.notifications': 'Bildirimler',
    'mobile.activities': 'Aktiviteler',
    'mobile.menu': 'Menü',
    'mobile.no_menu': 'Menü öğesi bulunamadı',
    'mobile.profile_settings': 'Profil Ayarları',
    'mobile.logout': 'Çıkış Yap',
    'mobile.user': 'Kullanıcı',
    // Sidebar Menu Items
    'menu.dashboard': 'Dashboard',
    'menu.arac_gerec': 'Araç Gereç',
    'menu.companies': 'Şirketler',
    'menu.locations': 'Lokasyonlar',
    'menu.suppliers': 'Tedarikçiler',
    'menu.equipment': 'Ekipmanlar',
    'menu.consumables': 'Sarf Malzemeler',
    'menu.documents': 'Evraklar',
    'menu.maintenance_contracts': 'Bakım Anlaşmaları',
    'menu.damage_theft': 'Hasar & Çalınma',
    'menu.orders': 'Siparişler',
    'menu.capex': 'CAPEX',
    'menu.printers': 'Yazıcılar',
    'menu.technical_service': 'Teknik Servis',
    'menu.it_equipment': 'IT Ekipmanları',
    'menu.computers': 'Bilgisayarlar',
    'menu.computer-brands': 'Markalar',
    'menu.computer-models': 'Modeller',
    'menu.mobile_phones': 'Cep Telefonları',
    'menu.servers': 'Sunucular',
    'menu.physical_servers': 'Fiziksel Sunucular',
    'menu.virtual_servers': 'Sanal Sunucular',
    'menu.industrial': 'Endüstriyel',
    'menu.iot': 'IoT Cihazları',
    'menu.scales': 'Akıllı Teraziler',
    'menu.radios': 'Telsizler',
    'menu.handheld_terminals': 'El Terminalleri',
    'menu.network': 'Ağ',
    'menu.network_switches': 'Network Switch',
    'menu.cabinets': 'IT Kabinetleri',
    'menu.circuits': 'Devreler',
    'menu.storage': 'Depolama Birimleri',
    'menu.meetings': 'Toplantılar',
    'menu.assignment_forms': 'Zimmet İşlemleri',
    'menu.assignment_forms_main': 'Zimmet Formları',
    'menu.assignment_logs': 'Zimmetleme İşlem Logları',
    'menu.settings': 'Ayarlar',
    'menu.assignment_definitions': 'Zimmet Tanımları',
    'menu.system_settings': 'Sistem Ayarları',
    'menu.users': 'Kullanıcılar',
    'menu.activities': 'Kullanıcı Aktiviteleri',
    'menu.announcements': 'Duyurular',
    'menu.menu-management': 'Menü Yönetimi',
    'menu.security_cameras': 'NVR & Kamera',
    'menu.cameras': 'Kamera',
    'menu.camera-faults': 'Kamera Arızaları',
    'menu.nvrs': 'NVR',
    'menu.profile': 'Profil',
    'menu.gsm_lines': 'GSM Hatları',
    'menu.tariffs': 'Tarifeler',
    'menu.monitors': 'Monitörler',
    'menu.notepad': 'Not Defteri',
    'menu.procedures': 'Prosedürler',
    'menu.security_vulnerabilities': 'Güvenlik Açıkları',
    'menu.checklists': 'Kontrol Listeleri',
    'menu.phone_replacement': 'Telefon Değişimi',
    'menu.scrap_computers': 'Hurda Bilgisayarlar',
    'menu.rbac': 'Yetki Yönetimi',
    'menu.cargo_labels': 'Kargo Etiketleri',
    // Dashboard
    'dashboard.subtitle': 'Sistem durumu ve performans metrikleri',
    'dashboard.refresh': 'Yenile',
    'dashboard.period.24h': '24 Saat',
    'dashboard.period.7d': '7 Gün',
    'dashboard.period.30d': '30 Gün',
    'dashboard.period.90d': '90 Gün',
    'dashboard.totalUsers': 'Toplam Kullanıcı',
    'dashboard.active': 'Aktif',
    'dashboard.online': 'Çevrimiçi',
    'dashboard.infrastructure': 'Altyapı',
    'dashboard.servers': 'Sunucular',
    'dashboard.physical': 'Fiziksel',
    'dashboard.virtual': 'Sanal',
    'dashboard.network': 'Ağ',
    'dashboard.storageLabel': 'Depolama',
    'dashboard.activeServices': 'Aktif Servisler',
    'dashboard.pending': 'Bekleyen',
    'dashboard.today': 'Bugün',
    'dashboard.completed': 'Tamamlandı',
    'dashboard.quickStats': 'Hızlı İstatistikler',
    'dashboard.operational': 'Operasyonel',
    'dashboard.activeOrders': 'Aktif Siparişler',
    'dashboard.pendingService': 'Bekleyen Servis',
    'dashboard.organization': 'Organizasyon',
    'dashboard.recentActivities': 'Son Aktiviteler',
    'dashboard.viewAll': 'Tümünü Gör',
    'dashboard.noActivities': 'Henüz aktivite bulunmuyor',
    'dashboard.liveFeed': 'Canlı Akış',
    'dashboard.system': 'Sistem',
    'dashboard.loginStats': 'Giriş İstatistikleriniz',
    'dashboard.lastLogin': 'Son Giriş',
    'dashboard.unknown': 'Bilinmiyor',
    'dashboard.activeStatus': 'Aktif Durum',
    'dashboard.roleLabel': 'Rol',
    'dashboard.technician': 'Teknisyen',
    'dashboard.employee': 'Çalışan',
    'dashboard.activitySummary': 'Aktivite Özetiniz',
    'dashboard.technicalService': 'Teknik Servis',
    'dashboard.hasAccess': 'Erişim var',
    'dashboard.limitedAccess': 'Sınırlı erişim',
    'dashboard.statusLabel': 'Durum',
    'dashboard.activeLabel': 'Aktif',
    'dashboard.refreshing': 'Yenileniyor',
    'dashboard.refreshingData': 'Dashboard verileri güncelleniyor...',
    'dashboard.refreshComplete': 'Tamamlandı',
    'dashboard.refreshSuccess': 'Dashboard başarıyla güncellendi!',
    'dashboard.loadError': 'Dashboard verileri yüklenirken hata oluştu',
    'dashboard.perfUpdated': 'Güncellendi',
    'dashboard.perfUpdateSuccess': 'Sistem performansı verileri yenilendi!',
    'dashboard.perfLoadError': 'Sistem performansı yüklenirken hata oluştu',
    // Tariffs Page
    'tariffs.title': 'Tarife Listesi',
    'tariffs.subtitle': 'Vodafone GSM tarife planlarını yönetin',
    'tariffs.newTariff': 'Yeni Tarife',
    'tariffs.searchPlaceholder': 'Tarife ara...',
    'tariffs.colName': 'Tarife Adı',
    'tariffs.colDescription': 'Açıklama',
    'tariffs.colPrice': 'Fiyat (₺/ay)',
    'tariffs.colLines': 'Kullanan Hat',
    'tariffs.colCreated': 'Oluşturulma',
    'tariffs.linesCount': '{count} hat',
    'tariffs.linesTitle': 'Bu tarifeyi kullanan hatları görüntüle',
    'tariffs.editTitle': 'Düzenle',
    'tariffs.deleteTitle': 'Tarifeyi sil',
    'tariffs.deleteDisabledTitle': 'Bu tarife kullanımda olduğu için silinemez',
    'tariffs.notFound': 'Tarife bulunamadı',
    'tariffs.modalEditTitle': 'Tarife Düzenle',
    'tariffs.modalNewTitle': 'Yeni Tarife',
    'tariffs.labelName': 'Tarife Adı *',
    'tariffs.labelPrice': 'Aylık Fiyat (₺) *',
    'tariffs.labelDescription': 'Açıklama',
    'tariffs.placeholderName': 'Örn: Kurumsal 20GB',
    'tariffs.placeholderPrice': '89.90',
    'tariffs.placeholderDescription': 'Tarife detayları (GB, dakika, SMS limitleri)',
    'tariffs.cancel': 'İptal',
    'tariffs.save': 'Kaydet',
    'tariffs.update': 'Güncelle',
    'tariffs.errorLoadData': 'Veriler yüklenirken hata oluştu',
    'tariffs.errorRequired': 'Tarife adı ve fiyat gereklidir',
    'tariffs.successUpdated': 'Tarife güncellendi',
    'tariffs.successCreated': 'Tarife oluşturuldu',
    'tariffs.errorSave': 'Tarife kaydedilirken hata oluştu',
    'tariffs.successDeleted': 'Tarife silindi',
    'tariffs.errorDelete': 'Tarife silinirken hata oluştu',
    'tariffs.deleteBlocked': 'Silme İşlemi Engellendi',
    'tariffs.deleteBlockedMsg': 'Bu tarife {count} GSM hattında aktif olarak kullanılıyor. Önce bu hatların tarifelerini değiştirin.',
    'tariffs.deleteConfirm': 'Bu tarife planını silmek istediğinizden emin misiniz?',
    // Security Vulnerabilities Page
    'secvuln.title': 'Güvenlik Açıkları',
    'secvuln.lastUpdated': 'Son güncelleme: {time}',
    'secvuln.updating': 'Güncelleniyor...',
    'secvuln.update': 'Güncelle',
    'secvuln.statTotal': 'Toplam',
    'secvuln.statCritical': 'Kritik',
    'secvuln.statHigh': 'Yüksek',
    'secvuln.statActiveExploit': 'Aktif İstismar',
    'secvuln.statNewToday': 'Bugün Eklenen',
    'secvuln.statCisaKev': 'CISA KEV',
    'secvuln.infoBand': '<strong>CISA KEV</strong> — sahada aktif istismar edilen açıklar · <strong>NIST NVD</strong> — tüm CVE kayıtları ve CVSS puanları. İçerik her gün saat 06:00\'da (TSİ) otomatik güncellenir.',
    'secvuln.infoBandAdmin': ' · <strong>Admin ve Superadmin</strong> rolleri güvenlik açıklarına çözüm ve kaynak bağlantısı ekleyebilir.',
    'secvuln.periodLabel': 'Dönem:',
    'secvuln.period1w': 'Son 1 Hafta',
    'secvuln.period2w': 'Son 2 Hafta',
    'secvuln.period1m': 'Son 1 Ay',
    'secvuln.periodAll': 'Tümü',
    'secvuln.searchPlaceholder': 'CVE ID veya açıklama ara...',
    'secvuln.filterBtn': 'Filtrele',
    'secvuln.clearFilters': 'Temizle',
    'secvuln.filterSource': 'Kaynak',
    'secvuln.filterSourceAll': 'Tümü',
    'secvuln.filterSeverity': 'Önem Derecesi',
    'secvuln.filterSeverityAll': 'Tümü',
    'secvuln.filterSeverityCritical': 'Kritik',
    'secvuln.filterSeverityHigh': 'Yüksek',
    'secvuln.filterSeverityMedium': 'Orta',
    'secvuln.filterSeverityLow': 'Düşük',
    'secvuln.filterActiveOnly': 'Yalnızca Aktif İstismar Edilenler (CISA KEV)',
    'secvuln.resultCount': '{count} güvenlik açığı',
    'secvuln.pageOf': 'Sayfa {page} / {pages}',
    'secvuln.activeExploitBadge': 'Aktif İstismar',
    'secvuln.noTranslation': '(Çeviri mevcut değil)',
    'secvuln.descriptionTr': 'Açıklama (Türkçe)',
    'secvuln.descriptionEn': 'Açıklama (İngilizce)',
    'secvuln.translating': 'Çevriliyor...',
    'secvuln.translate': 'Çevir',
    'secvuln.requiredAction': 'Gerekli Eylem (CISA)',
    'secvuln.cisaKevCatalog': 'CISA KEV Kataloğu',
    'secvuln.prevPage': 'Önceki',
    'secvuln.nextPage': 'Sonraki',
    'secvuln.updateHistory': 'Güncelleme Geçmişi',
    'secvuln.newOf': '{new} yeni / {fetched} kontrol',
    'secvuln.emptyTitle': 'Güvenlik açığı bulunamadı',
    'secvuln.emptyHintFiltered': 'Filtreleri temizleyerek veya farklı bir dönem seçerek tekrar deneyin',
    'secvuln.emptyHintNoData': '"Güncelle" butonu ile veri çekmeyi başlatın',
    'secvuln.errorLoad': 'Veriler yüklenirken hata oluştu',
    'secvuln.fetchStarted': 'Veri çekme işlemi başlatıldı. Birkaç dakika içinde tamamlanacak.',
    'secvuln.fetchError': 'Veri çekme başlatılamadı',
    'secvuln.translateError': 'Çeviri yapılamadı',
    'secvuln.solutionsTitle': 'Çözümler ve Kaynaklar',
    'secvuln.addSolution': 'Çözüm Ekle',
    'secvuln.solutionsLoading': 'Yükleniyor...',
    'secvuln.noSolutions': 'Henüz çözüm eklenmemiş.',
    'secvuln.noSolutionsHint': ' Yukarıdaki "Çözüm Ekle" butonunu kullanabilirsiniz.',
    'secvuln.solutionFormEditTitle': 'Çözümü Düzenle',
    'secvuln.solutionFormNewTitle': 'Yeni Çözüm Ekle',
    'secvuln.solutionPlaceholder': 'Çözüm açıklaması, uygulanan yamayı veya geçici önlemi yazın...',
    'secvuln.linkUrlPlaceholder': 'Bağlantı URL (isteğe bağlı)',
    'secvuln.linkLabelPlaceholder': 'Bağlantı etiketi (isteğe bağlı, boş bırakılırsa URL gösterilir)',
    'secvuln.saving': 'Kaydediliyor...',
    'secvuln.save': 'Kaydet',
    'secvuln.cancel': 'İptal',
    'secvuln.solutionRequired': 'Çözüm açıklaması zorunludur',
    'secvuln.solutionUpdated': 'Çözüm güncellendi',
    'secvuln.solutionAdded': 'Çözüm eklendi',
    'secvuln.solutionSaveError': 'Kaydedilemedi',
    'secvuln.solutionDeleteConfirm': '"{preview}..." çözümünü silmek istediğinize emin misiniz?',
    'secvuln.solutionDeleted': 'Çözüm silindi',
    'secvuln.solutionDeleteError': 'Silinemedi',
    'secvuln.linkTypeFix': 'Düzeltme',
    'secvuln.linkTypePatch': 'Yama',
    'secvuln.linkTypeWorkaround': 'Geçici Çözüm',
    'secvuln.linkTypeReference': 'Referans',
    'secvuln.linkTypeOther': 'Diğer',
    'secvuln.severityCritical': 'Kritik',
    'secvuln.severityHigh': 'Yüksek',
    'secvuln.severityMedium': 'Orta',
    'secvuln.severityLow': 'Düşük',
    'secvuln.severityNone': 'Yok',
    'secvuln.severityUnknown': 'Bilinmiyor',
    'secvuln.solutionCount': '{count} Çözüm',
    'secvuln.timeToday': 'Bugün',
    'secvuln.timeYesterday': 'Dün',
    'secvuln.timeDaysAgo': '{days} gün önce',
    'secvuln.timeWeeksAgo': '{weeks} hafta önce',
    'secvuln.timeMonthsAgo': '{months} ay önce',
    'secvuln.timeYearsAgo': '{years} yıl önce',
    // VirtualServersPage
    'virtserver.title': 'Sanal Sunucular',
    'virtserver.subtitle': 'Sanal makine envanteri ve performans takibi',
    'virtserver.addNew': 'Yeni Sanal Sunucu',
    'virtserver.loading': 'Sanal sunucular yükleniyor...',
    'virtserver.loadError': 'Veriler yüklenirken hata oluştu',
    'virtserver.totalVM': 'Toplam VM',
    'virtserver.running': 'Çalışıyor',
    'virtserver.stoppedStat': 'Durdurulmuş',
    'virtserver.totalVcpu': 'Toplam vCPU',
    'virtserver.searchPlaceholder': 'Sanal sunucu ara...',
    'virtserver.allPhysicalServers': 'Tüm Fiziksel Sunucular',
    'virtserver.allStatuses': 'Tüm Durumlar',
    'virtserver.allCompanies': 'Tüm Şirketler',
    'virtserver.allLocations': 'Tüm Konumlar',
    'virtserver.allStorageUnits': 'Tüm Storage Üniteleri',
    'virtserver.allStoragePools': 'Tüm Storage Pool\'lar',
    'virtserver.allHypervisors': 'Tüm Hypervisor\'lar',
    'virtserver.excelSheet': 'Sanal Sunucular',
    'virtserver.excelFilename': 'sanal-sunucular',
    'virtserver.pdfTitle': 'Sanal Sunucular Raporu',
    'virtserver.pdfReportDate': 'Rapor Tarihi:',
    'virtserver.pdfTotal': 'Toplam VM:',
    'virtserver.exportExcelSuccess': 'kayıt Excel\'e aktarıldı',
    'virtserver.exportExcelError': 'Excel aktarımı sırasında hata oluştu',
    'virtserver.exportPdfSuccess': 'kayıt PDF\'e aktarıldı',
    'virtserver.exportPdfError': 'PDF aktarımı sırasında hata oluştu',
    'virtserver.colVmName': 'VM Adı',
    'virtserver.colHostname': 'Hostname',
    'virtserver.colIpAddress': 'IP Adresi',
    'virtserver.colPhysicalServer': 'Fiziksel Sunucu',
    'virtserver.colCompany': 'Şirket',
    'virtserver.colResources': 'Kaynaklar',
    'virtserver.colStorage': 'Depolama',
    'virtserver.colStatus': 'Durum',
    'virtserver.colActions': 'İşlemler',
    'virtserver.notAssigned': 'Atanmamış',
    'virtserver.noResults': 'Sanal sunucu bulunamadı',
    'virtserver.noResultsDesc': 'Arama kriterlerinize uygun sanal sunucu bulunamadı.',
    'virtserver.titleHistory': 'Geçmiş',
    'virtserver.titleViewDetail': 'Detayları Görüntüle',
    'virtserver.titleCopy': 'Kopyala',
    'virtserver.titleEdit': 'Düzenle',
    'virtserver.titleDelete': 'Sil',
    'virtserver.modalEditTitle': 'Sanal Sunucu Düzenle',
    'virtserver.modalAddTitle': 'Yeni Sanal Sunucu',
    'virtserver.sectionBasicInfo': 'Temel Bilgiler',
    'virtserver.labelVmName': 'VM Adı *',
    'virtserver.labelHostname': 'Hostname *',
    'virtserver.labelIpAddress': 'IP Adresi *',
    'virtserver.labelPhysicalServer': 'Fiziksel Sunucu *',
    'virtserver.selectPhysicalServer': 'Fiziksel sunucu seçin',
    'virtserver.labelOs': 'İşletim Sistemi *',
    'virtserver.labelHypervisor': 'Hypervisor *',
    'virtserver.labelPurpose': 'Amaç *',
    'virtserver.labelStatus': 'Durum *',
    'virtserver.sectionResources': 'Kaynak Tahsisi',
    'virtserver.labelVcpu': 'vCPU Sayısı *',
    'virtserver.labelRam': 'RAM (GB) *',
    'virtserver.labelStorage': 'Depolama (GB) *',
    'virtserver.sectionLocation': 'Lokasyon ve Atama',
    'virtserver.labelCompany': 'Şirket *',
    'virtserver.selectCompany': 'Şirket seçin',
    'virtserver.labelLocation': 'Lokasyon *',
    'virtserver.selectLocation': 'Lokasyon seçin',
    'virtserver.labelAdmin': 'Sorumlu Admin',
    'virtserver.selectAdmin': 'Admin seçin',
    'virtserver.labelNotes': 'Notlar',
    'virtserver.notesPlaceholder': 'Sanal sunucu hakkında notlar...',
    'virtserver.btnCancel': 'İptal',
    'virtserver.btnUpdate': 'Güncelle',
    'virtserver.btnSave': 'Kaydet',
    'virtserver.errorRequired': 'Zorunlu alanları doldurunuz',
    'virtserver.errorInvalidIp': 'Geçersiz IP adresi formatı. Örnek: 192.168.1.100',
    'virtserver.errorDuplicateHostname': 'Bu hostname zaten kullanılıyor: {name}',
    'virtserver.errorDuplicateIp': 'Bu IP adresi zaten kullanılıyor: {name} ({ip})',
    'virtserver.successUpdated': 'Sanal sunucu güncellendi',
    'virtserver.successCreated': 'Sanal sunucu oluşturuldu',
    'virtserver.errorSave': 'Sanal sunucu kaydedilirken hata oluştu',
    'virtserver.confirmDelete': 'Bu sanal sunucuyu silmek istediğinizden emin misiniz?',
    'virtserver.successDeleted': 'Sanal sunucu silindi',
    'virtserver.errorDelete': 'Sanal sunucu silinirken hata oluştu',
    'virtserver.errorLoadActivities': 'Aktivite geçmişi yüklenirken hata oluştu',
    'virtserver.detailTitle': 'Sanal Sunucu Detayları',
    'virtserver.detailVmInfo': 'VM Bilgileri',
    'virtserver.detailVmName': 'VM Adı:',
    'virtserver.detailHostname': 'Hostname:',
    'virtserver.detailIpAddress': 'IP Adresi:',
    'virtserver.detailPhysicalServer': 'Fiziksel Sunucu:',
    'virtserver.detailHypervisor': 'Hypervisor:',
    'virtserver.detailOs': 'İşletim Sistemi:',
    'virtserver.detailPurpose': 'Amaç:',
    'virtserver.detailResources': 'Kaynak Tahsisi',
    'virtserver.detailVcpu': 'vCPU:',
    'virtserver.detailRam': 'RAM:',
    'virtserver.detailStorage': 'Depolama:',
    'virtserver.detailUptime': 'Uptime:',
    'virtserver.detailUptimeDays': '{days} gün',
    'virtserver.detailBackup': 'Yedekleme Bilgileri',
    'virtserver.detailBackupSchedule': 'Yedekleme Programı:',
    'virtserver.detailLastBackup': 'Son Yedekleme:',
    'virtserver.detailLastSnapshot': 'Son Snapshot:',
    'virtserver.detailSystemInfo': 'Sistem Bilgileri',
    'virtserver.detailCreatedAt': 'Oluşturulma:',
    'virtserver.detailUpdatedAt': 'Son Güncelleme:',
    'virtserver.detailAdmin': 'Sorumlu Admin:',
    'virtserver.detailNotes': 'Notlar',
    'virtserver.historyTitle': 'İşlem Geçmişi',
    'virtserver.historyLoading': 'Geçmiş yükleniyor...',
    'virtserver.historyEmpty': 'İşlem geçmişi bulunamadı',
    'virtserver.historyEmptyDesc': 'Bu sanal sunucu için henüz bir işlem kaydı bulunmuyor.',
    'virtserver.historyActionCreated': 'Oluşturuldu',
    'virtserver.historyActionUpdated': 'Güncellendi',
    'virtserver.historyActionDeleted': 'Silindi',
    'virtserver.historyActionStarted': 'Başlatıldı',
    'virtserver.historyActionStopped': 'Durduruldu',
    'virtserver.historyActionSuspended': 'Askıya Alındı',
    'virtserver.historyPerformedBy': 'İşlemi Yapan:',
    'virtserver.historyPhysicalServer': 'Fiziksel Sunucu:',
    'virtserver.historyChangedFields': 'Değişen Alanlar:',
    'virtserver.statusRunning': 'Çalışıyor',
    'virtserver.statusStopped': 'Durduruldu',
    'virtserver.statusSuspended': 'Askıya Alındı',
    'virtserver.statusMaintenance': 'Bakımda',
    'virtserver.copyNameSuffix': '(Kopya)',
    'virtserver.sectionStorage': 'Depolama',
    'virtserver.labelStorageUnit': 'Storage Ünitesi',
    'virtserver.selectStorageUnit': 'Storage ünitesi seçin (opsiyonel)',
    'virtserver.labelStoragePool': 'Storage Pool',
    'virtserver.selectStoragePool': 'Pool seçin (opsiyonel)',
    'virtserver.detailStorageUnit': 'Storage Ünitesi:',
    'virtserver.detailStoragePool': 'Storage Pool:',
    // RadiosPage
    'radios.title': 'Telsiz Yönetimi',
    'radios.subtitle': 'El ve sabit haberleşme ekipmanı envanteri',
    'radios.addNew': 'Yeni Telsiz',
    'radios.loadError': 'Veriler yüklenirken hata oluştu',
    'radios.totalRadios': 'Toplam Telsiz',
    'radios.active': 'Aktif',
    'radios.maintenanceFaulty': 'Bakım / Arızalı',
    'radios.assigned': 'Atanan',
    'radios.searchPlaceholder': 'Telsiz ara...',
    'radios.allStatuses': 'Tüm Durumlar',
    'radios.colRadio': 'Telsiz',
    'radios.colLocation': 'Lokasyon',
    'radios.colUser': 'Kullanıcı',
    'radios.colStatus': 'Durum',
    'radios.colSerialNo': 'Seri No',
    'radios.colActions': 'İşlemler',
    'radios.notAssigned': 'Atanmamış',
    'radios.noResults': 'Telsiz bulunamadı',
    'radios.noResultsDesc': 'Arama kriterlerinize uygun telsiz bulunmuyor.',
    'radios.titleViewDetail': 'Detayları Görüntüle',
    'radios.titleEdit': 'Düzenle',
    'radios.titleCopy': 'Kopyala',
    'radios.titlePrint': 'Etiket Yazdır',
    'radios.titleDelete': 'Sil',
    'radios.modalEditTitle': 'Telsiz Düzenle',
    'radios.modalAddTitle': 'Yeni Telsiz',
    'radios.sectionBasicInfo': 'Temel Bilgiler',
    'radios.labelName': 'Telsiz Adı *',
    'radios.labelBrand': 'Marka *',
    'radios.labelModel': 'Model *',
    'radios.labelSerialNo': 'Seri Numarası *',
    'radios.serialDuplicate': 'Zaten kullanılıyor',
    'radios.labelInventoryNo': 'Envanter No',
    'radios.labelStatus': 'Durum *',
    'radios.sectionTechnical': 'Teknik Özellikler',
    'radios.labelFrequency': 'Frekans',
    'radios.labelFrequencyRange': 'Frekans Aralığı',
    'radios.labelPowerOutput': 'Güç Çıkışı',
    'radios.labelBatteryType': 'Batarya Tipi',
    'radios.sectionLocation': 'Lokasyon ve Atama',
    'radios.labelCompany': 'Şirket *',
    'radios.selectCompany': 'Şirket seçin',
    'radios.labelLocation': 'Lokasyon *',
    'radios.selectLocation': 'Lokasyon seçin',
    'radios.labelAssignedUser': 'Atanan Kullanıcı',
    'radios.selectUser': 'Kullanıcı seçin',
    'radios.sectionPurchase': 'Satın Alma Bilgileri',
    'radios.labelPurchaseDate': 'Satın Alma Tarihi',
    'radios.labelWarrantyEnd': 'Garanti Bitiş Tarihi',
    'radios.labelPurchasePrice': 'Satın Alma Fiyatı',
    'radios.labelImage': 'Telsiz Görseli',
    'radios.imageKeepNote': 'Mevcut görsel korunacak. Değiştirmek için yeni dosya seçin.',
    'radios.labelNotes': 'Notlar',
    'radios.notesPlaceholder': 'Telsiz hakkında notlar...',
    'radios.btnCancel': 'İptal',
    'radios.btnUpdate': 'Güncelle',
    'radios.btnSave': 'Kaydet',
    'radios.errorRequired': 'Zorunlu alanları doldurunuz (Telsiz Adı, Marka, Model, Seri No)',
    'radios.errorLocationCompany': 'Lokasyon ve Şirket seçimi zorunludur',
    'radios.errorDuplicateSerial': 'Bu seri numarası zaten kullanılıyor',
    'radios.successUpdated': 'Telsiz güncellendi',
    'radios.successCreated': 'Telsiz oluşturuldu',
    'radios.errorSave': 'Telsiz kaydedilirken hata oluştu',
    'radios.confirmDelete': 'Bu telsizi silmek istediğinizden emin misiniz?',
    'radios.successDeleted': 'Telsiz silindi',
    'radios.errorDelete': 'Telsiz silinirken hata oluştu',
    'radios.errorPrint': 'Etiket oluşturulurken hata oluştu',
    'radios.detailTitle': 'Telsiz Detayları',
    'radios.detailRadioInfo': 'Telsiz Bilgileri',
    'radios.detailName': 'Telsiz Adı:',
    'radios.detailBrandModel': 'Marka / Model:',
    'radios.detailSerialNo': 'Seri No:',
    'radios.detailInventoryNo': 'Envanter No:',
    'radios.detailStatus': 'Durum:',
    'radios.detailAssignedUser': 'Atanan Kullanıcı:',
    'radios.detailLocationTechnical': 'Konum ve Teknik',
    'radios.detailCompany': 'Şirket:',
    'radios.detailLocation': 'Lokasyon:',
    'radios.detailFrequency': 'Frekans:',
    'radios.detailFrequencyRange': 'Frekans Aralığı:',
    'radios.detailPowerOutput': 'Güç Çıkışı:',
    'radios.detailBattery': 'Batarya:',
    'radios.detailPurchaseInfo': 'Satın Alma Bilgileri',
    'radios.detailPurchaseDate': 'Satın Alma Tarihi:',
    'radios.detailWarrantyEnd': 'Garanti Bitiş:',
    'radios.detailPrice': 'Fiyat:',
    'radios.detailNotes': 'Notlar',
    'radios.detailImage': 'Telsiz Görseli',
    'radios.btnEdit': 'Düzenle',
    'radios.btnPrint': 'Etiket Yazdır',
    'radios.statusActive': 'Aktif',
    'radios.statusInactive': 'Pasif',
    'radios.statusMaintenance': 'Bakımda',
    'radios.statusFaulty': 'Arızalı',
    'radios.copyNameSuffix': '- Kopya',
    // Common
    'common.error': 'Hata',
    'common.success': 'Başarılı',
    'common.loading': 'Yükleniyor...',
    'common.save': 'Kaydet',
    'common.cancel': 'İptal',
    'common.close': 'Kapat',
    'common.delete': 'Sil',
    'common.edit': 'Düzenle',
    'common.add': 'Ekle',
    'common.search': 'Ara',
    'common.operationFailed': 'İşlem başarısız',
    'common.filter': 'Filtrele',
    'common.filters': 'Filtreler',
    'common.clearFilters': 'Temizle',
    'common.export': 'Dışa Aktar',
    'common.import': 'İçe Aktar',
    'common.yes': 'Evet',
    'common.no': 'Hayır',
    'common.ok': 'Tamam',
    'common.back': 'Geri',
    'common.next': 'İleri',
    'common.previous': 'Önceki',
    'common.refresh': 'Yenile',
    'common.confirm': 'Onayla',
    'common.warning': 'Uyarı',
    'common.info': 'Bilgi',
    'common.actions': 'İşlemler',
    'common.status': 'Durum',
    'common.date': 'Tarih',
    'common.name': 'Ad',
    'common.description': 'Açıklama',
    'common.type': 'Tür',
    'common.total': 'Toplam',
    'common.noData': 'Veri bulunamadı',
    'common.pageOf': '{current} / {total} sayfa',
    'common.itemsPerPage': 'Sayfa başına öğe',
    'common.allRights': 'Tüm hakları saklıdır.',
    // Storage Units Page
    'storage.title': 'Depolama Üniteleri',
    'storage.subtitle': 'Depolama altyapısı yönetimi ve izleme',
    'storage.addNew': 'Yeni Depolama Birimi',
    'storage.totalUnits': 'Toplam Birim',
    'storage.totalCapacity': 'Toplam Kapasite',
    'storage.usedCapacity': 'Kullanılan',
    'storage.availableCapacity': 'Kullanılabilir',
    'storage.searchPlaceholder': 'Depolama birimi ara...',
    'storage.allTypes': 'Tüm Tipler',
    'storage.allStatuses': 'Tüm Durumlar',
    'storage.statusActive': 'Aktif',
    'storage.statusMaintenance': 'Bakımda',
    'storage.statusOffline': 'Çevrimdışı',
    'storage.statusDecommissioned': 'Hizmet Dışı',
    'storage.typeLabel': 'Tip:',
    'storage.totalCapacityLabel': 'Toplam Kapasite:',
    'storage.usageRate': 'Kullanım Oranı',
    'storage.usedLabel': 'Kullanılan',
    'storage.availableLabel': 'Kullanılabilir',
    'storage.encrypted': 'Şifreli',
    'storage.compression': 'Sıkıştırma',
    'storage.viewDetails': 'Detayları Görüntüle',
    'storage.modalAddTitle': 'Yeni Depolama Birimi',
    'storage.modalEditTitle': 'Depolama Birimi Düzenle',
    'storage.fieldName': 'Depolama Adı *',
    'storage.fieldType': 'Depolama Tipi *',
    'storage.fieldBrand': 'Marka *',
    'storage.fieldModel': 'Model *',
    'storage.fieldSerial': 'Seri Numarası *',
    'storage.fieldIP': 'IP Adresi',
    'storage.fieldTotalCapacity': 'Toplam Kapasite (TB) *',
    'storage.fieldUsedCapacity': 'Kullanılan Kapasite (TB)',
    'storage.fieldDiskType': 'Disk Tipi *',
    'storage.fieldConnectionType': 'Bağlantı Tipi *',
    'storage.fieldCompany': 'Şirket *',
    'storage.fieldLocation': 'Lokasyon *',
    'storage.fieldStatus': 'Durum *',
    'storage.fieldPurchaseDate': 'Satın Alma Tarihi *',
    'storage.fieldWarrantyEnd': 'Garanti Bitiş Tarihi',
    'storage.selectCompany': 'Şirket seçin',
    'storage.selectLocation': 'Lokasyon seçin',
    'storage.featuresTitle': 'Özellikler',
    'storage.featureEncryption': 'Şifreleme',
    'storage.featureCompression': 'Sıkıştırma',
    'storage.featureDeduplication': 'Deduplication',
    'storage.fieldNotes': 'Notlar',
    'storage.notesPlaceholder': 'Depolama birimi hakkında notlar...',
    'storage.cancel': 'İptal',
    'storage.save': 'Kaydet',
    'storage.update': 'Güncelle',
    'storage.detailTitle': 'Depolama Birimi Detayları',
    'storage.detailInfoSection': 'Depolama Bilgileri',
    'storage.detailCapacitySection': 'Kapasite Kullanımı',
    'storage.detailNameLabel': 'Depolama Adı:',
    'storage.detailTypeLabel': 'Tip:',
    'storage.detailBrandModelLabel': 'Marka/Model:',
    'storage.detailTotalCapacityLabel': 'Toplam Kapasite:',
    'storage.detailDiskTypeLabel': 'Disk Tipi:',
    'storage.errorRequired': 'Zorunlu alanları doldurunuz',
    'storage.errorLoad': 'Veriler yüklenirken hata oluştu',
    'storage.errorSave': 'Depolama birimi kaydedilirken hata oluştu',
    'storage.errorDelete': 'Depolama birimi silinirken hata oluştu',
    'storage.successUpdate': 'Depolama birimi güncellendi',
    'storage.successCreate': 'Depolama birimi oluşturuldu',
    'storage.successDelete': 'Depolama birimi silindi',
    'storage.confirmDelete': 'Bu depolama birimini silmek istediğinizden emin misiniz?',
    'storage.fieldRawCapacity': 'Ham Disk Kapasitesi (TB) *',
    'storage.fieldRaidLevel': 'RAID Seviyesi',
    'storage.fieldDiskCount': 'Disk Sayısı',
    'storage.raidNone': 'RAID yok',
    'storage.raidUsableLabel': 'RAID sonrası kullanılabilir kapasite',
    'storage.raidUsableNotice': 'Disk sayısı bu RAID seviyesi için yetersiz',
    // Assignment Logs Page
    'assignlog.title': 'Zimmetleme İşlem Logları',
    'assignlog.subtitle': 'Tüm envanter zimmetleme işlemlerinin detaylı logları',
    'assignlog.refresh': 'Yenile',
    'assignlog.export': 'Dışa Aktar',
    'assignlog.searchPlaceholder': 'Kullanıcı ara...',
    'assignlog.allTypes': 'Tüm Türler',
    'assignlog.allActions': 'Tüm İşlemler',
    'assignlog.allUsers': 'Tüm Kullanıcılar',
    'assignlog.totalRecords': 'Toplam {count} kayıt bulundu',
    'assignlog.clearFilters': 'Filtreleri Temizle',
    'assignlog.noLogs': 'Log kaydı bulunamadı',
    'assignlog.noLogsDesc': 'Seçilen kriterlere uygun log kaydı bulunmuyor.',
    'assignlog.colDateTime': 'Tarih/Saat',
    'assignlog.colUser': 'Kullanıcı',
    'assignlog.colType': 'Tür',
    'assignlog.colAction': 'İşlem',
    'assignlog.colChanges': 'Değişiklikler',
    'assignlog.colIP': 'IP',
    'assignlog.modalTitle': 'Zimmetleme İşlem Detayı',
    'assignlog.detailDateTime': 'Tarih / Saat',
    'assignlog.detailPerformedBy': 'İşlemi Yapan',
    'assignlog.detailEntityType': 'Varlık Türü',
    'assignlog.detailEntityId': 'Varlık ID',
    'assignlog.detailIPAddress': 'IP Adresi',
    'assignlog.detailSource': 'Kayıt Kaynağı',
    'assignlog.detailAction': 'İşlem:',
    'assignlog.detailChanges': 'Değişiklikler',
    'assignlog.detailDetails': 'Detaylar',
    'assignlog.assignmentInfo': 'Zimmet Bilgileri',
    'assignlog.unassignInfo': 'Kaldırılan Zimmet Bilgileri',
    'assignlog.returnInfo': 'İade Bilgileri',
    'assignlog.deletedRecord': 'Silinen Kayıt',
    'assignlog.createdRecord': 'Oluşturulan Kayıt',
    'assignlog.previousState': 'Önceki Durum',
    'assignlog.newState': 'Yeni Durum',
    'assignlog.compareFieldHeader': 'Alan',
    'assignlog.comparePreviousHeader': 'Önceki',
    'assignlog.compareNewHeader': 'Yeni',
    'assignlog.system': 'Sistem',
    'assignlog.pageOf': 'Sayfa {current} / {total}',
    'assignlog.cardNew': 'Yeni:',
    'assignlog.cardOld': 'Eski:',
    'assignlog.cardAssigned': 'Zimmetlenen:',
    'assignlog.cardUnassigned': 'Zimmet Kaldırılan:',
    'assignlog.cardReturn': 'İade Eden:',
    'assignlog.cardPrevious': 'Önceki:',
    'assignlog.cardDeleted': 'Silinen:',
    'assignlog.exportError': 'Loglar dışa aktarılamadı',
    'assignlog.actionAssign': 'Zimmetle',
    'assignlog.actionUnassign': 'Zimmet Kaldır',
    'assignlog.actionReturn': 'İade Et',
    'assignlog.actionTransfer': 'Transfer',
    'assignlog.entityEquipment': 'Ekipman',
    'assignlog.entityConsumable': 'Sarf Malzeme',
    'assignlog.entityEquipmentCategory': 'Ekipman Kategorisi',
    'assignlog.entityConsumableCategory': 'Sarf Malzeme Kategorisi',
    'assignlog.entityMobilePhone': 'Cep Telefonu',
    'assignlog.entityPrinter': 'Yazıcı',
    'assignlog.entityComputer': 'Bilgisayar',
    'assignlog.entityMonitor': 'Monitör',
    // AssignmentLogsPage fieldLabels
    'assignlog.fieldAssignedUserId': 'Atanan Kullanıcı ID',
    'assignlog.fieldAssignedUserName': 'Atanan Kullanıcı',
    'assignlog.fieldUnassignedUserId': 'Önceki Kullanıcı ID',
    'assignlog.fieldUnassignedUserName': 'Önceki Kullanıcı',
    'assignlog.fieldUnassignedByName': 'İşlemi Yapan',
    'assignlog.fieldAssignedByName': 'Atayan',
    'assignlog.fieldUserId': 'Kullanıcı ID',
    'assignlog.fieldUserName': 'Kullanıcı',
    'assignlog.fieldName': 'Ad',
    'assignlog.fieldSerialNumber': 'Seri No',
    'assignlog.fieldBarcode': 'Barkod',
    'assignlog.fieldDepartment': 'Departman',
    'assignlog.fieldLocation': 'Konum',
    'assignlog.fieldStatus': 'Durum',
    'assignlog.fieldNotes': 'Notlar',
    'assignlog.fieldNote': 'Not',
    'assignlog.fieldReason': 'Sebep',
    'assignlog.fieldBrand': 'Marka',
    'assignlog.fieldModel': 'Model',
    'assignlog.fieldDeviceBrand': 'Cihaz Marka',
    'assignlog.fieldDeviceModel': 'Cihaz Model',
    'assignlog.fieldComputerBrand': 'Bilgisayar Marka',
    'assignlog.fieldComputerModel': 'Bilgisayar Model',
    'assignlog.fieldEquipmentBrand': 'Ekipman Marka',
    'assignlog.fieldEquipmentModel': 'Ekipman Model',
    'assignlog.fieldAssignmentType': 'Zimmet Türü',
    'assignlog.fieldConditionOnAssignment': 'Zimmet Durumu',
    'assignlog.fieldImei': 'IMEI',
    'assignlog.fieldPhoneNumber': 'Telefon No',
    'assignlog.fieldLineNumber': 'Hat No',
    'assignlog.fieldGsmNumber': 'GSM No',
    'assignlog.fieldIpAddress': 'IP Adresi',
    'assignlog.fieldMacAddress': 'MAC Adresi',
    'assignlog.fieldHostname': 'Bilgisayar Adı',
    'assignlog.fieldEquipmentName': 'Ekipman Adı',
    'assignlog.fieldInventoryNumber': 'Envanter No',
    'assignlog.fieldCategory': 'Kategori',
    'assignlog.fieldQuantity': 'Miktar',
    'assignlog.fieldUnit': 'Birim',
    'assignlog.fieldWarrantyEnd': 'Garanti Bitiş',
    'assignlog.fieldPurchaseDate': 'Satın Alma Tarihi',
    'assignlog.fieldAssignedAt': 'Atama Tarihi',
    'assignlog.fieldUnassignedAt': 'Çıkarma Tarihi',
    'assignlog.fieldCreatedAt': 'Oluşturma Tarihi',
    'assignlog.fieldUpdatedAt': 'Güncelleme Tarihi',
    'assignlog.fieldFromUser': 'Önceki Kullanıcı',
    'assignlog.fieldToUser': 'Yeni Kullanıcı',
    'assignlog.fieldFromUserId': 'Önceki Kullanıcı ID',
    'assignlog.fieldToUserId': 'Yeni Kullanıcı ID',
    'assignlog.fieldPreviousUser': 'Önceki Kullanıcı',
    'assignlog.fieldNewUser': 'Yeni Kullanıcı',
    // AssignmentLogsPage valueLabels
    'assignlog.valuePermanent': 'Kalıcı',
    'assignlog.valueTemporary': 'Geçici',
    'assignlog.valueNew': 'Yeni',
    'assignlog.valueGood': 'İyi',
    'assignlog.valueFair': 'Orta',
    'assignlog.valuePoor': 'Kötü',
    'assignlog.valueDamaged': 'Hasarlı',
    'assignlog.valueActive': 'Aktif',
    'assignlog.valuePassive': 'Pasif',
    'assignlog.valueFree': 'Boşta',
    'assignlog.valueAssigned': 'Zimmetli',
    'assignlog.valueInUse': 'Kullanımda',
    'assignlog.valueInStock': 'Stokta',
    'assignlog.valueMaintenance': 'Bakımda',
    'assignlog.valueRetired': 'Kullanım Dışı',
    'assignlog.valueLost': 'Kayıp',
    'assignlog.valueStolen': 'Çalıntı',
    'assignlog.valueBroken': 'Arızalı',
    'assignlog.valueTrue': 'Evet',
    'assignlog.valueFalse': 'Hayır',
    'assignlog.valueEquipmentLog': 'Ekipman Logu',
    'assignlog.valueComputerHistory': 'Bilgisayar Geçmişi',
    'assignlog.valueMonitorHistory': 'Monitör Geçmişi',
    'assignlog.valueMobileHistory': 'Cep Telefonu Geçmişi',
    // IoTDevicesPage
    'iot.title': 'IoT Cihaz Yönetimi',
    'iot.subtitle': 'Nesnelerin interneti cihaz envanteri ve izleme',
    'iot.bulkLabel': 'Toplu Etiket',
    'iot.label': 'Etiket',
    'iot.newDevice': 'Yeni IoT Cihazı',
    'iot.statTotal': 'Toplam Cihaz',
    'iot.statOnline': 'Çevrimiçi',
    'iot.statOffline': 'Çevrimdışı',
    'iot.statWarning': 'Uyarı Durumu',
    'iot.searchPlaceholder': 'IoT cihazı ara...',
    'iot.filterAllTypes': 'Tüm Tipler',
    'iot.filterAllProtocols': 'Tüm Protokoller',
    'iot.filterAllStatuses': 'Tüm Durumlar',
    'iot.colDevice': 'Cihaz',
    'iot.colType': 'Tip',
    'iot.colCompany': 'Şirket',
    'iot.colLocation': 'Lokasyon',
    'iot.colIp': 'IP Adresi',
    'iot.colStatus': 'Durum',
    'iot.colActions': 'İşlemler',
    'iot.titleView': 'Detayları Görüntüle',
    'iot.titleCopy': 'Kopyala',
    'iot.titleQr': 'QR Kod Oluştur',
    'iot.titleEdit': 'Düzenle',
    'iot.titleDelete': 'Sil',
    'iot.modalTitleEdit': 'IoT Cihazı Düzenle',
    'iot.modalTitleNew': 'Yeni IoT Cihazı',
    'iot.sectionBasic': 'Temel Bilgiler',
    'iot.sectionComm': 'İletişim ve Konfigürasyon',
    'iot.sectionLocation': 'Lokasyon ve Atama',
    'iot.sectionPurchase': 'Satın Alma Bilgileri',
    'iot.labelDeviceName': 'Cihaz Adı *',
    'iot.labelDeviceType': 'Cihaz Tipi *',
    'iot.labelBrand': 'Marka *',
    'iot.labelModel': 'Model *',
    'iot.labelSerialNumber': 'Seri Numarası',
    'iot.labelMacAddress': 'MAC Adresi',
    'iot.labelIpAddress': 'IP Adresi',
    'iot.labelFirmware': 'Firmware Versiyonu',
    'iot.labelProtocol': 'İletişim Protokolü *',
    'iot.labelOs': 'İşletim Sistemi',
    'iot.labelStatus': 'Durum *',
    'iot.labelInstallDate': 'Kurulum Tarihi *',
    'iot.labelCompany': 'Şirket *',
    'iot.labelLocation': 'Lokasyon *',
    'iot.labelAdmin': 'Sorumlu Admin',
    'iot.labelWarrantyEnd': 'Garanti Bitiş Tarihi',
    'iot.labelPurchasePrice': 'Satın Alma Fiyatı',
    'iot.labelDeviceImage': 'Cihaz Görseli',
    'iot.labelNotes': 'Notlar',
    'iot.selectCompany': 'Şirket seçin',
    'iot.selectLocation': 'Lokasyon seçin',
    'iot.selectAdmin': 'Admin seçin',
    'iot.locationsLoadError': 'Lokasyonlar yüklenemedi. Sayfayı yenileyin.',
    'iot.imageHint': 'JPG, PNG, GIF, WebP destekleniyor (Max: 5MB)',
    'iot.imageSelectedFile': 'Seçilen dosya:',
    'iot.notesPlaceholder': 'IoT cihazı hakkında notlar...',
    'iot.detailTitle': 'IoT Cihaz Detayları',
    'iot.detailSectionDevice': 'Cihaz Bilgileri',
    'iot.detailSectionImage': 'Cihaz Görseli',
    'iot.detailSectionNetwork': 'Ağ Bilgileri',
    'iot.detailSectionStatus': 'Durum Bilgileri',
    'iot.detailSectionLocation': 'Lokasyon',
    'iot.detailSectionSensors': 'Sensör Okumaları',
    'iot.detailSectionNotes': 'Notlar',
    'iot.detailDeviceName': 'Cihaz Adı:',
    'iot.detailType': 'Tip:',
    'iot.detailBrandModel': 'Marka/Model:',
    'iot.detailSerialNo': 'Seri No:',
    'iot.detailFirmware': 'Firmware:',
    'iot.detailIpAddress': 'IP Adresi:',
    'iot.detailMacAddress': 'MAC Adresi:',
    'iot.detailProtocol': 'Protokol:',
    'iot.detailOs': 'İşletim Sistemi:',
    'iot.detailStatus': 'Durum:',
    'iot.detailCompany': 'Şirket:',
    'iot.detailLocation': 'Lokasyon:',
    'iot.detailInstallDate': 'Kurulum Tarihi:',
    'iot.detailAdmin': 'Sorumlu Admin:',
    'iot.detailUnassigned': 'Atanmamış',
    'iot.detailTemperature': 'Sıcaklık',
    'iot.detailHumidity': 'Nem',
    'iot.detailPressure': 'Basınç',
    'iot.detailCreatedAt': 'Oluşturulma:',
    'iot.detailUpdatedAt': 'Son Güncelleme:',
    'iot.typeSensor': 'Sensör',
    'iot.typeCamera': 'Kamera',
    'iot.typeDisplay': 'Ekran',
    'iot.typeController': 'Kontrolcü',
    'iot.typeGateway': 'Gateway',
    'iot.typeBeacon': 'Beacon',
    'iot.typeTracker': 'Tracker',
    'iot.statusOnline': 'Çevrimiçi',
    'iot.statusOffline': 'Çevrimdışı',
    'iot.statusMaintenance': 'Bakımda',
    'iot.statusFaulty': 'Arızalı',
    'iot.healthHealthy': 'Sağlıklı',
    'iot.healthWarning': 'Uyarı',
    'iot.healthCritical': 'Kritik',
    'iot.healthUnknown': 'Bilinmiyor',
    'iot.errorRequired': 'Zorunlu alanları doldurunuz',
    'iot.successUpdated': 'IoT cihazı güncellendi',
    'iot.successCreated': 'IoT cihazı oluşturuldu',
    'iot.errorSave': 'IoT cihazı kaydedilirken hata oluştu',
    'iot.successDeleted': 'IoT cihazı silindi',
    'iot.errorDelete': 'IoT cihazı silinirken hata oluştu',
    'iot.confirmDelete': 'Bu IoT cihazını silmek istediğinizden emin misiniz?',
    'iot.infoCopied': 'IoT cihaz bilgileri kopyalandı, benzersiz alanları düzenleyip kaydedin',
    'iot.errorLocations': 'Lokasyonlar yüklenirken hata oluştu',
    'iot.warnLocations': 'Lokasyonlar yüklenemedi. Lütfen sayfayı yenileyin.',
    'iot.errorData': 'Veriler yüklenirken hata oluştu',
    'iot.errorImageSize': "Dosya boyutu 5MB'dan büyük olamaz",
    'iot.errorImageType': 'Sadece resim dosyaları (JPG, PNG, GIF, WebP) yüklenebilir',
    'iot.successFileSelected': 'Dosya seçildi',
    'iot.bulkModalTitle': 'Toplu Etiket Yazdırma',
    'iot.bulkFilters': 'Filtreler',
    'iot.bulkFilterLocation': 'Lokasyon',
    'iot.bulkFilterStatus': 'Durum',
    'iot.bulkFilterType': 'Cihaz Tipi',
    'iot.bulkAllLocations': 'Tüm Lokasyonlar',
    'iot.bulkAllStatuses': 'Tüm Durumlar',
    'iot.bulkAllTypes': 'Tüm Tipler',
    'iot.bulkDeviceSelection': 'Cihaz Seçimi ({count} seçildi)',
    'iot.bulkSelectAll': 'Tümünü Seç',
    'iot.bulkDeselectAll': 'Seçimi Temizle',
    'iot.bulkPreviewBtn': 'Önizleme ({count} adet)',
    'iot.bulkPreviewTitle': 'Etiket Önizlemesi ({count} adet - {pages} sayfa)',
    'iot.bulkPreviewDesc': 'Her sayfada 4 etiket (2x2) basılacak. A4 kağıt boyutunda optimize edilmiştir.',
    'iot.bulkPrint': 'Yazdır',
    'iot.printIpLabel': 'IP Adresi:',
    'iot.printNotSpecified': 'Belirtilmemiş',
    'iot.update': 'Güncelle',
    // SmartScalesPage
    'scale.title': 'Akıllı Terazi Yönetimi',
    'scale.subtitle': 'Endüstriyel terazi envanteri ve kalibrasyon takibi',
    'scale.newScale': 'Yeni Akıllı Terazi',
    'scale.statTotal': 'Toplam Terazi',
    'scale.statActive': 'Aktif',
    'scale.statCalibNeeded': 'Kalibrasyon Gerekli',
    'scale.statDailyMeasurement': 'Günlük Ölçüm',
    'scale.searchPlaceholder': 'Akıllı terazi ara...',
    'scale.filterAllProtocols': 'Tüm Protokoller',
    'scale.filterAllStatuses': 'Tüm Durumlar',
    'scale.colScale': 'Terazi',
    'scale.colLocation': 'Lokasyon',
    'scale.colStatus': 'Durum',
    'scale.colProtocol': 'Protokol',
    'scale.colIp': 'IP Adresi',
    'scale.colCapacity': 'Kapasite',
    'scale.colCalibration': 'Kalibrasyon',
    'scale.colActions': 'İşlemler',
    'scale.calibRequired': 'Gerekli',
    'scale.calibOk': 'Tamam',
    'scale.titleView': 'Detayları Görüntüle',
    'scale.titleEdit': 'Düzenle',
    'scale.titleCopy': 'Kopyala',
    'scale.titleCalibrate': 'Kalibrasyon Yap',
    'scale.titleLabel': 'Etiket Yazdır',
    'scale.titleDelete': 'Sil',
    'scale.statusActive': 'Aktif',
    'scale.statusInactive': 'Pasif',
    'scale.statusMaintenance': 'Bakımda',
    'scale.statusCalibrationNeeded': 'Kalibrasyon Gerekli',
    'scale.healthHealthy': 'Sağlıklı',
    'scale.healthWarning': 'Uyarı',
    'scale.healthCritical': 'Kritik',
    'scale.healthUnknown': 'Bilinmiyor',
    'scale.modalTitleEdit': 'Akıllı Terazi Düzenle',
    'scale.modalTitleNew': 'Yeni Akıllı Terazi',
    'scale.modalCopyNote': 'Bu terazi kopyalanıyor. Lütfen benzersiz bir ad ve IP adresi girin.',
    'scale.sectionBasic': 'Temel Bilgiler',
    'scale.sectionTech': 'Teknik Özellikler',
    'scale.sectionInstall': 'Kurulum ve Kalibrasyon',
    'scale.sectionLocation': 'Lokasyon ve Atama',
    'scale.labelScaleName': 'Terazi Adı *',
    'scale.duplicateNameError': 'Bu terazi adı zaten kullanılıyor',
    'scale.labelBrand': 'Marka *',
    'scale.labelModel': 'Model *',
    'scale.labelSerialNumber': 'Seri Numarası *',
    'scale.labelMacAddress': 'MAC Adresi',
    'scale.macHint': 'MAC adresi okunamıyorsa boş bırakabilirsiniz',
    'scale.labelIpAddress': 'IP Adresi',
    'scale.duplicateIPError': 'Bu IP adresi zaten kullanılıyor',
    'scale.labelMaxCapacity': 'Maksimum Kapasite (kg) *',
    'scale.labelPrecision': 'Hassasiyet (gram) *',
    'scale.labelProtocol': 'İletişim Protokolü *',
    'scale.labelStatus': 'Durum *',
    'scale.labelInstallDate': 'Kurulum Tarihi *',
    'scale.labelLastCalib': 'Son Kalibrasyon Tarihi',
    'scale.labelNextCalib': 'Sonraki Kalibrasyon Tarihi',
    'scale.labelCompany': 'Şirket *',
    'scale.labelLocation': 'Lokasyon *',
    'scale.labelAdmin': 'Sorumlu Yetkili',
    'scale.labelPurchasePrice': 'Satın Alma Fiyatı',
    'scale.labelNotes': 'Notlar',
    'scale.selectCompany': 'Şirket seçin',
    'scale.selectLocation': 'Lokasyon seçin',
    'scale.selectAdmin': 'Yetkili seçin',
    'scale.notesPlaceholder': 'Akıllı terazi hakkında notlar...',
    'scale.update': 'Güncelle',
    'scale.detailTitle': 'Akıllı Terazi Detayları',
    'scale.detailSectionScale': 'Terazi Bilgileri',
    'scale.detailSectionNetwork': 'Ağ Bilgileri',
    'scale.detailSectionCalib': 'Kalibrasyon Bilgileri',
    'scale.detailSectionNotes': 'Notlar',
    'scale.detailScaleName': 'Terazi Adı:',
    'scale.detailBrandModel': 'Marka/Model:',
    'scale.detailSerialNo': 'Seri No:',
    'scale.detailCapacity': 'Kapasite:',
    'scale.detailPrecision': 'Hassasiyet:',
    'scale.detailIpAddress': 'IP Adresi:',
    'scale.detailMacAddress': 'MAC Adresi:',
    'scale.detailProtocol': 'Protokol:',
    'scale.detailLastCalib': 'Son Kalibrasyon:',
    'scale.detailNextCalib': 'Sonraki Kalibrasyon:',
    'scale.detailInstallDate': 'Kurulum Tarihi:',
    'scale.detailAdmin': 'Sorumlu Yetkili:',
    'scale.detailUnassigned': 'Atanmamış',
    'scale.calibrateBtn': 'Kalibrasyon Yap',
    'scale.calibHistoryBtn': 'Kalibrasyon Geçmişi',
    'scale.calibHistoryTitle': 'Kalibrasyon Geçmişi',
    'scale.calibHistoryEmpty': 'Henüz kalibrasyon kaydı bulunmuyor',
    'scale.calibHistoryType': 'Tip:',
    'scale.calibHistoryManual': 'Manuel',
    'scale.calibHistoryCompleted': 'Tamamlandı',
    'scale.calibHistoryPending': 'Beklemede',
    'scale.calibHistoryNewBtn': 'Yeni Kalibrasyon Kaydet',
    'scale.calibModalTitle': 'Kalibrasyon Yap',
    'scale.calibSectionInfo': 'Kalibrasyon Bilgileri',
    'scale.calibLabelCompany': 'Kalibrasyon Firması *',
    'scale.calibLabelNumber': 'Kalibrasyon Numarası *',
    'scale.calibLabelDate': 'Kalibrasyon Tarihi *',
    'scale.calibLabelNextDate': 'Sonraki Kalibrasyon Tarihi',
    'scale.calibLabelType': 'Kalibrasyon Tipi',
    'scale.calibTypeManual': 'Manuel Kalibrasyon',
    'scale.calibTypeAutomatic': 'Otomatik Kalibrasyon',
    'scale.calibTypeCertified': 'Sertifikalı Kalibrasyon',
    'scale.calibLabelStatus': 'Durum',
    'scale.calibStatusCompleted': 'Tamamlandı',
    'scale.calibStatusPending': 'Beklemede',
    'scale.calibStatusFailed': 'Başarısız',
    'scale.calibLabelNotes': 'Kalibrasyon Notları',
    'scale.calibNotesPlaceholder': 'Kalibrasyon süreci hakkında notlar...',
    'scale.calibImportanceTitle': 'Kalibrasyonun Önemi',
    'scale.calibImportance1': '• Tartımda doğru sonuçlar için şarttır',
    'scale.calibImportance2': '• Hatalı okuma müşteri kaybına neden olabilir',
    'scale.calibImportance3': '• Ticaret Bakanlığı denetimlerinde zorunludur',
    'scale.calibImportance4': '• CE belgeli cihazlar için düzenli kalibrasyon gereklidir',
    'scale.calibSaveBtn': 'Kalibrasyonu Kaydet',
    'scale.calibNotesPrompt': 'Kalibrasyon notları (isteğe bağlı):',
    'scale.calibDefaultNotes': 'Kalibrasyon başarıyla tamamlandı',
    'scale.labelModalTitle': 'Terazi Etiketi Ayarları',
    'scale.labelWidth': 'Genişlik (mm)',
    'scale.labelHeight': 'Yükseklik (mm)',
    'scale.labelOrientation': 'Yönlendirme',
    'scale.labelPortrait': 'Dikey (Portrait)',
    'scale.labelLandscape': 'Yatay (Landscape)',
    'scale.labelFontSize': 'Font Boyutu (px)',
    'scale.labelMargin': 'Kenar Boşluğu (mm)',
    'scale.labelPresets': 'Hazır Ayarlar:',
    'scale.presetStandard': 'Standart Etiket (80x60mm)',
    'scale.presetLarge': 'Büyük Etiket (120x80mm)',
    'scale.labelInfoTitle': 'Etiket Bilgileri:',
    'scale.labelInfoScaleName': 'Terazi Adı:',
    'scale.labelInfoBrandModel': 'Marka/Model:',
    'scale.labelInfoIp': 'IP Adresi:',
    'scale.labelInfoSerial': 'Seri No:',
    'scale.labelInfoCapacity': 'Kapasite:',
    'scale.labelInfoQr': 'QR Kod:',
    'scale.labelInfoQrDesc': 'Cihaz bilgileri ve kalibrasyon geçmişi',
    'scale.labelPrintBtn': 'Etiket Yazdır',
    'scale.printScaleName': 'TERAZİ ADI',
    'scale.errorRequired': 'Zorunlu alanları doldurunuz',
    'scale.errorDuplicateName': 'Bu terazi adı zaten kullanılıyor. Lütfen farklı bir ad girin.',
    'scale.errorDuplicateIP': 'Bu IP adresi zaten kullanılıyor. Lütfen farklı bir IP adresi girin.',
    'scale.successUpdated': 'Akıllı terazi güncellendi',
    'scale.successCreated': 'Akıllı terazi oluşturuldu',
    'scale.errorSave': 'Akıllı terazi kaydedilirken hata oluştu',
    'scale.confirmDelete': 'Bu akıllı teraziyi silmek istediğinizden emin misiniz?',
    'scale.successDeleted': 'Akıllı terazi silindi',
    'scale.errorDelete': 'Akıllı terazi silinirken hata oluştu',
    'scale.errorCalibHistory': 'Kalibrasyon geçmişi yüklenirken hata oluştu',
    'scale.errorCalibRequired': 'Kalibrasyon firması ve numarası zorunludur',
    'scale.successCalibSaved': 'Kalibrasyon kaydedildi',
    'scale.errorCalibSave': 'Kalibrasyon kaydedilirken hata oluştu',
    'scale.errorData': 'Veriler yüklenirken hata oluştu',
    'scale.errorLabel': 'Etiket oluşturulurken hata oluştu',
    // MonitorsPage
    'monitor.title': 'Monitörler',
    'monitor.subtitle': '{count} monitör listeleniyor',
    'monitor.brandsBtn': 'Markalar',
    'monitor.newMonitor': 'Yeni Monitör',
    'monitor.searchPlaceholder': 'Ara...',
    'monitor.filterAllStatuses': 'Tüm Durumlar',
    'monitor.filterAllCompanies': 'Tüm Firmalar',
    'monitor.filterAllLocations': 'Tüm Lokasyonlar',
    'monitor.resultsCount': '{count} sonuç',
    'monitor.colInventory': 'Envanter No',
    'monitor.colBrandModel': 'Marka / Model',
    'monitor.colSpecs': 'Özellikler',
    'monitor.colLocation': 'Lokasyon',
    'monitor.colUser': 'Kullanıcı',
    'monitor.colStatus': 'Durum',
    'monitor.colActions': 'İşlemler',
    'monitor.pagePrev': 'Önceki',
    'monitor.pageNext': 'Sonraki',
    'monitor.pageInfo': '{start} - {end} / {total} kayıt',
    'monitor.titleUnassign': 'Atamayı Kaldır',
    'monitor.titleAssign': 'Kullanıcıya Ata',
    'monitor.titleHistory': 'Geçmiş',
    'monitor.titleCopy': 'Hızlı Kopyala',
    'monitor.statusActive': 'Aktif',
    'monitor.statusInactive': 'Pasif',
    'monitor.statusRepair': 'Onarımda',
    'monitor.statusDamaged': 'Hasarlı',
    'monitor.statusRetired': 'Emekli',
    'monitor.statusScrapped': 'Hurda',
    'monitor.modalTitleEdit': 'Monitör Düzenle',
    'monitor.modalTitleNew': 'Yeni Monitör Ekle',
    'monitor.labelInventory': 'Envanter No *',
    'monitor.labelBrand': 'Marka *',
    'monitor.selectBrand': 'Marka Seçin',
    'monitor.labelModel': 'Model *',
    'monitor.selectModel': 'Model Seçin',
    'monitor.modelPlaceholder': 'Model adı',
    'monitor.addModelBtn': 'Yeni Model Ekle',
    'monitor.labelSerial': 'Seri Numarası *',
    'monitor.labelStatus': 'Durum',
    'monitor.labelScreenSize': 'Ekran Boyutu',
    'monitor.labelResolution': 'Çözünürlük',
    'monitor.labelPanelType': 'Panel Tipi',
    'monitor.selectDefault': 'Seçin',
    'monitor.labelLocation': 'Lokasyon',
    'monitor.labelCompany': 'Firma',
    'monitor.labelPurchaseDate': 'Satın Alma Tarihi',
    'monitor.labelWarranty': 'Garanti Bitiş',
    'monitor.labelPurchasePrice': 'Satın Alma Fiyatı',
    'monitor.labelCurrency': 'Para Birimi',
    'monitor.labelNotes': 'Notlar',
    'monitor.update': 'Güncelle',
    'monitor.assignTitle': 'Monitör Ata',
    'monitor.userSearchLabel': 'Kullanıcı Ara',
    'monitor.userSearchPlaceholder': 'İsim veya email...',
    'monitor.selectUserLabel': 'Kullanıcı Seç *',
    'monitor.labelComputer': 'Bilgisayar (Opsiyonel)',
    'monitor.continueBtn': 'Devam',
    'monitor.copyTitle': 'Monitörü Hızlı Kopyala',
    'monitor.copySourceLabel': 'Kopyalanacak Monitör',
    'monitor.copyScreenLabel': 'Ekran:',
    'monitor.copyPanelLabel': 'Panel:',
    'monitor.labelSerialNo': 'Seri No',
    'monitor.serialPlaceholder': 'Seri numarası',
    'monitor.selectCompany': 'Şirket seçin',
    'monitor.selectLocation': 'Lokasyon seçin',
    'monitor.labelAssignUser': 'Atanacak Kullanıcı',
    'monitor.optional': '(opsiyonel)',
    'monitor.userSearchPlaceholder2': 'Kullanıcı ara...',
    'monitor.userNotFound': 'Kullanıcı bulunamadı',
    'monitor.userSelected': '{name} seçildi',
    'monitor.copying': 'Kopyalanıyor...',
    'monitor.copyBtn': 'Kopyala',
    'monitor.assignFormTitle': 'Monitör Zimmet Atama',
    'monitor.assignUserLabel': 'Kullanıcı:',
    'monitor.noteOptional': 'Not (Opsiyonel)',
    'monitor.notePlaceholder': 'Atama ile ilgili not...',
    'monitor.assignWithoutForm': 'Zimmet Formsuz Ata',
    'monitor.assignWithForm': 'Zimmet Formu ile Ata',
    'monitor.unassignTitle': 'Zimmet Geri Teslim Formu Oluştur',
    'monitor.unassignMonitorLabel': 'Monitör:',
    'monitor.noteOptional2': 'Not (İsteğe Bağlı)',
    'monitor.removeReasonPlaceholder': 'Kaldırma sebebi...',
    'monitor.photosLabel': 'Cihaz Fotoğrafları (En fazla 4 adet)',
    'monitor.addPhoto': 'Ekle',
    'monitor.withReturnForm': 'Geri Zimmet Formu ile',
    'monitor.withoutForm': 'Form Olmadan',
    'monitor.historyTitle': 'Monitör Geçmişi',
    'monitor.historyCreated': 'Oluşturuldu',
    'monitor.historyUpdated': 'Güncellendi',
    'monitor.historyAssigned': 'Atandı',
    'monitor.historyUnassigned': 'Atama Kaldırıldı',
    'monitor.historyDeleted': 'Silindi',
    'monitor.historyPerformedBy': 'İşlemi Yapan:',
    'monitor.historyUser': 'Kullanıcı:',
    'monitor.historyNote': 'Not:',
    'monitor.historyEmpty': 'Geçmiş kaydı bulunamadı.',
    'monitor.brandsTitle': 'Monitör Markaları',
    'monitor.brandName': 'Marka Adı *',
    'monitor.brandLogo': 'Logo',
    'monitor.brandActive': 'Aktif',
    'monitor.addBtn': 'Ekle',
    'monitor.existingBrands': 'Mevcut Markalar',
    'monitor.quickModelTitle': 'Hızlı Model Ekle',
    'monitor.modelName': 'Model Adı *',
    'monitor.labelRefreshRate': 'Yenileme Hızı',
    'monitor.hasSpeaker': 'Hoparlör',
    'monitor.hasUsbHub': 'USB Hub',
    'monitor.isCurved': 'Curved',
    'monitor.saving': 'Kaydediliyor...',
    'monitor.addAndSelect': 'Ekle ve Seç',
    'monitor.errorData': 'Veriler yüklenirken hata oluştu',
    'monitor.successUpdated': 'Monitör güncellendi',
    'monitor.successCreated': 'Monitör eklendi',
    'monitor.errorSave': 'Monitör kaydedilirken hata oluştu',
    'monitor.confirmDelete': '{invNo} numaralı monitörü silmek istediğinize emin misiniz?',
    'monitor.successDeleted': 'Monitör silindi',
    'monitor.errorDelete': 'Monitör silinirken hata oluştu',
    'monitor.errorInventoryRequired': 'Envanter No zorunludur',
    'monitor.errorSerialRequired': 'Seri No zorunludur',
    'monitor.successCopied': 'Monitör kopyalandı ({invNo})',
    'monitor.successAssigned': 'Monitör atandı',
    'monitor.errorAssign': 'Monitör atanırken hata oluştu',
    'monitor.successFormCreated': 'Zimmet formu oluşturuldu ({formNo})',
    'monitor.successReturnForm': 'Geri zimmet formu oluşturuldu (Form No: {formNo})',
    'monitor.successUnassigned': 'Monitör ataması kaldırıldı',
    'monitor.errorUnassign': 'Atama kaldırılırken hata oluştu',
    'monitor.errorModelRequired': 'Model adı zorunludur',
    'monitor.successBrandUpdated': 'Marka güncellendi',
    'monitor.successBrandCreated': 'Marka eklendi',
    'monitor.errorBrandSave': 'Marka kaydedilirken hata oluştu',
    'monitor.successModelCreated': 'Model eklendi',
    'monitor.errorModelSave': 'Model kaydedilirken hata oluştu',
    'monitor.excelInventory': 'Envanter No',
    'monitor.excelBrand': 'Marka',
    'monitor.excelModel': 'Model',
    'monitor.excelSerial': 'Seri No',
    'monitor.excelScreenSize': 'Ekran Boyutu',
    'monitor.excelResolution': 'Çözünürlük',
    'monitor.excelPanelType': 'Panel Tipi',
    'monitor.excelLocation': 'Lokasyon',
    'monitor.excelCompany': 'Firma',
    'monitor.excelAssignedUser': 'Atanan Kullanıcı',
    'monitor.excelStatus': 'Durum',
    'monitor.excelPurchaseDate': 'Satın Alma Tarihi',
    'monitor.excelWarranty': 'Garanti Bitiş',
    // CameraFaultsPage
    'camera.title': 'Kamera Arızaları',
    'camera.subtitle': 'Kamera arızalarını yönetin ve takip edin',
    'camera.btnFilter': 'Filtrele',
    'camera.btnNewFault': 'Yeni Arıza',
    'camera.statTotal': 'Toplam Arıza',
    'camera.statTotalSub': 'Çözümlenmemiş',
    'camera.statOpen': 'Açık Arızalar',
    'camera.statResolved': 'Çözümlenen',
    'camera.statTopLocation': 'En Çok Arızalı Lokasyon',
    'camera.statNoData': 'Veri yok',
    'camera.statFaultCount': '{count} arıza',
    'camera.filterActive': 'Filtre aktif',
    'camera.searchPlaceholder': 'Kamera adı, arıza, konum ara...',
    'camera.filtersTitle': 'Filtreler',
    'camera.filterStatusLabel': 'Durum',
    'camera.filterStatusActive': 'Aktif Arızalar',
    'camera.filterStatusAll': 'Tüm Durumlar',
    'camera.filterStatusOpen': 'Açık',
    'camera.filterStatusReviewing': 'İnceleniyor',
    'camera.filterStatusConsignment': 'Konsinye Bırakıldı',
    'camera.filterStatusResolved': 'Çözümlendi',
    'camera.filterStatusClosed': 'Kapalı',
    'camera.filterLocationLabel': 'Lokasyon',
    'camera.filterAllLocations': 'Tüm Lokasyonlar',
    'camera.noFaults': 'Arıza bulunamadı',
    'camera.colCamera': 'Kamera',
    'camera.colFault': 'Arıza',
    'camera.colStatus': 'Durum',
    'camera.colDate': 'Tarih',
    'camera.colReporter': 'Bildiren',
    'camera.colActions': 'İşlemler',
    'camera.titleDetails': 'Detayları Görüntüle',
    'camera.titleAssignSupplier': 'Tedarikçi Ata',
    'camera.titleSupplierAssigned': 'Tedarikçi: {name}',
    'camera.titleReturnConsignment': 'Konsinye İade Al: {name}',
    'camera.titleConsignment': 'Konsinye Kamera Bırak',
    'camera.btnDetails': 'Detay',
    'camera.btnSupplierAssigned': 'Tedarikçi',
    'camera.btnAssignSupplier': 'Ata',
    'camera.btnReturnConsignment': 'İade Al',
    'camera.btnConsignment': 'Konsinye',
    'camera.pageInfo': '{start} - {end} arası, toplam {total} arıza',
    'camera.pagePrev': 'Önceki',
    'camera.pageOf': 'Sayfa {current} / {total}',
    'camera.pageNext': 'Sonraki',
    'camera.formTitleEdit': 'Arızayı Düzenle',
    'camera.formTitleNew': 'Yeni Arıza',
    'camera.formLabelLocation': 'Lokasyon *',
    'camera.formSelectLocation': 'Lokasyon Seçin',
    'camera.formNvrSelectLocation': '(Önce Lokasyon Seçin)',
    'camera.formSelectNvr': 'NVR Seçin',
    'camera.formCameraSelectNvr': '(Önce NVR Seçin)',
    'camera.formCameraPlaceholder': 'Kamera adı veya IP ile ara...',
    'camera.formCameraClearSelection': '✕ Seçimi Temizle',
    'camera.formNoNvrCameras': 'Bu NVR\'da kamera yok',
    'camera.formNoCamerasMatch': 'Eşleşen kamera bulunamadı',
    'camera.formCameraSelected': '✓ Kamera seçildi: {name}',
    'camera.formLabelCameraName': 'Kamera Adı *',
    'camera.formCameraNamePlaceholder': 'örn: Giriş Kamerası',
    'camera.formLabelIp': 'IP Adresi',
    'camera.formIpReadonlyNote': 'Kamera seçildiği için IP adresi düzenlenemez',
    'camera.formLabelArea': 'Bölge',
    'camera.formAreaPlaceholder': 'örn: 2. Kat, Ana Ofis Bölgesi',
    'camera.formLabelReportedBy': 'Bildirimi Yapan Kişi',
    'camera.formLabelStatus': 'Durum',
    'camera.formStatusOpen': 'Açık',
    'camera.formStatusReviewing': 'İnceleniyor',
    'camera.formStatusResolved': 'Çözümlendi',
    'camera.formStatusClosed': 'Kapalı',
    'camera.formLabelFaultDesc': 'Arıza Açıklaması *',
    'camera.formFaultDescSelect': 'Arıza Türünü Seçin',
    'camera.faultDesc1': 'Görüntü Gelmiyor',
    'camera.faultDesc2': 'Görüntü Gelip Gidiyor',
    'camera.faultDesc3': 'Kamera Merceği Temizlenmeli',
    'camera.faultDesc4': 'Haberleşme Kablosu Arızalı',
    'camera.faultDesc5': 'Diğer',
    'camera.formLabelNotes': 'Ek Açıklamalar',
    'camera.formNotesPlaceholder': 'Arızayla ilgili ek detaylar...',
    'camera.formLabelLastImage': 'Son Görüntüsü',
    'camera.formImageRemove': 'Resimi Kaldır',
    'camera.formImageUpload': 'Kameradan veya galeriden resim yükleyin',
    'camera.formImageHint': 'JPG, PNG (Max 5MB)',
    'camera.supplierTitle': 'Tedarikçi Ata',
    'camera.supplierLabelCamera': 'Kamera:',
    'camera.supplierLabelFault': 'Arıza:',
    'camera.supplierLabelLocation': 'Lokasyon:',
    'camera.supplierLabelSelect': 'Tedarikçi *',
    'camera.supplierSelectDefault': 'Tedarikçi Seçin',
    'camera.supplierNoFound': 'Güvenlik Kamera Sistemleri kategorisinde tedarikçi bulunamadı',
    'camera.supplierLabelNotes': 'Notlar (Opsiyonel)',
    'camera.supplierNotesPlaceholder': 'Tedarikçiye iletilecek özel notlar...',
    'camera.supplierBtnAssign': 'Tedarikçi Ata',
    'camera.consignmentTitle': 'Konsinye Kamera Bırak',
    'camera.consignmentFaultyCameraLabel': 'Teknik Servise Alınan Arızalı Kamera',
    'camera.consignmentLabelSelect': 'Yerine Bırakılacak Konsinye Kamera',
    'camera.consignmentSearchPlaceholder': 'Kamera adı, IP veya marka ile ara...',
    'camera.consignmentNoFound': 'Kamera bulunamadı',
    'camera.consignmentNoIp': 'IP yok',
    'camera.consignmentLabelNotes': 'Notlar (isteğe bağlı)',
    'camera.consignmentNotesPlaceholder': 'Konsinye bırakma ile ilgili notlar...',
    'camera.consignmentBtnPlace': 'Konsinye Bırak',
    'camera.consignmentBtnPlacing': 'Kaydediliyor...',
    'camera.returnTitle': 'Konsinye Kamerayı İade Al',
    'camera.returnActiveLabel': 'Aktif Konsinye Kamera',
    'camera.returnPlacedAt': '{date} tarihinde bırakıldı',
    'camera.returnBy': '{name} tarafından',
    'camera.returnConfirmPre': 'Onaylandığında: Konsinye kamera iade alınacak ve arıza ',
    'camera.returnConfirmStrong': 'Çözümlendi',
    'camera.returnConfirmPost': ' olarak işaretlenecek.',
    'camera.returnLabelNotes': 'İade Notları (isteğe bağlı)',
    'camera.returnNotesPlaceholder': 'Onarım sonucu, yapılan işlemler, vb...',
    'camera.returnBtnReturn': 'İade Al & Çözümlendi',
    'camera.returnBtnProcessing': 'İşleniyor...',
    'camera.detailTitle': 'Arıza Detayları',
    'camera.detailImageCamera': 'Kamera Son Görüntüsü',
    'camera.detailImageFault': 'Arıza Fotoğrafı',
    'camera.detailSectionDevice': 'Cihaz Bilgileri',
    'camera.detailLabelCameraName': 'Kamera Adı:',
    'camera.detailLabelBrandModel': 'Marka/Model:',
    'camera.detailLabelIp': 'IP Adresi:',
    'camera.detailLabelNvr': 'NVR:',
    'camera.detailLabelChannel': 'Kanal:',
    'camera.detailSectionLocation': 'Lokasyon Bilgileri',
    'camera.detailLabelLocation': 'Lokasyon:',
    'camera.detailLabelArea': 'Bölge:',
    'camera.detailLabelAddress': 'Adres:',
    'camera.detailSectionFault': 'Arıza Bilgileri',
    'camera.detailLabelFaultType': 'Arıza Türü:',
    'camera.detailLabelStatus': 'Durum:',
    'camera.detailLabelReporter': 'Bildiren Kişi:',
    'camera.detailLabelReportDate': 'Bildirim Tarihi:',
    'camera.detailLabelNotes': 'Notlar:',
    'camera.detailSectionSupplier': 'Atanan Tedarikçi',
    'camera.detailLabelCompany': 'Firma Adı:',
    'camera.detailLabelContact': 'Yetkili Kişi:',
    'camera.detailLabelAssignDate': 'Atama Tarihi:',
    'camera.detailSectionConsignment': 'Konsinye Kamera Kayıtları',
    'camera.detailConsignmentActive': 'Aktif',
    'camera.detailConsignmentReturned': 'İade Edildi',
    'camera.detailLabelFaultyCamera': 'Arızalı Kamera:',
    'camera.detailLabelConsignmentCamera': 'Konsinye Kamera:',
    'camera.detailLabelInventory': 'Envanter No:',
    'camera.detailLabelPlacedAt': 'Bırakma Tarihi:',
    'camera.detailLabelReturnedAt': 'İade Tarihi:',
    'camera.detailLabelConsignNotes': 'Notlar:',
    'camera.detailLabelReturnNotes': 'İade Notları:',
    'camera.detailByName': '{name} tarafından',
    'camera.detailSectionSolution': 'Çözüm Bilgileri',
    'camera.detailLabelResolvedBy': 'Çözen Kişi/Firma:',
    'camera.detailLabelResolvedAt': 'Çözüm Tarihi:',
    'camera.detailLabelFaultDescLabel': 'Arıza Tanımı:',
    'camera.detailLabelSolutionDesc': 'Çözüm Açıklaması:',
    'camera.detailLabelAttachedFile': 'Eklenen Dosya:',
    'camera.detailSectionSupplierHistory': 'Tedarikçi İşlem Geçmişi',
    'camera.detailActionStatusUpdated': 'Durum Güncelleme',
    'camera.detailActionNoteAdded': 'Not Eklendi',
    'camera.detailActionFileUploaded': 'Dosya Yüklendi',
    'camera.detailLabelPerformedBy': 'İşlemi Yapan:',
    'camera.detailLabelStatusChange': 'Durum:',
    'camera.detailLabelDescription': 'Açıklama:',
    'camera.detailLabelSolution': 'Çözüm:',
    'camera.detailUnknown': 'Bilinmiyor',
    'camera.detailSectionLogs': 'Sistem Logları',
    'camera.detailSystem': 'Sistem',
    'camera.detailNoDetails': 'Detay bilgisi bulunamadı',
    'camera.confirmDelete': 'Bu arızayı silmek istediğinizden emin misiniz?',
    'camera.alertCameraNameRequired': 'Kamera adı ve arıza açıklaması zorunludur!',
    'camera.alertUpdated': 'Arıza güncellendi!',
    'camera.alertAdded': 'Arıza eklendi!',
    'camera.alertDeleted': 'Arıza silindi!',
    'camera.alertError': 'Hata oluştu!',
    'camera.alertDetailsError': 'Arıza detayları yüklenemedi',
    'camera.alertDetailsErrorLoad': 'Arıza detayları yüklenirken bir hata oluştu',
    'camera.alertSelectConsignment': 'Lütfen bir konsinye kamera seçin',
    'camera.alertConsignmentSaved': 'Konsinye kamera başarıyla kaydedildi',
    'camera.alertConsignmentError': 'Hata oluştu',
    'camera.alertConnectionError': 'Bağlantı hatası',
    'camera.alertReturnSuccess': 'Konsinye kamera iade alındı, arıza çözümlendi',
    'camera.alertSelectSupplier': 'Lütfen bir tedarikçi seçin',
    'camera.alertSupplierAssigned': 'Tedarikçi başarıyla atandı!',
    'camera.alertSupplierError': 'Tedarikçi ataması başarısız oldu!',
    'camera.alertSupplierAssignError': 'Tedarikçi atanırken bir hata oluştu!',
    'camera.excelCameraName': 'Kamera Adı',
    'camera.excelIpAddress': 'IP Adresi',
    'camera.excelLocation': 'Konum',
    'camera.excelFault': 'Arıza',
    'camera.excelStatus': 'Durum',
    'camera.excelDate': 'Bildirim Tarihi',
    'camera.excelReporter': 'Bildirimi Yapan',
    'camera.excelNotes': 'Notlar',
    'camera.excelSheet': 'Arızalar',
    // HandheldTerminalsPage
    'handheld.pageTitle': 'El Terminalleri Yönetimi',
    'handheld.pageSubtitle': 'El terminali envanteri ve yönetimi',
    'handheld.statTotal': 'Toplam El Terminali',
    'handheld.statActive': 'Aktif',
    'handheld.statPassive': 'Pasif',
    'handheld.statFaulty': 'Arızalı',
    'handheld.activeFilter': 'Aktif Filtre:',
    'handheld.filterActive': '🟢 Aktif',
    'handheld.filterPassive': '⚫ Pasif',
    'handheld.filterFaulty': '🔴 Arızalı',
    'handheld.searchPlaceholder': 'Ara...',
    'handheld.notFound': 'El terminali bulunamadı',
    'handheld.colOrder': 'Sıra',
    'handheld.colBrand': 'Marka',
    'handheld.colModel': 'Model',
    'handheld.colInventoryNo': 'Envanter No',
    'handheld.colSerialNo': 'Seri No',
    'handheld.colIpAddress': 'IP Adresi',
    'handheld.colMacAddress': 'MAC Adresi',
    'handheld.colAssignedUser': 'Atanan Kullanıcı',
    'handheld.colLocation': 'Lokasyon',
    'handheld.colStatus': 'Durumu',
    'handheld.colDepartment': 'Bölüm',
    'handheld.colActions': 'İşlemler',
    'handheld.prevPage': 'Önceki',
    'handheld.nextPage': 'Sonraki',
    'handheld.tooltipEdit': 'Düzenle',
    'handheld.tooltipCopy': 'Hızlı Kopyala',
    'handheld.tooltipPrintLabel': 'Etiket Yazdır',
    'handheld.tooltipHistory': 'Geçmiş',
    'handheld.tooltipDelete': 'Sil',
    'handheld.cardSerialNo': 'Seri No:',
    'handheld.cardUser': 'Kullanıcı:',
    'handheld.cardLocation': 'Lokasyon:',
    'handheld.cardStatus': 'Durumu:',
    'handheld.cardDepartment': 'Bölüm:',
    'handheld.cardEnv': 'Env:',
    'handheld.statusActive': 'Aktif',
    'handheld.statusPassive': 'Pasif',
    'handheld.statusFaulty': 'Arızalı',
    'handheld.btnNewTerminal': 'Yeni El Terminali',
    'handheld.btnNew': 'Yeni',
    'handheld.btnBulkLabel': 'Toplu Etiket',
    'handheld.btnLabel': 'Etiket',
    'handheld.modalTitleAdd': 'Yeni El Terminali',
    'handheld.modalTitleEdit': 'El Terminali Düzenle',
    'handheld.formBrand': 'Marka *',
    'handheld.formModel': 'Model *',
    'handheld.formInventoryNo': 'Envanter No',
    'handheld.formSerialNo': 'Seri No',
    'handheld.formIpAddress': 'IP Adresi',
    'handheld.formMacAddress': 'MAC Adresi',
    'handheld.formLocation': 'Lokasyon *',
    'handheld.formAssignedUser': 'Atanan Kullanıcı',
    'handheld.formDepartment': 'Bölüm',
    'handheld.formStatus': 'Durumu *',
    'handheld.formFaultDetails': 'Arıza Detayı',
    'handheld.formLocationPlaceholder': 'Lokasyon Seçin',
    'handheld.formUserPlaceholder': 'Kullanıcı Seçin',
    'handheld.formDeptPlaceholder': 'Örn: Depo, Lojistik, Üretim',
    'handheld.formFaultPlaceholder': 'Arıza detaylarını açıklayınız...',
    'handheld.formStatusActive': 'Aktif',
    'handheld.formStatusPassive': 'Pasif',
    'handheld.formStatusFaulty': 'Arızalı',
    'handheld.faultRequiredWarning': 'Durumu "Arızalı" olarak seçerseniz arıza detayı zorunludur.',
    'handheld.btnCancel': 'İptal',
    'handheld.btnUpdate': 'Güncelle',
    'handheld.btnCreate': 'Oluştur',
    'handheld.historyTitle': 'Geçmiş',
    'handheld.historyLoading': 'Geçmiş yükleniyor...',
    'handheld.historyEmpty': 'Bu terminal için geçmiş kaydı yoktur.',
    'handheld.historyActionCreate': '🆕 Oluşturuldu',
    'handheld.historyActionUpdate': '✏️ Güncellendi',
    'handheld.historyActionDelete': '🗑️ Silindi',
    'handheld.historyActionAssign': '👤 Atandı',
    'handheld.historyActionUnassign': '👥 Ataması Kaldırıldı',
    'handheld.historyField': 'Alan:',
    'handheld.historyOldValue': 'Eski Değer:',
    'handheld.historyNewValue': 'Yeni Değer:',
    'handheld.historyChangedBy': 'Kullanıcı:',
    'handheld.historySystem': 'Sistem',
    'handheld.labelModalTitle': 'Toplu Etiket Yazdırma',
    'handheld.labelSize': 'Etiket Boyutu',
    'handheld.labelSizeInfoPre': 'Seçili boyut:',
    'handheld.labelSizeInfoMid': 'etiket/sayfa -',
    'handheld.labelSizeInfoSuffix': 'yönlendirme',
    'handheld.labelLandscape': 'Yatay',
    'handheld.labelPortrait': 'Dikey',
    'handheld.labelSelectionTitle': 'El Terminali Seçimi',
    'handheld.labelSelectionSelected': 'seçili',
    'handheld.labelSelectAll': 'Tümünü Seç',
    'handheld.labelDeselectAll': 'Seçimi Temizle',
    'handheld.labelPreviewBtn': 'Önizleme',
    'handheld.labelPreviewTitle': 'Etiket Önizlemesi',
    'handheld.labelPreviewItems': 'adet',
    'handheld.labelPreviewPages': 'sayfa',
    'handheld.labelPreviewPerPage': 'sayfa başına',
    'handheld.labelPreviewLabels': 'etiket',
    'handheld.labelBack': 'Geri',
    'handheld.labelPrint': 'Yazdır',
    'handheld.singleLabelTitle': 'Etiket Yazdır',
    'handheld.singleLabelInventoryNo': 'Envanter No:',
    'handheld.singleLabelSerialNo': 'Seri No:',
    'handheld.singleLabelLocation': 'Lokasyon:',
    'handheld.singleLabelPerPage': 'etiket/sayfa -',
    'handheld.labelSizeLandscape6': 'Yatay - 6 Etiket/Sayfa (90x90mm)',
    'handheld.labelSizePortrait24': 'Dikey - 24 Etiket/Sayfa (70x37mm)',
    'handheld.labelSizePortrait16': 'Dikey - 16 Etiket/Sayfa (99x34mm)',
    'handheld.labelSizePortrait12': 'Dikey - 12 Etiket/Sayfa (105x48mm)',
    'handheld.labelSizePortrait4': 'Dikey - 4 Etiket/Sayfa (105x148mm - A6)',
    'handheld.labelHTMLTitle': 'El Terminali Etiketleri',
    'handheld.pdfTitle': 'El Terminalleri Listesi',
    'handheld.pdfReportDate': 'Rapor Tarihi:',
    'handheld.pdfTotalTerminals': 'Toplam El Terminali:',
    'handheld.pdfColOrder': 'Sıra',
    'handheld.pdfColBrand': 'Marka',
    'handheld.pdfColModel': 'Model',
    'handheld.pdfColInventoryNo': 'Envanter No',
    'handheld.pdfColSerialNo': 'Seri No',
    'handheld.pdfColIpAddress': 'IP Adresi',
    'handheld.pdfColMacAddress': 'MAC Adresi',
    'handheld.pdfColAssignedUser': 'Atanan Kullanıcı',
    'handheld.pdfColLocation': 'Lokasyon',
    'handheld.pdfColDepartment': 'Bölüm',
    'handheld.excelColOrder': 'Sıra No',
    'handheld.excelColBrand': 'Marka',
    'handheld.excelColModel': 'Model',
    'handheld.excelColInventoryNo': 'Envanter No',
    'handheld.excelColSerialNo': 'Seri No',
    'handheld.excelColIpAddress': 'IP Adresi',
    'handheld.excelColMacAddress': 'MAC Adresi',
    'handheld.excelColAssignedUser': 'Atanan Kullanıcı',
    'handheld.excelColLocation': 'Lokasyon',
    'handheld.excelColStatus': 'Durumu',
    'handheld.excelColFaultDetails': 'Arıza Detayı',
    'handheld.excelColDepartment': 'Bölüm',
    'handheld.excelColCreatedAt': 'Oluşturulma Tarihi',
    'handheld.excelSheet': 'El Terminalleri',
    'handheld.invalidIpFormat': 'Geçersiz IP adresi formatı',
    'handheld.invalidMacFormat': 'Geçersiz MAC adresi formatı (Format: XX:XX:XX:XX:XX:XX veya XX-XX-XX-XX-XX-XX)',
    'handheld.ipAlreadyUsed': 'Bu IP adresi zaten kullanılıyor',
    'handheld.macAlreadyUsed': 'Bu MAC adresi zaten kullanılıyor',
    'handheld.notifLoadError': 'Veriler yüklenirken hata oluştu',
    'handheld.notifBrandModelRequired': 'Marka ve Model zorunludur',
    'handheld.notifInvalidIp': 'Geçerli bir IP adresi giriniz',
    'handheld.notifInvalidMac': 'Geçerli bir MAC adresi giriniz (Format: XX:XX:XX:XX:XX:XX)',
    'handheld.notifFixConflicts': 'Lütfen çakışan alanları düzeltin',
    'handheld.notifSelectLocation': 'Lokasyon seçiniz',
    'handheld.notifFaultRequired': 'Durumu "Arızalı" olarak seçerseniz arıza detayı zorunludur',
    'handheld.notifUpdated': 'El terminali güncellendi',
    'handheld.notifCreated': 'El terminali oluşturuldu',
    'handheld.notifSaveError': 'El terminali kaydedilirken hata oluştu',
    'handheld.notifDeleted': 'El terminali silindi',
    'handheld.notifDeleteError': 'El terminali silinirken hata oluştu',
    'handheld.notifCopied': 'El terminali bilgileri kopyalandı. Envanter No, Seri No, IP ve MAC adresini düzenleyip kaydedin.',
    'handheld.notifExcelSuccess': 'el terminali başarıyla Excel\'e aktarıldı',
    'handheld.notifExcelError': 'Excel dosyası oluşturulurken hata oluştu',
    'handheld.notifHistoryError': 'Terminal geçmişi yüklenirken hata oluştu',
    'handheld.notifLabelError': 'Etiket yazdırılırken hata oluştu',
    'handheld.notifPdfSuccess': 'el terminali başarıyla PDF\'e aktarıldı',
    'handheld.notifPdfError': 'PDF dosyası oluşturulurken hata oluştu',
    'handheld.confirmDeleteSuffix': 'el terminalini silmek istediğinizden emin misiniz?',
    // OrdersPage
    'order.pageTitle': 'Siparişler',
    'order.pageSubtitle': 'Sipariş takibi ve yönetimi',
    'order.newOrder': 'Yeni Sipariş',
    'order.noPermission': 'Bu işlem için yetkiniz yok',
    'order.statAll': 'Tüm Siparişler',
    'order.statNew': 'Yeni Siparişler',
    'order.statInvoicePending': 'Fatura Onayı Bekleyen',
    'order.statCancelled': 'İptal Edildi',
    'order.statCompleted': 'Tamamlanan Siparişler',
    'order.statMine': 'Benim Siparişlerim',
    'order.exchangeTitle': 'TCMB Güncel Kurları',
    'order.exchangeLastUpdate': 'Son güncelleme:',
    'order.exchangeLoading': 'Kurlar yükleniyor...',
    'order.exchangeRefresh': '🔄 Yenile',
    'order.exchangeLastUpdateLabel': 'Son Güncelleme',
    'order.searchPlaceholder': 'Sipariş no, kullanıcı adı, beam no, kalem adı ile ara...',
    'order.filterAll': 'Tüm Durumlar',
    'order.colOrderNo': 'Sipariş No',
    'order.colCompany': 'Şirket',
    'order.colLocation': 'Lokasyon',
    'order.colOpenedBy': 'Siparişi Açan',
    'order.colCategory': 'Kategori',
    'order.colAmount': 'Tutar(KDV hariç)',
    'order.colStatus': 'Durum',
    'order.colDate': 'Tarih',
    'order.colActions': 'İşlemler',
    'order.emptyTitle': 'Sipariş bulunamadı',
    'order.emptyText': 'Arama kriterlerinizi değiştirmeyi deneyin.',
    'order.paginationPrev': 'Önceki',
    'order.paginationNext': 'Sonraki',
    'order.detailsTooltip': 'Detayları Görüntüle',
    'order.statusCreated': 'Sipariş Oluşturuldu',
    'order.statusPending': 'Beklemede',
    'order.statusOrdered': 'Sipariş Verildi',
    'order.statusDelivered': 'Teslim Edildi',
    'order.statusInvoiceUploaded': 'Fatura Yüklendi',
    'order.statusInvoiceApproved': 'Fatura Onaylandı',
    'order.statusCompleted': 'Tamamlandı',
    'order.statusCancelled': 'İptal Edildi',
    'order.priorityLow': 'Düşük',
    'order.priorityNormal': 'Normal',
    'order.priorityHigh': 'Yüksek',
    'order.priorityUrgent': 'Acil',
    'order.catComputer': 'Bilgisayar',
    'order.catPhone': 'Telefon',
    'order.catEquipment': 'Ekipman',
    'order.catConsumables': 'Sarf Malzeme',
    'order.catElectronics': 'Elektronik',
    'order.catSwitch': 'Switch',
    'order.catServer': 'Server',
    'order.catMaintenance': 'Bakım',
    'order.catCamera': 'Kamera Sistemi',
    'order.catSound': 'Ses Sistemi',
    'order.catMonitor': 'Monitör',
    'order.catHandheld': 'El Terminali',
    'order.catRadio': 'Telsiz',
    'order.modalEditTitle': 'Sipariş Düzenle',
    'order.modalNewTitle': 'Yeni Sipariş',
    'order.alertEditBlockedTitle': 'Düzenleme Engellendi',
    'order.alertEditBlockedText': 'Fatura onayı verilmiş siparişler düzenlenemez. Tüm alanlar salt okunur durumdadır.',
    'order.formOrderNo': 'Toolbox Sipariş Numarası *',
    'order.formOrderNoAuto': 'Otomatik olarak müsait olan numara atandı',
    'order.formBeamOrderNo': 'ERP Sipariş No',
    'order.formBeamOrderNoTooltip': 'Beam Sipariş Numarası',
    'order.formTicketNo': 'Ticket Numarası *',
    'order.formCompany': 'Şirket *',
    'order.formLocation': 'Lokasyon *',
    'order.formCategory': 'Kategori *',
    'order.formStatus': 'Durum *',
    'order.formSupplier': 'Tedarikçi',
    'order.formCapex': 'CAPEX Bilgisi',
    'order.formDeliveryDate': 'Teslim Tarihi',
    'order.formDescription': 'Sipariş Açıklaması *',
    'order.formDescPlaceholder': 'Sipariş detaylarını açıklayın...',
    'order.formNotes': 'Notlar',
    'order.formNotesPlaceholder': 'Ek notlar...',
    'order.selectCompany': 'Şirket seçin',
    'order.selectLocation': 'Lokasyon seçin',
    'order.selectSupplier': 'Tedarikçi seçin',
    'order.selectCapex': 'CAPEX seçin',
    'order.capexUsed': 'Kullanılan CAPEX:',
    'order.capexCategory': 'Kategori:',
    'order.capexImmutableWarning': '⚠️ Sipariş oluşturulduktan sonra CAPEX değiştirilemez',
    'order.capexNone': 'Bu sipariş için CAPEX kullanılmamış',
    'order.useCapex': 'CAPEX kullanılacak mı?',
    'order.capexSelected': 'Seçilen CAPEX:',
    'order.capexAvailable': 'Kullanılabilir Tutar:',
    'order.capexTotal': 'Toplam:',
    'order.capexUsedAmount': 'Kullanılan:',
    'order.capexBlocked': 'Bloke:',
    'order.itemsTitle': 'Sipariş Kalemleri *',
    'order.currency': 'Para Birimi:',
    'order.addItem': 'Kalem Ekle',
    'order.itemN': 'Kalem',
    'order.immutable': 'Değiştirilemez',
    'order.itemName': 'Sipariş Adı *',
    'order.itemQty': 'Adet *',
    'order.itemUnitPrice': 'Birim Fiyat *',
    'order.itemVat': 'KDV Oranı (%)',
    'order.exclVat': 'KDV Hariç:',
    'order.plusVat': '+ KDV',
    'order.totalWithVat': 'Toplam KDV Dahil Tutar:',
    'order.vatInfo': 'Bilgi: KDV dahil tutar sadece bilgi amaçlıdır. CAPEX\'ten KDV hariç tutar düşecektir.',
    'order.exchangeRatesLabel': '💱 Güncel Kurlar:',
    'order.capexCheck': 'CAPEX Kontrol:',
    'order.capexInsufficient': '⚠️ CAPEX yetersiz!',
    'order.notCurrentRate': 'Güncel değil',
    'order.invoiceTitle': 'Fatura Yükleme',
    'order.invoiceUploaded': 'Fatura yüklendi',
    'order.invoiceView': 'Görüntüle',
    'order.invoiceDelete': 'Sil',
    'order.invoiceUploadedBy': 'Yükleyen:',
    'order.invoiceApprove': 'Faturayı Onayla',
    'order.invoiceSelectBtn': 'Fatura Seç',
    'order.invoiceFileTypes': 'PDF, JPG, PNG (Max 10MB)',
    'order.invoiceNeedDelivered': '⚠️ Fatura yüklemek için sipariş durumu "Teslim Edildi" olmalıdır.',
    'order.statusNeedsInvoice': ' (Fatura gerekli)',
    'order.statusNoReturn': ' (Geriye dönüş yok)',
    'order.statusAutoSet': ' (Otomatik ayarlanır)',
    'order.statusNeedsInvoiceFirst': '⚠️ Bu durumu seçmek için önce fatura yüklemeniz gerekir',
    'order.confirmDeleteInvoice': 'Faturayı silmek istediğinizden emin misiniz?',
    'order.invoiceApprovalTitle': 'Fatura Onay Bilgisi',
    'order.invoiceApprovedLabel': 'Fatura kullanıcı tarafından onaylandı',
    'order.invoiceAutoCompletedLabel': 'Sipariş otomatik tamamlandı',
    'order.invoiceOrderStatus': 'Durum:',
    'order.invoiceOrderAmount': 'Sipariş tutarı:',
    'order.invoiceInvoiceAmount': 'Fatura tutarı:',
    'order.invoiceCapexRefund': 'CAPEX iadesi:',
    'order.btnClose': 'Kapat',
    'order.btnCancel': 'İptal',
    'order.btnUpdate': 'Güncelle',
    'order.btnSave': 'Kaydet',
    'order.detailTitle': 'Sipariş Detayları',
    'order.detailOrderInfo': 'Sipariş Bilgileri',
    'order.detailOrderNo': 'Sipariş No:',
    'order.detailTicketNo': 'Ticket No:',
    'order.detailCategory': 'Kategori:',
    'order.detailTotal': 'Toplam Tutar:',
    'order.detailStatus': 'Durum:',
    'order.detailPriority': 'Öncelik:',
    'order.detailContactInfo': 'İletişim Bilgileri',
    'order.detailCompany': 'Şirket:',
    'order.detailLocation': 'Lokasyon:',
    'order.detailOrderer': 'Sipariş Veren:',
    'order.detailSupplier': 'Tedarikçi:',
    'order.detailCapex': 'CAPEX:',
    'order.detailDescription': 'Sipariş Açıklaması',
    'order.detailNotes': 'Notlar',
    'order.detailInvoice': 'Fatura',
    'order.detailInvoiceAvailable': 'Fatura mevcut',
    'order.detailView': 'Görüntüle',
    'order.activityTitle': 'Aktivite Geçmişi',
    'order.activitySystem': 'Sistem',
    'order.activityEmpty': 'Henüz aktivite kaydı bulunmuyor',
    'order.detailCreatedAt': 'Oluşturulma:',
    'order.detailUpdatedAt': 'Son Güncelleme:',
    'order.today': 'Bugün',
    'order.yesterday': 'Dün',
    'order.daysAgo': 'gün önce',
    'order.searching': 'Aranıyor...',
    'order.clickToAdd': 'Tıkla ekle',
    'order.priceCompare': 'Fiyat Karşılaştırma',
    'order.priceResultsN': 'sonuç bulundu',
    'order.priceNoResults': 'Sonuç bulunamadı',
    'order.priceSearchOn': 'Sitelerde ara:',
    'order.priceSearch': 'Online fiyat ara',
    'order.swalEditBlockedTitle': 'Düzenleme Engellendi',
    'order.swalEditBlockedText': 'Fatura onaylanan siparişler düzenlenemez',
    'order.swalInvoiceTitle': 'Fatura Onayı',
    'order.swalInvoiceText': 'siparişi için gelen fatura tutarını girin.',
    'order.swalInvoiceAmountLabel': 'Fatura Tutarı (KDV Hariç)',
    'order.swalInvoiceCurrencyLabel': 'Para Birimi',
    'order.swalInvoiceEurLabel': 'Fatura EUR karşılığı (anlık kur):',
    'order.swalCapexRefundLabel': 'CAPEX iadesi (tahmini):',
    'order.swalInvoiceFootnote': 'Fatura tutarı sipariş kaydına işlenir.',
    'order.swalInvoiceFootnoteCapex': ' Fatura EUR karşılığı anlık kur ile hesaplanır; CAPEX farkı otomatik iade edilir.',
    'order.swalCapexInfoTitle': 'CAPEX Bilgisi —',
    'order.swalCapexOrderAmount': 'Sipariş açılış tutarı:',
    'order.swalCapexDeducted': 'CAPEX\'ten kesilen (sipariş kuru):',
    'order.swalCapexCurrentRate': 'Anlık kur:',
    'order.swalCapexWarning': '⚠ CAPEX\'e bağlı sipariş — fark varsa otomatik iade edilecek',
    'order.swalValidAmount': 'Geçerli bir fatura tutarı girin',
    'order.swalInvoiceUploadedTitle': 'Fatura Yüklendi',
    'order.swalInvoiceUploadedText': 'Faturayı hemen onaylamak istiyor musunuz?',
    'order.swalInvoiceApproveYes': 'Evet, Onayla',
    'order.swalInvoiceApproveNo': 'Hayır, Sonra',
    'order.swalUpdateBlockedTitle': 'Güncelleme Engellendi',
    'order.swalUpdateBlockedText': 'Fatura onaylanan siparişler düzenlenemez',
    'order.swalCapexRequiredTitle': 'CAPEX Seçimi Zorunlu',
    'order.swalCapexRequiredAmountLabel': 'Sipariş Tutarı (KDV Hariç):',
    'order.swalCapexRequiredLimitLabel': 'CAPEX Limiti:',
    'order.swalCapexRequiredLimitSuffix': 'USD ve üzeri',
    'order.swalCapexRequiredMsg': 'Bu sipariş tutarı (KDV hariç)',
    'order.swalCapexRequiredMsg2': 'USD limitinin üzerinde olduğu için CAPEX seçimi zorunludur.',
    'order.swalCapexRequiredRetry': 'Lütfen bir CAPEX seçerek tekrar deneyin.',
    'order.swalDeleteTitle': 'Sipariş Silme Onayı',
    'order.swalDeleteOrderNo': 'Sipariş No:',
    'order.swalDeleteCompany': 'Şirket:',
    'order.swalDeleteAmount': 'Tutar:',
    'order.swalDeleteInvoiceWarn': '⚠️ Fatura dosyası da silinecek!',
    'order.swalDeleteIrreversible': 'Bu işlem geri alınamaz!',
    'order.swalDeleteYes': 'Evet, Sil',
    'order.swalDeletedTitle': 'Silindi!',
    'order.swalDeletedText': 'siparişi başarıyla silindi.',
    'order.swalErrorTitle': 'Hata!',
    'order.swalOk': 'Tamam',
    'order.swalCancel': 'İptal',
    'order.swalApprove': 'Onayla',
    'order.notifExchangeUpdated': 'TCMB Kurları Güncellendi',
    'order.notifExchangeError': 'Kur Güncelleme Hatası',
    'order.notifLoadError': 'Veriler yüklenirken hata oluştu',
    'order.notifMinSearch': 'Fiyat araması için en az 3 karakter giriniz',
    'order.notifPriceSearchError': 'Fiyat araması yapılırken bir hata oluştu',
    'order.notifRequiredFields': 'Zorunlu alanları doldurunuz',
    'order.notifCapexUnavailable': 'CAPEX Kullanılamaz',
    'order.notifCapexUnavailableMsg': 'Seçilen CAPEX\'te kullanılabilir limit bulunmuyor. Lütfen başka bir CAPEX seçin.',
    'order.notifCapexInsufficient': 'CAPEX Yetersiz',
    'order.notifUpdated': 'Sipariş güncellendi',
    'order.notifCreated': 'Sipariş oluşturuldu',
    'order.notifInvoiceApproved': 'Fatura onaylandı ve sipariş tamamlandı',
    'order.notifInvoiceCapexRefunded': 'iade edildi.',
    'order.notifInvoiceUploaded': 'Fatura yüklendi. Onay için daha sonra işlem yapabilirsiniz.',
    'order.notifStatusAutoSet': 'Tamamlandı durumu yalnızca fatura yüklendikten sonra otomatik olarak ayarlanır!',
    'order.notifNeedInvoiceFirst': 'Fatura onaylamak için önce fatura yüklemeniz gerekir!',
    'order.notifInvoiceDeleted': 'Fatura silindi',
    'order.notifSaveError': 'Sipariş kaydedilirken hata oluştu',
    'order.notifInvoiceError': 'Fatura yüklenirken hata oluştu',
    'order.notifInvoiceDeleteError': 'Fatura silinirken hata oluştu',
    'order.notifInvoiceApproveError': 'Fatura onaylanırken hata oluştu',
    'order.notifFileTypeError': 'Sadece PDF veya resim dosyaları (JPG, PNG) yükleyebilirsiniz!',
    'order.notifFileSizeError': 'Dosya boyutu 50MB\'dan küçük olmalıdır!',
    'order.notifSuccess': 'Başarılı',
    'order.notifError': 'Hata',
    'order.notifWarning': 'Uyarı',
    // ComputersPage
    'computer.pageTitle': 'Bilgisayar Yönetimi',
    'computer.totalCount': 'bilgisayar kayıtlı',
    'computer.locationStats': 'Lokasyonlara Göre',
    'computer.clearFilter': 'Filtreyi Temizle',
    'computer.filterActive': 'Filtre aktif',
    'computer.ageStats': 'Yaşa Göre (5 Yıl Takibi)',
    'computer.over5years': '5 Yılını Doldurmuş',
    'computer.renewalRecommended': 'Yenileme önerilir',
    'computer.near5years': '3 Ay İçinde 5 Yılını Dolduracak',
    'computer.nearRenewal': 'Yakında yenileme gerekebilir',
    'computer.searchPlaceholder': 'Envanter no, marka, model, seri no veya kullanıcı ara...',
    'computer.allStatuses': 'Tüm Durumlar',
    'computer.allCompanies': 'Tüm Şirketler',
    'computer.newComputer': 'Yeni Bilgisayar',
    'computer.brandManagement': 'Marka Yönetimi',
    'computer.modelManagement': 'Model Yönetimi',
    'computer.excelDownload': 'Excel İndir',
    'computer.scrapComputers': 'Hurda Bilgisayarlar',
    'computer.colInventoryNo': 'Envanter No',
    'computer.colBrandModel': 'Marka/Model',
    'computer.colSerialNo': 'Seri No',
    'computer.colSpecs': 'Özellikler',
    'computer.colCompanyLocation': 'Şirket/Lokasyon',
    'computer.colAssignedUser': 'Atanan Kullanıcı',
    'computer.storage': 'Depolama',
    'computer.notAssigned': 'Atanmamış',
    'computer.titleHistory': 'Geçmişi Görüntüle',
    'computer.titleUnassign': 'Atamayı Kaldır',
    'computer.titleAssign': 'Kullanıcıya Ata',
    'computer.titleQR': 'QR Kod Etiketi',
    'computer.titleCopy': 'Hızlı Kopyala',
    'computer.paginationInfo': 'kayıttan',
    'computer.paginationShowing': 'arası gösteriliyor',
    'computer.firstPage': 'İlk Sayfa',
    'computer.lastPage': 'Son Sayfa',
    'computer.prevPage': 'Önceki Sayfa',
    'computer.nextPage': 'Sonraki Sayfa',
    'computer.modalTitleEdit': 'Bilgisayar Düzenle',
    'computer.modalTitleAdd': 'Yeni Bilgisayar Ekle',
    'computer.fieldInventoryNo': 'Envanter No *',
    'computer.fieldSerialNo': 'Seri No *',
    'computer.fieldBrand': 'Marka *',
    'computer.fieldModel': 'Model *',
    'computer.fieldProcessor': 'İşlemci',
    'computer.fieldProcessorPlaceholder': 'Modelden otomatik gelir...',
    'computer.fieldAutoFill': 'Model seçildiğinde otomatik doldurulur',
    'computer.fieldGraphicsCard': 'Ekran Kartı',
    'computer.fieldStorageCapacity': 'Depolama Alanı',
    'computer.fieldStorageType': 'Depolama Tipi',
    'computer.fieldRAM': 'RAM',
    'computer.fieldProSupport': 'Dell Pro Support Aktif',
    'computer.fieldProSupportEnd': 'Pro Support Bitiş Tarihi',
    'computer.fieldPurchaseDate': 'Alım Tarihi',
    'computer.fieldWarrantyEnd': 'Garanti Bitiş Tarihi',
    'computer.fieldInvoice': 'Fatura (İsteğe Bağlı)',
    'computer.invoiceExists': 'Mevcut fatura yüklü',
    'computer.invoiceView': 'Görüntüle/İndir',
    'computer.invoiceFileHint': 'PDF veya resim dosyası (Maks. 10MB)',
    'computer.fieldCompany': 'Şirket',
    'computer.fieldLocation': 'Lokasyon',
    'computer.fieldNotes': 'Notlar',
    'computer.selectPlaceholder': 'Seçiniz...',
    'computer.update': 'Güncelle',
    'computer.brandModalTitleEdit': 'Marka Düzenle',
    'computer.brandModalTitleAdd': 'Yeni Marka Ekle',
    'computer.fieldBrandName': 'Marka Adı *',
    'computer.fieldLogo': 'Logo',
    'computer.fieldActive': 'Aktif',
    'computer.existingBrands': 'Mevcut Markalar',
    'computer.assignTitle': 'Kullanıcıya Ata',
    'computer.userSearchPlaceholder': 'Kullanıcı ara (isim veya e-posta)...',
    'computer.selectUser': 'Kullanıcı seçiniz...',
    'computer.assignWithForm': 'Zimmet Formu ile Ata',
    'computer.assignFormTitle': 'Zimmet Teslim Formu Oluştur',
    'computer.labelComputer': 'Bilgisayar:',
    'computer.labelUser': 'Kullanıcı:',
    'computer.formNotesOptional': 'Notlar (İsteğe Bağlı)',
    'computer.assignFormNotesPlaceholder': 'Zimmet teslim formu için notlar...',
    'computer.assignWithoutForm': 'Form Olmadan Ata',
    'computer.unassignFormTitle': 'Zimmet Geri Teslim Formu Oluştur',
    'computer.devicePhotos': 'Cihaz Fotoğrafları (En fazla 4 adet)',
    'computer.unassignFormNotesPlaceholder': 'Zimmet geri teslim formu için notlar...',
    'computer.unassignWithForm': 'Geri Zimmet Formu ile',
    'computer.unassignWithoutForm': 'Form Olmadan',
    'computer.scrapFormTitle': 'Hurda Cihaz Bilgi Formu',
    'computer.scrapStep1': 'Cihaz Bilgileri',
    'computer.scrapStep2': 'Teknik Durum',
    'computer.scrapStep3': 'Hurdaya Ayırma Nedeni',
    'computer.scrapStep4': 'Veri Güvenliği',
    'computer.scrapStep5': 'Fotoğraflar',
    'computer.scrapStep1Title': 'Cihaz Kimlik Bilgileri',
    'computer.scrapFieldDeviceType': 'Cihaz Türü',
    'computer.scrapFieldPreviousUser': 'Önceki Kullanıcı',
    'computer.scrapStep2Title': 'Teknik Donanım Durumu',
    'computer.scrapColPart': 'Parça',
    'computer.scrapColStatus': 'Durum',
    'computer.scrapColDetail': 'Detay',
    'computer.scrapColSparePart': 'Yedek Parça?',
    'computer.scrapPartCPU': 'İşlemci (CPU)',
    'computer.scrapPartRAM': 'Bellek (RAM)',
    'computer.scrapPartStorage': 'Depolama (Disk)',
    'computer.scrapPartScreen': 'Ekran/Panel',
    'computer.scrapPartMotherboard': 'Anakart',
    'computer.scrapPartBattery': 'Batarya',
    'computer.scrapPartAdapter': 'Adaptör',
    'computer.scrapPartCase': 'Kasa Kondisyonu',
    'computer.scrapPartKeyboard': 'Klavye/Mousepad',
    'computer.scrapPartPorts': 'Portlar (USB/HDMI)',
    'computer.scrapOptExists': 'Var',
    'computer.scrapOptMissing': 'Yok',
    'computer.scrapOptRemoved': 'Söküldü',
    'computer.scrapOptGood': 'İyi',
    'computer.scrapOptBroken': 'Kırık',
    'computer.scrapOptDeadPixel': 'Ölü Piksel',
    'computer.scrapOptStain': 'Lekeli',
    'computer.scrapOptNA': 'N/A',
    'computer.scrapOptWorking': 'Çalışıyor',
    'computer.scrapOptFaulty': 'Arızalı',
    'computer.scrapOptShortCircuit': 'Kısa Devre',
    'computer.scrapOptSwollen': 'Şişmiş',
    'computer.scrapOptNotCharging': 'Şarj Tutmuyor',
    'computer.scrapOptIncomplete': 'Eksik',
    'computer.scrapOptOxidized': 'Oksitlenmiş',
    'computer.scrapStep3Title': 'Hurdaya Ayırma Nedeni',
    'computer.scrapReasonPhysical': 'Fiziksel Hasar (Kırılma, sıvı teması)',
    'computer.scrapReasonObsolete': 'Teknolojik Eskime (Miadını doldurmuş)',
    'computer.scrapReasonRepairCost': 'Ekonomik Tamir Sınırı (Tamir masrafı değerinden yüksek)',
    'computer.scrapReasonParts': 'Parçası Tedarik Edilemiyor',
    'computer.scrapReasonOther': 'Diğer',
    'computer.scrapReasonDetailLabel': 'Açıklama (Detaylı)',
    'computer.scrapReasonDetailPlaceholder': 'Hurdaya ayırma nedenini detaylı açıklayın...',
    'computer.scrapStep4Title': 'Veri Güvenliği ve İmha (KVKK)',
    'computer.scrapDiskRemoved': 'Disk Söküldü',
    'computer.scrapDataWipeMethod': 'Veri Silme Yöntemi',
    'computer.scrapWipeNA': 'Uygulanmadı / N/A',
    'computer.scrapWipeSoftware': 'Yazılımsal Wipe',
    'computer.scrapWipePhysical': 'Fiziksel Delme',
    'computer.scrapWipeDegauss': 'Degauss',
    'computer.scrapWipeNot': 'İmha Edilmedi',
    'computer.scrapMediaCheck': 'SD Kart / Optik Medya Kontrolü Yapıldı (Unutulmuş kart veya CD yok)',
    'computer.scrapDataSecurityNote': 'Veri Güvenliği Notu',
    'computer.scrapDataSecurityPlaceholder': 'Varsa ek notlar...',
    'computer.scrapStep5Title': 'Fotoğraflar',
    'computer.scrapPhotosHint': 'Cihazın genel durumu, hasarlı bölgeler ve etiketlerin fotoğraflarını ekleyin (Maks. 5 adet)',
    'computer.scrapUploadClick': 'Fotoğraf yüklemek için tıklayın',
    'computer.scrapSubmit': 'Hurdaya Ayır',
    'computer.scrapProcessing': 'İşleniyor...',
    'computer.historyTitle': 'Bilgisayar Geçmişi',
    'computer.historyPerformedBy': 'İşlemi Yapan:',
    'computer.historyAssignedUser': 'Atanan Kullanıcı:',
    'computer.historyChanges': 'Değişiklikler:',
    'computer.historyNoData': 'Bu bilgisayar için geçmiş kaydı bulunamadı',
    'computer.actionCreated': 'Oluşturuldu',
    'computer.actionUpdated': 'Güncellendi',
    'computer.actionAssigned': 'Atandı',
    'computer.actionUnassigned': 'Atama Kaldırıldı',
    'computer.actionDeleted': 'Silindi',
    'computer.statusActive': 'Aktif',
    'computer.statusInactive': 'Pasif',
    'computer.statusRepair': 'Onarımda',
    'computer.statusDamaged': 'Arızalı',
    'computer.statusRetired': 'Kullanım Dışı',
    'computer.statusScrapped': 'Hurda',
    'computer.notifLoadError': 'Veriler yüklenirken hata oluştu',
    'computer.notifRequiredFields': 'Envanter No, Marka, Model ve Seri No alanları zorunludur',
    'computer.notifSaveSuccess': 'Bilgisayar eklendi',
    'computer.notifUpdateSuccess': 'Bilgisayar güncellendi',
    'computer.notifDeleteSuccess': 'Bilgisayar silindi',
    'computer.notifDeleteFail': 'Silme işlemi başarısız',
    'computer.notifAssignFormCreated': 'Zimmet teslim formu oluşturuldu',
    'computer.notifAssignWithFormSuccess': 'Zimmet formu oluşturuldu. Formu PDF olarak oluşturup zimmetleme işlemini tamamlayabilirsiniz.',
    'computer.notifAssignSuccess': 'Bilgisayar kullanıcıya atandı',
    'computer.notifAssignFail': 'Atama işlemi başarısız',
    'computer.notifAssignError': 'Atama işlemi sırasında bir hata oluştu',
    'computer.notifReturnFormCreated': 'Geri zimmet formu oluşturuldu. Formu PDF olarak oluşturup geri teslim işlemini tamamlayabilirsiniz.',
    'computer.notifReturnFormError': 'Geri zimmet formu oluşturma sırasında bir hata oluştu',
    'computer.notifUnassignSuccess': 'Atama kaldırıldı',
    'computer.notifBrandRequired': 'Marka adı zorunludur',
    'computer.notifBrandSaved': 'Marka eklendi',
    'computer.notifBrandUpdated': 'Marka güncellendi',
    'computer.notifBrandDeleted': 'Marka silindi',
    'computer.notifHistoryLoadFail': 'Geçmiş yüklenemedi',
    'computer.notifHistoryLoadError': 'Geçmiş yüklenirken bir hata oluştu',
    'computer.notifScrapSuccess': 'Bilgisayar hurdaya ayrıldı. Form No: ',
    'computer.confirmDelete': 'Bu bilgisayarı silmek istediğinizden emin misiniz?',
    'computer.confirmDeleteBrand': 'Bu markayı silmek istediğinizden emin misiniz?',
    'computer.excelSheetName': 'Bilgisayarlar',
    'computer.excelFileName': 'bilgisayarlar',
    // TechnicalServicePage
    'techservice.pageTitle': 'Teknik Servis',
    'techservice.pageSubtitle': 'Arızalı cihazları kaydedin ve takip edin',
    'techservice.addNew': 'Yeni Servis Kaydı',
    'techservice.statusCreated': 'Servis Kaydı Oluşturuldu',
    'techservice.statusSent': 'Teknik Servise Gönderildi',
    'techservice.statusProcessing': 'İşleme Alındı',
    'techservice.statusQuoteUploaded': 'Tedarikçi Teklif Yükledi',
    'techservice.statusOrderCreated': 'Sipariş Oluşturuldu',
    'techservice.statusRepairedSent': 'Onarıldı ve Gönderildi',
    'techservice.statusCompleted': 'Tamamlandı',
    'techservice.statusCancelled': 'İptal Edildi',
    'techservice.statusRejected': 'Reddedildi',
    'techservice.priorityLow': 'Düşük',
    'techservice.priorityNormal': 'Normal',
    'techservice.priorityHigh': 'Yüksek',
    'techservice.priorityUrgent': 'Acil',
    'techservice.statTotal': 'Toplam Kayıt',
    'techservice.statProcessing': 'İşleme Alınan',
    'techservice.statCompleted': 'Tamamlanan',
    'techservice.statQuotePending': 'Teklif Bekleyen',
    'techservice.statRejected': 'Reddedilen',
    'techservice.statOverdue': 'Geciken Kayıtlar',
    'techservice.statOverdueNote': '2 haftadır servise gönderilmemiş',
    'techservice.statQuoteWaiting': 'Teklif Bekleyen',
    'techservice.statQuoteWaitingNote': '1 haftadır teklif bekleniyor',
    'techservice.searchPlaceholder': 'Servis no, cihaz, şirket, lokasyon, seri no, envanter no, irtibat kişisi ara...',
    'techservice.filterAllStatuses': 'Tüm Durumlar',
    'techservice.filterAllPriorities': 'Tüm Öncelikler',
    'techservice.colService': 'Servis',
    'techservice.colCompanyLocation': 'Şirket/Lokasyon',
    'techservice.colDevice': 'Cihaz',
    'techservice.colStatus': 'Durum',
    'techservice.colPriority': 'Öncelik',
    'techservice.colDate': 'Tarih',
    'techservice.colActions': 'İşlemler',
    'techservice.envLabel': 'Env:',
    'techservice.noRecords': 'Henüz teknik servis kaydı bulunmuyor',
    'techservice.cardCompany': 'Şirket:',
    'techservice.cardLocation': 'Lokasyon:',
    'techservice.cardDevice': 'Cihaz:',
    'techservice.cardFault': 'Arıza:',
    'techservice.cardDate': 'Tarih:',
    'techservice.btnView': 'Görüntüle',
    'techservice.btnEdit': 'Düzenle',
    'techservice.titleViewDetail': 'Detayları Görüntüle',
    'techservice.titleServiceHistory': 'Servis Geçmişi',
    'techservice.titleEdit': 'Düzenle',
    'techservice.titleEditDisabled': 'Teklif verilen servis düzenlenemez',
    'techservice.titlePrintForm': 'Teknik Servis Bilgi Fişi',
    'techservice.titlePrintCargo': 'Kargo Etiketi Yazdır',
    'techservice.titleLabelSettings': 'Etiket Ayarları',
    'techservice.titleCreateOrder': 'Sipariş Oluştur',
    'techservice.titleRejectQuote': 'Teklifi Reddet',
    'techservice.titleSupplierQuote': 'Tedarikçi Onarım Teklifi',
    'techservice.titleCompleteService': 'Servisi Tamamla',
    'techservice.notifLoadError': 'Veriler yüklenirken hata oluştu',
    'techservice.notifRequiredFields': 'Zorunlu alanları doldurunuz',
    'techservice.notifDeviceRequired': 'En az bir cihaz bilgisi girilmelidir',
    'techservice.notifNoChanges': 'Hiçbir değişiklik yapmadınız',
    'techservice.notifUpdateSuccess': 'Teknik servis güncellendi',
    'techservice.notifSaveError': 'Teknik servis kaydedilirken hata oluştu',
    'techservice.notifDeleteSuccess': 'Teknik servis silindi',
    'techservice.notifDeleteError': 'Teknik servis silinirken hata oluştu',
    'techservice.notifRejectRequired': 'Reddetme açıklaması zorunludur',
    'techservice.notifRejectSuccess': 'Teklif başarıyla reddedildi',
    'techservice.notifRejectError': 'Teklif reddedilemedi',
    'techservice.notifSupplierHistoryError': 'Tedarikçi geçmişi yüklenemedi',
    'techservice.notifServiceHistoryError': 'Servis geçmişi yüklenemedi',
    'techservice.notifCargoNoSupplier': 'Bu servis için tedarikçi atanmamış',
    'techservice.notifOrderError': 'Sipariş oluşturulamadı',
    'techservice.notifCompleteSuccess': 'Servis tamamlandı!',
    'techservice.notifCompleteError': 'Servis tamamlanamadı',
    'techservice.notifLabelSaved': 'Etiket ayarları kaydedildi',
    'techservice.notifDuplicateInventory': 'Bu envanter numarasına sahip cihazı zaten eklediniz!',
    'techservice.notifDuplicateSerial': 'Bu seri numarasına sahip cihazı zaten eklediniz!',
    'techservice.confirmDelete': 'Bu teknik servis kaydını silmek istediğinizden emin misiniz?',
    'techservice.confirmComplete': 'Cihaz teslim alındı ve servis tamamlandı olarak işaretlemek istiyor musunuz?',
    'techservice.promptOrderNumber': 'Sipariş numarasını girin:',
    'techservice.progressStarting': 'İşlem başlatılıyor...',
    'techservice.progressCheckingChanges': 'Değişiklikler kontrol ediliyor...',
    'techservice.progressUpdating': 'Teknik servis güncelleniyor...',
    'techservice.progressUpdateDone': 'Güncelleme tamamlandı!',
    'techservice.progressCreating': 'Yeni servis oluşturuluyor...',
    'techservice.progressSaving': 'Servis kaydediliyor...',
    'techservice.progressSaved': 'Servis oluşturuldu!',
    'techservice.progressRefreshing': 'Veriler yenileniyor...',
    'techservice.modalEditTitle': 'Teknik Servis Düzenle',
    'techservice.modalAddTitle': 'Yeni Teknik Servis Kaydı',
    'techservice.savingProgress': 'İşlem devam ediyor...',
    'techservice.fieldServiceNo': 'Servis Numarası *',
    'techservice.fieldCompany': 'Şirket *',
    'techservice.selectCompany': 'Şirket seçin',
    'techservice.fieldLocation': 'Lokasyon *',
    'techservice.selectLocation': 'Lokasyon seçin',
    'techservice.devicesSection': 'Arızalı Cihazlar',
    'techservice.addDevice': 'Cihaz Ekle',
    'techservice.deviceDefault': 'Cihaz',
    'techservice.seriShort': 'Seri:',
    'techservice.titleCopyDevice': 'Cihazı Kopyala',
    'techservice.fieldCategory': 'Kategori *',
    'techservice.selectCategory': 'Kategori seçin',
    'techservice.catComputer': 'Bilgisayar',
    'techservice.catPrinter': 'Yazıcı',
    'techservice.catPhone': 'Telefon',
    'techservice.catNetwork': 'Ağ Ekipmanı',
    'techservice.catServer': 'Sunucu',
    'techservice.catCamera': 'Kamera',
    'techservice.catProjector': 'Projektör',
    'techservice.catTablet': 'Tablet',
    'techservice.catUps': 'UPS',
    'techservice.catScale': 'Terazi',
    'techservice.catTV': 'TV',
    'techservice.catRadio': 'Telsiz',
    'techservice.catIotScreen': 'IOT Ekran',
    'techservice.catHandheld': 'El Terminali',
    'techservice.catOther': 'Diğer',
    'techservice.serialLinked': 'bağlandı',
    'techservice.labelSearchComputer': 'Bilgisayar Ara',
    'techservice.placeholderSearchComputer': 'SN, Envanter No, Kullanıcı, Marka/Model ile arama yapın...',
    'techservice.labelSelectPrinter': 'Yazıcı Seçin (Opsiyonel)',
    'techservice.selectPrinterOption': 'Mevcut yazıcılardan seçin',
    'techservice.labelSearchPhone': 'Telefon Ara',
    'techservice.placeholderSearchPhone': 'Envanter No, IMEI, Kullanıcı, Marka/Model ile arama yapın...',
    'techservice.labelSelectHandheld': 'El Terminali Seçin (Opsiyonel)',
    'techservice.selectHandheldOption': 'Mevcut el terminallerinden seçin',
    'techservice.selectLocationFirst': 'Lütfen önce lokasyon seçin',
    'techservice.labelSelectRadio': 'Telsiz Seçin (Opsiyonel)',
    'techservice.selectRadioOption': 'Mevcut telsizlerden seçin',
    'techservice.labelSelectScale': 'Terazi Seçin (Opsiyonel)',
    'techservice.selectScaleOption': 'Mevcut terazilerden seçin',
    'techservice.labelSelectNetworkEquipment': 'Ağ Ekipmanı Seçin (Opsiyonel)',
    'techservice.selectNetworkEquipmentOption': 'Mevcut ağ ekipmanlarından seçin',
    'techservice.labelSelectServer': 'Sunucu Seçin (Opsiyonel)',
    'techservice.selectServerOption': 'Mevcut sunuculardan seçin',
    'techservice.labelSelectCamera': 'Kamera Seçin (Opsiyonel)',
    'techservice.selectCameraOption': 'Mevcut kameralardan seçin',
    'techservice.labelSelectIot': 'IOT Cihazı Seçin (Opsiyonel)',
    'techservice.selectIotOption': 'Mevcut IOT cihazlarından seçin',
    'techservice.fieldDeviceName': 'Cihaz Adı *',
    'techservice.fieldInventoryNo': 'Envanter No',
    'techservice.fieldSerialNo': 'Seri No',
    'techservice.fieldDeviceFault': 'Cihaza Özel Arıza Açıklaması',
    'techservice.placeholderDeviceFault': 'Bu cihaza özel arıza detayları (opsiyonel)',
    'techservice.fieldContactPerson': 'İrtibat Kişisi *',
    'techservice.selectContactPerson': 'Kişi seçin',
    'techservice.fieldSupplier': 'Tedarikçi',
    'techservice.selectSupplier': 'Tedarikçi seçin',
    'techservice.fieldTechnician': 'Atanan Teknisyen',
    'techservice.selectTechnician': 'Teknisyen seçin',
    'techservice.fieldStatus': 'Durum *',
    'techservice.fieldPriority': 'Öncelik *',
    'techservice.fieldEstimatedCompletion': 'Tahmini Tamamlanma',
    'techservice.fieldGeneralFault': 'Genel Arıza Açıklaması',
    'techservice.placeholderGeneralFault': 'Tüm cihazlar için ortak arıza açıklaması (her cihazın kendine özel açıklaması yoksa bu kullanılır)',
    'techservice.fieldNotes': 'Notlar',
    'techservice.placeholderNotes': 'Ek notlar...',
    'techservice.emailSection': '📧 E-posta Bildirimleri',
    'techservice.emailToContact': 'İrtibat Kişisine e-posta gönder',
    'techservice.emailToTechnician': 'Atanan Teknisyene e-posta gönder',
    'techservice.emailToSupplier': 'Tedarikçi kullanıcılarına e-posta gönder',
    'techservice.btnSavingUpdate': 'Güncelleniyor...',
    'techservice.btnSavingCreate': 'Kaydediliyor...',
    'techservice.btnUpdate': 'Güncelle',
    'techservice.btnSave': 'Kaydet',
    'techservice.detailTitle': 'Teknik Servis Detayları',
    'techservice.detailDeviceInfo': 'Cihaz Bilgileri',
    'techservice.detailDeviceLabel': 'Cihaz:',
    'techservice.detailInventoryLabel': 'Envanter No:',
    'techservice.detailSerialLabel': 'Seri No:',
    'techservice.detailStatusLabel': 'Durum:',
    'techservice.detailPriorityLabel': 'Öncelik:',
    'techservice.detailContactInfo': 'İletişim Bilgileri',
    'techservice.detailCompanyLabel': 'Şirket:',
    'techservice.detailLocationLabel': 'Lokasyon:',
    'techservice.detailContactLabel': 'İrtibat Kişisi:',
    'techservice.detailSupplierLabel': 'Tedarikçi:',
    'techservice.detailTechnicianLabel': 'Teknisyen:',
    'techservice.detailFaultTitle': 'Arıza Açıklaması',
    'techservice.detailSolutionTitle': 'Çözüm Açıklaması',
    'techservice.detailNotesTitle': 'Notlar',
    'techservice.detailDatesTitle': 'Tarihler',
    'techservice.detailCreatedDate': 'Oluşturulma:',
    'techservice.detailEstimatedDate': 'Tahmini Bitiş:',
    'techservice.detailActualDate': 'Gerçek Bitiş:',
    'techservice.detailCostTitle': 'Maliyet',
    'techservice.btnPrintForm': 'Teknik Servis Bilgi Fişi',
    'techservice.btnPrintLabel': 'Servis Etiketi',
    'techservice.btnPrintCargo': 'Kargo Etiketi',
    'techservice.btnSupplierQuoteReady': 'Tedarikçi Teklifi Hazır!',
    'techservice.historyTitle': 'Servis Geçmişi',
    'techservice.historyCreatedDate': 'Oluşturma:',
    'techservice.historyStatusLabel': 'Durum:',
    'techservice.historyStatusChange': 'Durum Değişikliği',
    'techservice.supplierHistoryTitle': 'Tedarikçi İşlem Geçmişi',
    'techservice.supplierActionsTitle': 'Tedarikçi İşlemleri',
    'techservice.supplierActStatusChange': 'Durum Değişikliği',
    'techservice.supplierActQuoteUpload': 'Teklif Yüklendi',
    'techservice.supplierActWorkDesc': 'İş Açıklaması',
    'techservice.supplierActFileUpload': 'Dosya Yüklendi',
    'techservice.supplierQuoteAmount': 'Teklif Tutarı:',
    'techservice.workDetailsTitle': 'Yapılan İşler',
    'techservice.workSerialNo': 'Seri No:',
    'techservice.workFault': 'Arıza:',
    'techservice.workPerformed': 'Yapılan İş:',
    'techservice.workLaborHours': 'Çalışma Saati:',
    'techservice.workHoursUnit': 'saat',
    'techservice.workLaborCost': 'İşçilik:',
    'techservice.workParts': 'Kullanılan Parçalar:',
    'techservice.workDeviceTotal': 'Cihaz Toplam:',
    'techservice.workNote': 'Not:',
    'techservice.noSupplierHistory': 'Henüz tedarikçi işlemi bulunmuyor',
    'techservice.serviceHistoryTitle': 'Servis Kaydı İşlem Geçmişi',
    'techservice.serviceLogsTitle': 'İşlem Geçmişleri',
    'techservice.serviceActEmailSent': '📧 E-posta Bildirimi Gönderildi',
    'techservice.serviceActEmailFailed': '❌ E-posta Gönderim Hatası',
    'techservice.serviceActSupplierStatus': '🔄 Tedarikçi Durum Değiştirdi',
    'techservice.serviceActSupplierQuote': '💰 Tedarikçi Teklif Yükledi',
    'techservice.serviceActSupplierQuoteUpdate': '✏️ Tedarikçi Teklif Güncelledi',
    'techservice.serviceActWorkQuote': '🔧 Tedarikçi İş Detayı Teklifi Verdi',
    'techservice.serviceActCreate': '🆕 Servis Kaydı Oluşturuldu',
    'techservice.serviceActUpdate': '✏️ Servis Güncellendi',
    'techservice.serviceActDelete': '🗑️ Servis Silindi',
    'techservice.serviceActStatusUpdate': '🔄 Durum Güncellendi',
    'techservice.serviceEmailDetails': '📬 E-posta Detayları:',
    'techservice.showRecipients': 'Alıcı Detaylarını Göster',
    'techservice.recipientContact': 'İrtibat Kişisi',
    'techservice.recipientTechnician': 'Atanan Teknisyen',
    'techservice.recipientSupplier': 'Tedarikçi',
    'techservice.serviceHistorySupplierActionsTitle': 'Tedarikçi İşlemleri',
    'techservice.serviceHistActStatusChange': '🔄 Durum Değişikliği',
    'techservice.serviceHistActQuoteUpload': '📄 Teklif Yüklendi',
    'techservice.serviceHistActWorkDesc': '🔧 İş Açıklaması',
    'techservice.serviceHistActFileUpload': '📎 Dosya Yüklendi',
    'techservice.serviceHistQuoteAmount': '💰 Teklif Tutarı:',
    'techservice.noServiceHistory': 'Henüz işlem geçmişi bulunmuyor',
    'techservice.labelSettingsTitle': 'Kargo Etiketi Ayarları',
    'techservice.labelWidth': 'Genişlik (mm)',
    'techservice.labelHeight': 'Yükseklik (mm)',
    'techservice.labelOrientation': 'Yönlendirme',
    'techservice.labelPortrait': 'Dikey (Portrait)',
    'techservice.labelLandscape': 'Yatay (Landscape)',
    'techservice.labelFontSize': 'Font Boyutu (px)',
    'techservice.labelMargin': 'Kenar Boşluğu (mm)',
    'techservice.labelPresets': 'Hazır Ayarlar:',
    'techservice.labelPresetStandard': 'Standart Etiket (80x60mm)',
    'techservice.labelPresetLarge': 'Büyük Etiket (120x80mm)',
    'techservice.labelSaved': 'Etiket ayarları kaydedildi',
    'techservice.rejectTitle': 'Teklifi Reddet',
    'techservice.rejectServiceNo': 'Servis Numarası:',
    'techservice.rejectReasonLabel': 'Reddetme Açıklaması *',
    'techservice.rejectPlaceholder': 'Reddetme sebebini açıklayın...',
    'techservice.btnReject': 'Reddet',
    'techservice.printLabelTitle': 'TEKNİK SERVİS',
    'techservice.printLabelDevice': 'Cihaz:',
    'techservice.printLabelInventory': 'Envanter:',
    'techservice.printLabelSerial': 'Seri No:',
    'techservice.printLabelCompany': 'Şirket:',
    'techservice.printLabelLocation': 'Lokasyon:',
    'techservice.printLabelStatus': 'Durum:',
    'techservice.printLabelDate': 'Tarih:',
    'techservice.printWindowTitle': 'Servis Etiketi',
    'techservice.roleSupplier': 'Tedarikçi',
    'techservice.roleSystem': 'Sistem',
    // GSMLinesPage
    'gsm.pageTitle': 'Vodafone GSM Hatları',
    'gsm.pageSubtitle': 'GSM hatlarını ve kullanıcı atamalarını yönetin',
    'gsm.loading': 'GSM hatları yükleniyor...',
    'gsm.newLine': 'Yeni GSM Hattı',
    'gsm.exportBtn': 'Dışa Aktar',
    'gsm.exportCSV': 'CSV Formatı',
    'gsm.exportExcel': 'Excel Formatı',
    'gsm.exportPDF': 'PDF Raporu',
    'gsm.sqlImportBtn': '🔥 SQL İÇE AKTAR 🔥',
    'gsm.csvImportBtn': 'CSV İçe Aktar',
    'gsm.statTotal': 'Toplam Hat',
    'gsm.statActive': 'Aktif Hatlar',
    'gsm.statUnassigned': 'Atanmamış Hatlar',
    'gsm.statAssigned': 'Atanmış Hatlar',
    'gsm.statReserved': 'Rezerve Hatlar',
    'gsm.statAvailable': 'Boş Hatlar',
    'gsm.statTransferred': 'Devredilen Hatlar',
    'gsm.statForwarded': 'Yönlendirilen Hatlar',
    'gsm.filterAllLocations': 'Tüm Lokasyonlar',
    'gsm.filterAllCompanies': 'Tüm Şirketler',
    'gsm.filterAllUsers': 'Tüm Kullanıcılar',
    'gsm.filterUnassigned': 'Atanmamış Hatlar',
    'gsm.filterAllStatuses': 'Tüm Durumlar',
    'gsm.statusActive': 'Aktif',
    'gsm.statusInactive': 'Pasif',
    'gsm.statusSuspended': 'Askıda',
    'gsm.statusReserved': 'Rezerve',
    'gsm.statusAvailable': 'Boş',
    'gsm.statusTransferred': 'Devredildi',
    'gsm.statusForwarded': 'Yönlendirildi',
    'gsm.statusUnknown': 'Bilinmiyor',
    'gsm.searchPlaceholder': 'GSM hattı, kullanıcı veya şirket ara...',
    'gsm.clearFilters': 'Temizle',
    'gsm.resultsInfo': 'Toplam {total} GSM hattından {start}-{end} arası gösteriliyor',
    'gsm.filteredFrom': '{total} toplam hattan filtrelendi',
    'gsm.page': 'Sayfa',
    'gsm.perPage': 'Sayfa başına 10 kayıt',
    'gsm.colGsmNo': 'GSM No',
    'gsm.colUser': 'Kullanıcı',
    'gsm.colCompany': 'Şirket',
    'gsm.colLocation': 'Lokasyon',
    'gsm.colTariff': 'Tarife',
    'gsm.colStatus': 'Durum',
    'gsm.colActions': 'İşlemler',
    'gsm.unassigned': 'Atanmamış',
    'gsm.mobileUser': 'Kullanıcı:',
    'gsm.mobileCompany': 'Şirket:',
    'gsm.mobileTariff': 'Tarife:',
    'gsm.mobileLocation': 'Lokasyon:',
    'gsm.monthlyFee': '/ay',
    'gsm.btnHistory': 'Geçmişi Görüntüle',
    'gsm.btnPrev': 'Önceki',
    'gsm.btnNext': 'Sonraki',
    'gsm.modalEditTitle': 'GSM Hattı Düzenle',
    'gsm.modalNewTitle': 'Yeni GSM Hattı',
    'gsm.fieldGsmNumber': 'GSM Numarası *',
    'gsm.fieldGsmHint': '+90 otomatik eklenir, sadece 10 haneli numarayı girin',
    'gsm.fieldTariff': 'Tarife *',
    'gsm.fieldTariffPlaceholder': 'Tarife seçin',
    'gsm.fieldCompany': 'Şirket *',
    'gsm.fieldCompanyPlaceholder': 'Şirket seçin',
    'gsm.fieldLocation': 'Lokasyon *',
    'gsm.fieldLocationPlaceholder': 'Lokasyon seçin',
    'gsm.fieldUserAssign': 'Kullanıcı Ataması (Opsiyonel)',
    'gsm.userUnassignedDue': 'Atanmamış (Durum gereği)',
    'gsm.btnQuickCreateUser': 'Hızlı Kullanıcı Oluştur',
    'gsm.userAssignHint': 'İsteğe bağlı. Boş bırakılırsa "Atanmamış" olarak kaydedilir. + butonuna tıklayarak hızlıca kullanıcı oluşturabilirsiniz.',
    'gsm.statusRestrictionHint': 'durumundaki hatlar kullanıcıya atanamaz.',
    'gsm.statusClearHint': 'Bu durum seçildiğinde kullanıcı ataması otomatik olarak kaldırılır.',
    'gsm.fieldStatus': 'Durum *',
    'gsm.fieldForwardedGsm': 'Yönlendirildiği GSM Numarası *',
    'gsm.forwardSearchPlaceholder': 'GSM numarası, şirket adı veya kullanıcı adı ile arayın...',
    'gsm.forwardSelected': 'Seçili',
    'gsm.forwardUser': 'Kullanıcı:',
    'gsm.forwardNoResult': 'Arama kriterlerinize uygun GSM hattı bulunamadı',
    'gsm.forwardChosenLabel': 'Seçilen:',
    'gsm.fieldPin': 'PIN Kodu *',
    'gsm.fieldPuk': 'PUK Kodu *',
    'gsm.fieldDescription': 'Açıklama',
    'gsm.descriptionPlaceholder': 'GSM hattı hakkında notlar...',
    'gsm.btnUpdate': 'Güncelle',
    'gsm.userModalTitle': 'Hızlı Kullanıcı Oluştur',
    'gsm.fieldFullName': 'Ad Soyad *',
    'gsm.fieldEmail': 'E-posta *',
    'gsm.fieldPhone': 'Telefon',
    'gsm.fieldTitle': 'Ünvan',
    'gsm.fieldPassword': 'Parola',
    'gsm.passwordHint': 'Boş bırakılırsa: demo123',
    'gsm.fieldRole': 'Yetki *',
    'gsm.btnCreateUser': 'Kullanıcı Oluştur',
    'gsm.sqlModalTitle': 'SQL Toplu İçe Aktarma',
    'gsm.sqlFormatTitle': '📋 Veri Formatı',
    'gsm.sqlFormatDesc': 'Mevcut GSM hatları tablonuzdan verileri tab ile ayrılmış (TSV) formatında yapıştırın. Her satır bir GSM hattı olmalıdır.',
    'gsm.sqlColumnDesc': 'Sütun Açıklamaları:',
    'gsm.sqlTip': '💡 İpucu: Mevcut GSM hatları tablonuzdan verileri seçip kopyalayın ve buraya yapıştırın. Sistem otomatik olarak sütunları tanıyacak ve uygun formata çevirecektir.',
    'gsm.sqlPasteLabel': 'GSM Verilerini Yapıştırın',
    'gsm.sqlPasteHint': 'Mevcut GSM hatları tablonuzdan veya Excel\'den kopyalayıp yapıştırabilirsiniz. Tab karakterleri otomatik olarak algılanır.',
    'gsm.validationErrors': 'Doğrulama Hataları',
    'gsm.previewTitle': 'Veri Önizlemesi',
    'gsm.andMoreRecords': 've {count} kayıt daha',
    'gsm.importSummaryTitle': '📊 İçe Aktarma Özeti',
    'gsm.summaryTotal': 'Toplam Kayıt:',
    'gsm.summaryWithUser': 'Kullanıcılı:',
    'gsm.summaryActive': 'Aktif:',
    'gsm.summaryErrors': 'Hata:',
    'gsm.btnImport': '{count} Kaydı İçe Aktar',
    'gsm.btnProcessing': 'İşleniyor...',
    'gsm.csvModalTitle': 'GSM Hatları Toplu İçe Aktarma',
    'gsm.csvStep1Title': '1. Şablon Dosyasını İndirin',
    'gsm.csvStep1Desc': 'Önce örnek veri içeren şablon dosyasını indirin ve kendi verilerinizle doldurun.',
    'gsm.btnDownloadTemplate': 'Şablon İndir',
    'gsm.csvStep2Title': '2. Doldurduğunuz Dosyayı Yükleyin',
    'gsm.fileDropText': 'Dosya seçin veya sürükleyip bırakın',
    'gsm.fileDropFormats': 'CSV, Excel (.xlsx, .xls) dosyaları desteklenir',
    'gsm.csvStep3Title': '3. Veri Önizlemesi',
    'gsm.importRulesTitle': '📋 Import Kuralları',
    'gsm.assignModalTitle': 'Hızlı Kullanıcı Ataması',
    'gsm.assignGsmLine': 'GSM Hattı:',
    'gsm.assignCurrentUser': 'Mevcut Kullanıcı:',
    'gsm.assignSearchLabel': 'Kullanıcı Ara ve Seç',
    'gsm.assignSearchPlaceholder': 'Kullanıcı adı veya e-posta ara...',
    'gsm.assignUserNotFound': 'Kullanıcı bulunamadı',
    'gsm.assignUserLoading': 'Kullanıcı listesi yükleniyor...',
    'gsm.btnAssign': 'Ata',
    'gsm.historyModalTitle': 'GSM Hattı Geçmişi',
    'gsm.historyCount': 'Toplam {count} kayıt bulundu',
    'gsm.historyLoading': 'Yükleniyor...',
    'gsm.historyUser': 'Kullanıcı:',
    'gsm.historyChanges': 'Değişiklikler:',
    'gsm.btnShowMore': 'Daha fazla göster',
    'gsm.btnShowLess': 'Daha az göster',
    'gsm.btnClose': 'Kapat',
    'gsm.tariffFilterApplied': 'Tarife Filtresi Uygulandı',
    'gsm.tariffFilterMsg': 'tarifesini kullanan hatlar gösteriliyor',
    'gsm.notifLineOp': 'GSM Hattı İşlemi',
    'gsm.errLoadData': 'Veriler yüklenirken hata oluştu',
    'gsm.errFileType': 'Sadece CSV ve Excel dosyaları desteklenir',
    'gsm.errCsvRead': 'CSV dosyası okunamadı',
    'gsm.errFixErrors': 'Önce hataları düzeltin',
    'gsm.errSqlImport': 'SQL import işlemi başarısız',
    'gsm.sqlImportDone': 'SQL Import Tamamlandı',
    'gsm.importWarnings': 'Import Uyarıları',
    'gsm.errImportFail': 'Import işlemi başarısız',
    'gsm.errRequired': 'Zorunlu alanları doldurunuz',
    'gsm.errPhoneFormat': 'GSM numarası 10 haneli olmalıdır (+90 otomatik eklenir)',
    'gsm.pinUpdated': 'PIN kodu güncellendi',
    'gsm.pukUpdated': 'PUK kodu güncellendi',
    'gsm.successUpdate': 'GSM hattı güncellendi',
    'gsm.successCreate': 'GSM hattı oluşturuldu',
    'gsm.errSaveLine': 'GSM hattı kaydedilirken hata oluştu',
    'gsm.errUserRequired': 'Ad, e-posta ve lokasyon zorunludur',
    'gsm.successUserCreated': 'Kullanıcı oluşturuldu ve GSM hattına atandı',
    'gsm.errCreateUser': 'Kullanıcı oluşturulurken hata oluştu',
    'gsm.errSelectUser': 'Lütfen bir kullanıcı seçin',
    'gsm.warnAlreadyAssigned': 'Bu hat zaten seçilen kullanıcıya atanmış',
    'gsm.successAssigned': 'GSM hattı kullanıcıya atandı',
    'gsm.errAssignLine': 'GSM hattı atanırken hata oluştu',
    'gsm.confirmDelete': 'Bu GSM hattını silmek istediğinizden emin misiniz?',
    'gsm.successDelete': 'GSM hattı silindi',
    'gsm.errDeleteLine': 'GSM hattı silinirken hata oluştu',
    'gsm.successExportCsv': 'GSM hatları listesi CSV olarak indirildi',
    'gsm.successExportExcel': 'GSM hatları listesi Excel olarak indirildi',
    'gsm.pdfInfo': 'HTML dosyası indirildi. Tarayıcınızda açıp PDF olarak yazdırabilirsiniz.',
    'gsm.templateDownloaded': 'Import şablonu başarıyla indirildi',
    // NetworkSwitchesPage
    'network.pageTitle': 'Network Switchler',
    'network.pageSubtitle': 'Ağ altyapısı yönetimi ve izleme',
    'network.loading': 'Yükleniyor...',
    'network.vlanMgmt': 'VLAN Yönetimi',
    'network.defineModel': 'Model Tanımla',
    'network.newSwitch': 'Yeni Switch',
    'network.configWizard': 'Config Wizard',
    'network.statTotal': 'Toplam Switch',
    'network.statActive': 'Aktif',
    'network.statTotalPorts': 'Toplam Port',
    'network.statPoe': 'PoE Destekli',
    'network.searchPlaceholder': 'Switch ara...',
    'network.filterAllStatuses': 'Tüm Durumlar',
    'network.filterAllHealth': 'Tüm Sağlık Durumları',
    'network.noSwitchFound': 'Switch bulunamadı',
    'network.statusActive': 'Aktif',
    'network.statusInactive': 'Pasif',
    'network.statusMaintenance': 'Bakımda',
    'network.statusFaulty': 'Arızalı',
    'network.healthHealthy': 'Sağlıklı',
    'network.healthWarning': 'Uyarı',
    'network.healthCritical': 'Kritik',
    'network.healthUnknown': 'Bilinmiyor',
    'network.colIpAddress': 'IP Adresi',
    'network.colPorts': 'Portlar',
    'network.colLocation': 'Lokasyon',
    'network.colStatus': 'Durum',
    'network.prevPage': 'Önceki',
    'network.nextPage': 'Sonraki',
    'network.yes': 'Evet',
    'network.no': 'Hayır',
    'network.cancel': 'İptal',
    'network.save': 'Kaydet',
    'network.update': 'Güncelle',
    'network.delete': 'Sil',
    'network.export': 'Dışarı Aktar',
    'network.notSpecified': 'Belirtilmemiş',
    'network.editSwitch': 'Switch Düzenle',
    'network.newSwitchTitle': 'Yeni Switch',
    'network.labelCabinet': 'Kabin',
    'network.selectCabinet': 'Kabin seçin',
    'network.labelSwitchName': 'Switch Adı *',
    'network.labelAlias': 'Takma Ad',
    'network.labelBrand': 'Marka *',
    'network.labelModel': 'Model *',
    'network.selectModel': 'Model seçin',
    'network.labelSerialNo': 'Seri Numarası *',
    'network.labelIpAddr': 'IP Adresi *',
    'network.labelMacAddr': 'MAC Adresi *',
    'network.labelInventoryNo': 'Envanter No',
    'network.labelFirmware': 'Firmware Versiyonu *',
    'network.labelPortCount': 'Port Sayısı *',
    'network.labelPortType': 'Port Tipi *',
    'network.labelCompany': 'Şirket *',
    'network.selectCompany': 'Şirket seçin',
    'network.labelLocation': 'Lokasyon *',
    'network.selectLocation': 'Lokasyon seçin',
    'network.labelRackPos': 'Raf Pozisyonu',
    'network.labelMgmtVlan': 'Yönetim VLAN',
    'network.labelUplinkPorts': 'Uplink Portları',
    'network.labelStatus': 'Durum',
    'network.labelPurchaseDate': 'Satın Alma Tarihi *',
    'network.labelWarrantyEnd': 'Garanti Bitiş Tarihi',
    'network.labelPurchasePrice': 'Satın Alma Fiyatı',
    'network.defineModelBtn': 'Model Tanımla',
    'network.modelAutoApplied': 'Model Bilgileri Otomatik Uygulandı',
    'network.poeSupportLabel': 'PoE Desteği',
    'network.poeBudgetLabel': 'PoE Budget (Watt)',
    'network.switchImageLabel': 'Switch Görseli',
    'network.adminUsernameLabel': 'Admin Kullanıcı Adı',
    'network.adminPasswordLabel': 'Admin Parolası',
    'network.lldpNeighborsTitle': 'LLDP Komşuları',
    'network.addLldpNeighbor': 'LLDP Komşusu Ekle',
    'network.neighborSwitch': 'Komşu Switch',
    'network.localPort': 'Yerel Port',
    'network.remotePort': 'Uzak Port',
    'network.detailTitle': 'Switch Detayları',
    'network.switchInfoTitle': 'Switch Bilgileri',
    'network.detailSwitchName': 'Switch Adı:',
    'network.detailBrandModel': 'Marka/Model:',
    'network.detailIpAddr': 'IP Adresi:',
    'network.detailPortCount': 'Port Sayısı:',
    'network.detailPoeSupport': 'PoE Desteği:',
    'network.switchImageTitle': 'Switch Görseli',
    'network.editModel': 'Model Düzenle',
    'network.newModelTitle': 'Yeni Model Tanımla',
    'network.labelPortSpeeds': 'Port Hızları',
    'network.labelModelImage': 'Model Görseli',
    'network.labelTechSpecs': 'Teknik Özellikler',
    'network.labelDescription': 'Açıklama',
    'network.labelSfpPorts': 'SFP Port Sayısı',
    'network.modelMgmtTitle': 'Switch Modelleri Yönetimi',
    'network.searchModel': 'Model ara...',
    'network.newModel': 'Yeni Model',
    'network.sfpPortsLabel': 'SFP Portları:',
    'network.usageLabel': 'Kullanım:',
    'network.noModels': 'Henüz model tanımlanmamış',
    'network.portMgmtTitle': 'Port Yönetimi',
    'network.portActive': 'Aktif',
    'network.portNameLabel': 'Ad:',
    'network.connectedDeviceLabel': 'Cihaz:',
    'network.vlanLabel': 'VLAN:',
    'network.ipLabel': 'IP:',
    'network.descriptionLabel': 'Açıklama:',
    'network.editPortTitle': 'Düzenle',
    'network.portNameField': 'Port Adı',
    'network.connectedDeviceField': 'Bağlı Cihaz',
    'network.portDescription': 'Açıklama',
    'network.locationField': 'Lokasyon',
    'network.selectLocationOpt': 'Lokasyon Seçin',
    'network.vlanField': 'VLAN',
    'network.selectVlanOpt': 'VLAN Seçin',
    'network.ipAddressField': 'IP Adresi',
    'network.ipMustBeInRange': "Seçilen VLAN'ın IP aralığında olmalıdır",
    'network.portActiveLabel': 'Port Aktif',
    'network.vlanMgmtTitle': 'VLAN Yönetimi',
    'network.searchVlan': 'VLAN ara...',
    'network.newVlan': 'Yeni VLAN',
    'network.editVlanTitle': 'VLAN Düzenle',
    'network.addVlanTitle': 'Yeni VLAN Ekle',
    'network.vlanIdLabel': 'VLAN ID *',
    'network.vlanNameLabel': 'VLAN Adı *',
    'network.networkAddressLabel': 'Network Adresi (CIDR)',
    'network.subnetMaskLabel': 'Subnet Mask',
    'network.gatewayLabel': 'Gateway',
    'network.ipRangeLabel': 'IP Aralığı',
    'network.autoCalculated': 'Otomatik hesaplanacak',
    'network.descriptionVlan': 'Açıklama',
    'network.existingVlans': "Mevcut VLAN'lar",
    'network.locationVlanLabel': 'Lokasyon:',
    'network.emptyPortsTitle': 'Boş Portlar',
    'network.noPortName': 'Ad yok',
    'network.allPortsFull': 'Tüm portlar dolu',
    'network.backupMgmtTitle': 'Backup Yönetimi',
    'network.newBackupTitle': 'Yeni Backup Yükle',
    'network.backupTypeLabel': 'Backup Tipi',
    'network.backupTypeText': 'Metin',
    'network.backupTypeFile': 'Dosya',
    'network.configTextLabel': 'Konfigürasyon Metni *',
    'network.backupFileLabel': 'Backup Dosyası *',
    'network.backupDescLabel': 'Açıklama',
    'network.backupUploadBtn': 'Backup Yükle',
    'network.backupHistoryTitle': 'Backup Geçmişi',
    'network.textBackup': 'Metin Backup',
    'network.fileBackup': 'Dosya Backup',
    'network.uploadedByLabel': 'Yükleyen:',
    'network.noBackups': 'Henüz backup yüklenmemiş',
    'network.analyzingConfig': 'Konfigürasyon analiz ediliyor...',
    'network.noIssues': 'Sorun Tespit Edilmedi',
    'network.vlanDetailTitle': 'VLAN Detayları',
    'network.maintenanceTitle': 'Bakım Kaydı',
    'network.maintenanceTypeLabel': 'Bakım Tipi *',
    'network.cleaningType': 'Temizlik',
    'network.inspectionType': 'Kontrol',
    'network.backupUpdateType': 'Backup Güncelleme',
    'network.firmwareUpdateType': 'Firmware Güncelleme',
    'network.maintenanceDateLabel': 'Bakım Tarihi *',
    'network.maintenanceNotesLabel': 'Notlar',
    'network.labelPrintTitle': 'Etiket Yazdır',
    'network.labelPrintDesc': 'Bu switch için etiket yazdırılacak.',
    'network.labelCustomDesc': 'Etiket boyutlarını özelleştirebilirsiniz.',
    'network.labelOrientationLabel': 'Etiket Yönü',
    'network.horizontal': 'Yatay',
    'network.vertical': 'Dikey',
    'network.switchInfoLabelTitle': 'Switch Bilgileri',
    'network.labelSizeTitle': 'Etiket Boyutları',
    'network.labelWidthMm': 'Genişlik (mm)',
    'network.labelHeightMm': 'Yükseklik (mm)',
    'network.printLabelBtn': 'Etiket Yazdır',
    'network.errLoadData': 'Veriler yüklenirken hata oluştu',
    'network.successSwitchUpdated': 'Switch güncellendi',
    'network.successSwitchCreated': 'Switch oluşturuldu',
    'network.errSavingSwitch': 'Switch kaydedilirken hata oluştu',
    'network.confirmDeleteSwitch': "Bu network switch'i silmek istediğinizden emin misiniz?",
    'network.successSwitchDeleted': 'Switch silindi',
    'network.errDeletingSwitch': 'Switch silinirken hata oluştu',
    'network.errRequiredFields': 'Switch Adı, IP Adresi ve Seri Numarası zorunludur',
    'network.errDuplicateIP': "Bu IP adresi zaten başka bir switch'te kullanılmaktadır",
    'network.errDuplicateSerial': "Bu seri numarası zaten başka bir switch'te kullanılmaktadır",
    'network.switchCopied': 'Switch bilgileri kopyalandı, benzersiz alanları düzenleyip kaydedin',
    'network.errLoadPorts': 'Port bilgileri yüklenirken hata oluştu',
    'network.successPortUpdated': 'Port güncellendi',
    'network.errUpdatePort': 'Port güncellenirken hata oluştu',
    'network.successVlanUpdated': 'VLAN güncellendi',
    'network.successVlanCreated': 'VLAN oluşturuldu',
    'network.errSavingVlan': 'VLAN kaydedilirken hata oluştu',
    'network.errVlanRequired': 'VLAN ID ve adı zorunludur',
    'network.errLoadEmptyPorts': 'Boş portlar yüklenirken hata oluştu',
    'network.errConfigRequired': 'Konfigürasyon metni gereklidir',
    'network.errBackupFileRequired': 'Backup dosyası seçiniz',
    'network.successBackupUploaded': 'Backup yüklendi',
    'network.errUploadingBackup': 'Backup yüklenirken hata oluştu',
    'network.confirmDeleteBackup': "Bu backup'ı silmek istediğinizden emin misiniz?",
    'network.successBackupDeleted': 'Backup silindi',
    'network.errDeletingBackup': 'Backup silinirken hata oluştu',
    'network.errAnalysisError': 'Analiz sırasında hata oluştu',
    'network.successModelUpdated': 'Model güncellendi',
    'network.successModelCreated': 'Model oluşturuldu',
    'network.errSavingModel': 'Model kaydedilirken hata oluştu',
    'network.errModelRequired': 'Marka ve model alanları zorunludur',
    'network.errLabelPrint': 'Etiket yazdırılırken hata oluştu',
    'network.errMaintenanceRequired': 'Gerekli alanları doldurunuz',
    'network.successMaintenanceSaved': 'Bakım kaydı eklendi',
    'network.errSavingMaintenance': 'Bakım kaydı eklenirken hata oluştu',
    'network.lastBackupNever': 'Hiç yedekleme alınmadı',
    'network.poeSupportedWith': 'Destekli',
    'network.poeNotSupported': 'Desteksiz',
    'network.poeWithBudget': 'bütçe',
    'network.modelImageFromModel': 'Görsel modelden alındı',
    // CompaniesPage
    'companies.title': 'Şirketler',
    'companies.subtitle': 'Şirket bilgilerini yönetin',
    'companies.export': 'Dışarı Aktar',
    'companies.newCompany': 'Yeni Şirket',
    'companies.searchPlaceholder': 'Şirket ara...',
    'companies.taxNo': 'Vergi No:',
    'companies.taxOffice': 'Vergi Dairesi:',
    'companies.gsmLines': 'GSM Hattı',
    'companies.users': 'Kullanıcı',
    'companies.printers': 'Yazıcı',
    'companies.createdAt': 'Oluşturulma:',
    'companies.editTitle': 'Şirket Düzenle',
    'companies.newTitle': 'Yeni Şirket',
    'companies.labelName': 'Şirket Adı *',
    'companies.labelTaxNo': 'Vergi Numarası *',
    'companies.labelTaxOffice': 'Vergi Dairesi',
    'companies.labelLocation': 'Lokasyon',
    'companies.selectLocation': 'Lokasyon seçin (isteğe bağlı)',
    'companies.cancel': 'İptal',
    'companies.save': 'Kaydet',
    'companies.update': 'Güncelle',
    'companies.capexList': 'CAPEX Listesi',
    'companies.noCapex': 'Bu şirket için CAPEX kaydı bulunamadı.',
    'companies.capexProjectName': 'Proje Adı',
    'companies.capexCategory': 'Kategori',
    'companies.capexAmount': 'Tutar',
    'companies.capexStatus': 'Durum',
    'companies.capexDate': 'Tarih',
    'companies.statusApproved': 'Onaylandı',
    'companies.statusPending': 'Beklemede',
    'companies.statusRejected': 'Reddedildi',
    'companies.errLoad': 'Veriler yüklenirken hata oluştu',
    'companies.errRequired': 'Zorunlu alanları doldurunuz',
    'companies.successCopied': 'Şirket bilgileri panoya kopyalandı',
    'companies.errCopy': 'Kopyalama işlemi başarısız',
    'companies.successUpdated': 'Şirket güncellendi',
    'companies.successCreated': 'Şirket oluşturuldu',
    'companies.errSave': 'Şirket kaydedilirken hata oluştu',
    'companies.confirmDelete': 'Bu şirketi silmek istediğinizden emin misiniz?',
    'companies.errDelete': 'Şirket silinirken hata oluştu',
    'companies.successExport': 'Şirketler listesi dışarı aktarıldı',
    'companies.errCapex': 'CAPEX verileri yüklenirken hata oluştu',
    // LocationsPage
    'locations.title': 'Lokasyonlar',
    'locations.subtitle': 'Şirket lokasyonlarını yönetin',
    'locations.newLocation': 'Yeni Lokasyon',
    'locations.searchPlaceholder': 'Lokasyon ara...',
    'locations.colLocation': 'Lokasyon',
    'locations.colAddress': 'Adres',
    'locations.colPhone': 'Telefon',
    'locations.colUser': 'Kullanıcı',
    'locations.colSwitch': 'Switch',
    'locations.colIot': 'IoT',
    'locations.colScale': 'Terazi',
    'locations.colCabinet': 'Kabin',
    'locations.colPhysicalServer': 'Fiziksel Sunucu',
    'locations.colVirtualServer': 'Sanal Sunucu',
    'locations.colGsm': 'GSM Hattı',
    'locations.colMobile': 'Mobil Telefon',
    'locations.colCreated': 'Oluşturulma',
    'locations.colActions': 'İşlemler',
    'locations.notFound': 'Lokasyon bulunamadı',
    'locations.notFoundSearch': 'Arama kriterlerinize uygun lokasyon bulunamadı.',
    'locations.notFoundEmpty': 'Henüz lokasyon eklenmemiş.',
    'locations.editTitle': 'Lokasyon Düzenle',
    'locations.newTitle': 'Yeni Lokasyon',
    'locations.labelName': 'Lokasyon Adı *',
    'locations.labelAddress': 'Adres *',
    'locations.labelPhone': 'Telefon *',
    'locations.cancel': 'İptal',
    'locations.save': 'Kaydet',
    'locations.update': 'Güncelle',
    'locations.errLoad': 'Veriler yüklenirken hata oluştu',
    'locations.errRequired': 'Tüm alanları doldurunuz',
    'locations.successUpdated': 'Lokasyon güncellendi',
    'locations.successCreated': 'Lokasyon oluşturuldu',
    'locations.errSave': 'Lokasyon kaydedilirken hata oluştu',
    'locations.confirmDelete': 'Bu lokasyonu silmek istediğinizden emin misiniz?',
    'locations.successDeleted': 'Lokasyon silindi',
    'locations.errDelete': 'Lokasyon silinirken hata oluştu',
    // SuppliersPage
    'suppliers.title': 'Tedarikçiler',
    'suppliers.subtitle': 'Tedarikçi bilgilerini yönetin',
    'suppliers.newSupplier': 'Yeni Tedarikçi',
    'suppliers.searchPlaceholder': 'Tedarikçi ara...',
    'suppliers.editTitle': 'Tedarikçi Düzenle',
    'suppliers.newTitle': 'Yeni Tedarikçi',
    'suppliers.cancel': 'İptal',
    'suppliers.save': 'Kaydet',
    'suppliers.update': 'Güncelle',
    'suppliers.createUser': 'Yeni Kullanıcı Oluştur',
    'suppliers.existingUsers': 'Mevcut Kullanıcılar',
    'suppliers.noUsers': 'Henüz kullanıcı bulunmuyor',
    'suppliers.unknownPassword': 'Bilinmiyor (eski kayıt)',
    'suppliers.errLoad': 'Veriler yüklenirken hata oluştu',
    'suppliers.errRequired': 'Zorunlu alanları doldurunuz',
    'suppliers.successUpdated': 'Tedarikçi güncellendi',
    'suppliers.successCreated': 'Tedarikçi oluşturuldu',
    'suppliers.errSave': 'Tedarikçi kaydedilirken hata oluştu',
    'suppliers.confirmDelete': 'Bu tedarikçiyi silmek istediğinizden emin misiniz?',
    'suppliers.successDeleted': 'Tedarikçi silindi',
    'suppliers.errDelete': 'Tedarikçi silinirken hata oluştu',
    'suppliers.userCreated': 'Kullanıcı oluşturuldu',
    'suppliers.errUserCreate': 'Kullanıcı oluşturulamadı',
    'suppliers.confirmResetPassword': 'Bu kullanıcının şifresini sıfırlamak istediğinizden emin misiniz?',
    'suppliers.errResetPassword': 'Şifre sıfırlanamadı',
    'suppliers.successEmailSent': 'Giriş bilgileri e-posta ile gönderildi',
    'suppliers.errEmailSend': 'E-posta gönderilemedi',
    'suppliers.taxNo': 'Vergi No:',
    'suppliers.serviceCategories': 'Hizmet Kategorileri:',
    'suppliers.createdAt': 'Oluşturulma:',
    'suppliers.userManagement': 'Kullanıcı Yönetimi',
    'suppliers.labelName': 'Tedarikçi Adı *',
    'suppliers.labelContact': 'Yetkili Kişi *',
    'suppliers.labelPhone': 'Telefon *',
    'suppliers.labelEmail': 'E-posta',
    'suppliers.labelWebsite': 'Web Sitesi',
    'suppliers.labelTaxNo': 'Vergi Numarası',
    'suppliers.labelAddress': 'Adres *',
    'suppliers.labelCategories': 'Hizmet Kategorileri',
    'suppliers.labelUsername': 'Kullanıcı Adı *',
    'suppliers.labelFullName': 'Ad Soyad *',
    'suppliers.labelEmail2': 'E-posta',
    'suppliers.labelPhone2': 'Telefon',
    'suppliers.labelPassword': 'Şifre *',
    'suppliers.statusActive': 'Aktif',
    'suppliers.statusInactive': 'Pasif',
    'suppliers.passwordLabel': 'Parola:',
    'suppliers.lastLogin': 'Son giriş:',
    'suppliers.createUserBtn': 'Kullanıcı Oluştur',
    'suppliers.close': 'Kapat',
    // EquipmentPage
    'equipment.title': 'Ekipmanlar',
    'equipment.subtitle': 'Ekipman envanterini yönetin',
    'equipment.newEquipment': 'Yeni Ekipman',
    'equipment.searchPlaceholder': 'Ekipman ara...',
    'equipment.allCategories': 'Tüm Kategoriler',
    'equipment.allStatuses': 'Tüm Durumlar',
    'equipment.statusAvailable': 'Müsait',
    'equipment.statusInUse': 'Kullanımda',
    'equipment.statusMaintenance': 'Bakımda',
    'equipment.statusRetired': 'Kullanım Dışı',
    'equipment.conditionGood': 'İyi',
    'equipment.conditionFair': 'Orta',
    'equipment.conditionPoor': 'Kötü',
    'equipment.locationNotSet': 'Lokasyon belirtilmemiş',
    'equipment.lowStock': 'Düşük Stok',
    'equipment.editTitle': 'Ekipmanı Düzenle',
    'equipment.newTitle': 'Yeni Ekipman Ekle',
    'equipment.selectCategory': 'Kategori Seçin',
    'equipment.selectLocation': 'Lokasyon Seçin',
    'equipment.selectUser': 'Kullanıcı Seçin',
    'equipment.assignTypeTemp': 'Geçici',
    'equipment.assignTypePerm': 'Kalıcı',
    'equipment.cancel': 'İptal',
    'equipment.save': 'Ekle',
    'equipment.update': 'Güncelle',
    'equipment.noHistory': 'Henüz zimmet geçmişi bulunmuyor',
    'equipment.historyUser': 'Kullanıcı',
    'equipment.historyType': 'Tür',
    'equipment.historyReturnDate': 'İade Tarihi',
    'equipment.historyAction': 'İşlem',
    'equipment.statusActive': 'Aktif',
    'equipment.statusReturned': 'İade Edildi',
    'equipment.errLoad': 'Veriler yüklenirken hata oluştu',
    'equipment.successUpdated': 'Ekipman başarıyla güncellendi',
    'equipment.successCreated': 'Ekipman başarıyla eklendi',
    'equipment.errSave': 'Ekipman kaydedilirken hata oluştu',
    'equipment.confirmDelete': 'Bu ekipmanı silmek istediğinizden emin misiniz?',
    'equipment.successDeleted': 'Ekipman başarıyla silindi',
    'equipment.errDelete': 'Ekipman silinirken hata oluştu',
    'equipment.successAssigned': 'Ekipman başarıyla zimmetlendi',
    'equipment.errAssign': 'Zimmetleme sırasında hata oluştu',
    'equipment.confirmUnassign': 'Bu zimmeti geri kaldırmak istediğinizden emin misiniz? Stok otomatik olarak geri eklenecektir.',
    'equipment.successUnassigned': 'Zimmet başarıyla geri kaldırıldı',
    'equipment.successStockAdded': 'Stok başarıyla eklendi',
    'equipment.errStockAdd': 'Stok eklenirken hata oluştu',
    // ConsumablesPage
    'consumables.title': 'Sarf Malzemeler',
    'consumables.subtitle': 'Sarf malzeme envanterini yönetin',
    'consumables.newConsumable': 'Yeni Sarf Malzeme',
    'consumables.searchPlaceholder': 'Malzeme adı, marka veya model ile ara...',
    'consumables.allCategories': 'Tüm Kategoriler',
    'consumables.brandNotSet': 'Marka belirtilmemiş',
    'consumables.locationNotSet': 'Belirtilmemiş',
    'consumables.editTitle': 'Sarf Malzemeyi Düzenle',
    'consumables.newTitle': 'Yeni Sarf Malzeme Ekle',
    'consumables.selectCategory': 'Kategori Seçin',
    'consumables.selectLocation': 'Lokasyon Seçin',
    'consumables.selectPrinter': 'Yazıcı Seçin',
    'consumables.selectUser': 'Kullanıcı Seçin',
    'consumables.selectSupplier': 'Tedarikçi Seçin',
    'consumables.currentPhoto': 'Mevcut fotoğraf:',
    'consumables.newPhotoPreview': 'Yeni fotoğraf önizlemesi:',
    'consumables.cancel': 'İptal',
    'consumables.save': 'Ekle',
    'consumables.update': 'Güncelle',
    'consumables.confirmDelete': 'Bu sarf malzemeyi silmek istediğinizden emin misiniz?',
    'consumables.successAdded': 'Sarf malzeme başarıyla eklendi',
    'consumables.errSave': 'Sarf malzeme kaydedilirken hata oluştu',
    'consumables.successAssigned': 'İşlem başarıyla tamamlandı',
    'consumables.errAssign': 'Zimmetleme işlemi başarısız',
    'consumables.successStockAdded': 'Stok başarıyla eklendi',
    // DocumentsPage
    'documents.title': 'Evraklar',
    'documents.subtitle': 'Belge ve dosyaları yönetin',
    'documents.allCategories': 'Tüm Kategoriler',
    'documents.allTypes': 'Tüm Türler',
    'documents.sortLabel': 'Sıralama:',
    'documents.statusSigned': 'İmzalandı',
    'documents.statusExpired': 'Süresi Dolmuş',
    'documents.statusCancelled': 'İptal Edilmiş',
    'documents.download': 'İndir',
    'documents.view': 'Görüntüle',
    'documents.downloadInvoice': 'Fatura İndir',
    'documents.statusApproved': 'Onaylandı',
    'documents.statusCompleted': 'Tamamlandı',
    'documents.statusUploaded': 'Fatura Yüklendi',
    // MaintenanceContractsPage
    'maintenance.title': 'Bakım Anlaşmaları',
    'maintenance.subtitle': 'Bakım ve servis anlaşmalarını yönetin',
    'maintenance.newContract': 'Yeni Anlaşma',
    'maintenance.searchPlaceholder': 'Anlaşma adı ara...',
    'maintenance.allStatuses': 'Tüm Durumlar',
    'maintenance.allSuppliers': 'Tüm Tedarikçiler',
    'maintenance.statActive': 'Toplam Aktif Anlaşma',
    'maintenance.stat1Month': '1 Ay İçinde Dolacak',
    'maintenance.stat3Month': '3 Ay İçinde Dolacak',
    'maintenance.stat6Month': '6 Ay İçinde Dolacak',
    'maintenance.statusActive': 'Aktif',
    'maintenance.statusExpired': 'Süresi Dolmuş',
    'maintenance.statusCancelled': 'İptal Edilmiş',
    'maintenance.editTitle': 'Bakım Anlaşmasını Düzenle',
    'maintenance.newTitle': 'Yeni Bakım Anlaşması',
    'maintenance.selectSupplier': 'Tedarikçi Seçin',
    'maintenance.currencyTL': 'Türk Lirası (₺)',
    'maintenance.download': 'İndir',
    'maintenance.upload': 'Yükle',
    'maintenance.uploading': 'Yükleniyor...',
    'maintenance.cancel': 'İptal',
    'maintenance.save': 'Oluştur',
    'maintenance.update': 'Güncelle',
    'maintenance.extendDays': 'Gün',
    'maintenance.extendMonths': 'Ay',
    'maintenance.extendYears': 'Yıl',
    'maintenance.confirmDeleteFile': 'Bu dosyayı silmek istediğinizden emin misiniz?',
    // ProceduresPage
    'procedures.title': 'Prosedürler',
    'procedures.subtitle': 'Standart işletim prosedürlerini yönetin',
    'procedures.newProcedure': 'Yeni Prosedür',
    'procedures.searchPlaceholder': 'Prosedür ara...',
    'procedures.allStatuses': 'Tüm Durumlar',
    'procedures.statusAll': 'Tümü',
    'procedures.statusPublished': 'Yayında',
    'procedures.statusArchived': 'Arşiv',
    'procedures.notFoundCategory': 'Bu kategoride prosedür bulunamadı.',
    'procedures.notFound': 'Prosedür bulunamadı.',
    'procedures.editTitle': 'Prosedür Düzenle',
    'procedures.newTitle': 'Yeni Prosedür Oluştur',
    'procedures.titlePlaceholder': 'Prosedür başlığı',
    'procedures.contentPlaceholder': 'Prosedür içeriğini yazın...',
    'procedures.selectCategory': 'Kategori seçin...',
    'procedures.statusPublish': 'Yayınla',
    'procedures.saving': 'Kaydediliyor...',
    'procedures.cancel': 'İptal',
    'procedures.save': 'Oluştur',
    'procedures.update': 'Güncelle',
    'procedures.noContent': 'İçerik bulunmuyor.',
    'procedures.historyCreated': 'Oluşturuldu',
    'procedures.historyUpdated': 'Güncellendi',
    'procedures.historyPublished': 'Yayınlandı',
    'procedures.historyArchived': 'Arşivlendi',
    'procedures.historyRestored': 'Geri Yüklendi',
    'procedures.errLoad': 'Prosedürler yüklenirken hata oluştu',
    'procedures.errSave': 'Prosedür kaydedilirken hata oluştu',
    'procedures.successUpdated': 'Prosedür başarıyla güncellendi',
    'procedures.successCreated': 'Prosedür başarıyla oluşturuldu',
    'procedures.successPublished': 'Prosedür başarıyla yayınlandı',
    'procedures.successArchived': 'Prosedür başarıyla arşivlendi',
    'procedures.successRestored': 'Prosedür başarıyla geri yüklendi',
    'procedures.successDeleted': 'Prosedür başarıyla silindi',
    'procedures.confirmDeleteFile': 'Bu dosyayı silmek istediğinizden emin misiniz?',
    'procedures.successFileDeleted': 'Dosya başarıyla silindi',
    // ChecklistPage & ChecklistPopup
    'checklist.pageTitle': 'Checklist Yönetimi',
    'checklist.pageSubtitle': 'Günlük, haftalık veya aylık görev listelerinizi yönetin',
    'checklist.newChecklist': 'Yeni Checklist',
    'checklist.tabMyChecklists': 'Checklistlerim',
    'checklist.tabHistory': 'Geçmiş',
    'checklist.loading': 'Yükleniyor...',
    'checklist.empty': 'Henüz checklist oluşturmadınız',
    'checklist.emptyHint': 'Yeni Checklist butonuna tıklayarak başlayın',
    'checklist.inactive': 'Pasif',
    'checklist.today': 'Bugün',
    'checklist.editTitle': 'Düzenle',
    'checklist.deleteTitle': 'Sil',
    'checklist.deactivate': 'Pasife Al',
    'checklist.activate': 'Aktif Et',
    'checklist.saving': 'Kaydediliyor...',
    'checklist.filterAll': 'Tüm Checklistler',
    'checklist.historyEmpty': 'Henüz geçmiş kaydı yok',
    'checklist.completed': 'Tamamlandı',
    'checklist.notCompleted': 'Tamamlanmadı',
    'checklist.prevPage': 'Önceki',
    'checklist.nextPage': 'Sonraki',
    'checklist.rightTabLeaderboard': 'Sıralama',
    'checklist.rightTabActivity': 'Aktivite',
    'checklist.rightTabOthers': 'Diğerleri',
    'checklist.leaderboardTitle': 'Toplam Puan Sıralaması',
    'checklist.leaderboardEmpty': 'Henüz puan kaydı yok',
    'checklist.leaderboardThisWeek': 'Bu hafta:',
    'checklist.leaderboardToday': 'bugün',
    'checklist.leaderboardPoints': 'puan',
    'checklist.leaderboardFooter': 'Her tamamlanan görev =',
    'checklist.activityTitle': 'Son Aktiviteler',
    'checklist.activityRefresh': 'Yenile',
    'checklist.activityEmpty': 'Henüz aktivite yok',
    'checklist.activityCompleted': 'tamamladı:',
    'checklist.activityPoint': '+1 puan',
    'checklist.othersTitle': 'Bugünkü Checklistler',
    'checklist.othersEmpty': 'Bugün aktif checklist yok',
    'checklist.modalCreateTitle': 'Yeni Checklist',
    'checklist.modalEditTitle': 'Checklist Düzenle',
    'checklist.labelTitle': 'Başlık',
    'checklist.labelDescription': 'Açıklama',
    'checklist.labelFrequency': 'Tekrar Sıklığı',
    'checklist.labelStartDate': 'Başlangıç Tarihi',
    'checklist.labelEndDate': 'Bitiş Tarihi',
    'checklist.labelItems': 'Görev Maddeleri',
    'checklist.addItem': 'Madde Ekle',
    'checklist.titlePlaceholder': 'Örn: Günlük Sabah Rutini',
    'checklist.descriptionPlaceholder': 'İsteğe bağlı açıklama...',
    'checklist.itemPlaceholder': 'Madde',
    'checklist.frequencyWeeklyHint': 'Her hafta başlangıç tarihiyle aynı gün gösterilir',
    'checklist.frequencyMonthlyHint': 'Her ay başlangıç tarihiyle aynı günde gösterilir',
    'checklist.frequencyMonthlyDay': '. gün',
    'checklist.btnCancel': 'İptal',
    'checklist.btnSave': 'Kaydet',
    'checklist.errTitleRequired': 'Başlık zorunludur',
    'checklist.errItemRequired': 'En az bir madde ekleyin',
    'checklist.successCreated': 'Checklist oluşturuldu',
    'checklist.successUpdated': 'Checklist güncellendi',
    'checklist.successDeleted': 'Checklist silindi',
    'checklist.errLoad': 'Checklistler yüklenirken hata oluştu',
    'checklist.errHistoryLoad': 'Geçmiş yüklenirken hata oluştu',
    'checklist.errSave': 'Kayıt sırasında hata oluştu',
    'checklist.errDelete': 'Silme işlemi başarısız',
    'checklist.errUpdate': 'Güncelleme başarısız',
    'checklist.confirmDelete': 'Bu checklist silinsin mi? İlgili tüm geçmiş kayıtlar da silinecektir.',
    'checklist.freqDaily': 'Günlük',
    'checklist.freqWeekly': 'Haftalık',
    'checklist.freqMonthly': 'Aylık',
    'checklist.justNow': 'Az önce',
    'checklist.minutesAgo': 'dk önce',
    'checklist.hoursAgo': 'sa önce',
    'checklist.popupHeader': 'Günlük Kontrol Listesi',
    'checklist.popupProgress': 'tamamlandı',
    'checklist.popupSkip': 'Atla',
    'checklist.popupSaveClose': 'Kaydet ve Kapat',
    'checklist.popupCompleted': 'Tamamlandı!',
    'checklist.popupSaving': 'Kaydediliyor...',
    // CapexPage
    'capex.title': 'CAPEX Yönetimi',
    'capex.subtitle': 'Şirket bütçelerini ve harcama takibini yönetin',
    'capex.newCapex': 'Yeni CAPEX',
    'capex.searchPlaceholder': 'CAPEX ara...',
    'capex.allYears': 'Tüm Yıllar',
    'capex.allCompanies': 'Tüm Şirketler',
    'capex.allCategories': 'Tüm Kategoriler',
    'capex.allStatuses': 'Tüm Durumlar',
    'capex.statusActive': 'Aktif',
    'capex.statusCompleted': 'Tamamlandı',
    'capex.statusCancelled': 'İptal Edildi',
    'capex.statusUnknown': 'Bilinmiyor',
    'capex.budgetUsage': 'Bütçe Kullanımı',
    'capex.total': 'Toplam',
    'capex.used': 'Kullanılan',
    'capex.blocked': 'Bloke',
    'capex.remaining': 'Kalan',
    'capex.blockedAmount': 'Bloke Edilmiş: {symbol}{amount}',
    'capex.viewHistory': 'Geçmişi Görüntüle',
    'capex.clearBlocked': 'Bloke Tutarı Temizle',
    'capex.confirmClearBlocked': "Bu CAPEX'in bloke edilen tutarını temizlemek istediğinizden emin misiniz?",
    'capex.confirmCancelOrders': "Bu CAPEX aktif siparişler tarafından kullanılıyor:\n{orders}\n\nBu siparişleri iptal edip bloke tutarı temizlemek istiyor musunuz?",
    'capex.confirmDelete': 'Bu CAPEX kaydını silmek istediğinizden emin misiniz?',
    'capex.blockedCleared': 'Bloke tutarı temizlendi',
    'capex.ordersAndBlockedCleared': 'Siparişler iptal edildi ve bloke tutarı temizlendi',
    'capex.modalTitleEdit': 'CAPEX Düzenle',
    'capex.modalTitleNew': 'Yeni CAPEX',
    'capex.fieldCapexNumber': 'CAPEX Numarası *',
    'capex.fieldCompany': 'Şirket *',
    'capex.selectCompany': 'Şirket seçin',
    'capex.fieldYear': 'Yıl *',
    'capex.fieldCategory': 'Kategori *',
    'capex.selectCategory': 'Kategori seçin',
    'capex.addNewCategory': 'Yeni Kategori Ekle',
    'capex.newCategoryPlaceholder': 'Yeni kategori adı...',
    'capex.addCategoryBtn': 'Ekle',
    'capex.fieldTotalAmount': 'Toplam Tutar *',
    'capex.fieldCurrency': 'Para Birimi *',
    'capex.currencyEUR': 'Euro (€)',
    'capex.currencyUSD': 'Amerikan Doları ($)',
    'capex.currencyTRY': 'Türk Lirası (₺)',
    'capex.fieldDescription': 'Açıklama',
    'capex.descriptionPlaceholder': 'CAPEX hakkında detaylı açıklama...',
    'capex.btnCancel': 'İptal',
    'capex.btnUpdate': 'Güncelle',
    'capex.btnSave': 'Kaydet',
    'capex.historyTitle': 'CAPEX Kullanım Geçmişi',
    'capex.totalBudget': 'Toplam Bütçe',
    'capex.usageRate': 'Kullanım Oranı',
    'capex.transactionHistory': 'İşlem Geçmişi',
    'capex.noOrders': 'Bu CAPEX ile oluşturulmuş sipariş bulunmamaktadır.',
    'capex.orderFieldCompany': 'Şirket:',
    'capex.orderFieldLocation': 'Lokasyon:',
    'capex.orderFieldSupplier': 'Tedarikçi:',
    'capex.orderFieldCategory': 'Kategori:',
    'capex.pdfTitle': 'CAPEX Raporu',
    'capex.pdfDate': 'Tarih:',
    'capex.pdfColCapexNo': 'CAPEX No',
    'capex.pdfColCompany': 'Şirket',
    'capex.pdfColCategory': 'Kategori',
    'capex.pdfColYear': 'Yıl',
    'capex.pdfColTotalBudget': 'Toplam Bütçe',
    'capex.pdfColUsed': 'Kullanılan',
    'capex.pdfColRemaining': 'Kalan',
    'capex.pdfColStatus': 'Durum',
    'capex.pdfReady': 'PDF raporu hazırlandı',
    'capex.excelDownloaded': 'Excel dosyası başarıyla indirildi',
    'capex.errorLoad': 'Veriler yüklenirken hata oluştu',
    'capex.errorRequiredFields': 'Zorunlu alanları doldurunuz',
    'capex.errorSave': 'CAPEX kaydedilirken hata oluştu',
    'capex.errorClearBlocked': 'Bloke tutarı temizlenirken hata oluştu',
    'capex.errorCategoryAdd': 'Kategori eklenemedi',
    'capex.errorCategoryAddGeneral': 'Kategori eklenirken hata oluştu',
    'capex.errorLoadOrders': 'CAPEX siparişleri yüklenirken hata oluştu',
    'capex.successUpdated': 'CAPEX güncellendi',
    'capex.successCreated': 'CAPEX oluşturuldu',
    'capex.successCategoryAdded': 'Kategori eklendi',
    'capex.orderStatusCreated': 'Sipariş Oluşturuldu',
    'capex.orderStatusPending': 'Beklemede',
    'capex.orderStatusApproved': 'Onaylandı',
    'capex.orderStatusOrdered': 'Sipariş Verildi',
    'capex.orderStatusDelivered': 'Teslim Edildi',
    'capex.orderStatusCompleted': 'Tamamlandı',
    'capex.orderStatusCancelled': 'İptal Edildi',
    // PhysicalServersPage
    'physerver.title': 'Fiziksel Sunucular',
    'physerver.subtitle': 'Sunucu altyapısı yönetimi ve izleme',
    'physerver.newServer': 'Yeni Sunucu',
    'physerver.searchPlaceholder': 'Sunucu ara...',
    'physerver.allStatuses': 'Tüm Durumlar',
    'physerver.allCompanies': 'Tüm Şirketler',
    'physerver.allLocations': 'Tüm Konumlar',
    'physerver.allBrands': 'Tüm Markalar',
    'physerver.allServerTypes': 'Tüm Türler',
    'physerver.excelSheet': 'Fiziksel Sunucular',
    'physerver.excelFilename': 'fiziksel-sunucular',
    'physerver.pdfTitle': 'Fiziksel Sunucular Raporu',
    'physerver.pdfReportDate': 'Rapor Tarihi:',
    'physerver.pdfTotal': 'Toplam Sunucu:',
    'physerver.exportExcelSuccess': 'kayıt Excel\'e aktarıldı',
    'physerver.exportExcelError': 'Excel aktarımı sırasında hata oluştu',
    'physerver.exportPdfSuccess': 'kayıt PDF\'e aktarıldı',
    'physerver.exportPdfError': 'PDF aktarımı sırasında hata oluştu',
    'physerver.statusActive': 'Aktif',
    'physerver.statusMaintenance': 'Bakımda',
    'physerver.statusOffline': 'Çevrimdışı',
    'physerver.statusDecommissioned': 'Hizmet Dışı',
    'physerver.statTotalServers': 'Toplam Sunucu',
    'physerver.statActive': 'Aktif',
    'physerver.statTotalRAM': 'Toplam RAM',
    'physerver.statTotalStorage': 'Toplam Depolama',
    'physerver.colServerName': 'Sunucu Adı',
    'physerver.colHostname': 'Hostname',
    'physerver.colIPAddress': 'IP Adresi',
    'physerver.colBrandModel': 'Marka/Model',
    'physerver.colCompany': 'Şirket',
    'physerver.colLocation': 'Lokasyon',
    'physerver.colResources': 'Kaynaklar (Kalan/Toplam)',
    'physerver.colStatus': 'Durum',
    'physerver.colActions': 'İşlemler',
    'physerver.notFound': 'Sunucu bulunamadı',
    'physerver.notFoundDesc': 'Arama kriterlerinize uygun sunucu bulunamadı.',
    'physerver.titleView': 'Detayları Görüntüle',
    'physerver.titleDuplicate': 'Kopyala',
    'physerver.titleEdit': 'Düzenle',
    'physerver.titleDelete': 'Sil',
    'physerver.confirmDelete': 'Bu fiziksel sunucuyu silmek istediğinizden emin misiniz?',
    'physerver.modalTitleEdit': 'Sunucu Düzenle',
    'physerver.modalTitleNew': 'Yeni Sunucu',
    'physerver.fieldServerName': 'Sunucu Adı *',
    'physerver.fieldHostname': 'Hostname *',
    'physerver.fieldIPAddress': 'IP Adresi *',
    'physerver.fieldServerType': 'Sunucu Tipi *',
    'physerver.fieldBrand': 'Marka *',
    'physerver.fieldModel': 'Model *',
    'physerver.fieldSerialNo': 'Seri No *',
    'physerver.fieldRAM': 'RAM (GB) *',
    'physerver.fieldStorage': 'Depolama (GB) *',
    'physerver.fieldProcessor': 'İşlemci *',
    'physerver.fieldCPUCores': 'CPU Çekirdek Sayısı *',
    'physerver.fieldOS': 'İşletim Sistemi *',
    'physerver.fieldCompany': 'Şirket *',
    'physerver.selectCompany': 'Şirket Seçin',
    'physerver.fieldLocation': 'Lokasyon *',
    'physerver.selectLocation': 'Lokasyon Seçin',
    'physerver.fieldPurchaseDate': 'Satın Alma Tarihi *',
    'physerver.fieldWarrantyEnd': 'Garanti Bitiş Tarihi',
    'physerver.fieldAssignedAdmin': 'Atanan Admin',
    'physerver.selectAdmin': 'Admin Seçin (Opsiyonel)',
    'physerver.btnCancel': 'İptal',
    'physerver.btnUpdate': 'Güncelle',
    'physerver.btnSave': 'Kaydet',
    'physerver.detailTitle': 'Sunucu Detayları',
    'physerver.detailSectionServer': 'Sunucu Bilgileri',
    'physerver.detailServerName': 'Sunucu Adı:',
    'physerver.detailHostname': 'Hostname:',
    'physerver.detailIPAddress': 'IP Adresi:',
    'physerver.detailBrandModel': 'Marka/Model:',
    'physerver.detailOS': 'İşletim Sistemi:',
    'physerver.detailSectionHardware': 'Donanım Özellikleri',
    'physerver.detailProcessor': 'İşlemci:',
    'physerver.detailRAM': 'RAM:',
    'physerver.detailStorage': 'Depolama:',
    'physerver.detailPowerConsumption': 'Güç Tüketimi:',
    'physerver.detailUptime': 'Uptime:',
    'physerver.detailUptimeDays': '{days} gün',
    'physerver.detailSectionVMs': 'Sanal Sunucular ve Kaynak Kullanımı',
    'physerver.vcpuAllocation': 'vCPU Tahsisi',
    'physerver.ramAllocation': 'RAM Tahsisi',
    'physerver.diskAllocation': 'Disk Tahsisi',
    'physerver.allocated': 'Tahsis Edilen:',
    'physerver.remaining': 'Kalan:',
    'physerver.connectedVMs': 'Bağlı Sanal Sunucular ({count})',
    'physerver.noVMs': 'Bu fiziksel sunucuya bağlı sanal sunucu bulunmamaktadır.',
    'physerver.duplicateSuffix': '(Kopya)',
    'physerver.errorLoad': 'Veriler yüklenirken hata oluştu',
    'physerver.errorRequiredFields': 'Tüm zorunlu alanları doldurunuz (Seri Numarası, Marka, Model, İşlemci, İşletim Sistemi, Şirket, Lokasyon, Satın Alma Tarihi)',
    'physerver.errorInvalidIP': 'Geçersiz IP adresi formatı. Örnek: 192.168.1.100',
    'physerver.errorDuplicateHostname': 'Bu hostname zaten kullanılıyor: {name}',
    'physerver.errorDuplicateIP': 'Bu IP adresi zaten kullanılıyor: {name} ({ip})',
    'physerver.errorSave': 'Sunucu kaydedilirken hata oluştu',
    'physerver.errorDelete': 'Sunucu silinirken hata oluştu',
    'physerver.successUpdated': 'Sunucu güncellendi',
    'physerver.successCreated': 'Sunucu oluşturuldu',
    'physerver.successDeleted': 'Sunucu silindi',

    // Circuits Page
    'circuits.title': 'Devre Yönetimi',
    'circuits.btnNew': 'Yeni Devre',
    'circuits.cardFiber': 'Fiber Devreler',
    'circuits.cardRadioLink': 'Radio Link Devreler',
    'circuits.cardAdslVdsl': 'Adsl & Vdsl Devreler',
    'circuits.searchPlaceholder': 'Devre adı, servis sağlayıcı, paket adı veya adres ara...',
    'circuits.filterTitle': 'Filtreler',
    'circuits.filterClearAll': 'Tümünü Temizle',
    'circuits.filterStatus': 'Durum',
    'circuits.filterAll': 'Tümü',
    'circuits.filterInfrastructure': 'Altyapı',
    'circuits.filterAdslVdslAll': 'Adsl & Vdsl (Tümü)',
    'circuits.filterLocation': 'Lokasyon',
    'circuits.colSeqNo': 'Sıra No',
    'circuits.colCircuitName': 'Devre Adı',
    'circuits.colServiceProvider': 'Servis Sağlayıcı',
    'circuits.colPackage': 'Paket',
    'circuits.colSpeed': 'Hız',
    'circuits.colInfrastructure': 'Altyapı',
    'circuits.colLocation': 'Lokasyon',
    'circuits.colStatus': 'Durum',
    'circuits.colActions': 'İşlemler',
    'circuits.emptyState': 'Devre bulunamadı',
    'circuits.actionEdit': 'Düzenle',
    'circuits.actionHistory': 'Geçmiş İşlemler',
    'circuits.actionDelete': 'Sil',
    'circuits.actionDownloadContract': 'Sözleşme İndir',
    'circuits.actionUploadContract': 'Sözleşme Yükle',
    'circuits.paginationPrev': 'Önceki',
    'circuits.paginationNext': 'Sonraki',
    'circuits.paginationPage': 'Sayfa {current} / {total}',
    'circuits.paginationInfo': 'Toplam {total} devre\'den {start}-{end} arası gösteriliyor',
    'circuits.emptyTitle': 'Henüz devre eklenmemiş',
    'circuits.emptyDesc': 'Yeni devre eklemek için yukarıdaki butonu kullanın.',
    'circuits.emptyBtn': 'İlk Devreyi Ekle',
    'circuits.statusActive': 'Aktif',
    'circuits.statusInactive': 'Pasif',
    'circuits.statusSuspended': 'Askıda',
    'circuits.formTitleNew': 'Yeni Devre Ekle',
    'circuits.formTitleEdit': 'Devre Düzenle',
    'circuits.labelServiceProvider': 'Servis Sağlayıcı *',
    'circuits.labelPackageName': 'Paket Adı *',
    'circuits.labelCircuitName': 'Devre Adı *',
    'circuits.labelDownloadSpeed': 'Download Hızı (Mbps) *',
    'circuits.labelUploadSpeed': 'Upload Hızı (Mbps) *',
    'circuits.labelPrice': 'Fiyat (TL) *',
    'circuits.labelInfrastructure': 'Altyapı *',
    'circuits.labelAddress': 'Adres (10.1.3.4/30 vb) *',
    'circuits.labelLocation': 'Lokasyon *',
    'circuits.placeholderLocation': 'Lokasyon Seçin',
    'circuits.labelStartDate': 'Başlangıç Tarihi',
    'circuits.labelEndDate': 'Bitiş Tarihi',
    'circuits.labelStatus': 'Durum',
    'circuits.labelNotes': 'Notlar',
    'circuits.cancel': 'İptal',
    'circuits.create': 'Oluştur',
    'circuits.update': 'Güncelle',
    'circuits.contractTitle': 'Sözleşme Yükle',
    'circuits.contractCircuit': 'Devre:',
    'circuits.contractProvider': 'Servis Sağlayıcı:',
    'circuits.contractFileLabel': 'Sözleşme Dosyası (PDF)',
    'circuits.contractUploading': 'Yükleniyor...',
    'circuits.contractUpload': 'Yükle',
    'circuits.historyTitle': 'Geçmiş İşlemler - {name}',
    'circuits.historyLoading': 'Geçmiş işlemler yükleniyor...',
    'circuits.historyEmptyTitle': 'Henüz işlem geçmişi yok',
    'circuits.historyEmptyDesc': 'Bu devre için henüz kayıtlı işlem bulunmuyor.',
    'circuits.historyActionCreated': 'Oluşturuldu',
    'circuits.historyActionUpdated': 'Güncellendi',
    'circuits.historyActionDeleted': 'Silindi',
    'circuits.historyUser': 'Kullanıcı:',
    'circuits.historyUnknown': 'Bilinmeyen',
    'circuits.historyDesc': 'Açıklama:',
    'circuits.historyChanges': 'Değişiklikler:',
    'circuits.historyEmpty': 'Boş',
    'circuits.fieldServiceProvider': 'Servis Sağlayıcı',
    'circuits.fieldPackageName': 'Paket Adı',
    'circuits.fieldCircuitName': 'Devre Adı',
    'circuits.fieldDownloadSpeed': 'Download Hızı (Mbps)',
    'circuits.fieldUploadSpeed': 'Upload Hızı (Mbps)',
    'circuits.fieldPrice': 'Fiyat (TL)',
    'circuits.fieldInfrastructure': 'Altyapı',
    'circuits.fieldAddress': 'Adres',
    'circuits.fieldLocation': 'Lokasyon',
    'circuits.fieldStartDate': 'Başlangıç Tarihi',
    'circuits.fieldEndDate': 'Bitiş Tarihi',
    'circuits.fieldNotes': 'Notlar',
    'circuits.fieldStatus': 'Durum',
    'circuits.errLoad': 'Devreler yüklenirken hata oluştu: {msg}',
    'circuits.errSave': 'Devre kaydedilirken hata oluştu: {msg}',
    'circuits.errDelete': 'Devre silinirken hata oluştu: {msg}',
    'circuits.errContractSelect': 'Lütfen bir dosya seçin.',
    'circuits.errContractUpload': 'Sözleşme yüklenirken hata oluştu: {msg}',
    'circuits.errContractDownload': 'Sözleşme indirilirken hata oluştu: {msg}',
    'circuits.errHistory': 'Geçmiş işlemler yüklenirken hata oluştu',
    'circuits.successUpdate': 'Devre başarıyla güncellendi!',
    'circuits.successCreate': 'Devre başarıyla oluşturuldu!',
    'circuits.successDelete': 'Devre başarıyla silindi!',
    'circuits.successContractUpload': 'Sözleşme başarıyla yüklendi!',
    'circuits.notifUpdated': 'Devre Güncellendi',
    'circuits.notifUpdatedMsg': '{name} devresi başarıyla güncellendi',
    'circuits.notifCreated': 'Devre Oluşturuldu',
    'circuits.notifCreatedMsg': '{name} devresi başarıyla oluşturuldu',
    'circuits.notifDeleted': 'Devre Silindi',
    'circuits.notifDeletedMsg': '{name} devresi başarıyla silindi',
    'circuits.confirmDelete': '"{name}" devresini silmek istediğinizden emin misiniz?',
    'circuits.notifDeleteErr': 'Silme Hatası',
    'circuits.notifDeleteErrMsg': 'Devre silinirken hata oluştu',
    'circuits.excelSuccess': '{count} devre başarıyla Excel\'e aktarıldı',
    'circuits.excelError': 'Excel dosyası oluşturulurken hata oluştu',
    'circuits.pdfSuccess': '{count} devre başarıyla PDF\'e aktarıldı',
    'circuits.pdfError': 'PDF dosyası oluşturulurken hata oluştu',
    'circuits.excelSheet': 'Devreler',
    'circuits.pdfTitle': 'Devreler Listesi',
    'circuits.pdfReportDate': 'Rapor Tarihi: {date}',
    'circuits.pdfTotalCircuits': 'Toplam Devre: {count}',
    'circuits.pdfSummaryTitle': 'Özet Bilgiler',
    'circuits.pdfActive': 'Aktif Devre: {count}',
    'circuits.pdfTotalCost': 'Toplam Aylık Maliyet: {amount} TL',
    'circuits.excelSeqNo': 'Sıra No',
    'circuits.excelCircuitName': 'Devre Adı',
    'circuits.excelAddress': 'Adres',
    'circuits.excelServiceProvider': 'Servis Sağlayıcı',
    'circuits.excelPackage': 'Paket',
    'circuits.excelDownloadSpeed': 'Download Hızı (Mbps)',
    'circuits.excelUploadSpeed': 'Upload Hızı (Mbps)',
    'circuits.excelTotalSpeed': 'Hız (Toplam)',
    'circuits.excelInfrastructure': 'Altyapı',
    'circuits.excelLocation': 'Lokasyon',
    'circuits.excelStatus': 'Durum',
    'circuits.excelPrice': 'Fiyat (TL)',
    'circuits.excelStartDate': 'Başlangıç Tarihi',
    'circuits.excelEndDate': 'Bitiş Tarihi',
    'circuits.excelNotes': 'Notlar',
    'circuits.excelCreatedAt': 'Oluşturulma Tarihi',
    'circuits.pdfColSeq': 'Sıra',
    'circuits.pdfColCircuit': 'Devre Adı',
    'circuits.pdfColProvider': 'Servis Sağlayıcı',
    'circuits.pdfColPackage': 'Paket',
    'circuits.pdfColSpeed': 'Hız',
    'circuits.pdfColInfrastructure': 'Altyapı',
    'circuits.pdfColLocation': 'Lokasyon',
    'circuits.pdfColStatus': 'Durum',
    'circuits.success': 'Başarılı',
    'circuits.error': 'Hata',

    // Assignment Forms Page
    'assignform.title': 'Zimmet Teslim Formları',
    'assignform.subtitle': 'Cihaz zimmet teslim formlarını yönetin',
    'assignform.tabMobile': 'Cep Telefonu Zimmetleri',
    'assignform.tabComputer': 'Bilgisayar Zimmetleri',
    'assignform.tabMonitor': 'Monitör Zimmetleri',
    'assignform.searchPlaceholder': 'Form numarası, envanter numarası, kullanıcı adı...',
    'assignform.filterAllStatuses': 'Tüm Durumlar',
    'assignform.statusPending': 'Beklemede',
    'assignform.statusSigned': 'İmzalandı',
    'assignform.statusCompleted': 'Tamamlandı',
    'assignform.cardTotal': 'Toplam Form',
    'assignform.cardAssignment': 'Zimmet Teslim (ZTF)',
    'assignform.cardReturn': 'Zimmet Geri Teslim (ZGTF)',
    'assignform.cardUnsigned': 'İmzalanmamış',
    'assignform.sectionAssignment': 'ZİMMET TESLİM FORMLARI (ZTF) - {count} Form',
    'assignform.sectionReturn': 'ZİMMET GERİ TESLİM FORMLARI (ZGTF) - {count} Form',
    'assignform.colFormInfo': 'Form Bilgileri',
    'assignform.colMobile': 'Cep Telefonu',
    'assignform.colComputer': 'Bilgisayar',
    'assignform.colMonitor': 'Monitör',
    'assignform.colUser': 'Atanan Kullanıcı',
    'assignform.colStatus': 'Durum',
    'assignform.colDate': 'Tarih',
    'assignform.colActions': 'İşlemler',
    'assignform.createdBy': 'Oluşturan: {name}',
    'assignform.actionDetails': 'Detayları Görüntüle',
    'assignform.actionPDF': 'PDF Oluştur',
    'assignform.actionDownloadSigned': 'Islak İmzalı Formu İndir',
    'assignform.actionSendEmail': 'E-posta Gönder ({email})',
    'assignform.actionUploadSigned': 'Islak İmzalı Form Yükle',
    'assignform.actionReuploadSigned': 'Islak İmzalı Formu Yeniden Yükle',
    'assignform.actionDelete': 'Sil',
    'assignform.emptyAssignment': 'Zimmet Teslim Formu bulunamadı',
    'assignform.emptyReturn': 'Zimmet Geri Teslim Formu bulunamadı',
    'assignform.emptySearch': 'Arama kriterlerinize uygun form bulunamadı.',
    'assignform.emptyNoAssignment': 'Henüz zimmet teslim formu oluşturulmamış.',
    'assignform.emptyNoReturn': 'Henüz zimmet geri teslim formu oluşturulmamış.',
    'assignform.emptyAll': 'Form bulunamadı',
    'assignform.emptyAllSearch': 'Arama kriterlerinize uygun form bulunamadı.',
    'assignform.emptyAllNone': 'Henüz zimmet formu oluşturulmamış.',
    'assignform.paginationInfo': 'Toplam {total} form - Sayfa {page} / {totalPages}',
    'assignform.paginationPrev': 'Önceki',
    'assignform.paginationNext': 'Sonraki',
    'assignform.uploadTitle': 'Islak İmzalı Form Yükle',
    'assignform.reuploadTitle': 'Islak İmzalı Formu Yeniden Yükle',
    'assignform.uploadWarning': '⚠️ Bu forma zaten bir evrak yüklü. Yeni dosya yüklerseniz eski dosya otomatik olarak silinecektir.',
    'assignform.uploadFormNo': 'Form Numarası:',
    'assignform.uploadDevice': 'Cihaz:',
    'assignform.uploadPreview': 'Önizleme',
    'assignform.uploadFileLabel': 'Islak İmzalı Form (PDF, JPG, PNG)',
    'assignform.uploadCamera': 'Kamera',
    'assignform.uploadChooseFile': 'Dosya Seç',
    'assignform.uploadNotesLabel': 'Notlar (Opsiyonel)',
    'assignform.uploadNotesPlaceholder': 'Ek notlar...',
    'assignform.uploading': 'Yükleniyor...',
    'assignform.detailsTitle': 'Zimmet Formu Detayları',
    'assignform.detailsFormInfo': 'Form Bilgileri',
    'assignform.detailsFormNumber': 'Form Numarası',
    'assignform.detailsStatus': 'Durum',
    'assignform.detailsAssignmentDate': 'Atama Tarihi',
    'assignform.detailsCreatedAt': 'Oluşturulma Tarihi',
    'assignform.detailsDeviceInfoMobile': 'Cep Telefonu Bilgileri',
    'assignform.detailsDeviceInfoComputer': 'Bilgisayar Bilgileri',
    'assignform.detailsInventoryNo': 'Envanter Numarası',
    'assignform.detailsBrandModel': 'Marka/Model',
    'assignform.detailsColor': 'Renk',
    'assignform.detailsStorage': 'Hafıza',
    'assignform.detailsSerialNo': 'Seri No',
    'assignform.detailsProcessor': 'İşlemci',
    'assignform.detailsGraphicsCard': 'Ekran Kartı',
    'assignform.detailsAssignedUser': 'Atanan Kullanıcı',
    'assignform.detailsFullName': 'Ad Soyad',
    'assignform.detailsEmail': 'E-posta',
    'assignform.detailsPhone': 'Telefon',
    'assignform.detailsDepartment': 'Departman',
    'assignform.detailsCreatedBy': 'Formu Oluşturan',
    'assignform.detailsNotes': 'Notlar',
    'assignform.emailHistory': 'E-posta Gönderim Geçmişi',
    'assignform.emailSend': 'E-posta Gönder',
    'assignform.emailSending': 'Gönderiliyor...',
    'assignform.emailHistoryLoading': 'Yükleniyor...',
    'assignform.emailHistoryEmpty': 'Henüz e-posta gönderilmemiş',
    'assignform.emailSent': 'Gönderildi',
    'assignform.emailFailed': 'Gönderilemedi',
    'assignform.emailSentBy': 'Gönderen: {name}',
    'assignform.close': 'Kapat',
    'assignform.errLoadForms': 'Formlar yüklenemedi',
    'assignform.errFileProcess': 'Dosya işlenirken hata oluştu',
    'assignform.errFileUpload': 'Dosya yüklenemedi',
    'assignform.errUploadTimeout': 'Dosya yükleme zaman aşımına uğradı. Lütfen daha küçük bir dosya deneyin.',
    'assignform.errDownloadFile': 'Dosya indirilemedi',
    'assignform.errDownloadEmpty': 'İndirilen dosya boş. Lütfen dosyayı tekrar yükleyin.',
    'assignform.errDownloadGeneral': 'Dosya indirilirken bir hata oluştu',
    'assignform.errDeleteForm': 'Form silinemedi',
    'assignform.errNoSignedForm': 'Islak imzalı form henüz yüklenmemiş',
    'assignform.errSendEmail': 'E-posta gönderilemedi',
    'assignform.successUpload': 'Islak imzalı form yüklendi',
    'assignform.successDownload': 'Dosya indirildi',
    'assignform.successDelete': 'Zimmet formu silindi',
    'assignform.confirmDelete': '{formNo} numaralı zimmet formunu silmek istediğinizden emin misiniz?',
    'assignform.confirmSendEmail': 'Zimmet formu ({formNo}) {name} adresine ({email}) e-posta ile gönderilsin mi?',
    'assignform.notifError': 'Hata',
    'assignform.notifSuccess': 'Başarılı',

    // ProfilePage
    'profile.title': 'Profil Ayarları',
    'profile.subtitle': 'Hesap bilgilerinizi ve tercihlerinizi yönetin',
    'profile.tabProfile': 'Profil Bilgileri',
    'profile.tabSecurity': 'Güvenlik',
    'profile.tabNotifications': 'Bildirimler',
    'profile.tabPreferences': 'Tercihler',
    'profile.tabPerformance': 'Performans',
    'profile.fieldName': 'Ad Soyad *',
    'profile.fieldEmail': 'E-posta *',
    'profile.fieldPhone': 'Telefon',
    'profile.fieldTitle': 'Ünvan',
    'profile.fieldDepartment': 'Departman',
    'profile.fieldLocation': 'Lokasyon *',
    'profile.selectLocation': 'Lokasyon seçin',
    'profile.fieldBirthDate': 'Doğum Tarihi',
    'profile.fieldEmergencyContact': 'Acil Durum İletişim',
    'profile.fieldEmergencyPhone': 'Acil Durum Telefon',
    'profile.fieldAddress': 'Adres',
    'profile.save': 'Kaydet',
    'profile.passwordChange': 'Parola Değişimi',
    'profile.fieldCurrentPassword': 'Mevcut Parola *',
    'profile.fieldNewPassword': 'Yeni Parola *',
    'profile.fieldConfirmPassword': 'Yeni Parola (Tekrar) *',
    'profile.generatePassword': 'Oluştur',
    'profile.passwordRequirements': 'Parola Gereksinimleri:',
    'profile.pwdReq1': 'En az 8 karakter',
    'profile.pwdReq2': 'En az 1 büyük harf',
    'profile.pwdReq3': 'En az 1 küçük harf',
    'profile.pwdReq4': 'En az 1 rakam',
    'profile.pwdReq5': 'En az 1 özel karakter (!@#$%^&*)',
    'profile.changePassword': 'Parolayı Değiştir',
    'profile.notifTitle': 'Bildirim Ayarları',
    'profile.emailNotif': 'E-posta Bildirimleri',
    'profile.emailNotifDesc': 'Sistem güncellemeleri ve önemli bildirimler',
    'profile.prefsTitle': 'Uygulama Tercihleri',
    'profile.fieldLanguage': 'Dil',
    'profile.fieldTimezone': 'Zaman Dilimi',
    'profile.fieldTheme': 'Tema',
    'profile.themeLight': 'Açık',
    'profile.themeDark': 'Koyu',
    'profile.themeAuto': 'Otomatik',
    'profile.fieldItemsPerPage': 'Sayfa Başına Kayıt',
    'profile.sidebarAutoHide': 'Sidebar Otomatik Gizle',
    'profile.sidebarAutoHideDesc': 'Sidebar\'ı varsayılan olarak kapalı tut',
    'profile.performanceTitle': 'Checklist Performansı',
    'profile.rankLabel': 'Sıralamanız',
    'profile.rankAmong': '/ {count} admin arasında',
    'profile.today': 'Bugün',
    'profile.thisWeek': 'Bu Hafta',
    'profile.thisMonth': 'Bu Ay',
    'profile.total': 'Toplam',
    'profile.points': 'puan',
    'profile.pointSystem': 'Puan Sistemi',
    'profile.pointSystemDesc': 'Her tamamlanan checklist görevi için +1 puan kazanırsınız. Puanlar günlük birikir ve sıralama gerçek zamanlı güncellenir. Checklist sayfasında diğer adminlerin aktivitelerini takip edebilirsiniz.',
    'profile.loadingPoints': 'Puan verisi yükleniyor...',
    'profile.successProfile': 'Profil bilgileriniz güncellendi',
    'profile.errLoad': 'Veriler yüklenirken hata oluştu',
    'profile.errProfileSave': 'Profil güncellenirken hata oluştu',
    'profile.errPasswordMismatch': 'Yeni parolalar eşleşmiyor!',
    'profile.errPasswordLength': 'Parola en az 8 karakter olmalıdır!',
    'profile.successPassword': 'Parolanız başarıyla değiştirildi',
    'profile.errPasswordChange': 'Parola değiştirilirken hata oluştu',
    'profile.successAvatar': 'Profil fotoğrafınız güncellendi',
    'profile.errAvatar': 'Profil fotoğrafı yüklenirken hata oluştu',

    // NotificationSettings
    'notifSettings.title': 'Bildirim Ayarları',
    'notifSettings.subtitle': 'Bildirim tercihlerinizi yönetin',
    'notifSettings.typesTitle': 'Bildirim Türleri',
    'notifSettings.emailNotif': 'E-posta Bildirimleri',
    'notifSettings.emailNotifDesc': 'Önemli güncellemeler e-posta ile gönderilir',
    'notifSettings.pushNotif': 'Push Bildirimleri',
    'notifSettings.pushNotifDesc': 'Mobil cihazınıza anlık bildirimler',
    'notifSettings.desktopNotif': 'Masaüstü Bildirimleri',
    'notifSettings.desktopNotifDesc': 'Tarayıcı bildirimleri (izin gerektirir)',
    'notifSettings.smsNotif': 'SMS Bildirimleri',
    'notifSettings.smsNotifDesc': 'Kritik uyarılar için SMS gönderimi',
    'notifSettings.categoriesTitle': 'Bildirim Kategorileri',
    'notifSettings.catOrders': 'Siparişler',
    'notifSettings.catOrdersDesc': 'Sipariş oluşturma, onay ve teslimat bildirimleri',
    'notifSettings.catServices': 'Teknik Servis',
    'notifSettings.catServicesDesc': 'Servis kayıtları, durum güncellemeleri ve tamamlanma bildirimleri',
    'notifSettings.catCapex': 'CAPEX',
    'notifSettings.catCapexDesc': 'Bütçe uyarıları ve harcama bildirimleri',
    'notifSettings.catSystem': 'Sistem',
    'notifSettings.catSystemDesc': 'Sunucu performansı ve sistem durumu uyarıları',
    'notifSettings.catBackup': 'Yedekleme',
    'notifSettings.catBackupDesc': 'Yedekleme başarı/başarısızlık bildirimleri',
    'notifSettings.catSecurity': 'Güvenlik',
    'notifSettings.catSecurityDesc': 'Güvenlik uyarıları ve giriş bildirimleri',
    'notifSettings.quietHoursTitle': 'Sessiz Saatler',
    'notifSettings.quietHoursDesc': 'Belirtilen saatlerde bildirim almayın',
    'notifSettings.quietStart': 'Başlangıç Saati',
    'notifSettings.quietEnd': 'Bitiş Saati',
    'notifSettings.digestTitle': 'Özet Bildirimleri',
    'notifSettings.digestDesc': 'Bildirimlerin özetini belirli aralıklarla alın',
    'notifSettings.digestFrequency': 'Özet Sıklığı',
    'notifSettings.digestNever': 'Hiçbir zaman',
    'notifSettings.digestDaily': 'Günlük',
    'notifSettings.digestWeekly': 'Haftalık',
    'notifSettings.digestMonthly': 'Aylık',
    'notifSettings.saveBtn': 'Ayarları Kaydet',

    // MenuManagementPage
    'menuMgmt.title': 'Menü Yönetimi',
    'menuMgmt.subtitle': 'Sidebar menülerini dinamik olarak yönetin',
    'menuMgmt.backup': 'Yedekle',
    'menuMgmt.newMenu': 'Yeni Menü',
    'menuMgmt.passive': 'Pasif',
    'menuMgmt.formEditTitle': 'Menü Düzenle',
    'menuMgmt.formNewTitle': 'Yeni Menü Ekle',
    'menuMgmt.fieldNameTR': 'Menü Adı (TR) *',
    'menuMgmt.fieldNameEN': 'Menu Name (EN)',
    'menuMgmt.fieldIcon': 'İkon',
    'menuMgmt.selectIcon': 'İkon Seçin',
    'menuMgmt.fieldParent': 'Üst Menü',
    'menuMgmt.mainMenu': 'Ana Menü',
    'menuMgmt.fieldOrder': 'Sıra',
    'menuMgmt.fieldRoles': 'Roller',
    'menuMgmt.fieldActive': 'Aktif',
    'menuMgmt.save': 'Kaydet',
    'menuMgmt.cancel': 'İptal',
    'menuMgmt.successCreated': 'Yeni menü başarıyla eklendi',
    'menuMgmt.successUpdated': 'Menü başarıyla güncellendi',
    'menuMgmt.errOperation': 'İşlem başarısız oldu',
    'menuMgmt.confirmDelete': 'Bu menü öğesini silmek istediğinizden emin misiniz?',
    'menuMgmt.successDeleted': 'Menü öğesi başarıyla silindi',
    'menuMgmt.errDelete': 'Silme işlemi başarısız oldu',
    'menuMgmt.successBackup': 'Menü yapısı başarıyla indirildi.',
    'menuMgmt.errBackup': 'Menü yedeği alınırken bir sorun oluştu.',
    'menuMgmt.successReorder': 'Menü sırası güncellendi',
    'menuMgmt.bulkRoleUpdate': '{count} menü öğesinin rolleri güncellendi',
    'menuMgmt.errBulkRole': 'Toplu rol güncelleme başarısız oldu',

    // UsersPage
    'users.title': 'Kullanıcı Yönetimi',
    'users.subtitle': 'Sistem kullanıcılarını ve rol yetkilerini yönetin',
    'users.newUser': 'Yeni Kullanıcı',
    'users.tabUsers': 'Kullanıcılar',
    'users.tabPermissions': 'Rol Erişim Yetkileri',
    'users.statTotal': 'Toplam',
    'users.statActive': 'Aktif',
    'users.statOnline': 'Çevrimiçi',
    'users.statAdmin': 'Admin',
    'users.searchPlaceholder': 'Kullanıcı ara...',
    'users.filterAllRoles': 'Tüm Roller',
    'users.filterAllStatuses': 'Tüm Durumlar',
    'users.filterAllLocations': 'Tüm Lokasyonlar',
    'users.filterActive': 'Aktif',
    'users.filterInactive': 'Pasif',
    'users.colUser': 'Kullanıcı',
    'users.colContact': 'İletişim',
    'users.colRole': 'Rol',
    'users.colLocation': 'Lokasyon',
    'users.colStatus': 'Durum',
    'users.colLastLogin': 'Son Giriş',
    'users.colActions': 'İşlemler',
    'users.notFound': 'Kullanıcı bulunamadı',
    'users.notFoundDesc': 'Arama kriterlerinizi değiştirerek tekrar deneyin',
    'users.statusActive': 'Aktif',
    'users.statusInactive': 'Pasif',
    'users.unassigned': 'Atanmamış',
    'users.never': 'Hiç',
    'users.lastLogin': 'Son giriş: {date}',
    'users.paginationInfo': 'Toplam {total} kullanıcıdan {start}-{end} arası gösteriliyor',
    'users.permissionsTitle': 'Rol Erişim Yetkileri',
    'users.permissionsDesc': 'Her rol için menü ve işlem yetkilerini belirleyin',
    'users.permColMenu': 'Menü / Alt Menü',
    'users.permLegend': 'G: Görüntüle, E: Ekle, D: Düzenle, S: Sil',
    'users.permEachBox': 'Her kutucuk ilgili yetkiyi temsil eder',
    'users.savePermissions': 'Değişiklikleri Kaydet',
    'users.modalEditTitle': 'Kullanıcı Düzenle',
    'users.modalNewTitle': 'Yeni Kullanıcı',
    'users.modalEditSubtitle': 'Kullanıcı bilgilerini güncelleyin',
    'users.modalNewSubtitle': 'Yeni kullanıcı bilgilerini girin',
    'users.sectionBasic': 'Temel Bilgiler',
    'users.sectionPersonal': 'Kişisel Bilgiler',
    'users.sectionSecurity': 'Güvenlik',
    'users.sectionNotes': 'Notlar',
    'users.fieldName': 'Ad Soyad',
    'users.fieldEmail': 'E-posta',
    'users.fieldPhone': 'Telefon',
    'users.fieldTitle': 'Ünvan',
    'users.fieldDepartment': 'Departman',
    'users.selectDepartment': 'Departman Seçin',
    'users.fieldLocation': 'Lokasyon',
    'users.selectLocation': 'Lokasyon seçin',
    'users.fieldAuthorizedLocations': 'Yetkili Olduğu Lokasyonlar',
    'users.selectedLocations': 'Seçilen lokasyonlar: {names}',
    'users.fieldCompany': 'Şirket',
    'users.selectCompany': 'Şirket seçin (Opsiyonel)',
    'users.fieldRole': 'Yetki',
    'users.fieldBirthDate': 'Doğum Tarihi',
    'users.fieldHireDate': 'İşe Başlama Tarihi',
    'users.optionalDate': '(İsteğe Bağlı)',
    'users.fieldEmergencyContact': 'Acil Durum İletişim',
    'users.fieldEmergencyPhone': 'Acil Durum Telefon',
    'users.fieldAddress': 'Adres',
    'users.fieldPassword': 'Parola',
    'users.fieldNotes': 'Kullanıcı Notları',
    'users.generatePassword': 'Oluştur',
    'users.cancel': 'İptal',
    'users.update': 'Güncelle',
    'users.save': 'Kaydet',
    'users.detailContactTitle': 'İletişim Bilgileri',
    'users.detailWorkTitle': 'İş Bilgileri',
    'users.detailPersonalTitle': 'Kişisel Bilgiler',
    'users.detailAddressTitle': 'Adres',
    'users.detailNotesTitle': 'Notlar',
    'users.detailSystemTitle': 'Sistem Bilgileri',
    'users.detailDepartment': 'Departman:',
    'users.detailHireDate': 'İşe Başlama:',
    'users.detailStatus': 'Durum:',
    'users.detailBirthDate': 'Doğum Tarihi:',
    'users.detailEmergencyContact': 'Acil İletişim:',
    'users.detailEmergencyPhone': 'Acil Telefon:',
    'users.detailCreatedAt': 'Kayıt Tarihi:',
    'users.detailUpdatedAt': 'Son Güncelleme:',
    'users.detailLastLogin': 'Son Giriş:',
    'users.detailEmailVerified': 'E-posta Doğrulandı:',
    'users.detailYes': 'Evet',
    'users.detailNo': 'Hayır',
    'users.addDeptTitle': 'Yeni Departman Ekle',
    'users.deptNameLabel': 'Departman Adı',
    'users.addDept': 'Ekle',
    'users.detailBtn': 'Detay',
    'users.editBtn': 'Düzenle',
    'users.passwordBtn': 'Parola',
    'users.labelBtn': 'Etiket',
    'users.deleteBtn': 'Sil',
    'users.errLoad': 'Veriler yüklenirken hata oluştu',
    'users.errRequiredFields': 'Ad Soyad ve E-posta alanları zorunludur',
    'users.errInvalidEmail': 'Geçerli bir e-posta adresi giriniz',
    'users.errNoLocation': 'Lütfen bir lokasyon seçiniz',
    'users.errNoCompany': 'Lütfen bir şirket seçiniz',
    'users.errSave': 'Kullanıcı kaydedilirken hata oluştu',
    'users.errCannotDeleteSelf': 'Kendi hesabınızı silemezsiniz',
    'users.errDelete': 'Kullanıcı silinirken hata oluştu',
    'users.errStatusChange': 'Kullanıcı durumu değiştirilirken hata oluştu',
    'users.errPasswordReset': 'Parola sıfırlanırken hata oluştu',
    'users.errPermSave': 'Rol yetkileri kaydedilirken hata oluştu',
    'users.errDeptEmpty': 'Departman adı boş olamaz',
    'users.errDeptExists': 'Bu departman zaten mevcut',
    'users.errDeptAdd': 'Departman eklenirken hata oluştu',
    'users.errEmailSend': 'E-posta gönderilirken hata oluştu',
    'users.successDeptAdded': 'Departman eklendi',
    'users.successPermSaved': 'Rol yetkileri kaydedildi',
    'users.emailSent': 'E-posta Gönderildi',
    'users.confirmExport': 'Kullanıcı listesini Excel dosyası olarak indirmek istediğinizden emin misiniz?',
    'users.exportSuccess': '{count} kullanıcı başarıyla dışarı aktarıldı',
    'users.errExport': 'Kullanıcılar dışarı aktarılırken hata oluştu',

    // Users - Zimmetli Ekipmanlar
    'users.detailAssetsTitle': 'Zimmetli Ekipmanlar',
    'users.detailAssetsPrintBtn': 'Zimmet Listesini Yazdır',
    'users.detailAssetsItemCount': '{count} kalem',
    'users.printAssetsTitle': 'Kullanıcı Zimmet Listesi',
    'users.printAssetsPrintedBy': 'Yazdıran',
    'users.printAssetsUser': 'Ad Soyad',
    'users.printAssetsDepartment': 'Departman',
    'users.printAssetsTitleField': 'Ünvan',
    'users.printAssetsLocation': 'Lokasyon',
    'users.printAssetsColSerial': 'Seri No / IMEI',
    'users.printAssetsColDetail': 'Detay',
    'users.printAssetsTotal': 'Toplam {count} kalem',
    'users.printAssetsPrintBtn': 'Yazdır / PDF Kaydet',
    'users.detailAssetsLoading': 'Yükleniyor...',
    'users.detailAssetsEmpty': 'Bu kullanıcıya atanmış ekipman bulunmuyor.',
    'users.detailAssetsGsm': 'GSM Hatları',
    'users.detailAssetsComputers': 'Bilgisayarlar',
    'users.detailAssetsMobilePhones': 'Mobil Telefonlar',
    'users.detailAssetsMonitors': 'Monitörler',
    'users.detailAssetsEquipment': 'Ekipmanlar',
    'users.detailAssetsForms': 'Zimmet Formları',
    'users.detailAssetsColLineNo': 'Hat No',
    'users.detailAssetsColTariff': 'Tarife',
    'users.detailAssetsColOperator': 'Operatör',
    'users.detailAssetsColStatus': 'Durum',
    'users.detailAssetsColInventory': 'Envanter No',
    'users.detailAssetsColBrandModel': 'Marka / Model',
    'users.detailAssetsColSerial': 'Seri No',
    'users.detailAssetsColLocation': 'Konum',
    'users.detailAssetsColImei': 'IMEI',
    'users.detailAssetsColCategory': 'Kategori',
    'users.detailAssetsColQty': 'Adet',
    'users.detailAssetsColAssignDate': 'Zimmet Tarihi',
    'users.detailAssetsColFormNo': 'Form No',
    'users.detailAssetsColType': 'Tür',
    'users.detailAssetsColDevice': 'Cihaz',
    'users.detailAssetsColDate': 'Tarih',
    'users.detailAssetsColDeliveredBy': 'Teslim Eden',
    'users.detailAssetsFormAssignment': 'Zimmet',
    'users.detailAssetsFormReturn': 'Geri Zimmet',
    'users.detailAssetsReturnBtn': 'Tüm Zimmetleri İade Et',

    // Users - Zimmet İade Modal
    'users.returnModalTitle': 'Zimmet İade İşlemi',
    'users.returnModalWarning': 'Aşağıdaki tüm zimmetler kullanıcıdan kaldırılacak ve bir Geri Zimmet Formu oluşturulacaktır.',
    'users.returnModalNotesLabel': 'Notlar (opsiyonel)',
    'users.returnModalNotesPh': 'İşten ayrılma sebebi, teslim notu vb.',
    'users.returnModalCancelBtn': 'İptal',
    'users.returnModalConfirmBtn': 'Tüm Zimmetleri İade Et ve Form Oluştur',
    'users.returnModalLoadingBtn': 'İşleniyor...',
    'users.returnModalSuccessMsg': 'Tüm zimmetler başarıyla iade edildi.',
    'users.returnModalFormLabel': 'Geri Zimmet Formu:',
    'users.returnModalCloseBtn': 'Kapat',
    'users.returnModalViewFormBtn': 'Formu Görüntüle',

    // CabinetsPage
    'cabinet.title': 'Kabin Yönetimi',
    'cabinet.subtitle': 'IT kabinetleri, switch düzeni ve temizlik takibi',
    'cabinet.newCabinet': 'Yeni Kabin',
    'cabinet.search': 'Kabin ara...',
    'cabinet.statTotal': 'Toplam Kabin',
    'cabinet.statSwitches': 'Toplam Switch',
    'cabinet.statCleanedThisMonth': 'Bu Ay Temizlenen',
    'cabinet.statNeedsCleaning': 'Temizlik Bekleyen',
    'cabinet.colName': 'Kabin Adı',
    'cabinet.colCompany': 'Şirket',
    'cabinet.colLocation': 'Lokasyon',
    'cabinet.colSwitchCount': 'Switch Sayısı',
    'cabinet.colDescription': 'Açıklama',
    'cabinet.colLastCleaning': 'Son Temizlik',
    'cabinet.colActions': 'İşlemler',
    'cabinet.notSpecified': 'Belirtilmemiş',
    'cabinet.notFound': 'Kabin Bulunamadı',
    'cabinet.notFoundSearch': 'Arama kriterlerine uygun kabin bulunamadı.',
    'cabinet.notFoundEmpty': 'Henüz kabin eklenmemiş.',
    'cabinet.noRecord': 'Kayıt yok',
    'cabinet.firstCleaning': 'İlk temizlik yapılmadı',
    'cabinet.actionView': 'Görüntüle',
    'cabinet.actionEdit': 'Düzenle',
    'cabinet.actionCopy': 'Kopyala',
    'cabinet.actionLabel': 'Etiket',
    'cabinet.actionDelete': 'Sil',
    'cabinet.newCleaning': 'Temizlik Kaydı',
    'cabinet.addTitle': 'Yeni Kabin Ekle',
    'cabinet.editTitle': 'Kabin Düzenle',
    'cabinet.fieldName': 'Kabin Adı *',
    'cabinet.fieldNamePlaceholder': 'Kabin-A1',
    'cabinet.fieldCompany': 'Şirket',
    'cabinet.fieldLocation': 'Lokasyon',
    'cabinet.fieldLastCleaning': 'Son Temizlik Tarihi',
    'cabinet.fieldDescription': 'Açıklama',
    'cabinet.fieldDescPlaceholder': 'Kabin hakkında detaylar...',
    'cabinet.fieldPhoto': 'Fotoğraf',
    'cabinet.selectCompany': 'Şirket seçin',
    'cabinet.selectLocation': 'Lokasyon seçin',
    'cabinet.btnSave': 'Kaydet',
    'cabinet.btnUpdate': 'Güncelle',
    'cabinet.btnCancel': 'İptal',
    'cabinet.successCreatedTitle': 'Başarılı',
    'cabinet.successCreatedMsg': 'Kabin başarıyla eklendi',
    'cabinet.successUpdatedTitle': 'Başarılı',
    'cabinet.successUpdatedMsg': 'Kabin başarıyla güncellendi',
    'cabinet.successDeletedTitle': 'Başarılı',
    'cabinet.successDeletedMsg': 'Kabin başarıyla silindi',
    'cabinet.successCleaningTitle': 'Başarılı',
    'cabinet.successCleaningMsg': 'Temizlik kaydı eklendi',
    'cabinet.errTitle': 'Hata',
    'cabinet.errLoadData': 'Veriler yüklenirken hata oluştu',
    'cabinet.errLoadDetail': 'Kabin detayları yüklenirken hata oluştu',
    'cabinet.errSave': 'Kabin kaydedilirken hata oluştu',
    'cabinet.errDelete': 'Kabin silinirken hata oluştu',
    'cabinet.errCleaning': 'Temizlik kaydı eklenirken hata oluştu',
    'cabinet.errNameRequired': 'Kabin adı zorunludur',
    'cabinet.errNoPermission': 'Bu işlem için yetkiniz yok',
    'cabinet.errPrint': 'Etiket yazdırılırken hata oluştu',
    'cabinet.confirmDelete': 'Bu kabini silmek istediğinizden emin misiniz?',
    'cabinet.detailTitle': 'Kabin Detayları',
    'cabinet.detailInfo': 'Kabin Bilgileri',
    'cabinet.detailCompany': 'Şirket:',
    'cabinet.detailLocation': 'Lokasyon:',
    'cabinet.detailLastCleaning': 'Son Temizlik:',
    'cabinet.detailPhoto': 'Fotoğraf',
    'cabinet.detailHistory': 'Tarihçe',
    'cabinet.switchesInCabinet': 'Kabindeki Switchler',
    'cabinet.moreSwitches': '+ {count} switch daha...',
    'cabinet.unknownCabinet': 'Bilinmeyen Kabin',
    'cabinet.infoCopied': 'Kabin bilgileri kopyalandı',
    'cabinet.infoTitle': 'Bilgi',
    'cabinet.cleaningModalTitle': 'Temizlik Kaydı Ekle',
    'cabinet.cleaningDate': 'Temizlik Tarihi *',
    'cabinet.cleaningNotes': 'Notlar',
    'cabinet.cleaningNotesPlaceholder': 'Temizlik ile ilgili notlar...',
    'cabinet.labelModalTitle': 'Kabin Etiketi',
    'cabinet.labelOrientation': 'Yön',
    'cabinet.labelHorizontal': 'Yatay',
    'cabinet.labelVertical': 'Dikey',
    'cabinet.labelIncludeSwitches': 'Switch listesi dahil et',
    'cabinet.labelWillPrint': 'Yazdırılacak',
    'cabinet.statusActive': 'Aktif',
    'cabinet.statusInactive': 'Pasif',
    'cabinet.statusMaintenance': 'Bakımda',
    'cabinet.statusFaulty': 'Arızalı',

    // PrintersPage
    'printer.title': 'Yazıcı Yönetimi',
    'printer.loading': 'Yükleniyor...',
    'printer.btnNewPrinter': 'Yeni Yazıcı Ekle',
    'printer.btnNew': 'Yeni Yazıcı',
    'printer.btnImport': 'Toplu İçe Aktar',
    'printer.btnImportShort': 'İçe Aktar',
    'printer.btnBulkLabel': 'Toplu Etiket Bas',
    'printer.btnLabel': 'Etiket Bas',
    'printer.btnExcel': 'Excel\'e Aktar',
    'printer.btnExcelShort': 'Excel',
    'printer.tabPrinters': 'Yazıcılar',
    'printer.tabBrands': 'Markalar',
    'printer.tabModels': 'Modeller',
    'printer.tabDrivers': 'Sürücüler',
    'printer.statTotal': 'Toplam Yazıcı',
    'printer.statOffice': 'Ofis Yazıcısı',
    'printer.statIndustrial': 'Endüstriyel Yazıcı',
    'printer.searchPlaceholder': 'Yazıcı adı, marka, model, IP, seri no...',
    'printer.filters': 'Filtreler',
    'printer.clearFilters': 'Filtreleri Temizle',
    'printer.filterAll': 'Tümü',
    'printer.filterCompany': 'Firma',
    'printer.filterNoCompany': 'Firma Yok',
    'printer.filterBrand': 'Marka',
    'printer.filterIp': 'IP Adresi',
    'printer.filterIpPlaceholder': 'IP ara...',
    'printer.filterSerial': 'Seri Numara',
    'printer.filterSerialPlaceholder': 'Seri no ara...',
    'printer.filterLocation': 'Lokasyon',
    'printer.filterCategory': 'Kategori',
    'printer.filterStatus': 'Durum',
    'printer.catOffice': 'Ofis',
    'printer.catIndustrial': 'Endüstriyel',
    'printer.catMobile': 'Mobil',
    'printer.colName': 'Ad',
    'printer.colCompany': 'Firma',
    'printer.colBrandModel': 'Marka / Model',
    'printer.colType': 'Tip',
    'printer.colCategory': 'Kategori',
    'printer.colIp': 'IP Adresi',
    'printer.colMac': 'MAC Adresi',
    'printer.colSerial': 'Seri No',
    'printer.colLocation': 'Lokasyon',
    'printer.colDepartment': 'Departman',
    'printer.colCounters': 'Sayaçlar',
    'printer.colStatus': 'Durum',
    'printer.colActions': 'İşlemler',
    'printer.mobileCompany': 'Firma',
    'printer.mobileType': 'Tip',
    'printer.noData': 'Veri yok',
    'printer.statusActive': 'Aktif',
    'printer.statusPassive': 'Pasif',
    'printer.statusContractExpired': 'Sözleşme Süresi Dolmuş',
    'printer.statusFaulty': 'Arızalı',
    'printer.actionEdit': 'Düzenle',
    'printer.actionCopy': 'Kopyala',
    'printer.actionCounter': 'Sayaç Gir',
    'printer.actionHistory': 'Geçmiş',
    'printer.actionToner': 'Toner Takma',
    'printer.actionQR': 'QR Kod',
    'printer.actionContract': 'Sözleşme',
    'printer.actionDelete': 'Sil',

    // MobilePhonesPage
    'mobilePhones.title': 'Cep Telefonları',
    'mobilePhones.subtitle': 'Envanter, atama ve sözleşme yönetimi',
    'mobilePhones.loading': 'Yükleniyor...',
    'mobilePhones.btnNewPhone': 'Yeni Cep Telefonu Ekle',
    'mobilePhones.btnBulkImport': 'Toplu İçe Aktar',
    'mobilePhones.btnImport': 'İçe Aktar',
    'mobilePhones.btnBulkLabel': 'Toplu Etiket Bas',
    'mobilePhones.btnLabel': 'Etiket Bas',
    'mobilePhones.searchPlaceholder': 'Envanter no, marka, model, IMEI, GSM no...',
    'mobilePhones.statTotal': 'Toplam',
    'mobilePhones.statActive': 'Aktif',
    'mobilePhones.statAssigned': 'Atanmış',
    'mobilePhones.statUnassigned': 'Atanmamış',
    'mobilePhones.statContractExpiring': 'Sözleşme Bitiyor',
    'mobilePhones.filterAllLocations': 'Tüm Lokasyonlar',
    'mobilePhones.filterAllModels': 'Tüm Modeller',
    'mobilePhones.filterAllStatuses': 'Tüm Durumlar',
    'mobilePhones.filterAllAssignments': 'Tüm Atamalar',
    'mobilePhones.filterContractStatus': 'Sözleşme Durumu',
    'mobilePhones.filterExpired': 'Süresi Geçmiş',
    'mobilePhones.filterExpires3Months': '3 Ay İçinde Bitiyor',
    'mobilePhones.filterExpiresMonth': '1 Ay İçinde Bitiyor',
    'mobilePhones.filterExpiresToday': 'Bugün Bitiyor',
    'mobilePhones.filterExpiresWeek': '1 Hafta İçinde Bitiyor',
    'mobilePhones.filterNoContract': 'Sözleşme Yok',
    'mobilePhones.colInventoryNo': 'Envanter No',
    'mobilePhones.colBrand': 'Marka',
    'mobilePhones.colModel': 'Model',
    'mobilePhones.colColor': 'Renk',
    'mobilePhones.colStorage': 'Depolama',
    'mobilePhones.colGsmNo': 'GSM No',
    'mobilePhones.colSerialNo': 'Seri No',
    'mobilePhones.colSubscriptionNo': 'Abonelik No',
    'mobilePhones.subscriptionNumber': 'Abonelik No (Sözleşme No)',
    'mobilePhones.errRecordNotFound': 'Kayıt bulunamadı. Silinmiş olabilir.',
    // Arşiv
    'mobilePhones.archive.viewArchive': 'Arşiv ({count})',
    'mobilePhones.archive.backToActive': 'Aktif Telefonlar',
    'mobilePhones.archive.archive': 'Arşivle',
    'mobilePhones.archive.restore': 'Arşivden Çıkar',
    'mobilePhones.archive.bannerTitle': 'Arşivdeki telefonlar ({count})',
    'mobilePhones.archive.bannerText': 'Arşivlenen telefonlar ana listede, sayımlarda ve atama ekranlarında görünmez; değişiklik ve zimmet geçmişleri korunur. Gerekirse arşivden çıkarabilirsiniz.',
    'mobilePhones.archive.selected': '{count} telefon seçildi',
    'mobilePhones.archive.selectAllFiltered': 'Filtrelenen tüm {count} telefonu seç',
    'mobilePhones.archive.clearSelection': 'Seçimi temizle',
    'mobilePhones.archive.selectPage': 'Bu sayfadakileri seç',
    'mobilePhones.archive.archiveSelected': 'Seçilenleri Arşivle ({count})',
    'mobilePhones.archive.restoreSelected': 'Seçilenleri Arşivden Çıkar ({count})',
    'mobilePhones.archive.colArchiveInfo': 'Arşivlenme',
    'mobilePhones.archive.colReason': 'Arşiv Nedeni',
    'mobilePhones.archive.empty': 'Arşivde telefon yok.',
    'mobilePhones.archive.noResults': 'Kriterlere uyan telefon bulunamadı.',
    'mobilePhones.archive.dialogArchiveTitle': '{count} telefonu arşivle',
    'mobilePhones.archive.dialogRestoreTitle': '{count} telefonu arşivden çıkar',
    'mobilePhones.archive.dialogArchiveText': 'Bu telefonlar listeden kaldırılacak; geçmiş kayıtları silinmeyecek. Arşiv görünümünden istediğiniz zaman geri alabilirsiniz.',
    'mobilePhones.archive.dialogRestoreText': 'Bu telefonlar tekrar aktif listeye alınacak ve durumları "Boşta" olacak. Zimmet otomatik olarak geri verilmez.',
    'mobilePhones.archive.warnAssigned': '{count} telefon zimmetli. Arşivlenince zimmetleri kaldırılacak ve zimmet loguna yazılacak.',
    'mobilePhones.archive.infoGsm': '{count} telefonun GSM numarası arşiv kaydına taşınacak; böylece aynı hat yeni telefona tanımlanabilir.',
    'mobilePhones.archive.reasonLabel': 'Arşiv nedeni (isteğe bağlı)',
    'mobilePhones.archive.reasonPlaceholder': 'Örn. Kiralama süresi doldu, firmaya iade edildi',
    'mobilePhones.archive.confirmArchive': '{count} Telefonu Arşivle',
    'mobilePhones.archive.confirmRestore': '{count} Telefonu Arşivden Çıkar',
    'mobilePhones.archive.successArchived': '{count} telefon arşivlendi.',
    'mobilePhones.archive.successUnassigned': '{count} telefonun zimmeti kaldırıldı.',
    'mobilePhones.archive.successRestored': '{count} telefon arşivden çıkarıldı.',
    'mobilePhones.archive.gsmConflict': 'Şu telefonların GSM numarası başka bir telefonda kullanıldığı için geri yüklenmedi: {list}',
    'mobilePhones.archive.errGeneric': 'Arşiv işlemi sırasında bir hata oluştu.',
    'mobilePhones.archive.gsmQuestion': '{count} telefonun GSM numarası ne olsun?',
    'mobilePhones.archive.gsmKeep': 'GSM numarası telefonda kalsın',
    'mobilePhones.archive.gsmKeepHint': 'Numara arşivdeki telefonda kayıtlı kalır. İleride yeni bir telefona girilirse oradan aktarmak için onayınız istenir.',
    'mobilePhones.archive.gsmRelease': 'GSM numarasını telefondan kaldır',
    'mobilePhones.archive.gsmReleaseHint': 'Numara telefondan kaldırılır (arşiv kaydında saklanır); hemen yeni bir telefona tanımlanabilir. GSM hattının geçmişine ve bildirimlere işlenir.',
    'mobilePhones.archive.gsmRemovedShort': 'telefondan kaldırıldı',
    'mobilePhones.archive.successGsmReleased': '{count} telefonun GSM numarası kaldırıldı.',
    'mobilePhones.archive.gsmTransferConfirm': '{gsm} numarası arşivdeki {device} telefonunda kayıtlı.\n\nNumara arşivdeki telefondan kaldırılıp bu telefona aktarılsın mı? İşlem GSM hattının geçmişine ve bildirimlere kaydedilir.',
    'mobilePhones.archive.gsmOnArchivedHint': 'Bu numara arşivdeki {device} telefonunda kayıtlı. Kaydederken arşivdeki telefondan aktarmak için onayınız istenecek.',
    // Bildirim değişiklik detayları
    'notif.mobile.create.title': 'Yeni Cep Telefonu Eklendi',
    'notif.mobile.update.title': 'Cep Telefonu Güncellendi',
    'notif.mobile.delete.title': 'Cep Telefonu Silindi',
    'notif.mobile.create.message': '{device} ({inventory}) cep telefonu sisteme eklendi',
    'notif.mobile.update.message': '{device} ({inventory}) güncellendi',
    'notif.mobile.delete.message': '{device} ({inventory}) cep telefonu silindi',
    'notif.mobile.archive.title': 'Cep Telefonları Arşivlendi',
    'notif.mobile.archive.message': '{count} cep telefonu arşivlendi',
    'notif.mobile.unarchive.title': 'Cep Telefonları Arşivden Çıkarıldı',
    'notif.mobile.unarchive.message': '{count} cep telefonu arşivden çıkarıldı',
    'notif.change.reason': 'Neden',
    'notif.change.unassigned': '{count} telefonun zimmeti kaldırıldı',
    'notif.change.gsmReleased': '{count} telefonun GSM numarası kaldırıldı',
    'notif.gsm.deviceChange.title': 'GSM Hattı Cihaz Değişikliği',
    'notif.gsm.deviceChange.message': '{number} hattının telefonu değişti',
    'notif.gsm.phone': 'Telefon',
    'notif.gsm.removed': 'Telefondan kaldırıldı',
    'notif.change.updated': 'güncellendi',
    'notif.change.more': '+{count} değişiklik daha',
    'notif.change.open': 'Kaydı aç',
    'notif.change.field.inventory_number': 'Envanter No',
    'notif.change.field.brand': 'Marka',
    'notif.change.field.model': 'Model',
    'notif.change.field.color': 'Renk',
    'notif.change.field.storage': 'Depolama',
    'notif.change.field.imei1': 'IMEI 1',
    'notif.change.field.imei2': 'IMEI 2',
    'notif.change.field.serial_number': 'Seri No',
    'notif.change.field.subscription_number': 'Abonelik No',
    'notif.change.field.gsm_number': 'GSM No',
    'notif.change.field.status': 'Durum',
    'notif.change.field.assigned_user_id': 'Atanan Kullanıcı',
    'notif.change.field.location_id': 'Lokasyon',
    'notif.change.field.company_id': 'Şirket',
    'notif.change.field.supplier_id': 'Tedarikçi',
    'notif.change.field.ownership': 'Sahiplik',
    'notif.change.field.creation_date': 'Oluşturma Tarihi',
    'notif.change.field.agreement_year': 'Anlaşma Yılı',
    'notif.change.field.currency': 'Para Birimi',
    'notif.change.field.exchange_rate': 'Döviz Kuru',
    'notif.change.field.contract_start_date': 'Sözleşme Başlangıç',
    'notif.change.field.contract_end_date': 'Sözleşme Bitiş',
    'notif.change.field.contract_price': 'Sözleşme Tutarı',
    'notif.change.field.monthly_payment': 'Aylık Ödeme',
    'notif.change.field.notes': 'Notlar',
    'notif.change.status.active': 'Aktif',
    'notif.change.status.inactive': 'Pasif',
    'notif.change.status.available': 'Boşta',
    'notif.change.status.assigned': 'Zimmetli',
    'notif.change.status.reserved': 'Rezerve',
    'notif.change.status.maintenance': 'Bakımda',
    'notif.change.status.lost': 'Kayıp',
    'notif.change.status.stolen': 'Çalıntı',
    'notif.change.status.damaged': 'Hasarlı',
    'notif.change.ownership.company': 'Şirket',
    'notif.change.ownership.rental': 'Kiralık',
    'notif.change.ownership.employee': 'Çalışan',
    'mobilePhones.colLocation': 'Lokasyon',
    'mobilePhones.colCompany': 'Firma',
    'mobilePhones.colSupplier': 'Tedarikçi',
    'mobilePhones.colAssignedUser': 'Atanan Kullanıcı',
    'mobilePhones.colContractStart': 'Sözleşme Başlangıç',
    'mobilePhones.colContractEnd': 'Sözleşme Bitiş',
    'mobilePhones.colContractPrice': 'Sözleşme Fiyatı',
    'mobilePhones.colMonthlyPayment': 'Aylık Ödeme',
    'mobilePhones.colStatus': 'Durum',
    'mobilePhones.colNotes': 'Notlar',
    'mobilePhones.colCreatedAt': 'Oluşturulma',
    'mobilePhones.colActions': 'İşlemler',
    'mobilePhones.colDeviceInfo': 'Cihaz Bilgisi',
    'mobilePhones.colLocationCompany': 'Lokasyon / Firma',
    'mobilePhones.sectionDeviceInfo': 'Cihaz Bilgileri',
    'mobilePhones.modalNewTitle': 'Yeni Cep Telefonu',
    'mobilePhones.modalEditTitle': 'Cep Telefonu Düzenle',
    'mobilePhones.labelInventoryNo': 'Envanter No *',
    'mobilePhones.labelBrand': 'Marka',
    'mobilePhones.labelCreationDate': 'Kayıt Tarihi',
    'mobilePhones.labelCurrency': 'Para Birimi',
    'mobilePhones.labelExchangeRate': 'Döviz Kuru',
    'mobilePhones.labelAgreementYear': 'Anlaşma Yılı',
    'mobilePhones.currencyTRY': 'TL',
    'mobilePhones.currencyUSD': 'USD',
    'mobilePhones.currencyGBP': 'GBP',
    'mobilePhones.optSelect': 'Seçiniz',
    'mobilePhones.available': 'Müsait',
    'mobilePhones.inventoryInUse': 'Bu envanter numarası zaten kullanılıyor',
    'mobilePhones.statusActive': 'Aktif',
    'mobilePhones.statusInactive': 'Pasif',
    'mobilePhones.statusLost': 'Kayıp',
    'mobilePhones.statusDamaged': 'Hasarlı',
    'mobilePhones.statusAssigned': 'Zimmetli',
    'mobilePhones.statusAvailable': 'Boşta',
    'mobilePhones.statusReserved': 'Rezerve',
    'mobilePhones.year': 'yıl',
    'mobilePhones.titleDelete': 'Telefon Sil',
    'mobilePhones.titleEdit': 'Düzenle',
    'mobilePhones.titleHistory': 'Geçmiş',
    'mobilePhones.titlePrintLabel': 'Etiket Bas',
    'mobilePhones.titleQuickAssign': 'Hızlı Atama',
    'mobilePhones.titleQuickCopy': 'Hızlı Kopyala',
    'mobilePhones.titleUnassign': 'Atamayı Kaldır',
    'mobilePhones.titleContractExpiredNoAssign': 'Sözleşme Süresi Dolmuş',
    'mobilePhones.assignedToUser': 'Kullanıcıya Atandı',
    'mobilePhones.unassignedSuccess': 'Atama Kaldırıldı',
    'mobilePhones.phoneAdded': 'Telefon eklendi',
    'mobilePhones.phoneUpdated': 'Telefon güncellendi',
    'mobilePhones.phoneDeleted': 'Telefon silindi',
    'mobilePhones.phoneCopied': 'Telefon kopyalandı',
    'mobilePhones.phoneAssigned': 'Telefon atandı',
    'mobilePhones.phoneAssignedWithForm': 'Telefon atandı ve form oluşturuldu',
    'mobilePhones.exportedToExcel': 'Excel\'e aktarıldı',
    'mobilePhones.importedSuccessfully': 'Başarıyla içe aktarıldı',
    'mobilePhones.importFailedRows': 'başarısız satır',
    'mobilePhones.importSummary': '{created} kayıt eklendi, {updated} kayıt güncellendi',
    'mobilePhones.importCreated': 'Eklendi',
    'mobilePhones.importUpdated': 'Güncellendi',
    'mobilePhones.importUnchangedSkipped': 'Değişmedi / Atlandı',
    'mobilePhones.importFailed': 'Başarısız',
    'mobilePhones.importPreviewTitle': 'Mevcut Kayıtlardaki Farklar',
    'mobilePhones.importPreviewDesc': 'Envanter No\'su sistemde bulunan {count} kayıtta Excel\'deki verilerle farklılık var. Güncellenmesini onayladığınız kayıtları seçin; yeni kayıt oluşturulmaz.',
    'mobilePhones.importPreviewStats': 'Yeni eklenecek: {create} · Değişiklik yok: {unchanged} · Hatalı: {failed}',
    'mobilePhones.importPreviewErrors': 'İşlenemeyecek satırlar',
    'mobilePhones.importSelectAll': 'Tümünü seç',
    'mobilePhones.importArchivedBadge': 'Arşivde',
    'mobilePhones.importRow': 'Satır {row}',
    'mobilePhones.importCancel': 'İptal',
    'mobilePhones.importConfirm': 'Onayla ({updated} güncelle, {created} ekle)',
    'mobilePhones.assignmentFormCreated': 'Atama formu oluşturuldu',
    'mobilePhones.returnFormCreated': 'İade formu oluşturuldu',
    'mobilePhones.formNo': 'Form No',
    'mobilePhones.paginationPrev': 'Önceki',
    'mobilePhones.paginationNext': 'Sonraki',
    'mobilePhones.paginationOf': '/',
    'mobilePhones.paginationPage': 'Sayfa {current} / {total}',
    'mobilePhones.emptyTitle': 'Cep Telefonu Bulunamadı',
    'mobilePhones.emptyDesc': 'Henüz cep telefonu eklenmemiş veya arama kriterlerinize uyan sonuç yok.',
    'mobilePhones.notifSuccess': 'Başarılı',
    'mobilePhones.notifError': 'Hata',
    'mobilePhones.notifWarning': 'Uyarı',
    'mobilePhones.notifInfo': 'Bilgi',
    'mobilePhones.errLoadData': 'Veriler yüklenirken hata oluştu',
    'mobilePhones.errDeleteFailed': 'Silme işlemi başarısız',
    'mobilePhones.errAssignFailed': 'Atama işlemi başarısız',
    'mobilePhones.errUnassignFailed': 'Atama kaldırma işlemi başarısız',
    'mobilePhones.errSelectUser': 'Kullanıcı seçiniz',
    'mobilePhones.errAlreadyAssigned': 'Bu telefon zaten bir kullanıcıya atanmış',
    'mobilePhones.errCannotAssign': 'Telefon atanamaz',
    'mobilePhones.errNotAssigned': 'Telefon atanmamış',
    'mobilePhones.errContractExpired': 'Sözleşme süresi dolmuş',
    'mobilePhones.errExpiredCannotAssign': 'Sözleşme süresi dolmuş, atama yapılamaz',
    'mobilePhones.errHistoryLoad': 'Geçmiş yüklenirken hata oluştu',
    'mobilePhones.errImportFailed': 'İçe aktarma başarısız',
    'mobilePhones.errSelectFile': 'Dosya seçiniz',
    'mobilePhones.errSelectExcelFile': 'Excel dosyası seçiniz',
    'mobilePhones.errNoValidData': 'Geçerli veri bulunamadı',
    'mobilePhones.errPasteData': 'Veri yapıştırma hatası',
    'mobilePhones.errOperationFailed': 'İşlem başarısız',
    'mobilePhones.errAssignmentFormFailed': 'Atama formu oluşturulamadı',
    'mobilePhones.errReturnFormFailed': 'İade formu oluşturulamadı',

    // SystemSettingsPage
    'sysSettings.title': 'Sistem Ayarları',
    'sysSettings.tabGeneral': 'Genel Ayarlar',
    'sysSettings.tabRecovery': 'Backup Geri Yükleme',
    'sysSettings.tabEmail': 'E-posta',
    'sysSettings.tabCron': 'Cron Jobs',
    'sysSettings.tabOrders': 'Sipariş Ayarları',
    'sysSettings.tabSecurity': 'Güvenlik',
    'sysSettings.tabLogs': 'Sistem Logları',
    'sysSettings.tabLoginLogs': 'Giriş Logları',
    'sysSettings.tabApi': 'API Yönetimi',
    'sysSettings.tabBulkPrint': 'Toplu Etiket Basma',
    'sysSettings.tabSounds': 'Ses Ayarları',
    'sysSettings.soundsTitle': 'Bildirim Ses Ayarları',
    'sysSettings.soundEnabled': 'Ses Bildirimleri',
    'sysSettings.soundEnabledDesc': 'Yeni mesaj geldiğinde ses çal',
    'sysSettings.soundVolume': 'Ses Seviyesi',
    'sysSettings.soundVolumeLow': 'Sessiz',
    'sysSettings.soundVolumeHigh': 'Yüksek',
    'sysSettings.soundStyle': 'Bildirim Sesi Stili',
    'sysSettings.soundStyleDesc': 'Tıkladığınızda önizleme çalar',
    'sysSettings.soundTest': 'Test Sesi',
    'sysSettings.soundTestDesc': 'Bildirim sesini test edin',
    'sysSettings.soundTyping': 'Klavye Yazma Sesi',
    'sysSettings.soundTypingDesc': 'Sohbette yazarken tuş sesi çal',
    'sysSettings.soundTypingTest': 'Yazma Sesini Test Et',
    'sysSettings.soundTip': 'Ses bildirimleri için tarayıcınızın ses iznini vermeniz gerekebilir.',
    'sysSettings.soundCustomFiles': 'Özel Ses Dosyaları',
    'sysSettings.soundCustomFilesDesc': 'MP3, OGG veya WAV formatında, maksimum 2MB',
    'sysSettings.soundUpload': 'Ses Dosyası Yükle',
    'sysSettings.soundUploading': 'Yükleniyor...',
    'sysSettings.soundUploadSuccess': 'Ses dosyası başarıyla yüklendi',
    'sysSettings.soundUploadError': 'Ses dosyası yüklenirken hata oluştu',
    'sysSettings.soundNoFiles': 'Henüz özel ses dosyası yüklenmedi',
    'sysSettings.soundSetActive': 'Aktif Yap',
    'sysSettings.soundActive': 'Aktif',
    'sysSettings.soundSetDefault': 'Varsayılana Dön',
    'sysSettings.soundDelete': 'Sil',
    'sysSettings.soundDeleteConfirm': 'Bu ses dosyasını silmek istediğinizden emin misiniz?',
    'sysSettings.soundDeleteSuccess': 'Ses dosyası silindi',
    'sysSettings.soundActivated': 'Aktif ses güncellendi',
    'sysSettings.soundPreview': 'Önizle',
    'sysSettings.soundFileSize': 'Boyut',
    'sysSettings.save': 'Kaydet',
    'sysSettings.cancel': 'İptal',
    'sysSettings.add': 'Ekle',
    'sysSettings.update': 'Güncelle',
    'sysSettings.active': 'Aktif',
    'sysSettings.passive': 'Pasif',

    // General Tab
    'sysSettings.loadingSettings': 'Sistem ayarları yükleniyor...',
    'sysSettings.pageSubtitle': 'Sistem konfigürasyonu ve yedekleme yönetimi',
    'sysSettings.generalTitle': 'Genel Sistem Ayarları',
    'sysSettings.newSetting': 'Yeni Ayar',
    'sysSettings.systemAppearance': 'Sistem Görünümü',
    'sysSettings.systemTitle': 'Sistem Başlığı',
    'sysSettings.systemLogo': 'Sistem Logosu',
    'sysSettings.logoHint': 'PNG, JPG, SVG, GIF, WebP destekleniyor (Max: 2MB) - Seçildiğinde otomatik yüklenir',
    'sysSettings.favicon': 'Favicon',
    'sysSettings.faviconHint': 'ICO, PNG formatı öneriliyor (32x32px) - Seçildiğinde otomatik yüklenir',
    'sysSettings.currentView': 'Mevcut Görünüm',
    'sysSettings.currentLogo': 'Mevcut Logo:',
    'sysSettings.removeLogo': 'Logoyu Kaldır',
    'sysSettings.removeLogoConfirm': 'Logoyu kaldırmak istediğinizden emin misiniz?',
    'sysSettings.logoUploaded': 'Logo başarıyla yüklendi!',
    'sysSettings.logoDeleted': 'Logo başarıyla silindi!',
    'sysSettings.logoDeleteError': 'Logo silinirken hata oluştu',
    'sysSettings.faviconUploaded': 'Favicon başarıyla yüklendi!',
    'sysSettings.loginBackground': 'Login Sayfası Background',
    'sysSettings.loginBgImage': 'Login Background Görseli',
    'sysSettings.loginBgHint': 'JPG, PNG, WebP destekleniyor (Max: 5MB) - Seçildiğinde otomatik yüklenir',
    'sysSettings.currentLoginBg': 'Mevcut Login Background:',
    'sysSettings.removeLoginBg': "Background'ı Kaldır",
    'sysSettings.removeLoginBgConfirm': "Login background'ı kaldırmak istediğinizden emin misiniz?",
    'sysSettings.loginBgUploaded': 'Login background başarıyla yüklendi!',
    'sysSettings.loginBgRemoved': 'Login background kaldırıldı!',
    'sysSettings.loginBgDeleteError': 'Login background silinirken hata oluştu',
    'sysSettings.settingsListTitle': 'Sistem Ayarları',
    'sysSettings.settingValue': 'Değer:',
    'sysSettings.settingType': 'Tip:',
    'sysSettings.settingUpdated': 'Güncelleme:',
    'sysSettings.noSettings': 'Henüz sistem ayarı tanımlanmamış',
    'sysSettings.errFileTooLarge2MB': "Dosya boyutu 2MB'dan büyük olamaz",
    'sysSettings.errFileTooLarge5MB': "Dosya boyutu 5MB'dan büyük olamaz",
    'sysSettings.errInvalidImageType': 'Sadece resim dosyaları (JPG, PNG, SVG, GIF, WebP) yüklenebilir',
    'sysSettings.errInvalidBgType': 'Sadece resim dosyaları (JPG, PNG, WebP) yüklenebilir',
    'sysSettings.titleUpdated': 'Sistem başlığı başarıyla güncellendi!',
    'sysSettings.titleUpdateError': 'Başlık güncellenirken hata oluştu!',

    // Category labels
    'sysSettings.catGeneral': 'Genel',
    'sysSettings.catEmail': 'E-posta',
    'sysSettings.catBackup': 'Yedekleme',
    'sysSettings.catSecurity': 'Güvenlik',
    'sysSettings.catNotification': 'Bildirim',
    'sysSettings.catIntegration': 'Entegrasyon',

    // Backup Tab
    'sysSettings.backupPlans': 'Yedekleme Planları',
    'sysSettings.backupStatusActive': 'Aktif',
    'sysSettings.backupStatusPaused': 'Duraklatıldı',
    'sysSettings.backupStatusDisabled': 'Devre Dışı',
    'sysSettings.backupType': 'Tip:',
    'sysSettings.backupSchedule': 'Program:',
    'sysSettings.backupRetention': 'Saklama:',
    'sysSettings.backupRetentionDays': '{days} gün',
    'sysSettings.backupSize': 'Boyut:',
    'sysSettings.backupSuccess': 'Başarı:',
    'sysSettings.backupLast': 'Son Yedekleme:',
    'sysSettings.backupNever': 'Hiç',
    'sysSettings.backupRunNow': 'Şimdi Çalıştır',
    'sysSettings.backupStarted': 'Yedekleme başlatıldı:',
    'sysSettings.backupRunError': 'Yedekleme başlatılırken hata oluştu',
    'sysSettings.noBackupPlans': 'Henüz yedekleme planı tanımlanmamış',
    'sysSettings.recentBackupLogs': 'Son Yedekleme Logları',
    'sysSettings.logStatusCompleted': 'Tamamlandı',
    'sysSettings.logStatusRunning': 'Çalışıyor',
    'sysSettings.logStatusFailed': 'Başarısız',
    'sysSettings.logStatusCancelled': 'İptal Edildi',
    'sysSettings.logStart': 'Başlangıç:',
    'sysSettings.logEnd': 'Bitiş:',
    'sysSettings.logDuration': 'Süre:',
    'sysSettings.logDurationMin': '{min} dk',
    'sysSettings.logSizeGb': 'Boyut:',
    'sysSettings.logUnknown': 'Bilinmiyor',
    'sysSettings.logError': 'Hata:',
    'sysSettings.noBackupLogs': 'Henüz yedekleme logu bulunmuyor',

    // Email Tab
    'sysSettings.emailConfigs': 'E-posta Konfigürasyonları',
    'sysSettings.newSmtp': 'Yeni SMTP',
    'sysSettings.emailDefault': 'Varsayılan',
    'sysSettings.emailSmtp': 'SMTP:',
    'sysSettings.emailEncryption': 'Şifreleme:',
    'sysSettings.emailFrom': 'Gönderen:',
    'sysSettings.emailDailyLimit': 'Günlük Limit:',
    'sysSettings.emailMonthlyLimit': 'Aylık Limit:',
    'sysSettings.emailLastTest': 'Son Test:',
    'sysSettings.emailNeverTested': 'Hiç test edilmedi',
    'sysSettings.emailTestTitle': 'Test Et',
    'sysSettings.emailTestPrompt': 'Test e-postası gönderilecek e-posta adresini girin:',
    'sysSettings.noEmailConfigs': 'Henüz e-posta konfigürasyonu tanımlanmamış',

    // Security Tab
    'sysSettings.securityTitle': 'Güvenlik Ayarları',
    'sysSettings.sessionSettings': 'Oturum Ayarları',
    'sysSettings.sessionTimeout': 'Oturum Zaman Aşımı',
    'sysSettings.sessionTimeoutValue': '60 dakika',
    'sysSettings.maxLoginAttempts': 'Maksimum Giriş Denemesi',
    'sysSettings.twoFactor': 'İki Faktörlü Doğrulama',
    'sysSettings.apiSecurity': 'API Güvenliği',
    'sysSettings.rateLimit': 'Rate Limit',
    'sysSettings.rateLimitValue': '1000/saat',
    'sysSettings.ipRestriction': 'IP Kısıtlaması',
    'sysSettings.apiKeyExpiry': 'API Key Süresi',
    'sysSettings.apiKeyExpiryValue': '1 yıl',

    // Logs Tab
    'sysSettings.systemLogsTitle': 'Sistem Logları',
    'sysSettings.searchLogs': 'Log ara...',
    'sysSettings.logCategory': 'Kategori:',
    'sysSettings.logUser': 'Kullanıcı:',
    'sysSettings.noSystemLogs': 'Henüz sistem logu bulunmuyor',

    // Login Logs Tab
    'sysSettings.loginLogsTitle': 'Giriş Logları ve Engellenen Hesaplar',
    'sysSettings.exportExcel': 'Excel İndir',
    'sysSettings.clearLogs': 'Logları Temizle',
    'sysSettings.clearLogsConfirm': 'Tüm giriş loglarını silmek istediğinizden emin misiniz?',
    'sysSettings.refresh': 'Yenile',
    'sysSettings.blockedAccounts': 'Engellenen Hesaplar',
    'sysSettings.blocked': 'Engellendi',
    'sysSettings.failedAttempts': 'Başarısız Deneme:',
    'sysSettings.blockedUntil': 'Engel Bitiş:',
    'sysSettings.lastAttempt': 'Son Deneme:',
    'sysSettings.unblock': 'Engeli Kaldır',
    'sysSettings.unblockConfirm': '{email} hesabının engelini kaldırmak istediğinizden emin misiniz?',
    'sysSettings.noBlockedAccounts': 'Şu anda engellenen hesap bulunmuyor',
    'sysSettings.loginLogsSubtitle': 'Giriş Logları',
    'sysSettings.totalRecords': 'Toplam {count} kayıt - Son 10 kayıt gösteriliyor',
    'sysSettings.statusSuccess': 'BAŞARILI',
    'sysSettings.statusBlocked': 'ENGELLENDİ',
    'sysSettings.statusFailed': 'BAŞARISIZ',
    'sysSettings.csvSuccess': 'Başarılı',
    'sysSettings.csvBlocked': 'Engellendi',
    'sysSettings.csvFailed': 'Başarısız',
    'sysSettings.engagedUntil': 'Engel Bitiş:',
    'sysSettings.noLoginLogs': 'Henüz giriş logu bulunmuyor',
    'sysSettings.showing110': '1-10 / {count} kayıt',
    'sysSettings.prev': 'Önceki',
    'sysSettings.showAll': 'Tümünü Göster',

    // Cron Tab
    'sysSettings.cronTitle': 'Cron Jobs Yönetimi',
    'sysSettings.newCronJob': 'Yeni Cron Job',
    'sysSettings.cronExpression': 'Cron:',
    'sysSettings.cronRunCount': 'Çalışma:',
    'sysSettings.cronRunCountValue': '{count} kez',
    'sysSettings.cronSuccess': 'Başarı:',
    'sysSettings.cronCommand': 'Komut:',
    'sysSettings.cronDescription': 'Açıklama:',
    'sysSettings.cronLastRun': 'Son Çalışma:',
    'sysSettings.cronNextRun': 'Sonraki:',
    'sysSettings.cronCreatedBy': 'Oluşturan:',
    'sysSettings.cronSystem': 'Sistem',
    'sysSettings.cronNever': 'Hiç',
    'sysSettings.cronUnknown': 'Bilinmiyor',
    'sysSettings.cronPause': 'Duraklat',
    'sysSettings.cronActivate': 'Aktifleştir',
    'sysSettings.cronRunNow': 'Şimdi çalıştır',
    'sysSettings.cronToggleError': 'Cron job durumu değiştirilirken hata oluştu',
    'sysSettings.cronDeleteConfirm': "Bu cron job'u silmek istediğinizden emin misiniz?",
    'sysSettings.cronDeleteError': 'Cron job silinirken hata oluştu',
    'sysSettings.noCronJobs': 'Henüz cron job tanımlanmamış',

    // Orders Tab
    'sysSettings.ordersTitle': 'Sipariş Ayarları',
    'sysSettings.capexTitle': 'CAPEX Zorunluluğu',
    'sysSettings.capexDesc': 'Belirli bir tutarın üzerindeki siparişler için CAPEX seçimini zorunlu kılın.',
    'sysSettings.capexMinAmount': 'Minimum Sipariş Tutarı (USD)',
    'sysSettings.capexSaved': 'CAPEX limiti başarıyla güncellendi!',
    'sysSettings.capexSaveError': 'CAPEX limiti güncellenirken hata oluştu',
    'sysSettings.capexNotes': 'Önemli Notlar:',
    'sysSettings.capexNote1': 'Tüm sipariş tutarları USD cinsine çevrilerek kontrol edilir',
    'sysSettings.capexNote2': 'Limit kontrolü sipariş oluşturulurken yapılır',
    'sysSettings.capexNote3': 'Kullanıcılar limit aşımında uyarı görür ve CAPEX seçmeden sipariş oluşturamazlar',
    'sysSettings.capexHint': 'Bu tutarın üzerindeki (veya eşit) siparişler için CAPEX seçimi zorunlu olacaktır. Örneğin: 200 USD girerseniz, 200 USD ve üzeri tüm siparişlerde CAPEX seçilmesi gerekir.',

    // Recovery Tab
    'sysSettings.recoveryTitle': 'Backup Geri Yükleme',
    'sysSettings.selectBackupSource': 'Backup Kaynağı Seçin',
    'sysSettings.uploadFile': 'Dosya Yükle',
    'sysSettings.serverBackup': 'Server Backup',
    'sysSettings.step1Upload': '1. Backup Dosyası Yükle',
    'sysSettings.backupFileLabel': 'Backup Dosyası (.sql.gz)',
    'sysSettings.onlySqlGz': 'Sadece .sql.gz uzantılı backup dosyaları desteklenir',
    'sysSettings.analyzing': 'Analiz Ediliyor...',
    'sysSettings.analyze': 'Analiz Et',
    'sysSettings.step1ServerBackup': '1. Server Backup Seçin',
    'sysSettings.noServerBackups': "Server'da backup dosyası bulunamadı",
    'sysSettings.selected': 'seçildi',
    'sysSettings.step2Tables': '2. Tablolar',
    'sysSettings.tablesFound': '{count} tablo bulundu',
    'sysSettings.selectAll': 'Tümünü Seç',
    'sysSettings.deselectAll': 'Tümünü Kaldır',
    'sysSettings.currentRecords': 'Mevcut:',
    'sysSettings.backupRecords': 'Backup:',
    'sysSettings.tableNotExists': 'Tablo mevcut değil',
    'sysSettings.backupHasMore': "Backup'ta daha fazla veri",
    'sysSettings.currentHasMore': "Mevcut'te daha fazla veri",
    'sysSettings.dataEqual': 'Veri eşit',
    'sysSettings.step3Recovery': '3. Geri Yükleme',
    'sysSettings.tablesSelected': '{count} tablo seçildi. Bu işlem mevcut verilerin üzerine yazabilir!',
    'sysSettings.restoring': 'Geri Yükleniyor...',
    'sysSettings.restore': 'Geri Yükle',
    'sysSettings.progress': 'İlerleme',
    'sysSettings.operationLogs': 'İşlem Logları',
    'sysSettings.serverBackupListError': 'Server backup listesi alınamadı:',
    'sysSettings.serverBackupListLoadError': 'Server backup listesi yüklenirken hata:',
    'sysSettings.unknownError': 'Bilinmeyen hata',
    'sysSettings.serverBackupAnalyzing': 'Server backup dosyası analiz ediliyor...',
    'sysSettings.serverBackupAnalyzed': 'Server backup analizi tamamlandı',
    'sysSettings.tablesFoundCount': '{count} tablo bulundu',
    'sysSettings.fileSize': 'Dosya boyutu: {size} MB',
    'sysSettings.backupFileAnalyzing': 'Backup dosyası analiz ediliyor...',
    'sysSettings.backupAnalyzed': 'Backup analizi tamamlandı',
    'sysSettings.recoveryStarting': 'Geri yükleme işlemi başlatılıyor...',
    'sysSettings.serverBackupProcessing': 'Server backup işleniyor...',
    'sysSettings.fileUploading': 'Backup dosyası sunucuya yükleniyor...',
    'sysSettings.dbProcessing': 'Veritabanı işlemleri gerçekleştiriliyor...',
    'sysSettings.recoverySuccess': 'Geri yükleme başarıyla tamamlandı!',
    'sysSettings.tablesRestored': '{tables} tablo geri yüklendi',
    'sysSettings.recordsProcessed': '{records} kayıt işlendi',
    'sysSettings.completedAt': 'Tamamlanma: {time}',
    'sysSettings.recoverySuccessAlert': 'Geri Yükleme Başarılı!',
    'sysSettings.recoverySuccessMsg': '{tables} tablo ve {records} kayıt başarıyla geri yüklendi.',
    'sysSettings.reloadConfirm': 'Sayfa yenilenerek güncel veriler gösterilsin mi?',
    'sysSettings.hoursAgo': '{hours} saat önce',

    // Bulk Print Tab
    'sysSettings.bulkPrintTitle': 'Toplu Etiket Basma',
    'sysSettings.printSettings': 'Baskı Ayarları',
    'sysSettings.locationSelect': 'Lokasyon Seçimi *',
    'sysSettings.selectLocation': 'Lokasyon seçin',
    'sysSettings.labelType': 'Etiket Tipi *',
    'sysSettings.cabinetLabel': 'IT Kabin Etiketi',
    'sysSettings.switchLabel': 'Network Switch Etiketi',
    'sysSettings.labelDimensions': 'Etiket Boyutları',
    'sysSettings.labelWidth': 'Genişlik (mm)',
    'sysSettings.labelHeight': 'Yükseklik (mm)',
    'sysSettings.labelOrientation': 'Etiket Yönü',
    'sysSettings.horizontal': 'Yatay',
    'sysSettings.vertical': 'Dikey',
    'sysSettings.margins': 'Kenar Boşlukları (mm)',
    'sysSettings.marginTop': 'Üst',
    'sysSettings.marginRight': 'Sağ',
    'sysSettings.marginBottom': 'Alt',
    'sysSettings.marginLeft': 'Sol',
    'sysSettings.includeSwitches': 'Network switchleri dahil et',
    'sysSettings.printLabels': 'Toplu Etiket Bas ({count} adet)',
    'sysSettings.itemsToPrint': 'Basılacak Öğeler ({count} adet)',
    'sysSettings.noCompany': 'Şirket yok',
    'sysSettings.noLocation': 'Lokasyon yok',
    'sysSettings.selectLocationFirst': 'Lokasyon seçin',
    'sysSettings.noItemsInLocation': 'Bu lokasyonda {type} bulunamadı',
    'sysSettings.cabinetType': 'kabin',
    'sysSettings.switchType': 'switch',
    'sysSettings.bulkPrintLoadError': 'Toplu baskı verileri yüklenirken hata oluştu',
    'sysSettings.noPrintItems': 'Baskı için öğe bulunamadı',
    'sysSettings.bulkPrintError': 'Toplu etiket baskısı sırasında hata oluştu',

    // API Tab
    'sysSettings.apiKeysTitle': 'API Anahtarları',
    'sysSettings.newApiKey': 'Yeni API Key',
    'sysSettings.apiKey': 'API Key:',
    'sysSettings.apiRateLimit': 'Rate Limit:',
    'sysSettings.apiRateLimitValue': '{count}/saat',
    'sysSettings.apiUsage': 'Kullanım:',
    'sysSettings.apiLastUsed': 'Son Kullanım:',
    'sysSettings.apiNeverUsed': 'Hiç',
    'sysSettings.apiPermissions': 'İzinler:',
    'sysSettings.apiExpiry': 'Bitiş:',
    'sysSettings.noApiKeys': 'Henüz API anahtarı bulunmuyor',

    // Modal
    'sysSettings.modalEditSetting': 'Ayar Düzenle',
    'sysSettings.modalNewSetting': 'Yeni Ayar',
    'sysSettings.modalEditBackup': 'Yedekleme Düzenle',
    'sysSettings.modalNewBackup': 'Yeni Yedekleme',
    'sysSettings.modalEditEmail': 'E-posta Düzenle',
    'sysSettings.modalNewEmail': 'Yeni E-posta',
    'sysSettings.modalEditCron': 'Cron Job Düzenle',
    'sysSettings.modalNewCron': 'Yeni Cron Job',
    'sysSettings.modalEditApi': 'API Düzenle',
    'sysSettings.modalNewApi': 'Yeni API',
    'sysSettings.settingKey': 'Ayar Anahtarı *',
    'sysSettings.settingCategory': 'Kategori *',
    'sysSettings.settingDataType': 'Veri Tipi *',
    'sysSettings.settingValueRequired': 'Değer *',
    'sysSettings.settingValuePlaceholder': 'Ayar değeri',
    'sysSettings.settingDesc': 'Açıklama *',
    'sysSettings.settingDescPlaceholder': 'Ayar açıklaması',
    'sysSettings.settingEncrypted': 'Şifrelenmiş değer',
    'sysSettings.backupName': 'Yedekleme Adı *',
    'sysSettings.backupNamePlaceholder': 'Günlük Veritabanı Yedekleme',
    'sysSettings.backupTypeSel': 'Yedekleme Tipi *',
    'sysSettings.backupTypeDatabase': 'Veritabanı',
    'sysSettings.backupTypeFiles': 'Dosyalar',
    'sysSettings.backupTypeSystem': 'Sistem',
    'sysSettings.backupTypeFull': 'Tam Yedekleme',
    'sysSettings.backupSourcePath': 'Kaynak Yolu *',
    'sysSettings.backupDestPath': 'Hedef Yolu *',
    'sysSettings.backupCronSchedule': 'Cron Programı *',
    'sysSettings.backupRetentionDaysSel': 'Saklama Süresi (Gün) *',
    'sysSettings.backupNotifEmails': 'Bildirim E-postaları',
    'sysSettings.backupAddEmail': '+ E-posta Ekle',
    'sysSettings.backupCompression': 'Sıkıştırma',
    'sysSettings.backupEncryption': 'Şifreleme',
    'sysSettings.emailConfigName': 'Konfigürasyon Adı *',
    'sysSettings.emailConfigPlaceholder': 'Ana SMTP Sunucu',
    'sysSettings.emailSmtpHost': 'SMTP Host *',
    'sysSettings.emailSmtpPort': 'SMTP Port *',
    'sysSettings.emailSmtpEncryption': 'Şifreleme *',
    'sysSettings.emailEncryptionNone': 'Yok',
    'sysSettings.emailUsername': 'Kullanıcı Adı *',
    'sysSettings.emailPassword': 'Parola *',
    'sysSettings.emailPasswordPlaceholder': 'SMTP parolası',
    'sysSettings.emailFromAddress': 'Gönderen E-posta *',
    'sysSettings.emailFromName': 'Gönderen Adı *',
    'sysSettings.emailDailyLimitField': 'Günlük Limit',
    'sysSettings.emailMonthlyLimitField': 'Aylık Limit',
    'sysSettings.emailIsDefault': 'Varsayılan konfigürasyon',
    'sysSettings.emailIsActive': 'Aktif',
    'sysSettings.cronJobName': 'Job Adı *',
    'sysSettings.cronJobNamePlaceholder': 'Veritabanı Yedekleme',
    'sysSettings.cronExpressionField': 'Cron İfadesi *',
    'sysSettings.cronExpressionHint': 'Örnek: "0 2 * * *" (Her gün saat 02:00)',
    'sysSettings.cronCommandField': 'Çalıştırılacak Betik *',
    'sysSettings.cronSelectScript': 'Betik seçin',
    'sysSettings.cronKeepCommand': 'Mevcut komutu koru',
    'sysSettings.cronDescField': 'Açıklama',
    'sysSettings.cronEmailNotif': 'E-posta Bildirimleri',
    'sysSettings.cronEmailNotifHint': "Bu cron job'dan e-posta bildirimi alacak admin/superadmin kullanıcıları seçin. Her cron job için farklı kullanıcılar seçebilirsiniz.",
    'sysSettings.cronAdminLoading': 'Admin kullanıcıları yükleniyor...',
    'sysSettings.cronIsActive': 'Aktif',
    'sysSettings.cronHelp': 'Cron İfadesi Yardımı',
    'sysSettings.cronHelpFields': 'Dakika Saat Gün Ay HaftanınGünü',
    'sysSettings.cronHelpEx1': 'Her gün saat 02:00',
    'sysSettings.cronHelpEx2': 'Her 6 saatte bir',
    'sysSettings.cronHelpEx3': 'Her pazar saat 00:00',
    'sysSettings.cronHelpEx4': "Her ayın 1'inde saat 00:00",
    'sysSettings.apiName': 'API Adı *',
    'sysSettings.apiRateLimitField': 'Rate Limit (Saatlik) *',
    'sysSettings.apiExpiryDate': 'Bitiş Tarihi',
    'sysSettings.apiIsActive': 'Aktif',
    'sysSettings.apiPermissionsField': 'İzinler',
    'sysSettings.apiAddPermission': '+ İzin Ekle',
    'sysSettings.apiAllowedIps': "İzin Verilen IP'ler",
    'sysSettings.apiAddIp': '+ IP Ekle',
    'sysSettings.apiAutoGenerate': 'API Anahtarı otomatik oluşturulacak',
    'sysSettings.apiPreview': 'Önizleme',
    'sysSettings.deleteConfirm': 'Bu {type} kaydını silmek istediğinizden emin misiniz?',
    'sysSettings.saveError': 'Kaydetme sırasında hata oluştu',
    'sysSettings.deleteError': 'Silme sırasında hata oluştu',

    // NotepadPage
    'notepad.sidebarTitle': 'Not Defteri',
    'notepad.newNote': 'Yeni Not',
    'notepad.categories': 'Kategoriler',
    'notepad.newCategoryTitle': 'Yeni kategori',
    'notepad.allNotes': 'Tüm Notlar',
    'notepad.uncategorized': 'Kategorisiz',
    'notepad.searchPlaceholder': 'Notlarda ara...',
    'notepad.noResults': 'Arama sonucu bulunamadı',
    'notepad.empty': 'Henüz not yok',
    'notepad.createFirst': 'İlk notu oluştur',
    'notepad.errLoadCategories': 'Kategoriler yüklenemedi',
    'notepad.errLoadNotes': 'Notlar yüklenemedi',
    'notepad.historyEmpty': 'Henüz geçmiş kaydı yok',
    'notepad.unknown': 'Bilinmeyen',
    'notepad.actionCreated': 'Oluşturdu',
    'notepad.actionUpdated': 'Güncelledi',
    'notepad.contentUpdated': 'içerik güncellendi',
    'notepad.copyLink': 'Linki kopyala',
    'notepad.copied': 'Kopyalandı',
    'notepad.share': 'Paylaş',
    'notepad.edit': 'Düzenle',
    'notepad.delete': 'Sil',
    'notepad.preview': 'Önizle',
    'notepad.images': 'Görseller',
    'notepad.addReaction': 'İfade ekle',
    'notepad.addEmoji': 'Ekle',
    'notepad.catEditTitle': 'Kategori Düzenle',
    'notepad.catNewTitle': 'Yeni Kategori',
    'notepad.catNameLabel': 'Kategori Adı *',
    'notepad.catColorLabel': 'Renk',
    'notepad.cancel': 'İptal',
    'notepad.save': 'Kaydet',
    'notepad.errCatNameRequired': 'Kategori adı gerekli',
    'notepad.errGeneral': 'Hata oluştu',
    'notepad.noteEditTitle': 'Notu Düzenle',
    'notepad.noteNewTitle': 'Yeni Not',
    'notepad.tabNote': 'Not',
    'notepad.tabHistory': 'Geçmiş',
    'notepad.titleLabel': 'Başlık *',
    'notepad.titlePlaceholder': 'Not başlığı...',
    'notepad.categoryLabel': 'Kategori',
    'notepad.quickCreate': 'Hızlı Oluştur',
    'notepad.uncategorizedOption': 'Kategorisiz',
    'notepad.newCategoryQuick': 'Yeni Kategori',
    'notepad.catNamePlaceholder': 'Kategori adı...',
    'notepad.contentLabel': 'İçerik',
    'notepad.contentPlaceholder': 'Not içeriğini yazın...',
    'notepad.imagesLabel': 'Görseller',
    'notepad.pasteTitle': 'Panodan yapıştır (Ctrl+V)',
    'notepad.paste': 'Yapıştır',
    'notepad.uploading': 'Yükleniyor...',
    'notepad.selectFile': 'Dosya Seç',
    'notepad.ctrlVHint': 'Forma tıklayıp Ctrl+V ile de yapıştırabilirsiniz.',
    'notepad.maxImagesReached': 'Maksimum görsel sayısına ulaşıldı.',
    'notepad.youtubeLabel': 'YouTube Linkleri',
    'notepad.youtubePlaceholder': 'YouTube linki yapıştırın...',
    'notepad.errMaxImages': 'En fazla {count} görsel eklenebilir',
    'notepad.errMaxImagesPartial': '{uploaded} tanesi yüklendi (maksimum {count})',
    'notepad.errImageUpload': 'Resim yüklenirken hata oluştu',
    'notepad.errNoImageClipboard': 'Panoda görsel bulunamadı',
    'notepad.errClipboardDenied': 'Pano erişimi reddedildi veya görsel yok',
    'notepad.errInvalidYoutube': 'Geçerli bir YouTube linki girin',
    'notepad.errYoutubeDuplicate': 'Bu link zaten eklenmiş',
    'notepad.errTitleRequired': 'Not başlığı gerekli',
    'notepad.errCatCreate': 'Kategori oluşturulamadı',
    'notepad.deleteCatTitle': 'Kategori Sil',
    'notepad.deleteNoteTitle': 'Not Sil',
    'notepad.deleteCatMsg': 'kategorisini silmek istediğinize emin misiniz? İçindeki notlar kategorisiz hale gelecektir.',
    'notepad.deleteNoteMsg': 'notunu kalıcı olarak silmek istediğinize emin misiniz?',

    // UserActivityPage
    'activity.title': 'Kullanıcı Aktiviteleri',
    'activity.subtitle': 'Sistemdeki tüm kullanıcı aktivitelerini görüntüleyin ve yönetin',
    'activity.export': 'Dışa Aktar',
    'activity.exportCSV': 'CSV Olarak İndir',
    'activity.exportExcel': 'Excel Olarak İndir',
    'activity.searchPlaceholder': 'Açıklama, kullanıcı adı...',
    'activity.allUsers': 'Tüm Kullanıcılar',
    'activity.allActions': 'Tüm Aksiyonlar',
    'activity.totalActivities': 'Toplam Aktivite',
    'activity.activeUsers': 'Aktif Kullanıcı',
    'activity.today': 'Bugün',
    'activity.page': 'Sayfa',
    'activity.list': 'Aktivite Listesi',
    'activity.collapseAll': 'Tümünü Kapat',
    'activity.expandAll': 'Tümünü Aç',
    'activity.categorizedView': 'Kategorize Görünüm',
    'activity.normalView': 'Normal Görünüm',
    'activity.refresh': 'Yenile',
    'activity.loading': 'Yükleniyor...',
    'activity.notFound': 'Aktivite bulunamadı',
    'activity.unknownAction': 'Bilinmeyen Aksiyon',
    'activity.mobile': 'Mobil',
    'activity.desktop': 'Desktop',
    'activity.previous': 'Önceki',
    'activity.next': 'Sonraki',
    'activity.col.date': 'Tarih',
    'activity.col.user': 'Kullanıcı',
    'activity.col.action': 'Aksiyon',
    'activity.col.description': 'Açıklama',
    'activity.col.ip': 'IP Adresi',
    'activity.col.device': 'Cihaz',
    'activity.exportTitle': 'Kullanıcı Aktiviteleri',
    'activity.cat.all': 'Tüm Kategoriler',
    'activity.cat.auth': 'Giriş - Çıkış İşlemleri',
    'activity.cat.capex': 'CAPEX İşlemleri',
    'activity.cat.printer': 'Yazıcı İşlemleri',
    'activity.cat.consumable': 'Sarf Malzeme İşlemleri',
    'activity.cat.network': 'Network İşlemleri',
    'activity.cat.industrial': 'Industrial İşlemleri',
    'activity.cat.order': 'Sipariş İşlemleri',
    'activity.cat.technical': 'Teknik Servis İşlemleri',
    'activity.cat.nvr_camera': 'NVR & Kamera İşlemleri',
    'activity.cat.gsm_telefon': 'GSM & Telefon İşlemleri',
    'activity.cat.arac_gerec': 'Araç Gereç İşlemleri',
    'activity.cat.server': 'Sunucu İşlemleri',
    'activity.cat.storage': 'Depolama İşlemleri',
    'activity.cat.meeting': 'Toplantı İşlemleri',
    'activity.cat.zimmet': 'Zimmet İşlemleri',
    'activity.cat.settings': 'Ayarlar İşlemleri',
    'activity.cat.other': 'Diğer İşlemler',

    // AnnouncementsPage
    'announce.title': 'Duyuru Yönetimi',
    'announce.subtitle': 'Site duyurularını ve geliştirme bilgilendirmelerini yönetin',
    'announce.newBtn': 'Yeni Duyuru',
    'announce.searchPlaceholder': 'Duyuru ara...',
    'announce.allTypes': 'Tüm Tipler',
    'announce.allStatuses': 'Tüm Durumlar',
    'announce.statusActive': 'Aktif',
    'announce.statusInactive': 'Pasif',
    'announce.count': '{count} duyuru',
    'announce.colTitle': 'Duyuru',
    'announce.colType': 'Tip',
    'announce.colStatus': 'Durum',
    'announce.colDates': 'Tarihler',
    'announce.colStats': 'İstatistik',
    'announce.colActions': 'İşlemler',
    'announce.statusPending': 'Beklemede',
    'announce.statusExpired': 'Süresi Doldu',
    'announce.live': '• Yayında',
    'announce.noAnnouncements': 'Duyuru bulunamadı.',
    'announce.titleToggleActive': 'Tıklayarak pasif yapabilirsiniz',
    'announce.titleToggleInactive': 'Tıklayarak aktif yapabilirsiniz',
    'announce.editTitle': 'Duyuru Düzenle',
    'announce.createTitle': 'Yeni Duyuru Oluştur',
    'announce.fieldTitle': 'Başlık *',
    'announce.fieldContent': 'İçerik *',
    'announce.fieldType': 'Tip',
    'announce.fieldPriority': 'Öncelik (1-5)',
    'announce.fieldRoles': 'Hedef Roller (boş bırakılırsa tüm roller)',
    'announce.fieldStartDate': 'Başlangıç Tarihi',
    'announce.fieldEndDate': 'Bitiş Tarihi',
    'announce.fieldActive': 'Aktif',
    'announce.fieldShowDashboard': 'Ana sayfada göster',
    'announce.fieldShowPopup': 'Popup olarak göster',
    'announce.cancel': 'İptal',
    'announce.update': 'Güncelle',
    'announce.create': 'Oluştur',
    'announce.viewStart': 'Başlangıç:',
    'announce.viewEnd': 'Bitiş:',
    'announce.close': 'Kapat',
    'announce.type.info': 'Bilgi',
    'announce.type.success': 'Başarı',
    'announce.type.warning': 'Uyarı',
    'announce.type.danger': 'Tehlike',
    'announce.type.feature': 'Özellik',
    'announce.type.maintenance': 'Bakım',
    'announce.role.superadmin': 'Süper Admin',
    'announce.role.user': 'Kullanıcı',
    'announce.role.technician': 'Teknisyen',
    'announce.errLoad': 'Duyurular yüklenirken hata oluştu',
    'announce.successUpdate': 'Duyuru başarıyla güncellendi',
    'announce.successCreate': 'Duyuru başarıyla oluşturuldu',
    'announce.errSave': 'Duyuru kaydedilirken hata oluştu',
    'announce.successDelete': 'Duyuru başarıyla silindi',
    'announce.errDelete': 'Duyuru silinirken hata oluştu',
    'announce.errToggle': 'Durum güncellenirken hata oluştu',
    'announce.titlePlaceholder': 'Duyuru başlığı',
    'announce.contentPlaceholder': 'Duyuru içeriğini yazın. Resim, video ve zengin metin formatları desteklenir...',

    // AssignmentDefinitionsPage
    'zimmetDef.title': 'Zimmet Yönetimi',
    'zimmetDef.addDef': 'Yeni Tanım Ekle',
    'zimmetDef.addTemplate': 'Yeni Şablon Ekle',
    'zimmetDef.tabDefs': 'Zimmet Tanımları',
    'zimmetDef.tabTemplates': 'Zimmet Şablonları',
    'zimmetDef.loading': 'Yükleniyor...',
    'zimmetDef.active': 'Aktif',
    'zimmetDef.default': 'Varsayılan',
    'zimmetDef.key': 'Anahtar:',
    'zimmetDef.file': 'Dosya:',
    'zimmetDef.download': 'İndir',
    'zimmetDef.activate': 'Aktif Yap',
    'zimmetDef.delete': 'Sil',
    'zimmetDef.noTemplates': 'Henüz şablon eklenmemiştir',
    'zimmetDef.all': 'Tümü',
    'zimmetDef.statusActive': 'Aktif',
    'zimmetDef.statusInactive': 'Pasif',
    'zimmetDef.edit': 'Düzenle',
    'zimmetDef.save': 'Kaydet',
    'zimmetDef.cancel': 'İptal',
    'zimmetDef.noDefs': 'Bu kategoride tanım bulunamadı',
    'zimmetDef.noDefs2': 'Henüz tanım eklenmemiştir',
    'zimmetDef.newTemplateTitle': 'Yeni Zimmet Şablonu',
    'zimmetDef.templateName': 'Şablon Adı',
    'zimmetDef.templateKey': 'Şablon Anahtarı',
    'zimmetDef.templateKeyHint': 'Küçük harf, tire ile ayrılmış benzersiz bir anahtar',
    'zimmetDef.templateDesc': 'Açıklama',
    'zimmetDef.templateFile': 'Referans Dosya',
    'zimmetDef.templateFileHint': 'Bu dosya zimmet formunun görsel referansı olarak saklanır, indirilebilir',
    'zimmetDef.templateFileLabel': 'DOCX veya PDF, opsiyonel',
    'zimmetDef.newDefTitle': 'Yeni Zimmet Tanımı',
    'zimmetDef.fieldCategory': 'Kategori',
    'zimmetDef.fieldTitle': 'Başlık',
    'zimmetDef.fieldContent': 'İçerik',
    'zimmetDef.fieldStatus': 'Durum',
    'zimmetDef.selectCategory': 'Kategori seçin',
    'zimmetDef.titlePlaceholder': 'Başlık girin',
    'zimmetDef.contentPlaceholder': 'İçerik girin',
    'zimmetDef.add': 'Ekle',
    'zimmetDef.saving': 'Kaydediliyor...',
    'zimmetDef.successActivate': 'Şablon aktif edildi',
    'zimmetDef.errActivate': 'Aktif etme başarısız',
    'zimmetDef.successDeleteTemplate': 'Şablon silindi',
    'zimmetDef.confirmDeleteTemplate': 'Bu şablonu silmek istediğinizden emin misiniz?',
    'zimmetDef.successAddTemplate': 'Şablon eklendi',
    'zimmetDef.successUpdate': 'Zimmet tanımı güncellendi',
    'zimmetDef.errUpdate': 'Güncelleme başarısız',
    'zimmetDef.successDelete': 'Zimmet tanımı silindi',
    'zimmetDef.confirmDelete': 'Bu zimmet tanımını silmek istediğinizden emin misiniz?',
    'zimmetDef.successAdd': 'Zimmet tanımı eklendi',
    'zimmetDef.errTitleContent': 'Başlık ve içerik gereklidir',
    'zimmetDef.errCategory': 'Lütfen bir kategori seçiniz',
    'zimmetDef.errTemplateFields': 'Ad ve şablon anahtarı zorunludur',
    'zimmetDef.success': 'Başarılı',
    'zimmetDef.error': 'Hata',
    // Marka ve Model Yönetimi
    'brandmodel.title': 'Marka ve Model Yönetimi',
    'brandmodel.subtitle': 'Cep telefonu marka ve modellerini yönetin',
    'brandmodel.tabBrands': 'Markalar',
    'brandmodel.tabBrandsShort': 'Marka',
    'brandmodel.tabModels': 'Modeller',
    'brandmodel.tabModelsShort': 'Model',
    'brandmodel.brandsHeading': 'Markalar',
    'brandmodel.newBrand': 'Yeni Marka',
    'brandmodel.colBrandName': 'Marka Adı',
    'brandmodel.colDescription': 'Açıklama',
    'brandmodel.colModelCount': 'Model Sayısı',
    'brandmodel.colPhoneCount': 'Telefon Sayısı',
    'brandmodel.colActions': 'İşlemler',
    'brandmodel.modelsHeading': 'Modeller',
    'brandmodel.newModel': 'Yeni Model',
    'brandmodel.colBrand': 'Marka',
    'brandmodel.colModelName': 'Model Adı',
    'brandmodel.editBrandTitle': 'Markayı Düzenle',
    'brandmodel.addBrandTitle': 'Yeni Marka Ekle',
    'brandmodel.labelBrandName': 'Marka Adı *',
    'brandmodel.labelDescription': 'Açıklama',
    'brandmodel.cancel': 'İptal',
    'brandmodel.update': 'Güncelle',
    'brandmodel.add': 'Ekle',
    'brandmodel.editModelTitle': 'Modeli Düzenle',
    'brandmodel.addModelTitle': 'Yeni Model Ekle',
    'brandmodel.labelBrand': 'Marka *',
    'brandmodel.placeholderBrand': 'Marka seçin',
    'brandmodel.labelModelName': 'Model Adı *',
    'brandmodel.errLoadData': 'Veriler yüklenemedi',
    'brandmodel.errBrandRequired': 'Marka adı zorunludur',
    'brandmodel.successBrandUpdated': 'Marka güncellendi',
    'brandmodel.successBrandAdded': 'Marka eklendi',
    'brandmodel.errOpFailed': 'İşlem başarısız',
    'brandmodel.errBrandModelRequired': 'Marka ve model adı zorunludur',
    'brandmodel.successModelUpdated': 'Model güncellendi',
    'brandmodel.successModelAdded': 'Model eklendi',
    'brandmodel.errBrandHasPhones': 'Bu markaya ait {count} telefon var. Önce telefonları silin veya başka bir markaya taşıyın.',
    'brandmodel.confirmDeleteBrand': '{name} markasını silmek istediğinize emin misiniz?',
    'brandmodel.successBrandDeleted': 'Marka silindi',
    'brandmodel.errBrandDeleted': 'Marka silinemedi',
    'brandmodel.errModelHasPhones': 'Bu modele ait {count} telefon var. Önce telefonları silin veya başka bir modele taşıyın.',
    'brandmodel.confirmDeleteModel': '{brand} {name} modelini silmek istediğinize emin misiniz?',
    'brandmodel.successModelDeleted': 'Model silindi',
    'brandmodel.errModelDeleted': 'Model silinemedi',
    'brandmodel.errTitle': 'Hata',
    'brandmodel.successTitle': 'Başarılı',
    'brandmodel.colImage': 'Görsel',
    'brandmodel.labelModelImage': 'Model Görseli',
    'brandmodel.previewAlt': 'Önizleme',
    'brandmodel.errImageUpload': 'Görsel yüklenemedi. Lütfen tekrar deneyin.',
    'brandmodel.errFileTooLarge': 'Dosya boyutu 5 MB\'ı geçemez',
  },
  en: {
    // Login Page
    'login.systemDescription': 'Corporate IT Management System',
    'login.emailLabel': 'Email Address',
    'login.emailPlaceholder': 'example@company.com',
    'login.passwordLabel': 'Password',
    'login.passwordPlaceholder': 'Enter your password',
    'login.twoFactorLabel': '2FA Code',
    'login.twoFactorHint': 'Enter the 6-digit code from Google Authenticator',
    'login.loginButton': 'Sign In',
    'login.loggingIn': 'Signing in...',
    'login.accountBlocked': 'Account Blocked',
    'login.forgotPassword': 'Forgot Password',
    'login.copyright': '© 2021 IT Toolbox by Devkit. All rights reserved.',
    'login.failedAttempts': '{count}/5 failed attempts. {remaining} attempts remaining.',
    'login.blockedMessage': 'Your account is blocked. Try again in {time}.',
    'login.tooManyAttempts': 'Too many failed login attempts. Try again in {time}.',
    'login.emailRequired': 'Email and password are required',
    'login.turnstileRequired': 'Please complete the security verification',
    'login.loginFailed': 'Login failed',
    'login.loginError': 'Login Error',
    'login.ok': 'OK',
    'login.success': 'Success',
    'login.loggedIn': 'Logged in!',
    // Forgot Password
    'forgot.title': 'Forgot Password',
    'forgot.description': 'Enter your email address and we will send you a password reset link',
    'forgot.emailLabel': 'Email Address',
    'forgot.submitButton': 'Send Password Reset Link',
    'forgot.sending': 'Sending...',
    'forgot.backToLogin': 'Back to login',
    'forgot.error': 'Error processing password reset request',
    'forgot.sendError': 'Error sending password reset request',
    // Version Update Modal
    'update.title': 'New Update Available!',
    'update.description': 'A new version of the application has been released. Update for the best experience.',
    'update.current': 'Current:',
    'update.new': 'New:',
    'update.later': 'Later',
    'update.update': 'Update',
    // Header
    'header.systemUpToDate': 'System Up to Date',
    'header.upToDate': 'Up to Date',
    'header.updateAvailable': 'Update Available',
    'header.update': 'Update',
    'header.announcements': 'Announcements',
    'header.notifications': 'Notifications',
    'header.language': 'Language',
    // Sidebar
    'sidebar.expand': 'Expand',
    'sidebar.collapse': 'Collapse',
    'sidebar.search': 'Search...',
    'sidebar.menuLoadError': 'Error loading menus',
    'sidebar.noMenuAccess': 'No menus available for your access level',
    'sidebar.version': 'Version:',
    // UserMenu
    'usermenu.logout_confirm': 'Are you sure you want to log out?',
    'usermenu.online': 'Online',
    'usermenu.last_login': '· Last login:',
    'usermenu.profile': 'My Profile',
    'usermenu.notification_settings': 'Notification Settings',
    'usermenu.user_activities': 'User Activities',
    'usermenu.logout': 'Log Out',
    'usermenu.role.teknisyen': 'Technician',
    'usermenu.role.calisan': 'Employee',
    // NotificationCenter
    'notif.title': 'Notification Center',
    'notif.unread': '{count} unread notifications',
    'notif.mark_all_read': 'Mark All as Read',
    'notif.clear_all': 'Clear All',
    'notif.confirm_clear': 'Are you sure you want to clear all notifications?',
    'notif.search': 'Search notifications...',
    'notif.filter.all_types': 'All Types',
    'notif.filter.info': 'Info',
    'notif.filter.success': 'Success',
    'notif.filter.warning': 'Warning',
    'notif.filter.error': 'Error',
    'notif.filter.system': 'System',
    'notif.category.all': 'All Categories',
    'notif.category.order': 'Orders',
    'notif.category.service': 'Technical Service',
    'notif.category.system': 'System',
    'notif.category.backup': 'Backup',
    'notif.category.security': 'Security',
    'notif.category.user': 'User',
    'notif.unread_only': 'Unread only',
    'notif.loading': 'Loading notifications...',
    'notif.not_found': 'No Notifications Found',
    'notif.no_match': 'No notifications match the selected criteria.',
    'notif.showing': '{count} notifications shown',
    'notif.settings': 'Notification Settings',
    'notif.priority.urgent': 'Urgent',
    'notif.priority.high': 'High',
    'notif.priority.normal': 'Normal',
    'notif.priority.low': 'Low',
    'notif.dismiss': 'Dismiss Notification',
    // AnnouncementPopup
    'announcement.title': 'Unread Announcements',
    'announcement.count': '{count} new announcements',
    'announcement.empty': 'No unread announcements',
    'announcement.high_priority': 'High Priority',
    'announcement.view': 'View',
    'announcement.close': 'Close',
    'announcement.dismiss': 'Dismiss',
    // GlobalSearch
    'search.searching': 'Searching...',
    'search.no_results': 'No results found',
    'search.no_match': 'No matching records for "{query}"',
    'search.results_found': '{count} results found',
    'search.records': '{count} records',
    'search.navigate_hint': '↑↓ Navigate · Enter Select · Esc Close',
    'search.tips_title': 'Quick Tips',
    'search.tip.gsm': 'Search by GSM number',
    'search.tip.imei': 'Search by IMEI number',
    'search.tip.serial': 'Search by serial or inventory number',
    'search.tip.user': 'Search by username or email',
    'search.min_chars': 'Enter at least 2 characters',
    'search.placeholder': 'Search... (Ctrl+K)',
    'search.mobile_placeholder': 'What are you looking for?',
    'search.cancel': 'Cancel',
    'search.categories_title': 'What can you search?',
    'search.cat.gsm': 'GSM Lines',
    'search.cat.gsm_sub': 'By phone number',
    'search.cat.mobile': 'Mobile Phones',
    'search.cat.mobile_sub': 'IMEI, number',
    'search.cat.computers': 'Computers',
    'search.cat.computers_sub': 'Inventory, serial no',
    'search.cat.users': 'Users',
    'search.cat.users_sub': 'Name, email',
    'search.cat.companies': 'Companies',
    'search.cat.companies_sub': 'Name, tax ID',
    'search.cat.orders': 'Orders',
    'search.cat.orders_sub': 'Order number',
    // Search result module labels
    'search.module.gsm-lines': 'GSM Lines',
    'search.module.mobile-phones': 'Mobile Phones',
    'search.module.computers': 'Computers',
    'search.module.monitors': 'Monitors',
    'search.module.printers': 'Printers',
    'search.module.users': 'Users',
    'search.module.companies': 'Companies',
    'search.module.orders': 'Orders',
    'search.module.locations': 'Locations',
    'search.module.suppliers': 'Suppliers',
    'search.module.equipment': 'Equipment',
    'search.module.notepad': 'Notepad',
    'search.module.cameras': 'Cameras',
    'search.module.nvrs': 'NVRs',
    'search.module.storage-units': 'Storage Units',
    'search.module.physical-servers': 'Physical Servers',
    'search.module.virtual-servers': 'Virtual Servers',
    'search.module.network-switches': 'Network Switches',
    'search.module.capex': 'CAPEX',
    // Badge statuses
    'badge.active': 'Active',
    'badge.inactive': 'Inactive',
    'badge.damaged': 'Damaged',
    'badge.lost': 'Lost',
    'badge.suspended': 'Suspended',
    'badge.available': 'Available',
    'badge.beklemede': 'Pending',
    'badge.onaylandi': 'Approved',
    'badge.teslim-edildi': 'Delivered',
    'badge.siparis-verildi': 'Ordered',
    'badge.maintenance': 'Maintenance',
    'badge.offline': 'Offline',
    'badge.decommissioned': 'Decommissioned',
    'badge.running': 'Running',
    'badge.stopped': 'Stopped',
    'badge.approved': 'Approved',
    'badge.rejected': 'Rejected',
    'badge.pending': 'Pending',
    'badge.completed': 'Completed',
    // MobileNavigation
    'mobile.dashboard': 'Home',
    'mobile.orders': 'Orders',
    'mobile.service': 'Service',
    'mobile.notifications': 'Notifications',
    'mobile.activities': 'Activities',
    'mobile.menu': 'Menu',
    'mobile.no_menu': 'No menu items found',
    'mobile.profile_settings': 'Profile Settings',
    'mobile.logout': 'Logout',
    'mobile.user': 'User',
    // Sidebar Menu Items
    'menu.dashboard': 'Dashboard',
    'menu.arac_gerec': 'Tools & Equipment',
    'menu.companies': 'Companies',
    'menu.locations': 'Locations',
    'menu.suppliers': 'Suppliers',
    'menu.equipment': 'Equipment',
    'menu.consumables': 'Consumables',
    'menu.documents': 'Documents',
    'menu.maintenance_contracts': 'Maintenance Contracts',
    'menu.damage_theft': 'Damage & Theft',
    'menu.orders': 'Orders',
    'menu.capex': 'CAPEX',
    'menu.printers': 'Printers',
    'menu.technical_service': 'Technical Service',
    'menu.it_equipment': 'IT Equipment',
    'menu.computers': 'Computers',
    'menu.computer-brands': 'Brands',
    'menu.computer-models': 'Models',
    'menu.mobile_phones': 'Mobile Phones',
    'menu.servers': 'Servers',
    'menu.physical_servers': 'Physical Servers',
    'menu.virtual_servers': 'Virtual Servers',
    'menu.industrial': 'Industrial',
    'menu.iot': 'IoT Devices',
    'menu.scales': 'Smart Scales',
    'menu.radios': 'Radios',
    'menu.handheld_terminals': 'Handheld Terminals',
    'menu.network': 'Network',
    'menu.network_switches': 'Network Switches',
    'menu.cabinets': 'IT Cabinets',
    'menu.circuits': 'Circuits',
    'menu.storage': 'Storage Units',
    'menu.meetings': 'Meetings',
    'menu.assignment_forms': 'Assignment Operations',
    'menu.assignment_forms_main': 'Assignment Forms',
    'menu.assignment_logs': 'Assignment Logs',
    'menu.settings': 'Settings',
    'menu.assignment_definitions': 'Assignment Definitions',
    'menu.system_settings': 'System Settings',
    'menu.users': 'Users',
    'menu.activities': 'User Activities',
    'menu.announcements': 'Announcements',
    'menu.menu-management': 'Menu Management',
    'menu.security_cameras': 'NVR & Cameras',
    'menu.cameras': 'Cameras',
    'menu.camera-faults': 'Camera Faults',
    'menu.nvrs': 'NVR',
    'menu.profile': 'Profile',
    'menu.gsm_lines': 'GSM Lines',
    'menu.tariffs': 'Tariffs',
    'menu.monitors': 'Monitors',
    'menu.notepad': 'Notepad',
    'menu.procedures': 'Procedures',
    'menu.security_vulnerabilities': 'Security Vulnerabilities',
    'menu.checklists': 'Checklists',
    'menu.phone_replacement': 'Phone Replacement',
    'menu.scrap_computers': 'Scrap Computers',
    'menu.rbac': 'Permission Management',
    'menu.cargo_labels': 'Cargo Labels',
    // Dashboard
    'dashboard.subtitle': 'System status and performance metrics',
    'dashboard.refresh': 'Refresh',
    'dashboard.period.24h': '24 Hours',
    'dashboard.period.7d': '7 Days',
    'dashboard.period.30d': '30 Days',
    'dashboard.period.90d': '90 Days',
    'dashboard.totalUsers': 'Total Users',
    'dashboard.active': 'Active',
    'dashboard.online': 'Online',
    'dashboard.infrastructure': 'Infrastructure',
    'dashboard.servers': 'Servers',
    'dashboard.physical': 'Physical',
    'dashboard.virtual': 'Virtual',
    'dashboard.network': 'Network',
    'dashboard.storageLabel': 'Storage',
    'dashboard.activeServices': 'Active Services',
    'dashboard.pending': 'Pending',
    'dashboard.today': 'Today',
    'dashboard.completed': 'Completed',
    'dashboard.quickStats': 'Quick Stats',
    'dashboard.operational': 'Operational',
    'dashboard.activeOrders': 'Active Orders',
    'dashboard.pendingService': 'Pending Service',
    'dashboard.organization': 'Organization',
    'dashboard.recentActivities': 'Recent Activities',
    'dashboard.viewAll': 'View All',
    'dashboard.noActivities': 'No activities yet',
    'dashboard.liveFeed': 'Live Feed',
    'dashboard.system': 'System',
    'dashboard.loginStats': 'Your Login Statistics',
    'dashboard.lastLogin': 'Last Login',
    'dashboard.unknown': 'Unknown',
    'dashboard.activeStatus': 'Active Status',
    'dashboard.roleLabel': 'Role',
    'dashboard.technician': 'Technician',
    'dashboard.employee': 'Employee',
    'dashboard.activitySummary': 'Your Activity Summary',
    'dashboard.technicalService': 'Technical Service',
    'dashboard.hasAccess': 'Has access',
    'dashboard.limitedAccess': 'Limited access',
    'dashboard.statusLabel': 'Status',
    'dashboard.activeLabel': 'Active',
    'dashboard.refreshing': 'Refreshing',
    'dashboard.refreshingData': 'Updating dashboard data...',
    'dashboard.refreshComplete': 'Completed',
    'dashboard.refreshSuccess': 'Dashboard successfully updated!',
    'dashboard.loadError': 'Error loading dashboard data',
    'dashboard.perfUpdated': 'Updated',
    'dashboard.perfUpdateSuccess': 'System performance data refreshed!',
    'dashboard.perfLoadError': 'Error loading system performance',
    // Tariffs Page
    'tariffs.title': 'Tariff List',
    'tariffs.subtitle': 'Manage Vodafone GSM tariff plans',
    'tariffs.newTariff': 'New Tariff',
    'tariffs.searchPlaceholder': 'Search tariff...',
    'tariffs.colName': 'Tariff Name',
    'tariffs.colDescription': 'Description',
    'tariffs.colPrice': 'Price (₺/mo)',
    'tariffs.colLines': 'Lines Using',
    'tariffs.colCreated': 'Created',
    'tariffs.linesCount': '{count} lines',
    'tariffs.linesTitle': 'View lines using this tariff',
    'tariffs.editTitle': 'Edit',
    'tariffs.deleteTitle': 'Delete tariff',
    'tariffs.deleteDisabledTitle': 'This tariff is in use and cannot be deleted',
    'tariffs.notFound': 'No tariffs found',
    'tariffs.modalEditTitle': 'Edit Tariff',
    'tariffs.modalNewTitle': 'New Tariff',
    'tariffs.labelName': 'Tariff Name *',
    'tariffs.labelPrice': 'Monthly Price (₺) *',
    'tariffs.labelDescription': 'Description',
    'tariffs.placeholderName': 'e.g. Corporate 20GB',
    'tariffs.placeholderPrice': '89.90',
    'tariffs.placeholderDescription': 'Tariff details (GB, minutes, SMS limits)',
    'tariffs.cancel': 'Cancel',
    'tariffs.save': 'Save',
    'tariffs.update': 'Update',
    'tariffs.errorLoadData': 'Error loading data',
    'tariffs.errorRequired': 'Tariff name and price are required',
    'tariffs.successUpdated': 'Tariff updated',
    'tariffs.successCreated': 'Tariff created',
    'tariffs.errorSave': 'Error saving tariff',
    'tariffs.successDeleted': 'Tariff deleted',
    'tariffs.errorDelete': 'Error deleting tariff',
    'tariffs.deleteBlocked': 'Delete Blocked',
    'tariffs.deleteBlockedMsg': 'This tariff is actively used by {count} GSM lines. Change their tariffs first.',
    'tariffs.deleteConfirm': 'Are you sure you want to delete this tariff plan?',
    // Security Vulnerabilities Page
    'secvuln.title': 'Security Vulnerabilities',
    'secvuln.lastUpdated': 'Last updated: {time}',
    'secvuln.updating': 'Updating...',
    'secvuln.update': 'Update',
    'secvuln.statTotal': 'Total',
    'secvuln.statCritical': 'Critical',
    'secvuln.statHigh': 'High',
    'secvuln.statActiveExploit': 'Active Exploit',
    'secvuln.statNewToday': 'Added Today',
    'secvuln.statCisaKev': 'CISA KEV',
    'secvuln.infoBand': '<strong>CISA KEV</strong> — actively exploited vulnerabilities in the wild · <strong>NIST NVD</strong> — all CVE records and CVSS scores. Content is updated automatically every day at 06:00 (TST).',
    'secvuln.infoBandAdmin': ' · <strong>Admin and Superadmin</strong> roles can add solutions and source links to vulnerabilities.',
    'secvuln.periodLabel': 'Period:',
    'secvuln.period1w': 'Last 1 Week',
    'secvuln.period2w': 'Last 2 Weeks',
    'secvuln.period1m': 'Last 1 Month',
    'secvuln.periodAll': 'All',
    'secvuln.searchPlaceholder': 'Search CVE ID or description...',
    'secvuln.filterBtn': 'Filter',
    'secvuln.clearFilters': 'Clear',
    'secvuln.filterSource': 'Source',
    'secvuln.filterSourceAll': 'All',
    'secvuln.filterSeverity': 'Severity',
    'secvuln.filterSeverityAll': 'All',
    'secvuln.filterSeverityCritical': 'Critical',
    'secvuln.filterSeverityHigh': 'High',
    'secvuln.filterSeverityMedium': 'Medium',
    'secvuln.filterSeverityLow': 'Low',
    'secvuln.filterActiveOnly': 'Actively Exploited Only (CISA KEV)',
    'secvuln.resultCount': '{count} vulnerabilities',
    'secvuln.pageOf': 'Page {page} / {pages}',
    'secvuln.activeExploitBadge': 'Active Exploit',
    'secvuln.noTranslation': '(No translation available)',
    'secvuln.descriptionTr': 'Description (Turkish)',
    'secvuln.descriptionEn': 'Description (English)',
    'secvuln.translating': 'Translating...',
    'secvuln.translate': 'Translate',
    'secvuln.requiredAction': 'Required Action (CISA)',
    'secvuln.cisaKevCatalog': 'CISA KEV Catalog',
    'secvuln.prevPage': 'Previous',
    'secvuln.nextPage': 'Next',
    'secvuln.updateHistory': 'Update History',
    'secvuln.newOf': '{new} new / {fetched} checked',
    'secvuln.emptyTitle': 'No vulnerabilities found',
    'secvuln.emptyHintFiltered': 'Try clearing filters or selecting a different period',
    'secvuln.emptyHintNoData': 'Start fetching data with the "Update" button',
    'secvuln.errorLoad': 'Error loading data',
    'secvuln.fetchStarted': 'Data fetch started. It will complete in a few minutes.',
    'secvuln.fetchError': 'Could not start data fetch',
    'secvuln.translateError': 'Translation failed',
    'secvuln.solutionsTitle': 'Solutions & Resources',
    'secvuln.addSolution': 'Add Solution',
    'secvuln.solutionsLoading': 'Loading...',
    'secvuln.noSolutions': 'No solutions added yet.',
    'secvuln.noSolutionsHint': ' You can use the "Add Solution" button above.',
    'secvuln.solutionFormEditTitle': 'Edit Solution',
    'secvuln.solutionFormNewTitle': 'Add New Solution',
    'secvuln.solutionPlaceholder': 'Solution description, applied patch or temporary measure...',
    'secvuln.linkUrlPlaceholder': 'Link URL (optional)',
    'secvuln.linkLabelPlaceholder': 'Link label (optional, URL shown if empty)',
    'secvuln.saving': 'Saving...',
    'secvuln.save': 'Save',
    'secvuln.cancel': 'Cancel',
    'secvuln.solutionRequired': 'Solution description is required',
    'secvuln.solutionUpdated': 'Solution updated',
    'secvuln.solutionAdded': 'Solution added',
    'secvuln.solutionSaveError': 'Could not save',
    'secvuln.solutionDeleteConfirm': 'Are you sure you want to delete solution "{preview}..."?',
    'secvuln.solutionDeleted': 'Solution deleted',
    'secvuln.solutionDeleteError': 'Could not delete',
    'secvuln.linkTypeFix': 'Fix',
    'secvuln.linkTypePatch': 'Patch',
    'secvuln.linkTypeWorkaround': 'Workaround',
    'secvuln.linkTypeReference': 'Reference',
    'secvuln.linkTypeOther': 'Other',
    'secvuln.severityCritical': 'Critical',
    'secvuln.severityHigh': 'High',
    'secvuln.severityMedium': 'Medium',
    'secvuln.severityLow': 'Low',
    'secvuln.severityNone': 'None',
    'secvuln.severityUnknown': 'Unknown',
    'secvuln.solutionCount': '{count} Solutions',
    'secvuln.timeToday': 'Today',
    'secvuln.timeYesterday': 'Yesterday',
    'secvuln.timeDaysAgo': '{days} days ago',
    'secvuln.timeWeeksAgo': '{weeks} weeks ago',
    'secvuln.timeMonthsAgo': '{months} months ago',
    'secvuln.timeYearsAgo': '{years} years ago',
    // VirtualServersPage
    'virtserver.title': 'Virtual Servers',
    'virtserver.subtitle': 'Virtual machine inventory and performance tracking',
    'virtserver.addNew': 'New Virtual Server',
    'virtserver.loading': 'Loading virtual servers...',
    'virtserver.loadError': 'Error loading data',
    'virtserver.totalVM': 'Total VMs',
    'virtserver.running': 'Running',
    'virtserver.stoppedStat': 'Stopped',
    'virtserver.totalVcpu': 'Total vCPU',
    'virtserver.searchPlaceholder': 'Search virtual server...',
    'virtserver.allPhysicalServers': 'All Physical Servers',
    'virtserver.allStatuses': 'All Statuses',
    'virtserver.allCompanies': 'All Companies',
    'virtserver.allLocations': 'All Locations',
    'virtserver.allStorageUnits': 'All Storage Units',
    'virtserver.allStoragePools': 'All Storage Pools',
    'virtserver.allHypervisors': 'All Hypervisors',
    'virtserver.excelSheet': 'Virtual Servers',
    'virtserver.excelFilename': 'virtual-servers',
    'virtserver.pdfTitle': 'Virtual Servers Report',
    'virtserver.pdfReportDate': 'Report Date:',
    'virtserver.pdfTotal': 'Total VMs:',
    'virtserver.exportExcelSuccess': 'records exported to Excel',
    'virtserver.exportExcelError': 'Error during Excel export',
    'virtserver.exportPdfSuccess': 'records exported to PDF',
    'virtserver.exportPdfError': 'Error during PDF export',
    'virtserver.colVmName': 'VM Name',
    'virtserver.colHostname': 'Hostname',
    'virtserver.colIpAddress': 'IP Address',
    'virtserver.colPhysicalServer': 'Physical Server',
    'virtserver.colCompany': 'Company',
    'virtserver.colResources': 'Resources',
    'virtserver.colStatus': 'Status',
    'virtserver.colActions': 'Actions',
    'virtserver.notAssigned': 'Unassigned',
    'virtserver.noResults': 'No virtual servers found',
    'virtserver.noResultsDesc': 'No virtual servers match your search criteria.',
    'virtserver.titleHistory': 'History',
    'virtserver.titleViewDetail': 'View Details',
    'virtserver.titleCopy': 'Copy',
    'virtserver.titleEdit': 'Edit',
    'virtserver.titleDelete': 'Delete',
    'virtserver.modalEditTitle': 'Edit Virtual Server',
    'virtserver.modalAddTitle': 'New Virtual Server',
    'virtserver.sectionBasicInfo': 'Basic Information',
    'virtserver.labelVmName': 'VM Name *',
    'virtserver.labelHostname': 'Hostname *',
    'virtserver.labelIpAddress': 'IP Address *',
    'virtserver.labelPhysicalServer': 'Physical Server *',
    'virtserver.selectPhysicalServer': 'Select physical server',
    'virtserver.labelOs': 'Operating System *',
    'virtserver.labelHypervisor': 'Hypervisor *',
    'virtserver.labelPurpose': 'Purpose *',
    'virtserver.labelStatus': 'Status *',
    'virtserver.sectionResources': 'Resource Allocation',
    'virtserver.labelVcpu': 'vCPU Count *',
    'virtserver.labelRam': 'RAM (GB) *',
    'virtserver.labelStorage': 'Storage (GB) *',
    'virtserver.sectionLocation': 'Location & Assignment',
    'virtserver.labelCompany': 'Company *',
    'virtserver.selectCompany': 'Select company',
    'virtserver.labelLocation': 'Location *',
    'virtserver.selectLocation': 'Select location',
    'virtserver.labelAdmin': 'Responsible Admin',
    'virtserver.selectAdmin': 'Select admin',
    'virtserver.labelNotes': 'Notes',
    'virtserver.notesPlaceholder': 'Notes about the virtual server...',
    'virtserver.btnCancel': 'Cancel',
    'virtserver.btnUpdate': 'Update',
    'virtserver.btnSave': 'Save',
    'virtserver.errorRequired': 'Please fill in required fields',
    'virtserver.errorInvalidIp': 'Invalid IP address format. Example: 192.168.1.100',
    'virtserver.errorDuplicateHostname': 'This hostname is already in use: {name}',
    'virtserver.errorDuplicateIp': 'This IP address is already in use: {name} ({ip})',
    'virtserver.successUpdated': 'Virtual server updated',
    'virtserver.successCreated': 'Virtual server created',
    'virtserver.errorSave': 'Error saving virtual server',
    'virtserver.confirmDelete': 'Are you sure you want to delete this virtual server?',
    'virtserver.successDeleted': 'Virtual server deleted',
    'virtserver.errorDelete': 'Error deleting virtual server',
    'virtserver.errorLoadActivities': 'Error loading activity history',
    'virtserver.detailTitle': 'Virtual Server Details',
    'virtserver.detailVmInfo': 'VM Information',
    'virtserver.detailVmName': 'VM Name:',
    'virtserver.detailHostname': 'Hostname:',
    'virtserver.detailIpAddress': 'IP Address:',
    'virtserver.detailPhysicalServer': 'Physical Server:',
    'virtserver.detailHypervisor': 'Hypervisor:',
    'virtserver.detailOs': 'Operating System:',
    'virtserver.detailPurpose': 'Purpose:',
    'virtserver.detailResources': 'Resource Allocation',
    'virtserver.detailVcpu': 'vCPU:',
    'virtserver.detailRam': 'RAM:',
    'virtserver.detailStorage': 'Storage:',
    'virtserver.detailUptime': 'Uptime:',
    'virtserver.detailUptimeDays': '{days} days',
    'virtserver.detailBackup': 'Backup Information',
    'virtserver.detailBackupSchedule': 'Backup Schedule:',
    'virtserver.detailLastBackup': 'Last Backup:',
    'virtserver.detailLastSnapshot': 'Last Snapshot:',
    'virtserver.detailSystemInfo': 'System Information',
    'virtserver.detailCreatedAt': 'Created:',
    'virtserver.detailUpdatedAt': 'Last Updated:',
    'virtserver.detailAdmin': 'Responsible Admin:',
    'virtserver.detailNotes': 'Notes',
    'virtserver.historyTitle': 'Action History',
    'virtserver.historyLoading': 'Loading history...',
    'virtserver.historyEmpty': 'No action history found',
    'virtserver.historyEmptyDesc': 'No action records exist for this virtual server yet.',
    'virtserver.historyActionCreated': 'Created',
    'virtserver.historyActionUpdated': 'Updated',
    'virtserver.historyActionDeleted': 'Deleted',
    'virtserver.historyActionStarted': 'Started',
    'virtserver.historyActionStopped': 'Stopped',
    'virtserver.historyActionSuspended': 'Suspended',
    'virtserver.historyPerformedBy': 'Performed By:',
    'virtserver.historyPhysicalServer': 'Physical Server:',
    'virtserver.historyChangedFields': 'Changed Fields:',
    'virtserver.statusRunning': 'Running',
    'virtserver.statusStopped': 'Stopped',
    'virtserver.statusSuspended': 'Suspended',
    'virtserver.statusMaintenance': 'Maintenance',
    'virtserver.copyNameSuffix': '(Copy)',
    'virtserver.sectionStorage': 'Storage',
    'virtserver.labelStorageUnit': 'Storage Unit',
    'virtserver.selectStorageUnit': 'Select storage unit (optional)',
    'virtserver.labelStoragePool': 'Storage Pool',
    'virtserver.selectStoragePool': 'Select pool (optional)',
    'virtserver.colStorage': 'Storage',
    'virtserver.detailStorageUnit': 'Storage Unit:',
    'virtserver.detailStoragePool': 'Storage Pool:',
    // RadiosPage
    'radios.title': 'Radio Management',
    'radios.subtitle': 'Handheld and fixed communication equipment inventory',
    'radios.addNew': 'New Radio',
    'radios.loadError': 'Error loading data',
    'radios.totalRadios': 'Total Radios',
    'radios.active': 'Active',
    'radios.maintenanceFaulty': 'Maintenance / Faulty',
    'radios.assigned': 'Assigned',
    'radios.searchPlaceholder': 'Search radio...',
    'radios.allStatuses': 'All Statuses',
    'radios.colRadio': 'Radio',
    'radios.colLocation': 'Location',
    'radios.colUser': 'User',
    'radios.colStatus': 'Status',
    'radios.colSerialNo': 'Serial No',
    'radios.colActions': 'Actions',
    'radios.notAssigned': 'Unassigned',
    'radios.noResults': 'No radios found',
    'radios.noResultsDesc': 'No radios match your search criteria.',
    'radios.titleViewDetail': 'View Details',
    'radios.titleEdit': 'Edit',
    'radios.titleCopy': 'Copy',
    'radios.titlePrint': 'Print Label',
    'radios.titleDelete': 'Delete',
    'radios.modalEditTitle': 'Edit Radio',
    'radios.modalAddTitle': 'New Radio',
    'radios.sectionBasicInfo': 'Basic Information',
    'radios.labelName': 'Radio Name *',
    'radios.labelBrand': 'Brand *',
    'radios.labelModel': 'Model *',
    'radios.labelSerialNo': 'Serial Number *',
    'radios.serialDuplicate': 'Already in use',
    'radios.labelInventoryNo': 'Inventory No',
    'radios.labelStatus': 'Status *',
    'radios.sectionTechnical': 'Technical Specifications',
    'radios.labelFrequency': 'Frequency',
    'radios.labelFrequencyRange': 'Frequency Range',
    'radios.labelPowerOutput': 'Power Output',
    'radios.labelBatteryType': 'Battery Type',
    'radios.sectionLocation': 'Location & Assignment',
    'radios.labelCompany': 'Company *',
    'radios.selectCompany': 'Select company',
    'radios.labelLocation': 'Location *',
    'radios.selectLocation': 'Select location',
    'radios.labelAssignedUser': 'Assigned User',
    'radios.selectUser': 'Select user',
    'radios.sectionPurchase': 'Purchase Information',
    'radios.labelPurchaseDate': 'Purchase Date',
    'radios.labelWarrantyEnd': 'Warranty End Date',
    'radios.labelPurchasePrice': 'Purchase Price',
    'radios.labelImage': 'Radio Image',
    'radios.imageKeepNote': 'Current image will be kept. Select a new file to replace.',
    'radios.labelNotes': 'Notes',
    'radios.notesPlaceholder': 'Notes about the radio...',
    'radios.btnCancel': 'Cancel',
    'radios.btnUpdate': 'Update',
    'radios.btnSave': 'Save',
    'radios.errorRequired': 'Please fill in required fields (Radio Name, Brand, Model, Serial No)',
    'radios.errorLocationCompany': 'Location and Company selection is required',
    'radios.errorDuplicateSerial': 'This serial number is already in use',
    'radios.successUpdated': 'Radio updated',
    'radios.successCreated': 'Radio created',
    'radios.errorSave': 'Error saving radio',
    'radios.confirmDelete': 'Are you sure you want to delete this radio?',
    'radios.successDeleted': 'Radio deleted',
    'radios.errorDelete': 'Error deleting radio',
    'radios.errorPrint': 'Error generating label',
    'radios.detailTitle': 'Radio Details',
    'radios.detailRadioInfo': 'Radio Information',
    'radios.detailName': 'Radio Name:',
    'radios.detailBrandModel': 'Brand / Model:',
    'radios.detailSerialNo': 'Serial No:',
    'radios.detailInventoryNo': 'Inventory No:',
    'radios.detailStatus': 'Status:',
    'radios.detailAssignedUser': 'Assigned User:',
    'radios.detailLocationTechnical': 'Location & Technical',
    'radios.detailCompany': 'Company:',
    'radios.detailLocation': 'Location:',
    'radios.detailFrequency': 'Frequency:',
    'radios.detailFrequencyRange': 'Frequency Range:',
    'radios.detailPowerOutput': 'Power Output:',
    'radios.detailBattery': 'Battery:',
    'radios.detailPurchaseInfo': 'Purchase Information',
    'radios.detailPurchaseDate': 'Purchase Date:',
    'radios.detailWarrantyEnd': 'Warranty End:',
    'radios.detailPrice': 'Price:',
    'radios.detailNotes': 'Notes',
    'radios.detailImage': 'Radio Image',
    'radios.btnEdit': 'Edit',
    'radios.btnPrint': 'Print Label',
    'radios.statusActive': 'Active',
    'radios.statusInactive': 'Inactive',
    'radios.statusMaintenance': 'Maintenance',
    'radios.statusFaulty': 'Faulty',
    'radios.copyNameSuffix': '- Copy',
    // Common
    'common.error': 'Error',
    'common.success': 'Success',
    'common.loading': 'Loading...',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.close': 'Close',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.operationFailed': 'Operation failed',
    'common.add': 'Add',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.filters': 'Filters',
    'common.clearFilters': 'Clear',
    'common.export': 'Export',
    'common.import': 'Import',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.ok': 'OK',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.previous': 'Previous',
    'common.refresh': 'Refresh',
    'common.confirm': 'Confirm',
    'common.warning': 'Warning',
    'common.info': 'Info',
    'common.actions': 'Actions',
    'common.status': 'Status',
    'common.date': 'Date',
    'common.name': 'Name',
    'common.description': 'Description',
    'common.type': 'Type',
    'common.total': 'Total',
    'common.noData': 'No data found',
    'common.pageOf': '{current} / {total} pages',
    'common.itemsPerPage': 'Items per page',
    'common.allRights': 'All rights reserved.',
    // Storage Units Page
    'storage.title': 'Storage Units',
    'storage.subtitle': 'Storage infrastructure management and monitoring',
    'storage.addNew': 'New Storage Unit',
    'storage.totalUnits': 'Total Units',
    'storage.totalCapacity': 'Total Capacity',
    'storage.usedCapacity': 'Used',
    'storage.availableCapacity': 'Available',
    'storage.searchPlaceholder': 'Search storage unit...',
    'storage.allTypes': 'All Types',
    'storage.allStatuses': 'All Statuses',
    'storage.statusActive': 'Active',
    'storage.statusMaintenance': 'Maintenance',
    'storage.statusOffline': 'Offline',
    'storage.statusDecommissioned': 'Decommissioned',
    'storage.typeLabel': 'Type:',
    'storage.totalCapacityLabel': 'Total Capacity:',
    'storage.usageRate': 'Usage Rate',
    'storage.usedLabel': 'Used',
    'storage.availableLabel': 'Available',
    'storage.encrypted': 'Encrypted',
    'storage.compression': 'Compression',
    'storage.viewDetails': 'View Details',
    'storage.modalAddTitle': 'New Storage Unit',
    'storage.modalEditTitle': 'Edit Storage Unit',
    'storage.fieldName': 'Storage Name *',
    'storage.fieldType': 'Storage Type *',
    'storage.fieldBrand': 'Brand *',
    'storage.fieldModel': 'Model *',
    'storage.fieldSerial': 'Serial Number *',
    'storage.fieldIP': 'IP Address',
    'storage.fieldTotalCapacity': 'Total Capacity (TB) *',
    'storage.fieldUsedCapacity': 'Used Capacity (TB)',
    'storage.fieldDiskType': 'Disk Type *',
    'storage.fieldConnectionType': 'Connection Type *',
    'storage.fieldCompany': 'Company *',
    'storage.fieldLocation': 'Location *',
    'storage.fieldStatus': 'Status *',
    'storage.fieldPurchaseDate': 'Purchase Date *',
    'storage.fieldWarrantyEnd': 'Warranty End Date',
    'storage.selectCompany': 'Select company',
    'storage.selectLocation': 'Select location',
    'storage.featuresTitle': 'Features',
    'storage.featureEncryption': 'Encryption',
    'storage.featureCompression': 'Compression',
    'storage.featureDeduplication': 'Deduplication',
    'storage.fieldNotes': 'Notes',
    'storage.notesPlaceholder': 'Notes about the storage unit...',
    'storage.cancel': 'Cancel',
    'storage.save': 'Save',
    'storage.update': 'Update',
    'storage.detailTitle': 'Storage Unit Details',
    'storage.detailInfoSection': 'Storage Information',
    'storage.detailCapacitySection': 'Capacity Usage',
    'storage.detailNameLabel': 'Storage Name:',
    'storage.detailTypeLabel': 'Type:',
    'storage.detailBrandModelLabel': 'Brand/Model:',
    'storage.detailTotalCapacityLabel': 'Total Capacity:',
    'storage.detailDiskTypeLabel': 'Disk Type:',
    'storage.errorRequired': 'Please fill in required fields',
    'storage.errorLoad': 'Error loading data',
    'storage.errorSave': 'Error saving storage unit',
    'storage.errorDelete': 'Error deleting storage unit',
    'storage.successUpdate': 'Storage unit updated',
    'storage.successCreate': 'Storage unit created',
    'storage.successDelete': 'Storage unit deleted',
    'storage.confirmDelete': 'Are you sure you want to delete this storage unit?',
    'storage.fieldRawCapacity': 'Raw Disk Capacity (TB) *',
    'storage.fieldRaidLevel': 'RAID Level',
    'storage.fieldDiskCount': 'Disk Count',
    'storage.raidNone': 'No RAID',
    'storage.raidUsableLabel': 'Usable capacity after RAID',
    'storage.raidUsableNotice': 'Disk count insufficient for this RAID level',
    // Assignment Logs Page
    'assignlog.title': 'Assignment Operation Logs',
    'assignlog.subtitle': 'Detailed logs of all inventory assignment operations',
    'assignlog.refresh': 'Refresh',
    'assignlog.export': 'Export',
    'assignlog.searchPlaceholder': 'Search user...',
    'assignlog.allTypes': 'All Types',
    'assignlog.allActions': 'All Actions',
    'assignlog.allUsers': 'All Users',
    'assignlog.totalRecords': 'Total {count} records found',
    'assignlog.clearFilters': 'Clear Filters',
    'assignlog.noLogs': 'No log records found',
    'assignlog.noLogsDesc': 'No log records match the selected criteria.',
    'assignlog.colDateTime': 'Date/Time',
    'assignlog.colUser': 'User',
    'assignlog.colType': 'Type',
    'assignlog.colAction': 'Action',
    'assignlog.colChanges': 'Changes',
    'assignlog.colIP': 'IP',
    'assignlog.modalTitle': 'Assignment Operation Detail',
    'assignlog.detailDateTime': 'Date / Time',
    'assignlog.detailPerformedBy': 'Performed By',
    'assignlog.detailEntityType': 'Entity Type',
    'assignlog.detailEntityId': 'Entity ID',
    'assignlog.detailIPAddress': 'IP Address',
    'assignlog.detailSource': 'Record Source',
    'assignlog.detailAction': 'Action:',
    'assignlog.detailChanges': 'Changes',
    'assignlog.detailDetails': 'Details',
    'assignlog.assignmentInfo': 'Assignment Information',
    'assignlog.unassignInfo': 'Removed Assignment Information',
    'assignlog.returnInfo': 'Return Information',
    'assignlog.deletedRecord': 'Deleted Record',
    'assignlog.createdRecord': 'Created Record',
    'assignlog.previousState': 'Previous State',
    'assignlog.newState': 'New State',
    'assignlog.compareFieldHeader': 'Field',
    'assignlog.comparePreviousHeader': 'Previous',
    'assignlog.compareNewHeader': 'New',
    'assignlog.system': 'System',
    'assignlog.pageOf': 'Page {current} / {total}',
    'assignlog.cardNew': 'New:',
    'assignlog.cardOld': 'Old:',
    'assignlog.cardAssigned': 'Assigned:',
    'assignlog.cardUnassigned': 'Unassigned:',
    'assignlog.cardReturn': 'Returned by:',
    'assignlog.cardPrevious': 'Previous:',
    'assignlog.cardDeleted': 'Deleted:',
    'assignlog.exportError': 'Could not export logs',
    'assignlog.actionAssign': 'Assign',
    'assignlog.actionUnassign': 'Unassign',
    'assignlog.actionReturn': 'Return',
    'assignlog.actionTransfer': 'Transfer',
    'assignlog.entityEquipment': 'Equipment',
    'assignlog.entityConsumable': 'Consumable',
    'assignlog.entityEquipmentCategory': 'Equipment Category',
    'assignlog.entityConsumableCategory': 'Consumable Category',
    'assignlog.entityMobilePhone': 'Mobile Phone',
    'assignlog.entityPrinter': 'Printer',
    'assignlog.entityComputer': 'Computer',
    'assignlog.entityMonitor': 'Monitor',
    // AssignmentLogsPage fieldLabels
    'assignlog.fieldAssignedUserId': 'Assigned User ID',
    'assignlog.fieldAssignedUserName': 'Assigned User',
    'assignlog.fieldUnassignedUserId': 'Previous User ID',
    'assignlog.fieldUnassignedUserName': 'Previous User',
    'assignlog.fieldUnassignedByName': 'Performed By',
    'assignlog.fieldAssignedByName': 'Assigned By',
    'assignlog.fieldUserId': 'User ID',
    'assignlog.fieldUserName': 'User',
    'assignlog.fieldName': 'Name',
    'assignlog.fieldSerialNumber': 'Serial No',
    'assignlog.fieldBarcode': 'Barcode',
    'assignlog.fieldDepartment': 'Department',
    'assignlog.fieldLocation': 'Location',
    'assignlog.fieldStatus': 'Status',
    'assignlog.fieldNotes': 'Notes',
    'assignlog.fieldNote': 'Note',
    'assignlog.fieldReason': 'Reason',
    'assignlog.fieldBrand': 'Brand',
    'assignlog.fieldModel': 'Model',
    'assignlog.fieldDeviceBrand': 'Device Brand',
    'assignlog.fieldDeviceModel': 'Device Model',
    'assignlog.fieldComputerBrand': 'Computer Brand',
    'assignlog.fieldComputerModel': 'Computer Model',
    'assignlog.fieldEquipmentBrand': 'Equipment Brand',
    'assignlog.fieldEquipmentModel': 'Equipment Model',
    'assignlog.fieldAssignmentType': 'Assignment Type',
    'assignlog.fieldConditionOnAssignment': 'Condition on Assignment',
    'assignlog.fieldImei': 'IMEI',
    'assignlog.fieldPhoneNumber': 'Phone No',
    'assignlog.fieldLineNumber': 'Line No',
    'assignlog.fieldGsmNumber': 'GSM No',
    'assignlog.fieldIpAddress': 'IP Address',
    'assignlog.fieldMacAddress': 'MAC Address',
    'assignlog.fieldHostname': 'Computer Name',
    'assignlog.fieldEquipmentName': 'Equipment Name',
    'assignlog.fieldInventoryNumber': 'Inventory No',
    'assignlog.fieldCategory': 'Category',
    'assignlog.fieldQuantity': 'Quantity',
    'assignlog.fieldUnit': 'Unit',
    'assignlog.fieldWarrantyEnd': 'Warranty End',
    'assignlog.fieldPurchaseDate': 'Purchase Date',
    'assignlog.fieldAssignedAt': 'Assignment Date',
    'assignlog.fieldUnassignedAt': 'Removal Date',
    'assignlog.fieldCreatedAt': 'Created At',
    'assignlog.fieldUpdatedAt': 'Updated At',
    'assignlog.fieldFromUser': 'Previous User',
    'assignlog.fieldToUser': 'New User',
    'assignlog.fieldFromUserId': 'Previous User ID',
    'assignlog.fieldToUserId': 'New User ID',
    'assignlog.fieldPreviousUser': 'Previous User',
    'assignlog.fieldNewUser': 'New User',
    // AssignmentLogsPage valueLabels
    'assignlog.valuePermanent': 'Permanent',
    'assignlog.valueTemporary': 'Temporary',
    'assignlog.valueNew': 'New',
    'assignlog.valueGood': 'Good',
    'assignlog.valueFair': 'Fair',
    'assignlog.valuePoor': 'Poor',
    'assignlog.valueDamaged': 'Damaged',
    'assignlog.valueActive': 'Active',
    'assignlog.valuePassive': 'Passive',
    'assignlog.valueFree': 'Free',
    'assignlog.valueAssigned': 'Assigned',
    'assignlog.valueInUse': 'In Use',
    'assignlog.valueInStock': 'In Stock',
    'assignlog.valueMaintenance': 'Under Maintenance',
    'assignlog.valueRetired': 'Retired',
    'assignlog.valueLost': 'Lost',
    'assignlog.valueStolen': 'Stolen',
    'assignlog.valueBroken': 'Broken',
    'assignlog.valueTrue': 'Yes',
    'assignlog.valueFalse': 'No',
    'assignlog.valueEquipmentLog': 'Equipment Log',
    'assignlog.valueComputerHistory': 'Computer History',
    'assignlog.valueMonitorHistory': 'Monitor History',
    'assignlog.valueMobileHistory': 'Mobile Phone History',
    // IoTDevicesPage
    'iot.title': 'IoT Device Management',
    'iot.subtitle': 'Internet of Things device inventory and monitoring',
    'iot.bulkLabel': 'Bulk Label',
    'iot.label': 'Label',
    'iot.newDevice': 'New IoT Device',
    'iot.statTotal': 'Total Devices',
    'iot.statOnline': 'Online',
    'iot.statOffline': 'Offline',
    'iot.statWarning': 'Warning Status',
    'iot.searchPlaceholder': 'Search IoT device...',
    'iot.filterAllTypes': 'All Types',
    'iot.filterAllProtocols': 'All Protocols',
    'iot.filterAllStatuses': 'All Statuses',
    'iot.colDevice': 'Device',
    'iot.colType': 'Type',
    'iot.colCompany': 'Company',
    'iot.colLocation': 'Location',
    'iot.colIp': 'IP Address',
    'iot.colStatus': 'Status',
    'iot.colActions': 'Actions',
    'iot.titleView': 'View Details',
    'iot.titleCopy': 'Copy',
    'iot.titleQr': 'Generate QR Code',
    'iot.titleEdit': 'Edit',
    'iot.titleDelete': 'Delete',
    'iot.modalTitleEdit': 'Edit IoT Device',
    'iot.modalTitleNew': 'New IoT Device',
    'iot.sectionBasic': 'Basic Information',
    'iot.sectionComm': 'Communication and Configuration',
    'iot.sectionLocation': 'Location and Assignment',
    'iot.sectionPurchase': 'Purchase Information',
    'iot.labelDeviceName': 'Device Name *',
    'iot.labelDeviceType': 'Device Type *',
    'iot.labelBrand': 'Brand *',
    'iot.labelModel': 'Model *',
    'iot.labelSerialNumber': 'Serial Number',
    'iot.labelMacAddress': 'MAC Address',
    'iot.labelIpAddress': 'IP Address',
    'iot.labelFirmware': 'Firmware Version',
    'iot.labelProtocol': 'Communication Protocol *',
    'iot.labelOs': 'Operating System',
    'iot.labelStatus': 'Status *',
    'iot.labelInstallDate': 'Installation Date *',
    'iot.labelCompany': 'Company *',
    'iot.labelLocation': 'Location *',
    'iot.labelAdmin': 'Responsible Admin',
    'iot.labelWarrantyEnd': 'Warranty End Date',
    'iot.labelPurchasePrice': 'Purchase Price',
    'iot.labelDeviceImage': 'Device Image',
    'iot.labelNotes': 'Notes',
    'iot.selectCompany': 'Select company',
    'iot.selectLocation': 'Select location',
    'iot.selectAdmin': 'Select admin',
    'iot.locationsLoadError': 'Locations could not be loaded. Please reload.',
    'iot.imageHint': 'JPG, PNG, GIF, WebP supported (Max: 5MB)',
    'iot.imageSelectedFile': 'Selected file:',
    'iot.notesPlaceholder': 'Notes about the IoT device...',
    'iot.detailTitle': 'IoT Device Details',
    'iot.detailSectionDevice': 'Device Information',
    'iot.detailSectionImage': 'Device Image',
    'iot.detailSectionNetwork': 'Network Information',
    'iot.detailSectionStatus': 'Status Information',
    'iot.detailSectionLocation': 'Location',
    'iot.detailSectionSensors': 'Sensor Readings',
    'iot.detailSectionNotes': 'Notes',
    'iot.detailDeviceName': 'Device Name:',
    'iot.detailType': 'Type:',
    'iot.detailBrandModel': 'Brand/Model:',
    'iot.detailSerialNo': 'Serial No:',
    'iot.detailFirmware': 'Firmware:',
    'iot.detailIpAddress': 'IP Address:',
    'iot.detailMacAddress': 'MAC Address:',
    'iot.detailProtocol': 'Protocol:',
    'iot.detailOs': 'Operating System:',
    'iot.detailStatus': 'Status:',
    'iot.detailCompany': 'Company:',
    'iot.detailLocation': 'Location:',
    'iot.detailInstallDate': 'Installation Date:',
    'iot.detailAdmin': 'Responsible Admin:',
    'iot.detailUnassigned': 'Unassigned',
    'iot.detailTemperature': 'Temperature',
    'iot.detailHumidity': 'Humidity',
    'iot.detailPressure': 'Pressure',
    'iot.detailCreatedAt': 'Created At:',
    'iot.detailUpdatedAt': 'Last Updated:',
    'iot.typeSensor': 'Sensor',
    'iot.typeCamera': 'Camera',
    'iot.typeDisplay': 'Display',
    'iot.typeController': 'Controller',
    'iot.typeGateway': 'Gateway',
    'iot.typeBeacon': 'Beacon',
    'iot.typeTracker': 'Tracker',
    'iot.statusOnline': 'Online',
    'iot.statusOffline': 'Offline',
    'iot.statusMaintenance': 'Under Maintenance',
    'iot.statusFaulty': 'Faulty',
    'iot.healthHealthy': 'Healthy',
    'iot.healthWarning': 'Warning',
    'iot.healthCritical': 'Critical',
    'iot.healthUnknown': 'Unknown',
    'iot.errorRequired': 'Please fill in all required fields',
    'iot.successUpdated': 'IoT device updated',
    'iot.successCreated': 'IoT device created',
    'iot.errorSave': 'Error saving IoT device',
    'iot.successDeleted': 'IoT device deleted',
    'iot.errorDelete': 'Error deleting IoT device',
    'iot.confirmDelete': 'Are you sure you want to delete this IoT device?',
    'iot.infoCopied': 'IoT device info copied, edit unique fields and save',
    'iot.errorLocations': 'Error loading locations',
    'iot.warnLocations': 'Locations could not be loaded. Please reload the page.',
    'iot.errorData': 'Error loading data',
    'iot.errorImageSize': 'File size cannot exceed 5MB',
    'iot.errorImageType': 'Only image files (JPG, PNG, GIF, WebP) can be uploaded',
    'iot.successFileSelected': 'File selected',
    'iot.bulkModalTitle': 'Bulk Label Printing',
    'iot.bulkFilters': 'Filters',
    'iot.bulkFilterLocation': 'Location',
    'iot.bulkFilterStatus': 'Status',
    'iot.bulkFilterType': 'Device Type',
    'iot.bulkAllLocations': 'All Locations',
    'iot.bulkAllStatuses': 'All Statuses',
    'iot.bulkAllTypes': 'All Types',
    'iot.bulkDeviceSelection': 'Device Selection ({count} selected)',
    'iot.bulkSelectAll': 'Select All',
    'iot.bulkDeselectAll': 'Clear Selection',
    'iot.bulkPreviewBtn': 'Preview ({count} items)',
    'iot.bulkPreviewTitle': 'Label Preview ({count} items - {pages} pages)',
    'iot.bulkPreviewDesc': '4 labels per page (2x2) will be printed. Optimized for A4 paper size.',
    'iot.bulkPrint': 'Print',
    'iot.printIpLabel': 'IP Address:',
    'iot.printNotSpecified': 'Not Specified',
    'iot.update': 'Update',
    // SmartScalesPage
    'scale.title': 'Smart Scale Management',
    'scale.subtitle': 'Industrial scale inventory and calibration tracking',
    'scale.newScale': 'New Smart Scale',
    'scale.statTotal': 'Total Scales',
    'scale.statActive': 'Active',
    'scale.statCalibNeeded': 'Calibration Required',
    'scale.statDailyMeasurement': 'Daily Measurements',
    'scale.searchPlaceholder': 'Search smart scale...',
    'scale.filterAllProtocols': 'All Protocols',
    'scale.filterAllStatuses': 'All Statuses',
    'scale.colScale': 'Scale',
    'scale.colLocation': 'Location',
    'scale.colStatus': 'Status',
    'scale.colProtocol': 'Protocol',
    'scale.colIp': 'IP Address',
    'scale.colCapacity': 'Capacity',
    'scale.colCalibration': 'Calibration',
    'scale.colActions': 'Actions',
    'scale.calibRequired': 'Required',
    'scale.calibOk': 'OK',
    'scale.titleView': 'View Details',
    'scale.titleEdit': 'Edit',
    'scale.titleCopy': 'Copy',
    'scale.titleCalibrate': 'Perform Calibration',
    'scale.titleLabel': 'Print Label',
    'scale.titleDelete': 'Delete',
    'scale.statusActive': 'Active',
    'scale.statusInactive': 'Inactive',
    'scale.statusMaintenance': 'Under Maintenance',
    'scale.statusCalibrationNeeded': 'Calibration Required',
    'scale.healthHealthy': 'Healthy',
    'scale.healthWarning': 'Warning',
    'scale.healthCritical': 'Critical',
    'scale.healthUnknown': 'Unknown',
    'scale.modalTitleEdit': 'Edit Smart Scale',
    'scale.modalTitleNew': 'New Smart Scale',
    'scale.modalCopyNote': 'This scale is being copied. Please enter a unique name and IP address.',
    'scale.sectionBasic': 'Basic Information',
    'scale.sectionTech': 'Technical Specifications',
    'scale.sectionInstall': 'Installation and Calibration',
    'scale.sectionLocation': 'Location and Assignment',
    'scale.labelScaleName': 'Scale Name *',
    'scale.duplicateNameError': 'This scale name is already in use',
    'scale.labelBrand': 'Brand *',
    'scale.labelModel': 'Model *',
    'scale.labelSerialNumber': 'Serial Number *',
    'scale.labelMacAddress': 'MAC Address',
    'scale.macHint': 'You can leave this blank if the MAC address is unavailable',
    'scale.labelIpAddress': 'IP Address',
    'scale.duplicateIPError': 'This IP address is already in use',
    'scale.labelMaxCapacity': 'Maximum Capacity (kg) *',
    'scale.labelPrecision': 'Precision (grams) *',
    'scale.labelProtocol': 'Communication Protocol *',
    'scale.labelStatus': 'Status *',
    'scale.labelInstallDate': 'Installation Date *',
    'scale.labelLastCalib': 'Last Calibration Date',
    'scale.labelNextCalib': 'Next Calibration Date',
    'scale.labelCompany': 'Company *',
    'scale.labelLocation': 'Location *',
    'scale.labelAdmin': 'Responsible Authority',
    'scale.labelPurchasePrice': 'Purchase Price',
    'scale.labelNotes': 'Notes',
    'scale.selectCompany': 'Select company',
    'scale.selectLocation': 'Select location',
    'scale.selectAdmin': 'Select authority',
    'scale.notesPlaceholder': 'Notes about the smart scale...',
    'scale.update': 'Update',
    'scale.detailTitle': 'Smart Scale Details',
    'scale.detailSectionScale': 'Scale Information',
    'scale.detailSectionNetwork': 'Network Information',
    'scale.detailSectionCalib': 'Calibration Information',
    'scale.detailSectionNotes': 'Notes',
    'scale.detailScaleName': 'Scale Name:',
    'scale.detailBrandModel': 'Brand/Model:',
    'scale.detailSerialNo': 'Serial No:',
    'scale.detailCapacity': 'Capacity:',
    'scale.detailPrecision': 'Precision:',
    'scale.detailIpAddress': 'IP Address:',
    'scale.detailMacAddress': 'MAC Address:',
    'scale.detailProtocol': 'Protocol:',
    'scale.detailLastCalib': 'Last Calibration:',
    'scale.detailNextCalib': 'Next Calibration:',
    'scale.detailInstallDate': 'Installation Date:',
    'scale.detailAdmin': 'Responsible Authority:',
    'scale.detailUnassigned': 'Unassigned',
    'scale.calibrateBtn': 'Perform Calibration',
    'scale.calibHistoryBtn': 'Calibration History',
    'scale.calibHistoryTitle': 'Calibration History',
    'scale.calibHistoryEmpty': 'No calibration records yet',
    'scale.calibHistoryType': 'Type:',
    'scale.calibHistoryManual': 'Manual',
    'scale.calibHistoryCompleted': 'Completed',
    'scale.calibHistoryPending': 'Pending',
    'scale.calibHistoryNewBtn': 'Save New Calibration',
    'scale.calibModalTitle': 'Perform Calibration',
    'scale.calibSectionInfo': 'Calibration Information',
    'scale.calibLabelCompany': 'Calibration Company *',
    'scale.calibLabelNumber': 'Calibration Number *',
    'scale.calibLabelDate': 'Calibration Date *',
    'scale.calibLabelNextDate': 'Next Calibration Date',
    'scale.calibLabelType': 'Calibration Type',
    'scale.calibTypeManual': 'Manual Calibration',
    'scale.calibTypeAutomatic': 'Automatic Calibration',
    'scale.calibTypeCertified': 'Certified Calibration',
    'scale.calibLabelStatus': 'Status',
    'scale.calibStatusCompleted': 'Completed',
    'scale.calibStatusPending': 'Pending',
    'scale.calibStatusFailed': 'Failed',
    'scale.calibLabelNotes': 'Calibration Notes',
    'scale.calibNotesPlaceholder': 'Notes about the calibration process...',
    'scale.calibImportanceTitle': 'Importance of Calibration',
    'scale.calibImportance1': '• Essential for accurate weighing results',
    'scale.calibImportance2': '• Incorrect readings can lead to customer losses',
    'scale.calibImportance3': '• Required for Ministry of Trade inspections',
    'scale.calibImportance4': '• Regular calibration required for CE certified devices',
    'scale.calibSaveBtn': 'Save Calibration',
    'scale.calibNotesPrompt': 'Calibration notes (optional):',
    'scale.calibDefaultNotes': 'Calibration completed successfully',
    'scale.labelModalTitle': 'Scale Label Settings',
    'scale.labelWidth': 'Width (mm)',
    'scale.labelHeight': 'Height (mm)',
    'scale.labelOrientation': 'Orientation',
    'scale.labelPortrait': 'Portrait',
    'scale.labelLandscape': 'Landscape',
    'scale.labelFontSize': 'Font Size (px)',
    'scale.labelMargin': 'Margin (mm)',
    'scale.labelPresets': 'Presets:',
    'scale.presetStandard': 'Standard Label (80x60mm)',
    'scale.presetLarge': 'Large Label (120x80mm)',
    'scale.labelInfoTitle': 'Label Information:',
    'scale.labelInfoScaleName': 'Scale Name:',
    'scale.labelInfoBrandModel': 'Brand/Model:',
    'scale.labelInfoIp': 'IP Address:',
    'scale.labelInfoSerial': 'Serial No:',
    'scale.labelInfoCapacity': 'Capacity:',
    'scale.labelInfoQr': 'QR Code:',
    'scale.labelInfoQrDesc': 'Device information and calibration history',
    'scale.labelPrintBtn': 'Print Label',
    'scale.printScaleName': 'SCALE NAME',
    'scale.errorRequired': 'Please fill in all required fields',
    'scale.errorDuplicateName': 'This scale name is already in use. Please enter a different name.',
    'scale.errorDuplicateIP': 'This IP address is already in use. Please enter a different IP address.',
    'scale.successUpdated': 'Smart scale updated',
    'scale.successCreated': 'Smart scale created',
    'scale.errorSave': 'Error saving smart scale',
    'scale.confirmDelete': 'Are you sure you want to delete this smart scale?',
    'scale.successDeleted': 'Smart scale deleted',
    'scale.errorDelete': 'Error deleting smart scale',
    'scale.errorCalibHistory': 'Error loading calibration history',
    'scale.errorCalibRequired': 'Calibration company and number are required',
    'scale.successCalibSaved': 'Calibration saved',
    'scale.errorCalibSave': 'Error saving calibration',
    'scale.errorData': 'Error loading data',
    'scale.errorLabel': 'Error creating label',
    // MonitorsPage
    'monitor.title': 'Monitors',
    'monitor.subtitle': '{count} monitors listed',
    'monitor.brandsBtn': 'Brands',
    'monitor.newMonitor': 'New Monitor',
    'monitor.searchPlaceholder': 'Search...',
    'monitor.filterAllStatuses': 'All Statuses',
    'monitor.filterAllCompanies': 'All Companies',
    'monitor.filterAllLocations': 'All Locations',
    'monitor.resultsCount': '{count} results',
    'monitor.colInventory': 'Inventory No',
    'monitor.colBrandModel': 'Brand / Model',
    'monitor.colSpecs': 'Specs',
    'monitor.colLocation': 'Location',
    'monitor.colUser': 'User',
    'monitor.colStatus': 'Status',
    'monitor.colActions': 'Actions',
    'monitor.pagePrev': 'Previous',
    'monitor.pageNext': 'Next',
    'monitor.pageInfo': '{start} - {end} / {total} records',
    'monitor.titleUnassign': 'Remove Assignment',
    'monitor.titleAssign': 'Assign to User',
    'monitor.titleHistory': 'History',
    'monitor.titleCopy': 'Quick Copy',
    'monitor.statusActive': 'Active',
    'monitor.statusInactive': 'Inactive',
    'monitor.statusRepair': 'Under Repair',
    'monitor.statusDamaged': 'Damaged',
    'monitor.statusRetired': 'Retired',
    'monitor.statusScrapped': 'Scrapped',
    'monitor.modalTitleEdit': 'Edit Monitor',
    'monitor.modalTitleNew': 'Add New Monitor',
    'monitor.labelInventory': 'Inventory No *',
    'monitor.labelBrand': 'Brand *',
    'monitor.selectBrand': 'Select Brand',
    'monitor.labelModel': 'Model *',
    'monitor.selectModel': 'Select Model',
    'monitor.modelPlaceholder': 'Model name',
    'monitor.addModelBtn': 'Add New Model',
    'monitor.labelSerial': 'Serial Number *',
    'monitor.labelStatus': 'Status',
    'monitor.labelScreenSize': 'Screen Size',
    'monitor.labelResolution': 'Resolution',
    'monitor.labelPanelType': 'Panel Type',
    'monitor.selectDefault': 'Select',
    'monitor.labelLocation': 'Location',
    'monitor.labelCompany': 'Company',
    'monitor.labelPurchaseDate': 'Purchase Date',
    'monitor.labelWarranty': 'Warranty End',
    'monitor.labelPurchasePrice': 'Purchase Price',
    'monitor.labelCurrency': 'Currency',
    'monitor.labelNotes': 'Notes',
    'monitor.update': 'Update',
    'monitor.assignTitle': 'Assign Monitor',
    'monitor.userSearchLabel': 'Search User',
    'monitor.userSearchPlaceholder': 'Name or email...',
    'monitor.selectUserLabel': 'Select User *',
    'monitor.labelComputer': 'Computer (Optional)',
    'monitor.continueBtn': 'Continue',
    'monitor.copyTitle': 'Quick Copy Monitor',
    'monitor.copySourceLabel': 'Source Monitor',
    'monitor.copyScreenLabel': 'Screen:',
    'monitor.copyPanelLabel': 'Panel:',
    'monitor.labelSerialNo': 'Serial No',
    'monitor.serialPlaceholder': 'Serial number',
    'monitor.selectCompany': 'Select company',
    'monitor.selectLocation': 'Select location',
    'monitor.labelAssignUser': 'Assign User',
    'monitor.optional': '(optional)',
    'monitor.userSearchPlaceholder2': 'Search user...',
    'monitor.userNotFound': 'No users found',
    'monitor.userSelected': '{name} selected',
    'monitor.copying': 'Copying...',
    'monitor.copyBtn': 'Copy',
    'monitor.assignFormTitle': 'Monitor Assignment',
    'monitor.assignUserLabel': 'User:',
    'monitor.noteOptional': 'Note (Optional)',
    'monitor.notePlaceholder': 'Note about the assignment...',
    'monitor.assignWithoutForm': 'Assign Without Form',
    'monitor.assignWithForm': 'Assign with Assignment Form',
    'monitor.unassignTitle': 'Create Return Form',
    'monitor.unassignMonitorLabel': 'Monitor:',
    'monitor.noteOptional2': 'Note (Optional)',
    'monitor.removeReasonPlaceholder': 'Reason for removal...',
    'monitor.photosLabel': 'Device Photos (Max 4)',
    'monitor.addPhoto': 'Add',
    'monitor.withReturnForm': 'With Return Form',
    'monitor.withoutForm': 'Without Form',
    'monitor.historyTitle': 'Monitor History',
    'monitor.historyCreated': 'Created',
    'monitor.historyUpdated': 'Updated',
    'monitor.historyAssigned': 'Assigned',
    'monitor.historyUnassigned': 'Unassigned',
    'monitor.historyDeleted': 'Deleted',
    'monitor.historyPerformedBy': 'Performed By:',
    'monitor.historyUser': 'User:',
    'monitor.historyNote': 'Note:',
    'monitor.historyEmpty': 'No history records found.',
    'monitor.brandsTitle': 'Monitor Brands',
    'monitor.brandName': 'Brand Name *',
    'monitor.brandLogo': 'Logo',
    'monitor.brandActive': 'Active',
    'monitor.addBtn': 'Add',
    'monitor.existingBrands': 'Existing Brands',
    'monitor.quickModelTitle': 'Quick Add Model',
    'monitor.modelName': 'Model Name *',
    'monitor.labelRefreshRate': 'Refresh Rate',
    'monitor.hasSpeaker': 'Speaker',
    'monitor.hasUsbHub': 'USB Hub',
    'monitor.isCurved': 'Curved',
    'monitor.saving': 'Saving...',
    'monitor.addAndSelect': 'Add & Select',
    'monitor.errorData': 'Error loading data',
    'monitor.successUpdated': 'Monitor updated',
    'monitor.successCreated': 'Monitor added',
    'monitor.errorSave': 'Error saving monitor',
    'monitor.confirmDelete': 'Are you sure you want to delete monitor {invNo}?',
    'monitor.successDeleted': 'Monitor deleted',
    'monitor.errorDelete': 'Error deleting monitor',
    'monitor.errorInventoryRequired': 'Inventory No is required',
    'monitor.errorSerialRequired': 'Serial No is required',
    'monitor.successCopied': 'Monitor copied ({invNo})',
    'monitor.successAssigned': 'Monitor assigned',
    'monitor.errorAssign': 'Error assigning monitor',
    'monitor.successFormCreated': 'Assignment form created ({formNo})',
    'monitor.successReturnForm': 'Return form created (Form No: {formNo})',
    'monitor.successUnassigned': 'Monitor assignment removed',
    'monitor.errorUnassign': 'Error removing assignment',
    'monitor.errorModelRequired': 'Model name is required',
    'monitor.successBrandUpdated': 'Brand updated',
    'monitor.successBrandCreated': 'Brand added',
    'monitor.errorBrandSave': 'Error saving brand',
    'monitor.successModelCreated': 'Model added',
    'monitor.errorModelSave': 'Error saving model',
    'monitor.excelInventory': 'Inventory No',
    'monitor.excelBrand': 'Brand',
    'monitor.excelModel': 'Model',
    'monitor.excelSerial': 'Serial No',
    'monitor.excelScreenSize': 'Screen Size',
    'monitor.excelResolution': 'Resolution',
    'monitor.excelPanelType': 'Panel Type',
    'monitor.excelLocation': 'Location',
    'monitor.excelCompany': 'Company',
    'monitor.excelAssignedUser': 'Assigned User',
    'monitor.excelStatus': 'Status',
    'monitor.excelPurchaseDate': 'Purchase Date',
    'monitor.excelWarranty': 'Warranty End',
    // CameraFaultsPage
    'camera.title': 'Camera Faults',
    'camera.subtitle': 'Manage and track camera faults',
    'camera.btnFilter': 'Filter',
    'camera.btnNewFault': 'New Fault',
    'camera.statTotal': 'Total Faults',
    'camera.statTotalSub': 'Unresolved',
    'camera.statOpen': 'Open Faults',
    'camera.statResolved': 'Resolved',
    'camera.statTopLocation': 'Most Faulty Location',
    'camera.statNoData': 'No data',
    'camera.statFaultCount': '{count} faults',
    'camera.filterActive': 'Filter active',
    'camera.searchPlaceholder': 'Search camera name, fault, location...',
    'camera.filtersTitle': 'Filters',
    'camera.filterStatusLabel': 'Status',
    'camera.filterStatusActive': 'Active Faults',
    'camera.filterStatusAll': 'All Statuses',
    'camera.filterStatusOpen': 'Open',
    'camera.filterStatusReviewing': 'Under Review',
    'camera.filterStatusConsignment': 'Consignment Placed',
    'camera.filterStatusResolved': 'Resolved',
    'camera.filterStatusClosed': 'Closed',
    'camera.filterLocationLabel': 'Location',
    'camera.filterAllLocations': 'All Locations',
    'camera.noFaults': 'No faults found',
    'camera.colCamera': 'Camera',
    'camera.colFault': 'Fault',
    'camera.colStatus': 'Status',
    'camera.colDate': 'Date',
    'camera.colReporter': 'Reported By',
    'camera.colActions': 'Actions',
    'camera.titleDetails': 'View Details',
    'camera.titleAssignSupplier': 'Assign Supplier',
    'camera.titleSupplierAssigned': 'Supplier: {name}',
    'camera.titleReturnConsignment': 'Return Consignment: {name}',
    'camera.titleConsignment': 'Place Consignment Camera',
    'camera.btnDetails': 'Detail',
    'camera.btnSupplierAssigned': 'Supplier',
    'camera.btnAssignSupplier': 'Assign',
    'camera.btnReturnConsignment': 'Return',
    'camera.btnConsignment': 'Consignment',
    'camera.pageInfo': '{start} - {end} of {total} faults',
    'camera.pagePrev': 'Previous',
    'camera.pageOf': 'Page {current} of {total}',
    'camera.pageNext': 'Next',
    'camera.formTitleEdit': 'Edit Fault',
    'camera.formTitleNew': 'New Fault',
    'camera.formLabelLocation': 'Location *',
    'camera.formSelectLocation': 'Select Location',
    'camera.formNvrSelectLocation': '(Select Location First)',
    'camera.formSelectNvr': 'Select NVR',
    'camera.formCameraSelectNvr': '(Select NVR First)',
    'camera.formCameraPlaceholder': 'Search by camera name or IP...',
    'camera.formCameraClearSelection': '✕ Clear Selection',
    'camera.formNoNvrCameras': 'No cameras in this NVR',
    'camera.formNoCamerasMatch': 'No matching cameras found',
    'camera.formCameraSelected': '✓ Camera selected: {name}',
    'camera.formLabelCameraName': 'Camera Name *',
    'camera.formCameraNamePlaceholder': 'e.g. Entry Camera',
    'camera.formLabelIp': 'IP Address',
    'camera.formIpReadonlyNote': 'IP address cannot be edited when a camera is selected',
    'camera.formLabelArea': 'Area',
    'camera.formAreaPlaceholder': 'e.g. 2nd Floor, Main Office Area',
    'camera.formLabelReportedBy': 'Reported By',
    'camera.formLabelStatus': 'Status',
    'camera.formStatusOpen': 'Open',
    'camera.formStatusReviewing': 'Under Review',
    'camera.formStatusResolved': 'Resolved',
    'camera.formStatusClosed': 'Closed',
    'camera.formLabelFaultDesc': 'Fault Description *',
    'camera.formFaultDescSelect': 'Select Fault Type',
    'camera.faultDesc1': 'No Image',
    'camera.faultDesc2': 'Intermittent Image',
    'camera.faultDesc3': 'Camera Lens Needs Cleaning',
    'camera.faultDesc4': 'Communication Cable Faulty',
    'camera.faultDesc5': 'Other',
    'camera.formLabelNotes': 'Additional Notes',
    'camera.formNotesPlaceholder': 'Additional details about the fault...',
    'camera.formLabelLastImage': 'Last Screenshot',
    'camera.formImageRemove': 'Remove Image',
    'camera.formImageUpload': 'Upload image from camera or gallery',
    'camera.formImageHint': 'JPG, PNG (Max 5MB)',
    'camera.supplierTitle': 'Assign Supplier',
    'camera.supplierLabelCamera': 'Camera:',
    'camera.supplierLabelFault': 'Fault:',
    'camera.supplierLabelLocation': 'Location:',
    'camera.supplierLabelSelect': 'Supplier *',
    'camera.supplierSelectDefault': 'Select Supplier',
    'camera.supplierNoFound': 'No suppliers found in Security Camera Systems category',
    'camera.supplierLabelNotes': 'Notes (Optional)',
    'camera.supplierNotesPlaceholder': 'Special notes to forward to supplier...',
    'camera.supplierBtnAssign': 'Assign Supplier',
    'camera.consignmentTitle': 'Place Consignment Camera',
    'camera.consignmentFaultyCameraLabel': 'Faulty Camera Taken to Technical Service',
    'camera.consignmentLabelSelect': 'Replacement Consignment Camera',
    'camera.consignmentSearchPlaceholder': 'Search by camera name, IP or brand...',
    'camera.consignmentNoFound': 'Camera not found',
    'camera.consignmentNoIp': 'No IP',
    'camera.consignmentLabelNotes': 'Notes (optional)',
    'camera.consignmentNotesPlaceholder': 'Notes regarding consignment placement...',
    'camera.consignmentBtnPlace': 'Place Consignment',
    'camera.consignmentBtnPlacing': 'Saving...',
    'camera.returnTitle': 'Return Consignment Camera',
    'camera.returnActiveLabel': 'Active Consignment Camera',
    'camera.returnPlacedAt': 'Placed on {date}',
    'camera.returnBy': 'By {name}',
    'camera.returnConfirmPre': 'Upon confirmation: The consignment camera will be returned and the fault will be marked as ',
    'camera.returnConfirmStrong': 'Resolved',
    'camera.returnConfirmPost': '.',
    'camera.returnLabelNotes': 'Return Notes (optional)',
    'camera.returnNotesPlaceholder': 'Repair result, operations performed, etc...',
    'camera.returnBtnReturn': 'Return & Resolved',
    'camera.returnBtnProcessing': 'Processing...',
    'camera.detailTitle': 'Fault Details',
    'camera.detailImageCamera': 'Camera Last Screenshot',
    'camera.detailImageFault': 'Fault Photo',
    'camera.detailSectionDevice': 'Device Information',
    'camera.detailLabelCameraName': 'Camera Name:',
    'camera.detailLabelBrandModel': 'Brand/Model:',
    'camera.detailLabelIp': 'IP Address:',
    'camera.detailLabelNvr': 'NVR:',
    'camera.detailLabelChannel': 'Channel:',
    'camera.detailSectionLocation': 'Location Information',
    'camera.detailLabelLocation': 'Location:',
    'camera.detailLabelArea': 'Area:',
    'camera.detailLabelAddress': 'Address:',
    'camera.detailSectionFault': 'Fault Information',
    'camera.detailLabelFaultType': 'Fault Type:',
    'camera.detailLabelStatus': 'Status:',
    'camera.detailLabelReporter': 'Reported By:',
    'camera.detailLabelReportDate': 'Report Date:',
    'camera.detailLabelNotes': 'Notes:',
    'camera.detailSectionSupplier': 'Assigned Supplier',
    'camera.detailLabelCompany': 'Company Name:',
    'camera.detailLabelContact': 'Contact Person:',
    'camera.detailLabelAssignDate': 'Assignment Date:',
    'camera.detailSectionConsignment': 'Consignment Camera Records',
    'camera.detailConsignmentActive': 'Active',
    'camera.detailConsignmentReturned': 'Returned',
    'camera.detailLabelFaultyCamera': 'Faulty Camera:',
    'camera.detailLabelConsignmentCamera': 'Consignment Camera:',
    'camera.detailLabelInventory': 'Inventory No:',
    'camera.detailLabelPlacedAt': 'Placed Date:',
    'camera.detailLabelReturnedAt': 'Return Date:',
    'camera.detailLabelConsignNotes': 'Notes:',
    'camera.detailLabelReturnNotes': 'Return Notes:',
    'camera.detailByName': 'By {name}',
    'camera.detailSectionSolution': 'Solution Information',
    'camera.detailLabelResolvedBy': 'Resolved By:',
    'camera.detailLabelResolvedAt': 'Solution Date:',
    'camera.detailLabelFaultDescLabel': 'Fault Description:',
    'camera.detailLabelSolutionDesc': 'Solution Description:',
    'camera.detailLabelAttachedFile': 'Attached File:',
    'camera.detailSectionSupplierHistory': 'Supplier Action History',
    'camera.detailActionStatusUpdated': 'Status Update',
    'camera.detailActionNoteAdded': 'Note Added',
    'camera.detailActionFileUploaded': 'File Uploaded',
    'camera.detailLabelPerformedBy': 'Performed By:',
    'camera.detailLabelStatusChange': 'Status:',
    'camera.detailLabelDescription': 'Description:',
    'camera.detailLabelSolution': 'Solution:',
    'camera.detailUnknown': 'Unknown',
    'camera.detailSectionLogs': 'System Logs',
    'camera.detailSystem': 'System',
    'camera.detailNoDetails': 'No detail information found',
    'camera.confirmDelete': 'Are you sure you want to delete this fault?',
    'camera.alertCameraNameRequired': 'Camera name and fault description are required!',
    'camera.alertUpdated': 'Fault updated!',
    'camera.alertAdded': 'Fault added!',
    'camera.alertDeleted': 'Fault deleted!',
    'camera.alertError': 'An error occurred!',
    'camera.alertDetailsError': 'Failed to load fault details',
    'camera.alertDetailsErrorLoad': 'An error occurred while loading fault details',
    'camera.alertSelectConsignment': 'Please select a consignment camera',
    'camera.alertConsignmentSaved': 'Consignment camera saved successfully',
    'camera.alertConsignmentError': 'An error occurred',
    'camera.alertConnectionError': 'Connection error',
    'camera.alertReturnSuccess': 'Consignment camera returned, fault resolved',
    'camera.alertSelectSupplier': 'Please select a supplier',
    'camera.alertSupplierAssigned': 'Supplier assigned successfully!',
    'camera.alertSupplierError': 'Supplier assignment failed!',
    'camera.alertSupplierAssignError': 'An error occurred while assigning supplier!',
    'camera.excelCameraName': 'Camera Name',
    'camera.excelIpAddress': 'IP Address',
    'camera.excelLocation': 'Location',
    'camera.excelFault': 'Fault',
    'camera.excelStatus': 'Status',
    'camera.excelDate': 'Report Date',
    'camera.excelReporter': 'Reported By',
    'camera.excelNotes': 'Notes',
    'camera.excelSheet': 'Faults',
    // HandheldTerminalsPage
    'handheld.pageTitle': 'Handheld Terminals Management',
    'handheld.pageSubtitle': 'Handheld terminal inventory and management',
    'handheld.statTotal': 'Total Handheld Terminals',
    'handheld.statActive': 'Active',
    'handheld.statPassive': 'Inactive',
    'handheld.statFaulty': 'Faulty',
    'handheld.activeFilter': 'Active Filter:',
    'handheld.filterActive': '🟢 Active',
    'handheld.filterPassive': '⚫ Inactive',
    'handheld.filterFaulty': '🔴 Faulty',
    'handheld.searchPlaceholder': 'Search...',
    'handheld.notFound': 'No handheld terminal found',
    'handheld.colOrder': '#',
    'handheld.colBrand': 'Brand',
    'handheld.colModel': 'Model',
    'handheld.colInventoryNo': 'Inventory No',
    'handheld.colSerialNo': 'Serial No',
    'handheld.colIpAddress': 'IP Address',
    'handheld.colMacAddress': 'MAC Address',
    'handheld.colAssignedUser': 'Assigned User',
    'handheld.colLocation': 'Location',
    'handheld.colStatus': 'Status',
    'handheld.colDepartment': 'Department',
    'handheld.colActions': 'Actions',
    'handheld.prevPage': 'Previous',
    'handheld.nextPage': 'Next',
    'handheld.tooltipEdit': 'Edit',
    'handheld.tooltipCopy': 'Quick Copy',
    'handheld.tooltipPrintLabel': 'Print Label',
    'handheld.tooltipHistory': 'History',
    'handheld.tooltipDelete': 'Delete',
    'handheld.cardSerialNo': 'Serial No:',
    'handheld.cardUser': 'User:',
    'handheld.cardLocation': 'Location:',
    'handheld.cardStatus': 'Status:',
    'handheld.cardDepartment': 'Department:',
    'handheld.cardEnv': 'Inv:',
    'handheld.statusActive': 'Active',
    'handheld.statusPassive': 'Inactive',
    'handheld.statusFaulty': 'Faulty',
    'handheld.btnNewTerminal': 'New Handheld Terminal',
    'handheld.btnNew': 'New',
    'handheld.btnBulkLabel': 'Bulk Labels',
    'handheld.btnLabel': 'Label',
    'handheld.modalTitleAdd': 'New Handheld Terminal',
    'handheld.modalTitleEdit': 'Edit Handheld Terminal',
    'handheld.formBrand': 'Brand *',
    'handheld.formModel': 'Model *',
    'handheld.formInventoryNo': 'Inventory No',
    'handheld.formSerialNo': 'Serial No',
    'handheld.formIpAddress': 'IP Address',
    'handheld.formMacAddress': 'MAC Address',
    'handheld.formLocation': 'Location *',
    'handheld.formAssignedUser': 'Assigned User',
    'handheld.formDepartment': 'Department',
    'handheld.formStatus': 'Status *',
    'handheld.formFaultDetails': 'Fault Details',
    'handheld.formLocationPlaceholder': 'Select Location',
    'handheld.formUserPlaceholder': 'Select User',
    'handheld.formDeptPlaceholder': 'E.g.: Warehouse, Logistics, Production',
    'handheld.formFaultPlaceholder': 'Describe the fault details...',
    'handheld.formStatusActive': 'Active',
    'handheld.formStatusPassive': 'Inactive',
    'handheld.formStatusFaulty': 'Faulty',
    'handheld.faultRequiredWarning': 'Fault details are required when status is "Faulty".',
    'handheld.btnCancel': 'Cancel',
    'handheld.btnUpdate': 'Update',
    'handheld.btnCreate': 'Create',
    'handheld.historyTitle': 'History',
    'handheld.historyLoading': 'Loading history...',
    'handheld.historyEmpty': 'No history records for this terminal.',
    'handheld.historyActionCreate': '🆕 Created',
    'handheld.historyActionUpdate': '✏️ Updated',
    'handheld.historyActionDelete': '🗑️ Deleted',
    'handheld.historyActionAssign': '👤 Assigned',
    'handheld.historyActionUnassign': '👥 Unassigned',
    'handheld.historyField': 'Field:',
    'handheld.historyOldValue': 'Old Value:',
    'handheld.historyNewValue': 'New Value:',
    'handheld.historyChangedBy': 'User:',
    'handheld.historySystem': 'System',
    'handheld.labelModalTitle': 'Bulk Label Printing',
    'handheld.labelSize': 'Label Size',
    'handheld.labelSizeInfoPre': 'Selected size:',
    'handheld.labelSizeInfoMid': 'labels/page -',
    'handheld.labelSizeInfoSuffix': 'orientation',
    'handheld.labelLandscape': 'Landscape',
    'handheld.labelPortrait': 'Portrait',
    'handheld.labelSelectionTitle': 'Handheld Terminal Selection',
    'handheld.labelSelectionSelected': 'selected',
    'handheld.labelSelectAll': 'Select All',
    'handheld.labelDeselectAll': 'Deselect All',
    'handheld.labelPreviewBtn': 'Preview',
    'handheld.labelPreviewTitle': 'Label Preview',
    'handheld.labelPreviewItems': 'items',
    'handheld.labelPreviewPages': 'pages',
    'handheld.labelPreviewPerPage': 'per page',
    'handheld.labelPreviewLabels': 'labels',
    'handheld.labelBack': 'Back',
    'handheld.labelPrint': 'Print',
    'handheld.singleLabelTitle': 'Print Label',
    'handheld.singleLabelInventoryNo': 'Inventory No:',
    'handheld.singleLabelSerialNo': 'Serial No:',
    'handheld.singleLabelLocation': 'Location:',
    'handheld.singleLabelPerPage': 'labels/page -',
    'handheld.labelSizeLandscape6': 'Landscape - 6 Labels/Page (90x90mm)',
    'handheld.labelSizePortrait24': 'Portrait - 24 Labels/Page (70x37mm)',
    'handheld.labelSizePortrait16': 'Portrait - 16 Labels/Page (99x34mm)',
    'handheld.labelSizePortrait12': 'Portrait - 12 Labels/Page (105x48mm)',
    'handheld.labelSizePortrait4': 'Portrait - 4 Labels/Page (105x148mm - A6)',
    'handheld.labelHTMLTitle': 'Handheld Terminal Labels',
    'handheld.pdfTitle': 'Handheld Terminals List',
    'handheld.pdfReportDate': 'Report Date:',
    'handheld.pdfTotalTerminals': 'Total Handheld Terminals:',
    'handheld.pdfColOrder': '#',
    'handheld.pdfColBrand': 'Brand',
    'handheld.pdfColModel': 'Model',
    'handheld.pdfColInventoryNo': 'Inventory No',
    'handheld.pdfColSerialNo': 'Serial No',
    'handheld.pdfColIpAddress': 'IP Address',
    'handheld.pdfColMacAddress': 'MAC Address',
    'handheld.pdfColAssignedUser': 'Assigned User',
    'handheld.pdfColLocation': 'Location',
    'handheld.pdfColDepartment': 'Department',
    'handheld.excelColOrder': '#',
    'handheld.excelColBrand': 'Brand',
    'handheld.excelColModel': 'Model',
    'handheld.excelColInventoryNo': 'Inventory No',
    'handheld.excelColSerialNo': 'Serial No',
    'handheld.excelColIpAddress': 'IP Address',
    'handheld.excelColMacAddress': 'MAC Address',
    'handheld.excelColAssignedUser': 'Assigned User',
    'handheld.excelColLocation': 'Location',
    'handheld.excelColStatus': 'Status',
    'handheld.excelColFaultDetails': 'Fault Details',
    'handheld.excelColDepartment': 'Department',
    'handheld.excelColCreatedAt': 'Created Date',
    'handheld.excelSheet': 'Handheld Terminals',
    'handheld.invalidIpFormat': 'Invalid IP address format',
    'handheld.invalidMacFormat': 'Invalid MAC address format (Format: XX:XX:XX:XX:XX:XX or XX-XX-XX-XX-XX-XX)',
    'handheld.ipAlreadyUsed': 'This IP address is already in use',
    'handheld.macAlreadyUsed': 'This MAC address is already in use',
    'handheld.notifLoadError': 'Error loading data',
    'handheld.notifBrandModelRequired': 'Brand and Model are required',
    'handheld.notifInvalidIp': 'Please enter a valid IP address',
    'handheld.notifInvalidMac': 'Please enter a valid MAC address (Format: XX:XX:XX:XX:XX:XX)',
    'handheld.notifFixConflicts': 'Please fix the conflicting fields',
    'handheld.notifSelectLocation': 'Please select a location',
    'handheld.notifFaultRequired': 'Fault details are required when status is "Faulty"',
    'handheld.notifUpdated': 'Handheld terminal updated',
    'handheld.notifCreated': 'Handheld terminal created',
    'handheld.notifSaveError': 'Error saving handheld terminal',
    'handheld.notifDeleted': 'Handheld terminal deleted',
    'handheld.notifDeleteError': 'Error deleting handheld terminal',
    'handheld.notifCopied': 'Handheld terminal info copied. Please edit the Inventory No, Serial No, IP and MAC address before saving.',
    'handheld.notifExcelSuccess': 'handheld terminals exported to Excel successfully',
    'handheld.notifExcelError': 'Error creating Excel file',
    'handheld.notifHistoryError': 'Error loading terminal history',
    'handheld.notifLabelError': 'Error printing label',
    'handheld.notifPdfSuccess': 'handheld terminals exported to PDF successfully',
    'handheld.notifPdfError': 'Error creating PDF file',
    'handheld.confirmDeleteSuffix': 'Are you sure you want to delete this handheld terminal?',
    // OrdersPage
    'order.pageTitle': 'Orders',
    'order.pageSubtitle': 'Order tracking and management',
    'order.newOrder': 'New Order',
    'order.noPermission': 'You do not have permission for this action',
    'order.statAll': 'All Orders',
    'order.statNew': 'New Orders',
    'order.statInvoicePending': 'Pending Invoice Approval',
    'order.statCancelled': 'Cancelled',
    'order.statCompleted': 'Completed Orders',
    'order.statMine': 'My Orders',
    'order.exchangeTitle': 'TCMB Current Exchange Rates',
    'order.exchangeLastUpdate': 'Last update:',
    'order.exchangeLoading': 'Loading exchange rates...',
    'order.exchangeRefresh': '🔄 Refresh',
    'order.exchangeLastUpdateLabel': 'Last Update',
    'order.searchPlaceholder': 'Search by order no, username, beam no, item name...',
    'order.filterAll': 'All Statuses',
    'order.colOrderNo': 'Order No',
    'order.colCompany': 'Company',
    'order.colLocation': 'Location',
    'order.colOpenedBy': 'Opened By',
    'order.colCategory': 'Category',
    'order.colAmount': 'Amount (excl. VAT)',
    'order.colStatus': 'Status',
    'order.colDate': 'Date',
    'order.colActions': 'Actions',
    'order.emptyTitle': 'No orders found',
    'order.emptyText': 'Try changing your search criteria.',
    'order.paginationPrev': 'Previous',
    'order.paginationNext': 'Next',
    'order.detailsTooltip': 'View Details',
    'order.statusCreated': 'Order Created',
    'order.statusPending': 'Pending',
    'order.statusOrdered': 'Ordered',
    'order.statusDelivered': 'Delivered',
    'order.statusInvoiceUploaded': 'Invoice Uploaded',
    'order.statusInvoiceApproved': 'Invoice Approved',
    'order.statusCompleted': 'Completed',
    'order.statusCancelled': 'Cancelled',
    'order.priorityLow': 'Low',
    'order.priorityNormal': 'Normal',
    'order.priorityHigh': 'High',
    'order.priorityUrgent': 'Urgent',
    'order.catComputer': 'Computer',
    'order.catPhone': 'Phone',
    'order.catEquipment': 'Equipment',
    'order.catConsumables': 'Consumables',
    'order.catElectronics': 'Electronics',
    'order.catSwitch': 'Switch',
    'order.catServer': 'Server',
    'order.catMaintenance': 'Maintenance',
    'order.catCamera': 'Camera System',
    'order.catSound': 'Sound System',
    'order.catMonitor': 'Monitor',
    'order.catHandheld': 'Handheld Terminal',
    'order.catRadio': 'Radio',
    'order.modalEditTitle': 'Edit Order',
    'order.modalNewTitle': 'New Order',
    'order.alertEditBlockedTitle': 'Editing Blocked',
    'order.alertEditBlockedText': 'Orders with approved invoices cannot be edited. All fields are read-only.',
    'order.formOrderNo': 'Toolbox Order Number *',
    'order.formOrderNoAuto': 'Next available number assigned automatically',
    'order.formBeamOrderNo': 'ERP Order No',
    'order.formBeamOrderNoTooltip': 'Beam Order Number',
    'order.formTicketNo': 'Ticket Number *',
    'order.formCompany': 'Company *',
    'order.formLocation': 'Location *',
    'order.formCategory': 'Category *',
    'order.formStatus': 'Status *',
    'order.formSupplier': 'Supplier',
    'order.formCapex': 'CAPEX Information',
    'order.formDeliveryDate': 'Delivery Date',
    'order.formDescription': 'Order Description *',
    'order.formDescPlaceholder': 'Describe the order details...',
    'order.formNotes': 'Notes',
    'order.formNotesPlaceholder': 'Additional notes...',
    'order.selectCompany': 'Select company',
    'order.selectLocation': 'Select location',
    'order.selectSupplier': 'Select supplier',
    'order.selectCapex': 'Select CAPEX',
    'order.capexUsed': 'CAPEX Used:',
    'order.capexCategory': 'Category:',
    'order.capexImmutableWarning': '⚠️ CAPEX cannot be changed after order creation',
    'order.capexNone': 'No CAPEX used for this order',
    'order.useCapex': 'Use CAPEX?',
    'order.capexSelected': 'Selected CAPEX:',
    'order.capexAvailable': 'Available Amount:',
    'order.capexTotal': 'Total:',
    'order.capexUsedAmount': 'Used:',
    'order.capexBlocked': 'Blocked:',
    'order.itemsTitle': 'Order Items *',
    'order.currency': 'Currency:',
    'order.addItem': 'Add Item',
    'order.itemN': 'Item',
    'order.immutable': 'Read-only',
    'order.itemName': 'Item Name *',
    'order.itemQty': 'Quantity *',
    'order.itemUnitPrice': 'Unit Price *',
    'order.itemVat': 'VAT Rate (%)',
    'order.exclVat': 'Excl. VAT:',
    'order.plusVat': '+ VAT',
    'order.totalWithVat': 'Total Amount Incl. VAT:',
    'order.vatInfo': 'Info: The VAT-inclusive amount is for informational purposes only. CAPEX deduction is based on the ex-VAT amount.',
    'order.exchangeRatesLabel': '💱 Current Rates:',
    'order.capexCheck': 'CAPEX Check:',
    'order.capexInsufficient': '⚠️ Insufficient CAPEX!',
    'order.notCurrentRate': 'Not current',
    'order.invoiceTitle': 'Invoice Upload',
    'order.invoiceUploaded': 'Invoice uploaded',
    'order.invoiceView': 'View',
    'order.invoiceDelete': 'Delete',
    'order.invoiceUploadedBy': 'Uploaded by:',
    'order.invoiceApprove': 'Approve Invoice',
    'order.invoiceSelectBtn': 'Select Invoice',
    'order.invoiceFileTypes': 'PDF, JPG, PNG (Max 10MB)',
    'order.invoiceNeedDelivered': '⚠️ Order status must be "Delivered" to upload an invoice.',
    'order.statusNeedsInvoice': ' (Invoice required)',
    'order.statusNoReturn': ' (No return)',
    'order.statusAutoSet': ' (Set automatically)',
    'order.statusNeedsInvoiceFirst': '⚠️ You must upload an invoice before selecting this status',
    'order.confirmDeleteInvoice': 'Are you sure you want to delete the invoice?',
    'order.invoiceApprovalTitle': 'Invoice Approval Information',
    'order.invoiceApprovedLabel': 'Invoice approved by user',
    'order.invoiceAutoCompletedLabel': 'Order auto-completed',
    'order.invoiceOrderStatus': 'Status:',
    'order.invoiceOrderAmount': 'Order amount:',
    'order.invoiceInvoiceAmount': 'Invoice amount:',
    'order.invoiceCapexRefund': 'CAPEX refund:',
    'order.btnClose': 'Close',
    'order.btnCancel': 'Cancel',
    'order.btnUpdate': 'Update',
    'order.btnSave': 'Save',
    'order.detailTitle': 'Order Details',
    'order.detailOrderInfo': 'Order Information',
    'order.detailOrderNo': 'Order No:',
    'order.detailTicketNo': 'Ticket No:',
    'order.detailCategory': 'Category:',
    'order.detailTotal': 'Total Amount:',
    'order.detailStatus': 'Status:',
    'order.detailPriority': 'Priority:',
    'order.detailContactInfo': 'Contact Information',
    'order.detailCompany': 'Company:',
    'order.detailLocation': 'Location:',
    'order.detailOrderer': 'Ordered By:',
    'order.detailSupplier': 'Supplier:',
    'order.detailCapex': 'CAPEX:',
    'order.detailDescription': 'Order Description',
    'order.detailNotes': 'Notes',
    'order.detailInvoice': 'Invoice',
    'order.detailInvoiceAvailable': 'Invoice available',
    'order.detailView': 'View',
    'order.activityTitle': 'Activity History',
    'order.activitySystem': 'System',
    'order.activityEmpty': 'No activity records yet',
    'order.detailCreatedAt': 'Created:',
    'order.detailUpdatedAt': 'Last Update:',
    'order.today': 'Today',
    'order.yesterday': 'Yesterday',
    'order.daysAgo': 'days ago',
    'order.searching': 'Searching...',
    'order.clickToAdd': 'Click to add',
    'order.priceCompare': 'Price Comparison',
    'order.priceResultsN': 'results found',
    'order.priceNoResults': 'No results found',
    'order.priceSearchOn': 'Search on sites:',
    'order.priceSearch': 'Search online price',
    'order.swalEditBlockedTitle': 'Editing Blocked',
    'order.swalEditBlockedText': 'Orders with approved invoices cannot be edited',
    'order.swalInvoiceTitle': 'Invoice Approval',
    'order.swalInvoiceText': 'Enter the invoice amount for order',
    'order.swalInvoiceAmountLabel': 'Invoice Amount (Excl. VAT)',
    'order.swalInvoiceCurrencyLabel': 'Currency',
    'order.swalInvoiceEurLabel': 'Invoice EUR equivalent (current rate):',
    'order.swalCapexRefundLabel': 'CAPEX refund (estimated):',
    'order.swalInvoiceFootnote': 'The invoice amount will be recorded in the order.',
    'order.swalInvoiceFootnoteCapex': ' The invoice EUR equivalent is calculated at current rate; CAPEX difference is automatically refunded.',
    'order.swalCapexInfoTitle': 'CAPEX Information —',
    'order.swalCapexOrderAmount': 'Order opening amount:',
    'order.swalCapexDeducted': 'Deducted from CAPEX (order rate):',
    'order.swalCapexCurrentRate': 'Current rate:',
    'order.swalCapexWarning': '⚠ Order linked to CAPEX — difference will be automatically refunded',
    'order.swalValidAmount': 'Please enter a valid invoice amount',
    'order.swalInvoiceUploadedTitle': 'Invoice Uploaded',
    'order.swalInvoiceUploadedText': 'Do you want to approve the invoice now?',
    'order.swalInvoiceApproveYes': 'Yes, Approve',
    'order.swalInvoiceApproveNo': 'No, Later',
    'order.swalUpdateBlockedTitle': 'Update Blocked',
    'order.swalUpdateBlockedText': 'Orders with approved invoices cannot be edited',
    'order.swalCapexRequiredTitle': 'CAPEX Selection Required',
    'order.swalCapexRequiredAmountLabel': 'Order Amount (Excl. VAT):',
    'order.swalCapexRequiredLimitLabel': 'CAPEX Limit:',
    'order.swalCapexRequiredLimitSuffix': 'USD and above',
    'order.swalCapexRequiredMsg': 'This order amount (excl. VAT) exceeds the',
    'order.swalCapexRequiredMsg2': 'USD limit, so CAPEX selection is required.',
    'order.swalCapexRequiredRetry': 'Please select a CAPEX and try again.',
    'order.swalDeleteTitle': 'Order Deletion Confirmation',
    'order.swalDeleteOrderNo': 'Order No:',
    'order.swalDeleteCompany': 'Company:',
    'order.swalDeleteAmount': 'Amount:',
    'order.swalDeleteInvoiceWarn': '⚠️ Invoice file will also be deleted!',
    'order.swalDeleteIrreversible': 'This action cannot be undone!',
    'order.swalDeleteYes': 'Yes, Delete',
    'order.swalDeletedTitle': 'Deleted!',
    'order.swalDeletedText': 'order was successfully deleted.',
    'order.swalErrorTitle': 'Error!',
    'order.swalOk': 'OK',
    'order.swalCancel': 'Cancel',
    'order.swalApprove': 'Approve',
    'order.notifExchangeUpdated': 'TCMB Exchange Rates Updated',
    'order.notifExchangeError': 'Exchange Rate Update Error',
    'order.notifLoadError': 'Error loading data',
    'order.notifMinSearch': 'Enter at least 3 characters for price search',
    'order.notifPriceSearchError': 'Error while searching prices',
    'order.notifRequiredFields': 'Please fill in required fields',
    'order.notifCapexUnavailable': 'CAPEX Unavailable',
    'order.notifCapexUnavailableMsg': 'No available limit in selected CAPEX. Please select another CAPEX.',
    'order.notifCapexInsufficient': 'Insufficient CAPEX',
    'order.notifUpdated': 'Order updated',
    'order.notifCreated': 'Order created',
    'order.notifInvoiceApproved': 'Invoice approved and order completed',
    'order.notifInvoiceCapexRefunded': 'refunded.',
    'order.notifInvoiceUploaded': 'Invoice uploaded. You can approve it later.',
    'order.notifStatusAutoSet': 'The Completed status is only set automatically after the invoice is uploaded!',
    'order.notifNeedInvoiceFirst': 'You must upload an invoice before approving!',
    'order.notifInvoiceDeleted': 'Invoice deleted',
    'order.notifSaveError': 'Error saving order',
    'order.notifInvoiceError': 'Error uploading invoice',
    'order.notifInvoiceDeleteError': 'Error deleting invoice',
    'order.notifInvoiceApproveError': 'Error approving invoice',
    'order.notifFileTypeError': 'Only PDF or image files (JPG, PNG) can be uploaded!',
    'order.notifFileSizeError': 'File size must be less than 50MB!',
    'order.notifSuccess': 'Success',
    'order.notifError': 'Error',
    'order.notifWarning': 'Warning',
    // ComputersPage
    'computer.pageTitle': 'Computer Management',
    'computer.totalCount': 'computers registered',
    'computer.locationStats': 'By Location',
    'computer.clearFilter': 'Clear Filter',
    'computer.filterActive': 'Filter active',
    'computer.ageStats': 'By Age (5 Year Tracking)',
    'computer.over5years': 'Over 5 Years Old',
    'computer.renewalRecommended': 'Renewal recommended',
    'computer.near5years': 'Approaching 5 Years (3 Months)',
    'computer.nearRenewal': 'Renewal may be needed soon',
    'computer.searchPlaceholder': 'Search by inventory no, brand, model, serial no or user...',
    'computer.allStatuses': 'All Statuses',
    'computer.allCompanies': 'All Companies',
    'computer.newComputer': 'New Computer',
    'computer.brandManagement': 'Brand Management',
    'computer.modelManagement': 'Model Management',
    'computer.excelDownload': 'Download Excel',
    'computer.scrapComputers': 'Scrap Computers',
    'computer.colInventoryNo': 'Inventory No',
    'computer.colBrandModel': 'Brand/Model',
    'computer.colSerialNo': 'Serial No',
    'computer.colSpecs': 'Specs',
    'computer.colCompanyLocation': 'Company/Location',
    'computer.colAssignedUser': 'Assigned User',
    'computer.storage': 'Storage',
    'computer.notAssigned': 'Unassigned',
    'computer.titleHistory': 'View History',
    'computer.titleUnassign': 'Remove Assignment',
    'computer.titleAssign': 'Assign to User',
    'computer.titleQR': 'QR Code Label',
    'computer.titleCopy': 'Quick Copy',
    'computer.paginationInfo': 'of',
    'computer.paginationShowing': 'records',
    'computer.firstPage': 'First Page',
    'computer.lastPage': 'Last Page',
    'computer.prevPage': 'Previous Page',
    'computer.nextPage': 'Next Page',
    'computer.modalTitleEdit': 'Edit Computer',
    'computer.modalTitleAdd': 'Add New Computer',
    'computer.fieldInventoryNo': 'Inventory No *',
    'computer.fieldSerialNo': 'Serial No *',
    'computer.fieldBrand': 'Brand *',
    'computer.fieldModel': 'Model *',
    'computer.fieldProcessor': 'Processor',
    'computer.fieldProcessorPlaceholder': 'Auto-filled from model...',
    'computer.fieldAutoFill': 'Auto-filled when model is selected',
    'computer.fieldGraphicsCard': 'Graphics Card',
    'computer.fieldStorageCapacity': 'Storage Capacity',
    'computer.fieldStorageType': 'Storage Type',
    'computer.fieldRAM': 'RAM',
    'computer.fieldProSupport': 'Dell Pro Support Active',
    'computer.fieldProSupportEnd': 'Pro Support End Date',
    'computer.fieldPurchaseDate': 'Purchase Date',
    'computer.fieldWarrantyEnd': 'Warranty End Date',
    'computer.fieldInvoice': 'Invoice (Optional)',
    'computer.invoiceExists': 'Invoice already uploaded',
    'computer.invoiceView': 'View/Download',
    'computer.invoiceFileHint': 'PDF or image file (Max. 10MB)',
    'computer.fieldCompany': 'Company',
    'computer.fieldLocation': 'Location',
    'computer.fieldNotes': 'Notes',
    'computer.selectPlaceholder': 'Select...',
    'computer.update': 'Update',
    'computer.brandModalTitleEdit': 'Edit Brand',
    'computer.brandModalTitleAdd': 'Add New Brand',
    'computer.fieldBrandName': 'Brand Name *',
    'computer.fieldLogo': 'Logo',
    'computer.fieldActive': 'Active',
    'computer.existingBrands': 'Existing Brands',
    'computer.assignTitle': 'Assign to User',
    'computer.userSearchPlaceholder': 'Search user (name or email)...',
    'computer.selectUser': 'Select a user...',
    'computer.assignWithForm': 'Assign with Assignment Form',
    'computer.assignFormTitle': 'Create Assignment Form',
    'computer.labelComputer': 'Computer:',
    'computer.labelUser': 'User:',
    'computer.formNotesOptional': 'Notes (Optional)',
    'computer.assignFormNotesPlaceholder': 'Notes for assignment form...',
    'computer.assignWithoutForm': 'Assign Without Form',
    'computer.unassignFormTitle': 'Create Return Form',
    'computer.devicePhotos': 'Device Photos (Max. 4)',
    'computer.unassignFormNotesPlaceholder': 'Notes for return form...',
    'computer.unassignWithForm': 'With Return Form',
    'computer.unassignWithoutForm': 'Without Form',
    'computer.scrapFormTitle': 'Scrap Device Information Form',
    'computer.scrapStep1': 'Device Info',
    'computer.scrapStep2': 'Technical Status',
    'computer.scrapStep3': 'Scrap Reason',
    'computer.scrapStep4': 'Data Security',
    'computer.scrapStep5': 'Photos',
    'computer.scrapStep1Title': 'Device Identity Information',
    'computer.scrapFieldDeviceType': 'Device Type',
    'computer.scrapFieldPreviousUser': 'Previous User',
    'computer.scrapStep2Title': 'Technical Hardware Status',
    'computer.scrapColPart': 'Component',
    'computer.scrapColStatus': 'Status',
    'computer.scrapColDetail': 'Detail',
    'computer.scrapColSparePart': 'Spare Part?',
    'computer.scrapPartCPU': 'Processor (CPU)',
    'computer.scrapPartRAM': 'Memory (RAM)',
    'computer.scrapPartStorage': 'Storage (Disk)',
    'computer.scrapPartScreen': 'Screen/Panel',
    'computer.scrapPartMotherboard': 'Motherboard',
    'computer.scrapPartBattery': 'Battery',
    'computer.scrapPartAdapter': 'Adapter',
    'computer.scrapPartCase': 'Case Condition',
    'computer.scrapPartKeyboard': 'Keyboard/Mousepad',
    'computer.scrapPartPorts': 'Ports (USB/HDMI)',
    'computer.scrapOptExists': 'Present',
    'computer.scrapOptMissing': 'Missing',
    'computer.scrapOptRemoved': 'Removed',
    'computer.scrapOptGood': 'Good',
    'computer.scrapOptBroken': 'Broken',
    'computer.scrapOptDeadPixel': 'Dead Pixel',
    'computer.scrapOptStain': 'Stained',
    'computer.scrapOptNA': 'N/A',
    'computer.scrapOptWorking': 'Working',
    'computer.scrapOptFaulty': 'Faulty',
    'computer.scrapOptShortCircuit': 'Short Circuit',
    'computer.scrapOptSwollen': 'Swollen',
    'computer.scrapOptNotCharging': 'Not Charging',
    'computer.scrapOptIncomplete': 'Incomplete',
    'computer.scrapOptOxidized': 'Oxidized',
    'computer.scrapStep3Title': 'Scrap Reason',
    'computer.scrapReasonPhysical': 'Physical Damage (Breakage, liquid contact)',
    'computer.scrapReasonObsolete': 'Technological Obsolescence (Past its useful life)',
    'computer.scrapReasonRepairCost': 'Economic Repair Limit (Repair cost exceeds value)',
    'computer.scrapReasonParts': 'Parts Unavailable',
    'computer.scrapReasonOther': 'Other',
    'computer.scrapReasonDetailLabel': 'Description (Detailed)',
    'computer.scrapReasonDetailPlaceholder': 'Explain the scrap reason in detail...',
    'computer.scrapStep4Title': 'Data Security and Disposal (KVKK)',
    'computer.scrapDiskRemoved': 'Disk Removed',
    'computer.scrapDataWipeMethod': 'Data Wipe Method',
    'computer.scrapWipeNA': 'Not Applied / N/A',
    'computer.scrapWipeSoftware': 'Software Wipe',
    'computer.scrapWipePhysical': 'Physical Drilling',
    'computer.scrapWipeDegauss': 'Degauss',
    'computer.scrapWipeNot': 'Not Wiped',
    'computer.scrapMediaCheck': 'SD Card / Optical Media Check Done (No forgotten cards or CDs)',
    'computer.scrapDataSecurityNote': 'Data Security Note',
    'computer.scrapDataSecurityPlaceholder': 'Additional notes if any...',
    'computer.scrapStep5Title': 'Photos',
    'computer.scrapPhotosHint': 'Add photos of the device condition, damaged areas, and labels (Max. 5)',
    'computer.scrapUploadClick': 'Click to upload photos',
    'computer.scrapSubmit': 'Mark as Scrap',
    'computer.scrapProcessing': 'Processing...',
    'computer.historyTitle': 'Computer History',
    'computer.historyPerformedBy': 'Performed By:',
    'computer.historyAssignedUser': 'Assigned User:',
    'computer.historyChanges': 'Changes:',
    'computer.historyNoData': 'No history records found for this computer',
    'computer.actionCreated': 'Created',
    'computer.actionUpdated': 'Updated',
    'computer.actionAssigned': 'Assigned',
    'computer.actionUnassigned': 'Unassigned',
    'computer.actionDeleted': 'Deleted',
    'computer.statusActive': 'Active',
    'computer.statusInactive': 'Inactive',
    'computer.statusRepair': 'Under Repair',
    'computer.statusDamaged': 'Damaged',
    'computer.statusRetired': 'Retired',
    'computer.statusScrapped': 'Scrapped',
    'computer.notifLoadError': 'Error loading data',
    'computer.notifRequiredFields': 'Inventory No, Brand, Model and Serial No are required',
    'computer.notifSaveSuccess': 'Computer added',
    'computer.notifUpdateSuccess': 'Computer updated',
    'computer.notifDeleteSuccess': 'Computer deleted',
    'computer.notifDeleteFail': 'Delete operation failed',
    'computer.notifAssignFormCreated': 'Assignment form created',
    'computer.notifAssignWithFormSuccess': 'Assignment form created. You can create the form as PDF and complete the assignment process.',
    'computer.notifAssignSuccess': 'Computer assigned to user',
    'computer.notifAssignFail': 'Assignment operation failed',
    'computer.notifAssignError': 'An error occurred during the assignment process',
    'computer.notifReturnFormCreated': 'Return form created. You can create the form as PDF and complete the return process.',
    'computer.notifReturnFormError': 'An error occurred while creating the return form',
    'computer.notifUnassignSuccess': 'Assignment removed',
    'computer.notifBrandRequired': 'Brand name is required',
    'computer.notifBrandSaved': 'Brand added',
    'computer.notifBrandUpdated': 'Brand updated',
    'computer.notifBrandDeleted': 'Brand deleted',
    'computer.notifHistoryLoadFail': 'Could not load history',
    'computer.notifHistoryLoadError': 'An error occurred while loading history',
    'computer.notifScrapSuccess': 'Computer marked as scrap. Form No: ',
    'computer.confirmDelete': 'Are you sure you want to delete this computer?',
    'computer.confirmDeleteBrand': 'Are you sure you want to delete this brand?',
    'computer.excelSheetName': 'Computers',
    'computer.excelFileName': 'computers',
    // TechnicalServicePage
    'techservice.pageTitle': 'Technical Service',
    'techservice.pageSubtitle': 'Register and track faulty devices',
    'techservice.addNew': 'New Service Record',
    'techservice.statusCreated': 'Service Record Created',
    'techservice.statusSent': 'Sent to Technical Service',
    'techservice.statusProcessing': 'In Processing',
    'techservice.statusQuoteUploaded': 'Supplier Quote Uploaded',
    'techservice.statusOrderCreated': 'Order Created',
    'techservice.statusRepairedSent': 'Repaired and Sent',
    'techservice.statusCompleted': 'Completed',
    'techservice.statusCancelled': 'Cancelled',
    'techservice.statusRejected': 'Rejected',
    'techservice.priorityLow': 'Low',
    'techservice.priorityNormal': 'Normal',
    'techservice.priorityHigh': 'High',
    'techservice.priorityUrgent': 'Urgent',
    'techservice.statTotal': 'Total Records',
    'techservice.statProcessing': 'In Processing',
    'techservice.statCompleted': 'Completed',
    'techservice.statQuotePending': 'Quote Pending',
    'techservice.statRejected': 'Rejected',
    'techservice.statOverdue': 'Overdue Records',
    'techservice.statOverdueNote': 'Not sent to service for 2 weeks',
    'techservice.statQuoteWaiting': 'Awaiting Quote',
    'techservice.statQuoteWaitingNote': 'Awaiting quote for 1 week',
    'techservice.searchPlaceholder': 'Search by service no, device, company, location, serial no, inventory no, contact person...',
    'techservice.filterAllStatuses': 'All Statuses',
    'techservice.filterAllPriorities': 'All Priorities',
    'techservice.colService': 'Service',
    'techservice.colCompanyLocation': 'Company/Location',
    'techservice.colDevice': 'Device',
    'techservice.colStatus': 'Status',
    'techservice.colPriority': 'Priority',
    'techservice.colDate': 'Date',
    'techservice.colActions': 'Actions',
    'techservice.envLabel': 'Inv:',
    'techservice.noRecords': 'No technical service records yet',
    'techservice.cardCompany': 'Company:',
    'techservice.cardLocation': 'Location:',
    'techservice.cardDevice': 'Device:',
    'techservice.cardFault': 'Fault:',
    'techservice.cardDate': 'Date:',
    'techservice.btnView': 'View',
    'techservice.btnEdit': 'Edit',
    'techservice.titleViewDetail': 'View Details',
    'techservice.titleServiceHistory': 'Service History',
    'techservice.titleEdit': 'Edit',
    'techservice.titleEditDisabled': 'Service with quote cannot be edited',
    'techservice.titlePrintForm': 'Technical Service Info Sheet',
    'techservice.titlePrintCargo': 'Print Cargo Label',
    'techservice.titleLabelSettings': 'Label Settings',
    'techservice.titleCreateOrder': 'Create Order',
    'techservice.titleRejectQuote': 'Reject Quote',
    'techservice.titleSupplierQuote': 'Supplier Repair Quote',
    'techservice.titleCompleteService': 'Complete Service',
    'techservice.notifLoadError': 'Error loading data',
    'techservice.notifRequiredFields': 'Please fill in required fields',
    'techservice.notifDeviceRequired': 'At least one device must be entered',
    'techservice.notifNoChanges': 'No changes were made',
    'techservice.notifUpdateSuccess': 'Technical service updated',
    'techservice.notifSaveError': 'Error saving technical service',
    'techservice.notifDeleteSuccess': 'Technical service deleted',
    'techservice.notifDeleteError': 'Error deleting technical service',
    'techservice.notifRejectRequired': 'Rejection reason is required',
    'techservice.notifRejectSuccess': 'Quote successfully rejected',
    'techservice.notifRejectError': 'Quote could not be rejected',
    'techservice.notifSupplierHistoryError': 'Could not load supplier history',
    'techservice.notifServiceHistoryError': 'Could not load service history',
    'techservice.notifCargoNoSupplier': 'No supplier assigned to this service',
    'techservice.notifOrderError': 'Order could not be created',
    'techservice.notifCompleteSuccess': 'Service completed!',
    'techservice.notifCompleteError': 'Service could not be completed',
    'techservice.notifLabelSaved': 'Label settings saved',
    'techservice.notifDuplicateInventory': 'A device with this inventory number is already added!',
    'techservice.notifDuplicateSerial': 'A device with this serial number is already added!',
    'techservice.confirmDelete': 'Are you sure you want to delete this technical service record?',
    'techservice.confirmComplete': 'Do you want to mark the device as received and the service as completed?',
    'techservice.promptOrderNumber': 'Enter order number:',
    'techservice.progressStarting': 'Starting operation...',
    'techservice.progressCheckingChanges': 'Checking changes...',
    'techservice.progressUpdating': 'Updating technical service...',
    'techservice.progressUpdateDone': 'Update complete!',
    'techservice.progressCreating': 'Creating new service...',
    'techservice.progressSaving': 'Saving service...',
    'techservice.progressSaved': 'Service created!',
    'techservice.progressRefreshing': 'Refreshing data...',
    'techservice.modalEditTitle': 'Edit Technical Service',
    'techservice.modalAddTitle': 'New Technical Service Record',
    'techservice.savingProgress': 'Operation in progress...',
    'techservice.fieldServiceNo': 'Service Number *',
    'techservice.fieldCompany': 'Company *',
    'techservice.selectCompany': 'Select company',
    'techservice.fieldLocation': 'Location *',
    'techservice.selectLocation': 'Select location',
    'techservice.devicesSection': 'Faulty Devices',
    'techservice.addDevice': 'Add Device',
    'techservice.deviceDefault': 'Device',
    'techservice.seriShort': 'Serial:',
    'techservice.titleCopyDevice': 'Copy Device',
    'techservice.fieldCategory': 'Category *',
    'techservice.selectCategory': 'Select category',
    'techservice.catComputer': 'Computer',
    'techservice.catPrinter': 'Printer',
    'techservice.catPhone': 'Phone',
    'techservice.catNetwork': 'Network Equipment',
    'techservice.catServer': 'Server',
    'techservice.catCamera': 'Camera',
    'techservice.catProjector': 'Projector',
    'techservice.catTablet': 'Tablet',
    'techservice.catUps': 'UPS',
    'techservice.catScale': 'Scale',
    'techservice.catTV': 'TV',
    'techservice.catRadio': 'Radio',
    'techservice.catIotScreen': 'IoT Screen',
    'techservice.catHandheld': 'Handheld Terminal',
    'techservice.catOther': 'Other',
    'techservice.serialLinked': 'linked',
    'techservice.labelSearchComputer': 'Search Computer',
    'techservice.placeholderSearchComputer': 'Search by SN, Inventory No, User, Brand/Model...',
    'techservice.labelSelectPrinter': 'Select Printer (Optional)',
    'techservice.selectPrinterOption': 'Select from existing printers',
    'techservice.labelSearchPhone': 'Search Phone',
    'techservice.placeholderSearchPhone': 'Search by Inventory No, IMEI, User, Brand/Model...',
    'techservice.labelSelectHandheld': 'Select Handheld Terminal (Optional)',
    'techservice.selectHandheldOption': 'Select from existing handheld terminals',
    'techservice.selectLocationFirst': 'Please select a location first',
    'techservice.labelSelectRadio': 'Select Radio (Optional)',
    'techservice.selectRadioOption': 'Select from existing radios',
    'techservice.labelSelectScale': 'Select Scale (Optional)',
    'techservice.selectScaleOption': 'Select from existing scales',
    'techservice.labelSelectNetworkEquipment': 'Select Network Equipment (Optional)',
    'techservice.selectNetworkEquipmentOption': 'Select from existing network equipment',
    'techservice.labelSelectServer': 'Select Server (Optional)',
    'techservice.selectServerOption': 'Select from existing servers',
    'techservice.labelSelectCamera': 'Select Camera (Optional)',
    'techservice.selectCameraOption': 'Select from existing cameras',
    'techservice.labelSelectIot': 'Select IoT Device (Optional)',
    'techservice.selectIotOption': 'Select from existing IoT devices',
    'techservice.fieldDeviceName': 'Device Name *',
    'techservice.fieldInventoryNo': 'Inventory No',
    'techservice.fieldSerialNo': 'Serial No',
    'techservice.fieldDeviceFault': 'Device-Specific Fault Description',
    'techservice.placeholderDeviceFault': 'Device-specific fault details (optional)',
    'techservice.fieldContactPerson': 'Contact Person *',
    'techservice.selectContactPerson': 'Select person',
    'techservice.fieldSupplier': 'Supplier',
    'techservice.selectSupplier': 'Select supplier',
    'techservice.fieldTechnician': 'Assigned Technician',
    'techservice.selectTechnician': 'Select technician',
    'techservice.fieldStatus': 'Status *',
    'techservice.fieldPriority': 'Priority *',
    'techservice.fieldEstimatedCompletion': 'Estimated Completion',
    'techservice.fieldGeneralFault': 'General Fault Description',
    'techservice.placeholderGeneralFault': "Common fault description for all devices (used if each device doesn't have its own)",
    'techservice.fieldNotes': 'Notes',
    'techservice.placeholderNotes': 'Additional notes...',
    'techservice.emailSection': '📧 Email Notifications',
    'techservice.emailToContact': 'Send email to contact person',
    'techservice.emailToTechnician': 'Send email to assigned technician',
    'techservice.emailToSupplier': 'Send email to supplier users',
    'techservice.btnSavingUpdate': 'Updating...',
    'techservice.btnSavingCreate': 'Saving...',
    'techservice.btnUpdate': 'Update',
    'techservice.btnSave': 'Save',
    'techservice.detailTitle': 'Technical Service Details',
    'techservice.detailDeviceInfo': 'Device Information',
    'techservice.detailDeviceLabel': 'Device:',
    'techservice.detailInventoryLabel': 'Inventory No:',
    'techservice.detailSerialLabel': 'Serial No:',
    'techservice.detailStatusLabel': 'Status:',
    'techservice.detailPriorityLabel': 'Priority:',
    'techservice.detailContactInfo': 'Contact Information',
    'techservice.detailCompanyLabel': 'Company:',
    'techservice.detailLocationLabel': 'Location:',
    'techservice.detailContactLabel': 'Contact Person:',
    'techservice.detailSupplierLabel': 'Supplier:',
    'techservice.detailTechnicianLabel': 'Technician:',
    'techservice.detailFaultTitle': 'Fault Description',
    'techservice.detailSolutionTitle': 'Solution Description',
    'techservice.detailNotesTitle': 'Notes',
    'techservice.detailDatesTitle': 'Dates',
    'techservice.detailCreatedDate': 'Created:',
    'techservice.detailEstimatedDate': 'Estimated Completion:',
    'techservice.detailActualDate': 'Actual Completion:',
    'techservice.detailCostTitle': 'Cost',
    'techservice.btnPrintForm': 'Technical Service Info Sheet',
    'techservice.btnPrintLabel': 'Service Label',
    'techservice.btnPrintCargo': 'Cargo Label',
    'techservice.btnSupplierQuoteReady': 'Supplier Quote Ready!',
    'techservice.historyTitle': 'Service History',
    'techservice.historyCreatedDate': 'Created:',
    'techservice.historyStatusLabel': 'Status:',
    'techservice.historyStatusChange': 'Status Change',
    'techservice.supplierHistoryTitle': 'Supplier Transaction History',
    'techservice.supplierActionsTitle': 'Supplier Actions',
    'techservice.supplierActStatusChange': 'Status Change',
    'techservice.supplierActQuoteUpload': 'Quote Uploaded',
    'techservice.supplierActWorkDesc': 'Work Description',
    'techservice.supplierActFileUpload': 'File Uploaded',
    'techservice.supplierQuoteAmount': 'Quote Amount:',
    'techservice.workDetailsTitle': 'Work Performed',
    'techservice.workSerialNo': 'Serial No:',
    'techservice.workFault': 'Fault:',
    'techservice.workPerformed': 'Work Performed:',
    'techservice.workLaborHours': 'Labor Hours:',
    'techservice.workHoursUnit': 'hours',
    'techservice.workLaborCost': 'Labor:',
    'techservice.workParts': 'Parts Used:',
    'techservice.workDeviceTotal': 'Device Total:',
    'techservice.workNote': 'Note:',
    'techservice.noSupplierHistory': 'No supplier actions yet',
    'techservice.serviceHistoryTitle': 'Service Record History',
    'techservice.serviceLogsTitle': 'Transaction History',
    'techservice.serviceActEmailSent': '📧 Email Notification Sent',
    'techservice.serviceActEmailFailed': '❌ Email Send Error',
    'techservice.serviceActSupplierStatus': '🔄 Supplier Changed Status',
    'techservice.serviceActSupplierQuote': '💰 Supplier Quote Uploaded',
    'techservice.serviceActSupplierQuoteUpdate': '✏️ Supplier Quote Updated',
    'techservice.serviceActWorkQuote': '🔧 Supplier Submitted Work Detail Quote',
    'techservice.serviceActCreate': '🆕 Service Record Created',
    'techservice.serviceActUpdate': '✏️ Service Updated',
    'techservice.serviceActDelete': '🗑️ Service Deleted',
    'techservice.serviceActStatusUpdate': '🔄 Status Updated',
    'techservice.serviceEmailDetails': '📬 Email Details:',
    'techservice.showRecipients': 'Show Recipient Details',
    'techservice.recipientContact': 'Contact Person',
    'techservice.recipientTechnician': 'Assigned Technician',
    'techservice.recipientSupplier': 'Supplier',
    'techservice.serviceHistorySupplierActionsTitle': 'Supplier Actions',
    'techservice.serviceHistActStatusChange': '🔄 Status Change',
    'techservice.serviceHistActQuoteUpload': '📄 Quote Uploaded',
    'techservice.serviceHistActWorkDesc': '🔧 Work Description',
    'techservice.serviceHistActFileUpload': '📎 File Uploaded',
    'techservice.serviceHistQuoteAmount': '💰 Quote Amount:',
    'techservice.noServiceHistory': 'No transaction history yet',
    'techservice.labelSettingsTitle': 'Cargo Label Settings',
    'techservice.labelWidth': 'Width (mm)',
    'techservice.labelHeight': 'Height (mm)',
    'techservice.labelOrientation': 'Orientation',
    'techservice.labelPortrait': 'Portrait',
    'techservice.labelLandscape': 'Landscape',
    'techservice.labelFontSize': 'Font Size (px)',
    'techservice.labelMargin': 'Margin (mm)',
    'techservice.labelPresets': 'Presets:',
    'techservice.labelPresetStandard': 'Standard Label (80x60mm)',
    'techservice.labelPresetLarge': 'Large Label (120x80mm)',
    'techservice.labelSaved': 'Label settings saved',
    'techservice.rejectTitle': 'Reject Quote',
    'techservice.rejectServiceNo': 'Service Number:',
    'techservice.rejectReasonLabel': 'Rejection Reason *',
    'techservice.rejectPlaceholder': 'Explain the reason for rejection...',
    'techservice.btnReject': 'Reject',
    'techservice.printLabelTitle': 'TECHNICAL SERVICE',
    'techservice.printLabelDevice': 'Device:',
    'techservice.printLabelInventory': 'Inventory:',
    'techservice.printLabelSerial': 'Serial No:',
    'techservice.printLabelCompany': 'Company:',
    'techservice.printLabelLocation': 'Location:',
    'techservice.printLabelStatus': 'Status:',
    'techservice.printLabelDate': 'Date:',
    'techservice.printWindowTitle': 'Service Label',
    'techservice.roleSupplier': 'Supplier',
    'techservice.roleSystem': 'System',
    // GSMLinesPage
    'gsm.pageTitle': 'Vodafone GSM Lines',
    'gsm.pageSubtitle': 'Manage GSM lines and user assignments',
    'gsm.loading': 'Loading GSM lines...',
    'gsm.newLine': 'New GSM Line',
    'gsm.exportBtn': 'Export',
    'gsm.exportCSV': 'CSV Format',
    'gsm.exportExcel': 'Excel Format',
    'gsm.exportPDF': 'PDF Report',
    'gsm.sqlImportBtn': '🔥 SQL IMPORT 🔥',
    'gsm.csvImportBtn': 'CSV Import',
    'gsm.statTotal': 'Total Lines',
    'gsm.statActive': 'Active Lines',
    'gsm.statUnassigned': 'Unassigned Lines',
    'gsm.statAssigned': 'Assigned Lines',
    'gsm.statReserved': 'Reserved Lines',
    'gsm.statAvailable': 'Available Lines',
    'gsm.statTransferred': 'Transferred Lines',
    'gsm.statForwarded': 'Forwarded Lines',
    'gsm.filterAllLocations': 'All Locations',
    'gsm.filterAllCompanies': 'All Companies',
    'gsm.filterAllUsers': 'All Users',
    'gsm.filterUnassigned': 'Unassigned Lines',
    'gsm.filterAllStatuses': 'All Statuses',
    'gsm.statusActive': 'Active',
    'gsm.statusInactive': 'Inactive',
    'gsm.statusSuspended': 'Suspended',
    'gsm.statusReserved': 'Reserved',
    'gsm.statusAvailable': 'Available',
    'gsm.statusTransferred': 'Transferred',
    'gsm.statusForwarded': 'Forwarded',
    'gsm.statusUnknown': 'Unknown',
    'gsm.searchPlaceholder': 'Search GSM line, user or company...',
    'gsm.clearFilters': 'Clear',
    'gsm.resultsInfo': 'Showing {start}-{end} of {total} GSM lines',
    'gsm.filteredFrom': 'filtered from {total} total lines',
    'gsm.page': 'Page',
    'gsm.perPage': '10 records per page',
    'gsm.colGsmNo': 'GSM No',
    'gsm.colUser': 'User',
    'gsm.colCompany': 'Company',
    'gsm.colLocation': 'Location',
    'gsm.colTariff': 'Tariff',
    'gsm.colStatus': 'Status',
    'gsm.colActions': 'Actions',
    'gsm.unassigned': 'Unassigned',
    'gsm.mobileUser': 'User:',
    'gsm.mobileCompany': 'Company:',
    'gsm.mobileTariff': 'Tariff:',
    'gsm.mobileLocation': 'Location:',
    'gsm.monthlyFee': '/mo',
    'gsm.btnHistory': 'View History',
    'gsm.btnPrev': 'Previous',
    'gsm.btnNext': 'Next',
    'gsm.modalEditTitle': 'Edit GSM Line',
    'gsm.modalNewTitle': 'New GSM Line',
    'gsm.fieldGsmNumber': 'GSM Number *',
    'gsm.fieldGsmHint': '+90 is added automatically, enter only 10-digit number',
    'gsm.fieldTariff': 'Tariff *',
    'gsm.fieldTariffPlaceholder': 'Select tariff',
    'gsm.fieldCompany': 'Company *',
    'gsm.fieldCompanyPlaceholder': 'Select company',
    'gsm.fieldLocation': 'Location *',
    'gsm.fieldLocationPlaceholder': 'Select location',
    'gsm.fieldUserAssign': 'User Assignment (Optional)',
    'gsm.userUnassignedDue': 'Unassigned (Status required)',
    'gsm.btnQuickCreateUser': 'Quick Create User',
    'gsm.userAssignHint': 'Optional. If left blank, saved as "Unassigned". Click + to quickly create a user.',
    'gsm.statusRestrictionHint': 'status lines cannot be assigned to a user.',
    'gsm.statusClearHint': 'Selecting this status will automatically remove user assignment.',
    'gsm.fieldStatus': 'Status *',
    'gsm.fieldForwardedGsm': 'Forwarded GSM Number *',
    'gsm.forwardSearchPlaceholder': 'Search by GSM number, company name or user name...',
    'gsm.forwardSelected': 'Selected',
    'gsm.forwardUser': 'User:',
    'gsm.forwardNoResult': 'No GSM line found matching your search criteria',
    'gsm.forwardChosenLabel': 'Selected:',
    'gsm.fieldPin': 'PIN Code *',
    'gsm.fieldPuk': 'PUK Code *',
    'gsm.fieldDescription': 'Description',
    'gsm.descriptionPlaceholder': 'Notes about the GSM line...',
    'gsm.btnUpdate': 'Update',
    'gsm.userModalTitle': 'Quick Create User',
    'gsm.fieldFullName': 'Full Name *',
    'gsm.fieldEmail': 'Email *',
    'gsm.fieldPhone': 'Phone',
    'gsm.fieldTitle': 'Title',
    'gsm.fieldPassword': 'Password',
    'gsm.passwordHint': 'If left blank: demo123',
    'gsm.fieldRole': 'Role *',
    'gsm.btnCreateUser': 'Create User',
    'gsm.sqlModalTitle': 'SQL Bulk Import',
    'gsm.sqlFormatTitle': '📋 Data Format',
    'gsm.sqlFormatDesc': 'Paste data from your existing GSM lines table in tab-separated (TSV) format. Each line must be one GSM line.',
    'gsm.sqlColumnDesc': 'Column Descriptions:',
    'gsm.sqlTip': '💡 Tip: Select and copy data from your existing GSM lines table and paste it here. The system will automatically detect columns and convert to the appropriate format.',
    'gsm.sqlPasteLabel': 'Paste GSM Data',
    'gsm.sqlPasteHint': 'You can copy and paste from your existing GSM lines table or Excel. Tab characters are automatically detected.',
    'gsm.validationErrors': 'Validation Errors',
    'gsm.previewTitle': 'Data Preview',
    'gsm.andMoreRecords': 'and {count} more records',
    'gsm.importSummaryTitle': '📊 Import Summary',
    'gsm.summaryTotal': 'Total Records:',
    'gsm.summaryWithUser': 'With User:',
    'gsm.summaryActive': 'Active:',
    'gsm.summaryErrors': 'Errors:',
    'gsm.btnImport': 'Import {count} Records',
    'gsm.btnProcessing': 'Processing...',
    'gsm.csvModalTitle': 'GSM Lines Bulk Import',
    'gsm.csvStep1Title': '1. Download Template File',
    'gsm.csvStep1Desc': 'First download the template file with sample data and fill it with your own data.',
    'gsm.btnDownloadTemplate': 'Download Template',
    'gsm.csvStep2Title': '2. Upload Your Filled File',
    'gsm.fileDropText': 'Select file or drag and drop',
    'gsm.fileDropFormats': 'CSV, Excel (.xlsx, .xls) files are supported',
    'gsm.csvStep3Title': '3. Data Preview',
    'gsm.importRulesTitle': '📋 Import Rules',
    'gsm.assignModalTitle': 'Quick User Assignment',
    'gsm.assignGsmLine': 'GSM Line:',
    'gsm.assignCurrentUser': 'Current User:',
    'gsm.assignSearchLabel': 'Search and Select User',
    'gsm.assignSearchPlaceholder': 'Search by username or email...',
    'gsm.assignUserNotFound': 'User not found',
    'gsm.assignUserLoading': 'Loading user list...',
    'gsm.btnAssign': 'Assign',
    'gsm.historyModalTitle': 'GSM Line History',
    'gsm.historyCount': 'Total {count} records found',
    'gsm.historyLoading': 'Loading...',
    'gsm.historyUser': 'User:',
    'gsm.historyChanges': 'Changes:',
    'gsm.btnShowMore': 'Show more',
    'gsm.btnShowLess': 'Show less',
    'gsm.btnClose': 'Close',
    'gsm.tariffFilterApplied': 'Tariff Filter Applied',
    'gsm.tariffFilterMsg': 'lines using tariff are being shown',
    'gsm.notifLineOp': 'GSM Line Operation',
    'gsm.errLoadData': 'Error loading data',
    'gsm.errFileType': 'Only CSV and Excel files are supported',
    'gsm.errCsvRead': 'Could not read CSV file',
    'gsm.errFixErrors': 'Please fix errors first',
    'gsm.errSqlImport': 'SQL import operation failed',
    'gsm.sqlImportDone': 'SQL Import Completed',
    'gsm.importWarnings': 'Import Warnings',
    'gsm.errImportFail': 'Import operation failed',
    'gsm.errRequired': 'Please fill in required fields',
    'gsm.errPhoneFormat': 'GSM number must be 10 digits (+90 is added automatically)',
    'gsm.pinUpdated': 'PIN code updated',
    'gsm.pukUpdated': 'PUK code updated',
    'gsm.successUpdate': 'GSM line updated',
    'gsm.successCreate': 'GSM line created',
    'gsm.errSaveLine': 'Error saving GSM line',
    'gsm.errUserRequired': 'Name, email and location are required',
    'gsm.successUserCreated': 'User created and assigned to GSM line',
    'gsm.errCreateUser': 'Error creating user',
    'gsm.errSelectUser': 'Please select a user',
    'gsm.warnAlreadyAssigned': 'This line is already assigned to the selected user',
    'gsm.successAssigned': 'GSM line assigned to user',
    'gsm.errAssignLine': 'Error assigning GSM line',
    'gsm.confirmDelete': 'Are you sure you want to delete this GSM line?',
    'gsm.successDelete': 'GSM line deleted',
    'gsm.errDeleteLine': 'Error deleting GSM line',
    'gsm.successExportCsv': 'GSM lines list downloaded as CSV',
    'gsm.successExportExcel': 'GSM lines list downloaded as Excel',
    'gsm.pdfInfo': 'HTML file downloaded. You can open it in your browser and print as PDF.',
    'gsm.templateDownloaded': 'Import template downloaded successfully',
    // NetworkSwitchesPage
    'network.pageTitle': 'Network Switches',
    'network.pageSubtitle': 'Network infrastructure management and monitoring',
    'network.loading': 'Loading...',
    'network.vlanMgmt': 'VLAN Management',
    'network.defineModel': 'Define Model',
    'network.newSwitch': 'New Switch',
    'network.configWizard': 'Config Wizard',
    'network.statTotal': 'Total Switches',
    'network.statActive': 'Active',
    'network.statTotalPorts': 'Total Ports',
    'network.statPoe': 'PoE Supported',
    'network.searchPlaceholder': 'Search switch...',
    'network.filterAllStatuses': 'All Statuses',
    'network.filterAllHealth': 'All Health States',
    'network.noSwitchFound': 'No switch found',
    'network.statusActive': 'Active',
    'network.statusInactive': 'Inactive',
    'network.statusMaintenance': 'In Maintenance',
    'network.statusFaulty': 'Faulty',
    'network.healthHealthy': 'Healthy',
    'network.healthWarning': 'Warning',
    'network.healthCritical': 'Critical',
    'network.healthUnknown': 'Unknown',
    'network.colIpAddress': 'IP Address',
    'network.colPorts': 'Ports',
    'network.colLocation': 'Location',
    'network.colStatus': 'Status',
    'network.prevPage': 'Previous',
    'network.nextPage': 'Next',
    'network.yes': 'Yes',
    'network.no': 'No',
    'network.cancel': 'Cancel',
    'network.save': 'Save',
    'network.update': 'Update',
    'network.delete': 'Delete',
    'network.export': 'Export',
    'network.notSpecified': 'Not specified',
    'network.editSwitch': 'Edit Switch',
    'network.newSwitchTitle': 'New Switch',
    'network.labelCabinet': 'Cabinet',
    'network.selectCabinet': 'Select cabinet',
    'network.labelSwitchName': 'Switch Name *',
    'network.labelAlias': 'Alias',
    'network.labelBrand': 'Brand *',
    'network.labelModel': 'Model *',
    'network.selectModel': 'Select model',
    'network.labelSerialNo': 'Serial Number *',
    'network.labelIpAddr': 'IP Address *',
    'network.labelMacAddr': 'MAC Address *',
    'network.labelInventoryNo': 'Inventory No',
    'network.labelFirmware': 'Firmware Version *',
    'network.labelPortCount': 'Port Count *',
    'network.labelPortType': 'Port Type *',
    'network.labelCompany': 'Company *',
    'network.selectCompany': 'Select company',
    'network.labelLocation': 'Location *',
    'network.selectLocation': 'Select location',
    'network.labelRackPos': 'Rack Position',
    'network.labelMgmtVlan': 'Management VLAN',
    'network.labelUplinkPorts': 'Uplink Ports',
    'network.labelStatus': 'Status',
    'network.labelPurchaseDate': 'Purchase Date *',
    'network.labelWarrantyEnd': 'Warranty End Date',
    'network.labelPurchasePrice': 'Purchase Price',
    'network.defineModelBtn': 'Define Model',
    'network.modelAutoApplied': 'Model Information Applied Automatically',
    'network.poeSupportLabel': 'PoE Support',
    'network.poeBudgetLabel': 'PoE Budget (Watt)',
    'network.switchImageLabel': 'Switch Image',
    'network.adminUsernameLabel': 'Admin Username',
    'network.adminPasswordLabel': 'Admin Password',
    'network.lldpNeighborsTitle': 'LLDP Neighbors',
    'network.addLldpNeighbor': 'Add LLDP Neighbor',
    'network.neighborSwitch': 'Neighbor Switch',
    'network.localPort': 'Local Port',
    'network.remotePort': 'Remote Port',
    'network.detailTitle': 'Switch Details',
    'network.switchInfoTitle': 'Switch Information',
    'network.detailSwitchName': 'Switch Name:',
    'network.detailBrandModel': 'Brand/Model:',
    'network.detailIpAddr': 'IP Address:',
    'network.detailPortCount': 'Port Count:',
    'network.detailPoeSupport': 'PoE Support:',
    'network.switchImageTitle': 'Switch Image',
    'network.editModel': 'Edit Model',
    'network.newModelTitle': 'Define New Model',
    'network.labelPortSpeeds': 'Port Speeds',
    'network.labelModelImage': 'Model Image',
    'network.labelTechSpecs': 'Technical Specifications',
    'network.labelDescription': 'Description',
    'network.labelSfpPorts': 'SFP Port Count',
    'network.modelMgmtTitle': 'Switch Models Management',
    'network.searchModel': 'Search model...',
    'network.newModel': 'New Model',
    'network.sfpPortsLabel': 'SFP Ports:',
    'network.usageLabel': 'Usage:',
    'network.noModels': 'No models defined yet',
    'network.portMgmtTitle': 'Port Management',
    'network.portActive': 'Active',
    'network.portNameLabel': 'Name:',
    'network.connectedDeviceLabel': 'Device:',
    'network.vlanLabel': 'VLAN:',
    'network.ipLabel': 'IP:',
    'network.descriptionLabel': 'Description:',
    'network.editPortTitle': 'Edit',
    'network.portNameField': 'Port Name',
    'network.connectedDeviceField': 'Connected Device',
    'network.portDescription': 'Description',
    'network.locationField': 'Location',
    'network.selectLocationOpt': 'Select Location',
    'network.vlanField': 'VLAN',
    'network.selectVlanOpt': 'Select VLAN',
    'network.ipAddressField': 'IP Address',
    'network.ipMustBeInRange': "Must be within selected VLAN's IP range",
    'network.portActiveLabel': 'Port Active',
    'network.vlanMgmtTitle': 'VLAN Management',
    'network.searchVlan': 'Search VLAN...',
    'network.newVlan': 'New VLAN',
    'network.editVlanTitle': 'Edit VLAN',
    'network.addVlanTitle': 'Add New VLAN',
    'network.vlanIdLabel': 'VLAN ID *',
    'network.vlanNameLabel': 'VLAN Name *',
    'network.networkAddressLabel': 'Network Address (CIDR)',
    'network.subnetMaskLabel': 'Subnet Mask',
    'network.gatewayLabel': 'Gateway',
    'network.ipRangeLabel': 'IP Range',
    'network.autoCalculated': 'Auto-calculated',
    'network.descriptionVlan': 'Description',
    'network.existingVlans': 'Existing VLANs',
    'network.locationVlanLabel': 'Location:',
    'network.emptyPortsTitle': 'Empty Ports',
    'network.noPortName': 'No name',
    'network.allPortsFull': 'All ports are occupied',
    'network.backupMgmtTitle': 'Backup Management',
    'network.newBackupTitle': 'Upload New Backup',
    'network.backupTypeLabel': 'Backup Type',
    'network.backupTypeText': 'Text',
    'network.backupTypeFile': 'File',
    'network.configTextLabel': 'Configuration Text *',
    'network.backupFileLabel': 'Backup File *',
    'network.backupDescLabel': 'Description',
    'network.backupUploadBtn': 'Upload Backup',
    'network.backupHistoryTitle': 'Backup History',
    'network.textBackup': 'Text Backup',
    'network.fileBackup': 'File Backup',
    'network.uploadedByLabel': 'Uploaded by:',
    'network.noBackups': 'No backups uploaded yet',
    'network.analyzingConfig': 'Analyzing configuration...',
    'network.noIssues': 'No Issues Detected',
    'network.vlanDetailTitle': 'VLAN Details',
    'network.maintenanceTitle': 'Maintenance Record',
    'network.maintenanceTypeLabel': 'Maintenance Type *',
    'network.cleaningType': 'Cleaning',
    'network.inspectionType': 'Inspection',
    'network.backupUpdateType': 'Backup Update',
    'network.firmwareUpdateType': 'Firmware Update',
    'network.maintenanceDateLabel': 'Maintenance Date *',
    'network.maintenanceNotesLabel': 'Notes',
    'network.labelPrintTitle': 'Print Label',
    'network.labelPrintDesc': 'A label will be printed for this switch.',
    'network.labelCustomDesc': 'You can customize the label dimensions.',
    'network.labelOrientationLabel': 'Label Orientation',
    'network.horizontal': 'Horizontal',
    'network.vertical': 'Vertical',
    'network.switchInfoLabelTitle': 'Switch Information',
    'network.labelSizeTitle': 'Label Dimensions',
    'network.labelWidthMm': 'Width (mm)',
    'network.labelHeightMm': 'Height (mm)',
    'network.printLabelBtn': 'Print Label',
    'network.errLoadData': 'Error loading data',
    'network.successSwitchUpdated': 'Switch updated',
    'network.successSwitchCreated': 'Switch created',
    'network.errSavingSwitch': 'Error saving switch',
    'network.confirmDeleteSwitch': 'Are you sure you want to delete this network switch?',
    'network.successSwitchDeleted': 'Switch deleted',
    'network.errDeletingSwitch': 'Error deleting switch',
    'network.errRequiredFields': 'Switch Name, IP Address and Serial Number are required',
    'network.errDuplicateIP': 'This IP address is already used by another switch',
    'network.errDuplicateSerial': 'This serial number is already used by another switch',
    'network.switchCopied': 'Switch info copied, edit unique fields and save',
    'network.errLoadPorts': 'Error loading port information',
    'network.successPortUpdated': 'Port updated',
    'network.errUpdatePort': 'Error updating port',
    'network.successVlanUpdated': 'VLAN updated',
    'network.successVlanCreated': 'VLAN created',
    'network.errSavingVlan': 'Error saving VLAN',
    'network.errVlanRequired': 'VLAN ID and name are required',
    'network.errLoadEmptyPorts': 'Error loading empty ports',
    'network.errConfigRequired': 'Configuration text is required',
    'network.errBackupFileRequired': 'Please select a backup file',
    'network.successBackupUploaded': 'Backup uploaded',
    'network.errUploadingBackup': 'Error uploading backup',
    'network.confirmDeleteBackup': 'Are you sure you want to delete this backup?',
    'network.successBackupDeleted': 'Backup deleted',
    'network.errDeletingBackup': 'Error deleting backup',
    'network.errAnalysisError': 'Error during analysis',
    'network.successModelUpdated': 'Model updated',
    'network.successModelCreated': 'Model created',
    'network.errSavingModel': 'Error saving model',
    'network.errModelRequired': 'Brand and model fields are required',
    'network.errLabelPrint': 'Error printing label',
    'network.errMaintenanceRequired': 'Please fill in required fields',
    'network.successMaintenanceSaved': 'Maintenance record added',
    'network.errSavingMaintenance': 'Error adding maintenance record',
    'network.lastBackupNever': 'No backups taken',
    'network.poeSupportedWith': 'Supported',
    'network.poeNotSupported': 'Not Supported',
    'network.poeWithBudget': 'budget',
    'network.modelImageFromModel': 'Image from model',
    // CompaniesPage
    'companies.title': 'Companies',
    'companies.subtitle': 'Manage company information',
    'companies.export': 'Export',
    'companies.newCompany': 'New Company',
    'companies.searchPlaceholder': 'Search company...',
    'companies.taxNo': 'Tax No:',
    'companies.taxOffice': 'Tax Office:',
    'companies.gsmLines': 'GSM Lines',
    'companies.users': 'Users',
    'companies.printers': 'Printers',
    'companies.createdAt': 'Created:',
    'companies.editTitle': 'Edit Company',
    'companies.newTitle': 'New Company',
    'companies.labelName': 'Company Name *',
    'companies.labelTaxNo': 'Tax Number *',
    'companies.labelTaxOffice': 'Tax Office',
    'companies.labelLocation': 'Location',
    'companies.selectLocation': 'Select location (optional)',
    'companies.cancel': 'Cancel',
    'companies.save': 'Save',
    'companies.update': 'Update',
    'companies.capexList': 'CAPEX List',
    'companies.noCapex': 'No CAPEX records found for this company.',
    'companies.capexProjectName': 'Project Name',
    'companies.capexCategory': 'Category',
    'companies.capexAmount': 'Amount',
    'companies.capexStatus': 'Status',
    'companies.capexDate': 'Date',
    'companies.statusApproved': 'Approved',
    'companies.statusPending': 'Pending',
    'companies.statusRejected': 'Rejected',
    'companies.errLoad': 'Error loading data',
    'companies.errRequired': 'Please fill in required fields',
    'companies.successCopied': 'Company info copied to clipboard',
    'companies.errCopy': 'Copy operation failed',
    'companies.successUpdated': 'Company updated',
    'companies.successCreated': 'Company created',
    'companies.errSave': 'Error saving company',
    'companies.confirmDelete': 'Are you sure you want to delete this company?',
    'companies.errDelete': 'Error deleting company',
    'companies.successExport': 'Companies list exported',
    'companies.errCapex': 'Error loading CAPEX data',
    // LocationsPage
    'locations.title': 'Locations',
    'locations.subtitle': 'Manage company locations',
    'locations.newLocation': 'New Location',
    'locations.searchPlaceholder': 'Search location...',
    'locations.colLocation': 'Location',
    'locations.colAddress': 'Address',
    'locations.colPhone': 'Phone',
    'locations.colUser': 'Users',
    'locations.colSwitch': 'Switches',
    'locations.colIot': 'IoT',
    'locations.colScale': 'Scales',
    'locations.colCabinet': 'Cabinets',
    'locations.colPhysicalServer': 'Physical Servers',
    'locations.colVirtualServer': 'Virtual Servers',
    'locations.colGsm': 'GSM Lines',
    'locations.colMobile': 'Mobile Phones',
    'locations.colCreated': 'Created',
    'locations.colActions': 'Actions',
    'locations.notFound': 'No location found',
    'locations.notFoundSearch': 'No location matches your search criteria.',
    'locations.notFoundEmpty': 'No locations added yet.',
    'locations.editTitle': 'Edit Location',
    'locations.newTitle': 'New Location',
    'locations.labelName': 'Location Name *',
    'locations.labelAddress': 'Address *',
    'locations.labelPhone': 'Phone *',
    'locations.cancel': 'Cancel',
    'locations.save': 'Save',
    'locations.update': 'Update',
    'locations.errLoad': 'Error loading data',
    'locations.errRequired': 'Please fill in all fields',
    'locations.successUpdated': 'Location updated',
    'locations.successCreated': 'Location created',
    'locations.errSave': 'Error saving location',
    'locations.confirmDelete': 'Are you sure you want to delete this location?',
    'locations.successDeleted': 'Location deleted',
    'locations.errDelete': 'Error deleting location',
    // SuppliersPage
    'suppliers.title': 'Suppliers',
    'suppliers.subtitle': 'Manage supplier information',
    'suppliers.newSupplier': 'New Supplier',
    'suppliers.searchPlaceholder': 'Search supplier...',
    'suppliers.editTitle': 'Edit Supplier',
    'suppliers.newTitle': 'New Supplier',
    'suppliers.cancel': 'Cancel',
    'suppliers.save': 'Save',
    'suppliers.update': 'Update',
    'suppliers.createUser': 'Create New User',
    'suppliers.existingUsers': 'Existing Users',
    'suppliers.noUsers': 'No users yet',
    'suppliers.unknownPassword': 'Unknown (old record)',
    'suppliers.errLoad': 'Error loading data',
    'suppliers.errRequired': 'Please fill in required fields',
    'suppliers.successUpdated': 'Supplier updated',
    'suppliers.successCreated': 'Supplier created',
    'suppliers.errSave': 'Error saving supplier',
    'suppliers.confirmDelete': 'Are you sure you want to delete this supplier?',
    'suppliers.successDeleted': 'Supplier deleted',
    'suppliers.errDelete': 'Error deleting supplier',
    'suppliers.userCreated': 'User created',
    'suppliers.errUserCreate': 'Failed to create user',
    'suppliers.confirmResetPassword': 'Are you sure you want to reset this user\'s password?',
    'suppliers.errResetPassword': 'Password reset failed',
    'suppliers.successEmailSent': 'Login credentials sent by email',
    'suppliers.errEmailSend': 'Failed to send email',
    'suppliers.taxNo': 'Tax No:',
    'suppliers.serviceCategories': 'Service Categories:',
    'suppliers.createdAt': 'Created:',
    'suppliers.userManagement': 'User Management',
    'suppliers.labelName': 'Supplier Name *',
    'suppliers.labelContact': 'Contact Person *',
    'suppliers.labelPhone': 'Phone *',
    'suppliers.labelEmail': 'Email',
    'suppliers.labelWebsite': 'Website',
    'suppliers.labelTaxNo': 'Tax Number',
    'suppliers.labelAddress': 'Address *',
    'suppliers.labelCategories': 'Service Categories',
    'suppliers.labelUsername': 'Username *',
    'suppliers.labelFullName': 'Full Name *',
    'suppliers.labelEmail2': 'Email',
    'suppliers.labelPhone2': 'Phone',
    'suppliers.labelPassword': 'Password *',
    'suppliers.statusActive': 'Active',
    'suppliers.statusInactive': 'Inactive',
    'suppliers.passwordLabel': 'Password:',
    'suppliers.lastLogin': 'Last login:',
    'suppliers.createUserBtn': 'Create User',
    'suppliers.close': 'Close',
    // EquipmentPage
    'equipment.title': 'Equipment',
    'equipment.subtitle': 'Manage equipment inventory',
    'equipment.newEquipment': 'New Equipment',
    'equipment.searchPlaceholder': 'Search equipment...',
    'equipment.allCategories': 'All Categories',
    'equipment.allStatuses': 'All Statuses',
    'equipment.statusAvailable': 'Available',
    'equipment.statusInUse': 'In Use',
    'equipment.statusMaintenance': 'Maintenance',
    'equipment.statusRetired': 'Retired',
    'equipment.conditionGood': 'Good',
    'equipment.conditionFair': 'Fair',
    'equipment.conditionPoor': 'Poor',
    'equipment.locationNotSet': 'Location not specified',
    'equipment.lowStock': 'Low Stock',
    'equipment.editTitle': 'Edit Equipment',
    'equipment.newTitle': 'Add New Equipment',
    'equipment.selectCategory': 'Select Category',
    'equipment.selectLocation': 'Select Location',
    'equipment.selectUser': 'Select User',
    'equipment.assignTypeTemp': 'Temporary',
    'equipment.assignTypePerm': 'Permanent',
    'equipment.cancel': 'Cancel',
    'equipment.save': 'Add',
    'equipment.update': 'Update',
    'equipment.noHistory': 'No assignment history yet',
    'equipment.historyUser': 'User',
    'equipment.historyType': 'Type',
    'equipment.historyReturnDate': 'Return Date',
    'equipment.historyAction': 'Action',
    'equipment.statusActive': 'Active',
    'equipment.statusReturned': 'Returned',
    'equipment.errLoad': 'Error loading data',
    'equipment.successUpdated': 'Equipment updated successfully',
    'equipment.successCreated': 'Equipment added successfully',
    'equipment.errSave': 'Error saving equipment',
    'equipment.confirmDelete': 'Are you sure you want to delete this equipment?',
    'equipment.successDeleted': 'Equipment deleted successfully',
    'equipment.errDelete': 'Error deleting equipment',
    'equipment.successAssigned': 'Equipment assigned successfully',
    'equipment.errAssign': 'Error during assignment',
    'equipment.confirmUnassign': 'Are you sure you want to remove this assignment? Stock will be automatically restored.',
    'equipment.successUnassigned': 'Assignment removed successfully',
    'equipment.successStockAdded': 'Stock added successfully',
    'equipment.errStockAdd': 'Error adding stock',
    // ConsumablesPage
    'consumables.title': 'Consumables',
    'consumables.subtitle': 'Manage consumable inventory',
    'consumables.newConsumable': 'New Consumable',
    'consumables.searchPlaceholder': 'Search by name, brand or model...',
    'consumables.allCategories': 'All Categories',
    'consumables.brandNotSet': 'Brand not specified',
    'consumables.locationNotSet': 'Not specified',
    'consumables.editTitle': 'Edit Consumable',
    'consumables.newTitle': 'Add New Consumable',
    'consumables.selectCategory': 'Select Category',
    'consumables.selectLocation': 'Select Location',
    'consumables.selectPrinter': 'Select Printer',
    'consumables.selectUser': 'Select User',
    'consumables.selectSupplier': 'Select Supplier',
    'consumables.currentPhoto': 'Current photo:',
    'consumables.newPhotoPreview': 'New photo preview:',
    'consumables.cancel': 'Cancel',
    'consumables.save': 'Add',
    'consumables.update': 'Update',
    'consumables.confirmDelete': 'Are you sure you want to delete this consumable?',
    'consumables.successAdded': 'Consumable added successfully',
    'consumables.errSave': 'Error saving consumable',
    'consumables.successAssigned': 'Operation completed successfully',
    'consumables.errAssign': 'Assignment operation failed',
    'consumables.successStockAdded': 'Stock added successfully',
    // DocumentsPage
    'documents.title': 'Documents',
    'documents.subtitle': 'Manage documents and files',
    'documents.allCategories': 'All Categories',
    'documents.allTypes': 'All Types',
    'documents.sortLabel': 'Sort:',
    'documents.statusSigned': 'Signed',
    'documents.statusExpired': 'Expired',
    'documents.statusCancelled': 'Cancelled',
    'documents.download': 'Download',
    'documents.view': 'View',
    'documents.downloadInvoice': 'Download Invoice',
    'documents.statusApproved': 'Approved',
    'documents.statusCompleted': 'Completed',
    'documents.statusUploaded': 'Invoice Uploaded',
    // MaintenanceContractsPage
    'maintenance.title': 'Maintenance Contracts',
    'maintenance.subtitle': 'Manage maintenance and service agreements',
    'maintenance.newContract': 'New Contract',
    'maintenance.searchPlaceholder': 'Search contract name...',
    'maintenance.allStatuses': 'All Statuses',
    'maintenance.allSuppliers': 'All Suppliers',
    'maintenance.statActive': 'Total Active Contracts',
    'maintenance.stat1Month': 'Expiring in 1 Month',
    'maintenance.stat3Month': 'Expiring in 3 Months',
    'maintenance.stat6Month': 'Expiring in 6 Months',
    'maintenance.statusActive': 'Active',
    'maintenance.statusExpired': 'Expired',
    'maintenance.statusCancelled': 'Cancelled',
    'maintenance.editTitle': 'Edit Maintenance Contract',
    'maintenance.newTitle': 'New Maintenance Contract',
    'maintenance.selectSupplier': 'Select Supplier',
    'maintenance.currencyTL': 'Turkish Lira (₺)',
    'maintenance.download': 'Download',
    'maintenance.upload': 'Upload',
    'maintenance.uploading': 'Uploading...',
    'maintenance.cancel': 'Cancel',
    'maintenance.save': 'Create',
    'maintenance.update': 'Update',
    'maintenance.extendDays': 'Days',
    'maintenance.extendMonths': 'Months',
    'maintenance.extendYears': 'Years',
    'maintenance.confirmDeleteFile': 'Are you sure you want to delete this file?',
    // ProceduresPage
    'procedures.title': 'Procedures',
    'procedures.subtitle': 'Manage standard operating procedures',
    'procedures.newProcedure': 'New Procedure',
    'procedures.searchPlaceholder': 'Search procedure...',
    'procedures.allStatuses': 'All Statuses',
    'procedures.statusAll': 'All',
    'procedures.statusPublished': 'Published',
    'procedures.statusArchived': 'Archived',
    'procedures.notFoundCategory': 'No procedures found in this category.',
    'procedures.notFound': 'No procedure found.',
    'procedures.editTitle': 'Edit Procedure',
    'procedures.newTitle': 'Create New Procedure',
    'procedures.titlePlaceholder': 'Procedure title',
    'procedures.contentPlaceholder': 'Write procedure content...',
    'procedures.selectCategory': 'Select category...',
    'procedures.statusPublish': 'Publish',
    'procedures.saving': 'Saving...',
    'procedures.cancel': 'Cancel',
    'procedures.save': 'Create',
    'procedures.update': 'Update',
    'procedures.noContent': 'No content available.',
    'procedures.historyCreated': 'Created',
    'procedures.historyUpdated': 'Updated',
    'procedures.historyPublished': 'Published',
    'procedures.historyArchived': 'Archived',
    'procedures.historyRestored': 'Restored',
    'procedures.errLoad': 'Error loading procedures',
    'procedures.errSave': 'Error saving procedure',
    'procedures.successUpdated': 'Procedure updated successfully',
    'procedures.successCreated': 'Procedure created successfully',
    'procedures.successPublished': 'Procedure published successfully',
    'procedures.successArchived': 'Procedure archived successfully',
    'procedures.successRestored': 'Procedure restored successfully',
    'procedures.successDeleted': 'Procedure deleted successfully',
    'procedures.confirmDeleteFile': 'Are you sure you want to delete this file?',
    'procedures.successFileDeleted': 'File deleted successfully',
    // CapexPage
    'capex.title': 'CAPEX Management',
    'capex.subtitle': 'Manage company budgets and spending tracking',
    'capex.newCapex': 'New CAPEX',
    'capex.searchPlaceholder': 'Search CAPEX...',
    'capex.allYears': 'All Years',
    'capex.allCompanies': 'All Companies',
    'capex.allCategories': 'All Categories',
    'capex.allStatuses': 'All Statuses',
    'capex.statusActive': 'Active',
    'capex.statusCompleted': 'Completed',
    'capex.statusCancelled': 'Cancelled',
    'capex.statusUnknown': 'Unknown',
    'capex.budgetUsage': 'Budget Usage',
    'capex.total': 'Total',
    'capex.used': 'Used',
    'capex.blocked': 'Blocked',
    'capex.remaining': 'Remaining',
    'capex.blockedAmount': 'Blocked: {symbol}{amount}',
    'capex.viewHistory': 'View History',
    'capex.clearBlocked': 'Clear Blocked Amount',
    'capex.confirmClearBlocked': 'Are you sure you want to clear the blocked amount for this CAPEX?',
    'capex.confirmCancelOrders': 'This CAPEX is being used by active orders:\n{orders}\n\nDo you want to cancel these orders and clear the blocked amount?',
    'capex.confirmDelete': 'Are you sure you want to delete this CAPEX record?',
    'capex.blockedCleared': 'Blocked amount cleared',
    'capex.ordersAndBlockedCleared': 'Orders cancelled and blocked amount cleared',
    'capex.modalTitleEdit': 'Edit CAPEX',
    'capex.modalTitleNew': 'New CAPEX',
    'capex.fieldCapexNumber': 'CAPEX Number *',
    'capex.fieldCompany': 'Company *',
    'capex.selectCompany': 'Select company',
    'capex.fieldYear': 'Year *',
    'capex.fieldCategory': 'Category *',
    'capex.selectCategory': 'Select category',
    'capex.addNewCategory': 'Add New Category',
    'capex.newCategoryPlaceholder': 'New category name...',
    'capex.addCategoryBtn': 'Add',
    'capex.fieldTotalAmount': 'Total Amount *',
    'capex.fieldCurrency': 'Currency *',
    'capex.currencyEUR': 'Euro (€)',
    'capex.currencyUSD': 'US Dollar ($)',
    'capex.currencyTRY': 'Turkish Lira (₺)',
    'capex.fieldDescription': 'Description',
    'capex.descriptionPlaceholder': 'Detailed description about CAPEX...',
    'capex.btnCancel': 'Cancel',
    'capex.btnUpdate': 'Update',
    'capex.btnSave': 'Save',
    'capex.historyTitle': 'CAPEX Usage History',
    'capex.totalBudget': 'Total Budget',
    'capex.usageRate': 'Usage Rate',
    'capex.transactionHistory': 'Transaction History',
    'capex.noOrders': 'No orders found created with this CAPEX.',
    'capex.orderFieldCompany': 'Company:',
    'capex.orderFieldLocation': 'Location:',
    'capex.orderFieldSupplier': 'Supplier:',
    'capex.orderFieldCategory': 'Category:',
    'capex.pdfTitle': 'CAPEX Report',
    'capex.pdfDate': 'Date:',
    'capex.pdfColCapexNo': 'CAPEX No',
    'capex.pdfColCompany': 'Company',
    'capex.pdfColCategory': 'Category',
    'capex.pdfColYear': 'Year',
    'capex.pdfColTotalBudget': 'Total Budget',
    'capex.pdfColUsed': 'Used',
    'capex.pdfColRemaining': 'Remaining',
    'capex.pdfColStatus': 'Status',
    'capex.pdfReady': 'PDF report ready',
    'capex.excelDownloaded': 'Excel file downloaded successfully',
    'capex.errorLoad': 'Error loading data',
    'capex.errorRequiredFields': 'Please fill in all required fields',
    'capex.errorSave': 'Error saving CAPEX',
    'capex.errorClearBlocked': 'Error clearing blocked amount',
    'capex.errorCategoryAdd': 'Category could not be added',
    'capex.errorCategoryAddGeneral': 'Error adding category',
    'capex.errorLoadOrders': 'Error loading CAPEX orders',
    'capex.successUpdated': 'CAPEX updated',
    'capex.successCreated': 'CAPEX created',
    'capex.successCategoryAdded': 'Category added',
    'capex.orderStatusCreated': 'Order Created',
    'capex.orderStatusPending': 'Pending',
    'capex.orderStatusApproved': 'Approved',
    'capex.orderStatusOrdered': 'Ordered',
    'capex.orderStatusDelivered': 'Delivered',
    'capex.orderStatusCompleted': 'Completed',
    'capex.orderStatusCancelled': 'Cancelled',
    // PhysicalServersPage
    'physerver.title': 'Physical Servers',
    'physerver.subtitle': 'Server infrastructure management and monitoring',
    'physerver.newServer': 'New Server',
    'physerver.searchPlaceholder': 'Search server...',
    'physerver.allStatuses': 'All Statuses',
    'physerver.allCompanies': 'All Companies',
    'physerver.allLocations': 'All Locations',
    'physerver.allBrands': 'All Brands',
    'physerver.allServerTypes': 'All Types',
    'physerver.excelSheet': 'Physical Servers',
    'physerver.excelFilename': 'physical-servers',
    'physerver.pdfTitle': 'Physical Servers Report',
    'physerver.pdfReportDate': 'Report Date:',
    'physerver.pdfTotal': 'Total Servers:',
    'physerver.exportExcelSuccess': 'records exported to Excel',
    'physerver.exportExcelError': 'Error during Excel export',
    'physerver.exportPdfSuccess': 'records exported to PDF',
    'physerver.exportPdfError': 'Error during PDF export',
    'physerver.statusActive': 'Active',
    'physerver.statusMaintenance': 'Maintenance',
    'physerver.statusOffline': 'Offline',
    'physerver.statusDecommissioned': 'Decommissioned',
    'physerver.statTotalServers': 'Total Servers',
    'physerver.statActive': 'Active',
    'physerver.statTotalRAM': 'Total RAM',
    'physerver.statTotalStorage': 'Total Storage',
    'physerver.colServerName': 'Server Name',
    'physerver.colHostname': 'Hostname',
    'physerver.colIPAddress': 'IP Address',
    'physerver.colBrandModel': 'Brand/Model',
    'physerver.colCompany': 'Company',
    'physerver.colLocation': 'Location',
    'physerver.colResources': 'Resources (Remaining/Total)',
    'physerver.colStatus': 'Status',
    'physerver.colActions': 'Actions',
    'physerver.notFound': 'No servers found',
    'physerver.notFoundDesc': 'No servers match your search criteria.',
    'physerver.titleView': 'View Details',
    'physerver.titleDuplicate': 'Duplicate',
    'physerver.titleEdit': 'Edit',
    'physerver.titleDelete': 'Delete',
    'physerver.confirmDelete': 'Are you sure you want to delete this physical server?',
    'physerver.modalTitleEdit': 'Edit Server',
    'physerver.modalTitleNew': 'New Server',
    'physerver.fieldServerName': 'Server Name *',
    'physerver.fieldHostname': 'Hostname *',
    'physerver.fieldIPAddress': 'IP Address *',
    'physerver.fieldServerType': 'Server Type *',
    'physerver.fieldBrand': 'Brand *',
    'physerver.fieldModel': 'Model *',
    'physerver.fieldSerialNo': 'Serial No *',
    'physerver.fieldRAM': 'RAM (GB) *',
    'physerver.fieldStorage': 'Storage (GB) *',
    'physerver.fieldProcessor': 'Processor *',
    'physerver.fieldCPUCores': 'CPU Core Count *',
    'physerver.fieldOS': 'Operating System *',
    'physerver.fieldCompany': 'Company *',
    'physerver.selectCompany': 'Select Company',
    'physerver.fieldLocation': 'Location *',
    'physerver.selectLocation': 'Select Location',
    'physerver.fieldPurchaseDate': 'Purchase Date *',
    'physerver.fieldWarrantyEnd': 'Warranty End Date',
    'physerver.fieldAssignedAdmin': 'Assigned Admin',
    'physerver.selectAdmin': 'Select Admin (Optional)',
    'physerver.btnCancel': 'Cancel',
    'physerver.btnUpdate': 'Update',
    'physerver.btnSave': 'Save',
    'physerver.detailTitle': 'Server Details',
    'physerver.detailSectionServer': 'Server Information',
    'physerver.detailServerName': 'Server Name:',
    'physerver.detailHostname': 'Hostname:',
    'physerver.detailIPAddress': 'IP Address:',
    'physerver.detailBrandModel': 'Brand/Model:',
    'physerver.detailOS': 'Operating System:',
    'physerver.detailSectionHardware': 'Hardware Specifications',
    'physerver.detailProcessor': 'Processor:',
    'physerver.detailRAM': 'RAM:',
    'physerver.detailStorage': 'Storage:',
    'physerver.detailPowerConsumption': 'Power Consumption:',
    'physerver.detailUptime': 'Uptime:',
    'physerver.detailUptimeDays': '{days} days',
    'physerver.detailSectionVMs': 'Virtual Servers and Resource Usage',
    'physerver.vcpuAllocation': 'vCPU Allocation',
    'physerver.ramAllocation': 'RAM Allocation',
    'physerver.diskAllocation': 'Disk Allocation',
    'physerver.allocated': 'Allocated:',
    'physerver.remaining': 'Remaining:',
    'physerver.connectedVMs': 'Connected Virtual Servers ({count})',
    'physerver.noVMs': 'No virtual servers connected to this physical server.',
    'physerver.duplicateSuffix': '(Copy)',
    'physerver.errorLoad': 'Error loading data',
    'physerver.errorRequiredFields': 'Please fill in all required fields (Serial Number, Brand, Model, Processor, Operating System, Company, Location, Purchase Date)',
    'physerver.errorInvalidIP': 'Invalid IP address format. Example: 192.168.1.100',
    'physerver.errorDuplicateHostname': 'This hostname is already in use: {name}',
    'physerver.errorDuplicateIP': 'This IP address is already in use: {name} ({ip})',
    'physerver.errorSave': 'Error saving server',
    'physerver.errorDelete': 'Error deleting server',
    'physerver.successUpdated': 'Server updated',
    'physerver.successCreated': 'Server created',
    'physerver.successDeleted': 'Server deleted',

    // nvrs.*
    'nvrs.title': 'NVR Management',
    'nvrs.subtitle': 'Manage NVR devices',
    'nvrs.filter': 'Filter',
    'nvrs.bulkLabel': 'Bulk Label',
    'nvrs.newNvr': 'New NVR',
    'nvrs.searchPlaceholder': 'Search NVR, location, IP, brand, model, username...',
    'nvrs.selectLocations': 'Select Locations',
    'nvrs.nvrCount': '{count} NVR Device(s)',
    'nvrs.filterTitle': '📡 {location} Location NVR Filters',
    'nvrs.filterBrand': 'Brand',
    'nvrs.filterIp': 'IP Address',
    'nvrs.filterIpPlaceholder': 'Search by IP address...',
    'nvrs.filterRaid': 'RAID Structure',
    'nvrs.allBrands': 'All Brands',
    'nvrs.allRaidTypes': 'All RAID Types',
    'nvrs.selectLocationPrompt': 'Please select a location above to see NVR devices.',
    'nvrs.colInfo': 'NVR Info',
    'nvrs.colTech': 'Technical Specs',
    'nvrs.colStorage': 'Storage',
    'nvrs.colActions': 'Actions',
    'nvrs.channels': '{count} Channel(s)',
    'nvrs.usable': 'Available: {space}',
    'nvrs.titleEdit': 'Edit',
    'nvrs.titleCopy': 'Copy',
    'nvrs.titleQr': 'QR Code',
    'nvrs.titleHistory': 'History',
    'nvrs.titleDelete': 'Delete',
    'nvrs.prevPage': 'Previous',
    'nvrs.nextPage': 'Next',
    'nvrs.paginationInfo': '{start}-{end} of {total} records',
    'nvrs.modalEditTitle': 'Edit NVR',
    'nvrs.modalCopyTitle': 'Copy NVR',
    'nvrs.modalNewTitle': 'New NVR',
    'nvrs.labelName': 'NVR Name *',
    'nvrs.labelLocation': 'Location *',
    'nvrs.labelBrand': 'Brand *',
    'nvrs.labelModel': 'Model *',
    'nvrs.labelIp': 'IP Address *',
    'nvrs.labelInventory': 'Inventory Number',
    'nvrs.labelChannels': 'Channel Count',
    'nvrs.labelDiskCount': 'Total Disk Count',
    'nvrs.labelDiskSize': 'Single Disk Size *',
    'nvrs.labelTotalSpace': 'Total Disk Space',
    'nvrs.labelRaid': 'RAID Structure *',
    'nvrs.labelUsable': 'Usable Space',
    'nvrs.labelUsername': 'Username',
    'nvrs.labelPassword': 'Password',
    'nvrs.labelRecordingTime': 'Estimated Recording Time',
    'nvrs.labelNotes': 'Notes',
    'nvrs.placeholderAutoName': 'Will be auto-generated after selecting location',
    'nvrs.placeholderSelectLocation': 'Select Location',
    'nvrs.placeholderSelectDisk': 'Select Disk Size',
    'nvrs.placeholderAutoCalc': 'Will be calculated automatically',
    'nvrs.placeholderSelectRaid': 'Select RAID Type',
    'nvrs.placeholderRaidCalc': 'Will be calculated based on RAID',
    'nvrs.placeholderRecordingTime': 'e.g.: 30 days',
    'nvrs.cancel': 'Cancel',
    'nvrs.save': 'Save',
    'nvrs.historyTitle': 'NVR History',
    'nvrs.historyEmpty': 'No history records found for this NVR.',
    'nvrs.historyCreated': 'Created',
    'nvrs.historyUpdated': 'Updated',
    'nvrs.historyDeleted': 'Deleted',
    'nvrs.historyField': '{field} field',
    'nvrs.historyEmptyValue': 'Empty',
    'nvrs.bulkLabelTitle': 'Bulk Label Printing',
    'nvrs.bulkLabelFilters': 'Filters',
    'nvrs.bulkLabelLocation': 'Location',
    'nvrs.bulkLabelBrand': 'Brand',
    'nvrs.bulkLabelAllLocations': 'All Locations',
    'nvrs.bulkLabelAllBrands': 'All Brands',
    'nvrs.bulkLabelFilter': 'Filter',
    'nvrs.bulkLabelSelection': 'NVR Selection ({count} selected)',
    'nvrs.bulkLabelSelectAll': 'Select All',
    'nvrs.bulkLabelDeselectAll': 'Deselect All',
    'nvrs.bulkLabelNoLocation': 'No location',
    'nvrs.bulkLabelPreview': 'Preview ({count})',
    'nvrs.bulkLabelPreviewTitle': 'Label Preview ({count} items - {pages} pages)',
    'nvrs.bulkLabelPerPage': 'Each page will have 4 labels (2x2). Optimized for A4 paper.',
    'nvrs.bulkLabelBack': 'Back',
    'nvrs.bulkLabelPrint': 'Print',
    'nvrs.swalIpTitle': 'IP Address Error',
    'nvrs.swalIpText': 'Please enter a valid IP address!',
    'nvrs.swalOk': 'OK',
    'nvrs.swalSuccessTitle': 'Success!',
    'nvrs.swalUpdated': 'NVR updated!',
    'nvrs.swalAdded': 'NVR added!',
    'nvrs.swalInfoTitle': 'Info',
    'nvrs.swalNoChanges': 'No changes were made',
    'nvrs.swalErrorTitle': 'Error!',
    'nvrs.swalErrorText': 'An error occurred!',
    'nvrs.swalDeleteTitle': 'Are you sure?',
    'nvrs.swalDeleteText': 'Are you sure you want to delete this NVR?',
    'nvrs.swalDeleteConfirm': 'Yes, Delete!',
    'nvrs.swalDeleteCancel': 'Cancel',
    'nvrs.swalDeletedTitle': 'Deleted!',
    'nvrs.swalDeletedText': 'NVR deleted successfully!',
    'nvrs.swalDeleteError': 'NVR could not be deleted!',
    'nvrs.minDisks': 'Min {n} disks required',
    'nvrs.raidDesc0': 'No redundancy, maximum performance',
    'nvrs.raidDesc1': 'Full backup, 50% space loss',
    'nvrs.raidDesc5': 'Most common, tolerates 1 disk failure',
    'nvrs.raidDesc6': 'Tolerates 2 disk failures',
    'nvrs.raidDesc10': 'Mirror + Stripe, high performance',
    'nvrs.excelName': 'Name',
    'nvrs.excelBrand': 'Brand',
    'nvrs.excelModel': 'Model',
    'nvrs.excelInventory': 'Inventory No',
    'nvrs.excelLocation': 'Location',
    'nvrs.excelIp': 'IP Address',
    'nvrs.excelChannels': 'Channel Count',
    'nvrs.excelDisks': 'Disk Count',
    'nvrs.excelTotalSpace': 'Total Space',
    'nvrs.excelRaid': 'RAID Structure',
    'nvrs.excelUsable': 'Usable Space',
    'nvrs.excelUsername': 'Username',
    'nvrs.excelRecording': 'Estimated Recording Time',
    'nvrs.excelNotes': 'Notes',
    'nvrs.excelCreatedAt': 'Created At',

    // cameras.*
    'cameras.title': 'Camera Management',
    'cameras.totalCount': 'Total {count} cameras',
    'cameras.filter': 'Filter',
    'cameras.newCamera': 'New Camera',
    'cameras.locations': '📍 Locations',
    'cameras.nvrTitle': '📡 {location} Location NVR Devices',
    'cameras.searchPlaceholder': 'Search by camera name, IP address...',
    'cameras.filterTitle': 'Filters',
    'cameras.filterCameraName': 'Camera Name',
    'cameras.filterIp': 'IP Address',
    'cameras.filterBrand': 'Brand',
    'cameras.allBrands': 'All Brands',
    'cameras.clearFilters': 'Clear Filters',
    'cameras.colCamera': '📷 Camera',
    'cameras.colChannel': '🔗 Channel & IP',
    'cameras.colLocation': '📍 Location',
    'cameras.colWarranty': '📦 Warranty',
    'cameras.colActions': '⚙️ Actions',
    'cameras.channel': 'Channel {number}',
    'cameras.unspecified': 'Unspecified',
    'cameras.noCamera': 'No cameras found for this NVR',
    'cameras.paginationInfo': '{start}-{end} of {total} records',
    'cameras.noRecords': 'No records found',
    'cameras.prevPage': '← Previous',
    'cameras.nextPage': 'Next →',
    'cameras.duplicateIps': 'Conflicting IP Addresses ({count})',
    'cameras.duplicateFoundIn': 'Found in {count} NVR devices',
    'cameras.warrantyExpired': 'Expired',
    'cameras.warrantyActive': 'Active',
    'cameras.warrantyUnknown': 'Unknown',
    'cameras.selectLocationPrompt': 'Select a Location to Start',
    'cameras.selectLocationDesc': 'Select a location above to get started',
    'cameras.selectNvrPrompt': 'Select an NVR',
    'cameras.selectNvrDesc': 'Select one of the NVRs in {location} to view its cameras',
    'cameras.modalEditTitle': 'Edit Camera',
    'cameras.modalCopyTitle': 'Copy Camera',
    'cameras.modalNewTitle': 'New Camera',
    'cameras.labelBrand': 'Brand *',
    'cameras.labelModel': 'Model *',
    'cameras.labelAlias': 'Alias',
    'cameras.labelNvr': 'Connected NVR *',
    'cameras.labelChannelNumber': 'Channel Number *',
    'cameras.labelIp': 'IP Address *',
    'cameras.labelWarrantyStart': 'Warranty Start',
    'cameras.labelWarrantyEnd': 'Warranty End',
    'cameras.labelInventory': 'Inventory Number',
    'cameras.labelInstallLocation': 'Installation Location',
    'cameras.labelNotes': 'Notes',
    'cameras.placeholderBrand': 'Select Brand',
    'cameras.placeholderModel': 'Select Model',
    'cameras.placeholderNvr': 'Select NVR',
    'cameras.placeholderChannelNvr': 'Select NVR First',
    'cameras.placeholderChannel': 'Select Channel',
    'cameras.placeholderCameraName': 'Camera name...',
    'cameras.placeholderIp': 'IP address...',
    'cameras.placeholderInstallLocation': 'e.g.: Main Entrance, Parking Lot',
    'cameras.placeholderAlias': 'Front Door Camera',
    'cameras.placeholderFaultDetails': 'Additional details about the fault...',
    'cameras.cancel': 'Cancel',
    'cameras.save': 'Save',
    'cameras.channelFull': '(Occupied - {camera})',
    'cameras.channelEmpty': '(Empty)',
    'cameras.faultModalTitle': 'Add Fault Record',
    'cameras.faultType': 'Fault Type *',
    'cameras.faultNotes': 'Additional Notes',
    'cameras.faultLastImage': 'Last Screenshot',
    'cameras.faultImageUpload': 'Upload Image',
    'cameras.faultImageRemove': 'Remove Image',
    'cameras.faultImageHint': 'JPG, PNG (Max 5MB)',
    'cameras.faultSubmit': 'Create Fault Record',
    'cameras.faultSubmitting': 'Saving...',
    'cameras.faultDesc1': 'No Image',
    'cameras.faultDesc2': 'Intermittent Image',
    'cameras.faultDesc3': 'Lens Needs Cleaning',
    'cameras.faultDesc4': 'Communication Cable Faulty',
    'cameras.faultDesc5': 'Other',
    'cameras.addBrandModalTitle': 'Add New Brand',
    'cameras.labelBrandName': 'Brand Name *',
    'cameras.addBrandBtn': 'Add',
    'cameras.newBrandTooltip': 'Add New Brand',
    'cameras.close': 'Close',
    'cameras.ipValidError': 'Please enter a valid IP address (e.g.: 192.168.1.100)',
    'cameras.ipFixError': 'Please fix the IP address error!',
    'cameras.ipWarning': '⚠️ This IP address is also used in {nvrs} NVR.',
    'cameras.ipConfirmDuplicate': 'This IP address is also used in {nvrs} NVR. Are you sure you want to save anyway?',
    'cameras.alertFaultCreated': 'Fault record created!',
    'cameras.alertUpdated': 'Camera updated!',
    'cameras.alertAdded': 'Camera added!',
    'cameras.alertDeleted': 'Camera deleted!',
    'cameras.alertError': 'An error occurred!',
    'cameras.alertBrandRequired': 'Brand name is required!',
    'cameras.alertBrandAdded': 'Brand added successfully!',
    'cameras.alertDeleteConfirm': 'Are you sure you want to delete this camera?',
    'cameras.titleEdit': 'Edit',
    'cameras.titleCopy': 'Copy',
    'cameras.titleQr': 'QR Code',
    'cameras.titleFault': 'Add Fault Record',
    'cameras.titleDelete': 'Delete',
    'cameras.titleViewImage': 'View Image',
    'cameras.excelBrand': 'Brand',
    'cameras.excelModel': 'Model',
    'cameras.excelAlias': 'Alias',
    'cameras.excelInventory': 'Inventory No',
    'cameras.excelNvr': 'NVR',
    'cameras.excelChannel': 'Channel',
    'cameras.excelIp': 'IP Address',
    'cameras.excelInstallLocation': 'Installation Location',
    'cameras.excelWarrantyStart': 'Warranty Start',
    'cameras.excelWarrantyEnd': 'Warranty End',
    'cameras.excelNotes': 'Notes',
    'cameras.excelCreatedAt': 'Created At',

    // brandmodel.*
    'brandmodel.title': 'Brand and Model Management',
    'brandmodel.subtitle': 'Manage mobile phone brands and models',
    'brandmodel.tabBrands': 'Brands',
    'brandmodel.tabBrandsShort': 'Brand',
    'brandmodel.tabModels': 'Models',
    'brandmodel.tabModelsShort': 'Model',
    'brandmodel.brandsHeading': 'Brands',
    'brandmodel.newBrand': 'New Brand',
    'brandmodel.colBrandName': 'Brand Name',
    'brandmodel.colDescription': 'Description',
    'brandmodel.colModelCount': 'Model Count',
    'brandmodel.colPhoneCount': 'Phone Count',
    'brandmodel.colActions': 'Actions',
    'brandmodel.modelsHeading': 'Models',
    'brandmodel.newModel': 'New Model',
    'brandmodel.colBrand': 'Brand',
    'brandmodel.colModelName': 'Model Name',
    'brandmodel.editBrandTitle': 'Edit Brand',
    'brandmodel.addBrandTitle': 'Add New Brand',
    'brandmodel.labelBrandName': 'Brand Name *',
    'brandmodel.labelDescription': 'Description',
    'brandmodel.cancel': 'Cancel',
    'brandmodel.update': 'Update',
    'brandmodel.add': 'Add',
    'brandmodel.editModelTitle': 'Edit Model',
    'brandmodel.addModelTitle': 'Add New Model',
    'brandmodel.labelBrand': 'Brand *',
    'brandmodel.placeholderBrand': 'Select Brand',
    'brandmodel.labelModelName': 'Model Name *',
    'brandmodel.errLoadData': 'Could not load data',
    'brandmodel.errBrandRequired': 'Brand name is required',
    'brandmodel.successBrandUpdated': 'Brand updated',
    'brandmodel.successBrandAdded': 'Brand added',
    'brandmodel.errOpFailed': 'Operation failed',
    'brandmodel.errBrandModelRequired': 'Brand and model name are required',
    'brandmodel.successModelUpdated': 'Model updated',
    'brandmodel.successModelAdded': 'Model added',
    'brandmodel.errBrandHasPhones': 'This brand has {count} phone(s). Delete or move phones first.',
    'brandmodel.confirmDeleteBrand': 'Are you sure you want to delete the brand {name}?',
    'brandmodel.successBrandDeleted': 'Brand deleted',
    'brandmodel.errBrandDeleted': 'Brand could not be deleted',
    'brandmodel.errModelHasPhones': 'This model has {count} phone(s). Delete or move phones first.',
    'brandmodel.confirmDeleteModel': 'Are you sure you want to delete the model {brand} {name}?',
    'brandmodel.successModelDeleted': 'Model deleted',
    'brandmodel.errModelDeleted': 'Model could not be deleted',
    'brandmodel.errTitle': 'Error',
    'brandmodel.successTitle': 'Success',
    'brandmodel.colImage': 'Image',
    'brandmodel.labelModelImage': 'Model Image',
    'brandmodel.previewAlt': 'Preview',
    'brandmodel.errImageUpload': 'Image could not be uploaded. Please try again.',
    'brandmodel.errFileTooLarge': 'File size cannot exceed 5 MB',

    // Circuits Page
    'circuits.title': 'Circuit Management',
    'circuits.btnNew': 'New Circuit',
    'circuits.cardFiber': 'Fiber Circuits',
    'circuits.cardRadioLink': 'Radio Link Circuits',
    'circuits.cardAdslVdsl': 'ADSL & VDSL Circuits',
    'circuits.searchPlaceholder': 'Search by circuit name, provider, package or address...',
    'circuits.filterTitle': 'Filters',
    'circuits.filterClearAll': 'Clear All',
    'circuits.filterStatus': 'Status',
    'circuits.filterAll': 'All',
    'circuits.filterInfrastructure': 'Infrastructure',
    'circuits.filterAdslVdslAll': 'ADSL & VDSL (All)',
    'circuits.filterLocation': 'Location',
    'circuits.colSeqNo': 'No',
    'circuits.colCircuitName': 'Circuit Name',
    'circuits.colServiceProvider': 'Service Provider',
    'circuits.colPackage': 'Package',
    'circuits.colSpeed': 'Speed',
    'circuits.colInfrastructure': 'Infrastructure',
    'circuits.colLocation': 'Location',
    'circuits.colStatus': 'Status',
    'circuits.colActions': 'Actions',
    'circuits.emptyState': 'No circuits found',
    'circuits.actionEdit': 'Edit',
    'circuits.actionHistory': 'History',
    'circuits.actionDelete': 'Delete',
    'circuits.actionDownloadContract': 'Download Contract',
    'circuits.actionUploadContract': 'Upload Contract',
    'circuits.paginationPrev': 'Previous',
    'circuits.paginationNext': 'Next',
    'circuits.paginationPage': 'Page {current} / {total}',
    'circuits.paginationInfo': 'Showing {start}-{end} of {total} circuits',
    'circuits.emptyTitle': 'No circuits added yet',
    'circuits.emptyDesc': 'Use the button above to add a new circuit.',
    'circuits.emptyBtn': 'Add First Circuit',
    'circuits.statusActive': 'Active',
    'circuits.statusInactive': 'Inactive',
    'circuits.statusSuspended': 'Suspended',
    'circuits.formTitleNew': 'Add New Circuit',
    'circuits.formTitleEdit': 'Edit Circuit',
    'circuits.labelServiceProvider': 'Service Provider *',
    'circuits.labelPackageName': 'Package Name *',
    'circuits.labelCircuitName': 'Circuit Name *',
    'circuits.labelDownloadSpeed': 'Download Speed (Mbps) *',
    'circuits.labelUploadSpeed': 'Upload Speed (Mbps) *',
    'circuits.labelPrice': 'Price (TL) *',
    'circuits.labelInfrastructure': 'Infrastructure *',
    'circuits.labelAddress': 'Address (10.1.3.4/30 etc.) *',
    'circuits.labelLocation': 'Location *',
    'circuits.placeholderLocation': 'Select Location',
    'circuits.labelStartDate': 'Start Date',
    'circuits.labelEndDate': 'End Date',
    'circuits.labelStatus': 'Status',
    'circuits.labelNotes': 'Notes',
    'circuits.cancel': 'Cancel',
    'circuits.create': 'Create',
    'circuits.update': 'Update',
    'circuits.contractTitle': 'Upload Contract',
    'circuits.contractCircuit': 'Circuit:',
    'circuits.contractProvider': 'Service Provider:',
    'circuits.contractFileLabel': 'Contract File (PDF)',
    'circuits.contractUploading': 'Uploading...',
    'circuits.contractUpload': 'Upload',
    'circuits.historyTitle': 'History - {name}',
    'circuits.historyLoading': 'Loading history...',
    'circuits.historyEmptyTitle': 'No history yet',
    'circuits.historyEmptyDesc': 'No recorded operations for this circuit yet.',
    'circuits.historyActionCreated': 'Created',
    'circuits.historyActionUpdated': 'Updated',
    'circuits.historyActionDeleted': 'Deleted',
    'circuits.historyUser': 'User:',
    'circuits.historyUnknown': 'Unknown',
    'circuits.historyDesc': 'Description:',
    'circuits.historyChanges': 'Changes:',
    'circuits.historyEmpty': 'Empty',
    'circuits.fieldServiceProvider': 'Service Provider',
    'circuits.fieldPackageName': 'Package Name',
    'circuits.fieldCircuitName': 'Circuit Name',
    'circuits.fieldDownloadSpeed': 'Download Speed (Mbps)',
    'circuits.fieldUploadSpeed': 'Upload Speed (Mbps)',
    'circuits.fieldPrice': 'Price (TL)',
    'circuits.fieldInfrastructure': 'Infrastructure',
    'circuits.fieldAddress': 'Address',
    'circuits.fieldLocation': 'Location',
    'circuits.fieldStartDate': 'Start Date',
    'circuits.fieldEndDate': 'End Date',
    'circuits.fieldNotes': 'Notes',
    'circuits.fieldStatus': 'Status',
    'circuits.errLoad': 'Error loading circuits: {msg}',
    'circuits.errSave': 'Error saving circuit: {msg}',
    'circuits.errDelete': 'Error deleting circuit: {msg}',
    'circuits.errContractSelect': 'Please select a file.',
    'circuits.errContractUpload': 'Error uploading contract: {msg}',
    'circuits.errContractDownload': 'Error downloading contract: {msg}',
    'circuits.errHistory': 'Error loading history',
    'circuits.successUpdate': 'Circuit updated successfully!',
    'circuits.successCreate': 'Circuit created successfully!',
    'circuits.successDelete': 'Circuit deleted successfully!',
    'circuits.successContractUpload': 'Contract uploaded successfully!',
    'circuits.notifUpdated': 'Circuit Updated',
    'circuits.notifUpdatedMsg': '{name} circuit updated successfully',
    'circuits.notifCreated': 'Circuit Created',
    'circuits.notifCreatedMsg': '{name} circuit created successfully',
    'circuits.notifDeleted': 'Circuit Deleted',
    'circuits.notifDeletedMsg': '{name} circuit deleted successfully',
    'circuits.confirmDelete': 'Are you sure you want to delete circuit "{name}"?',
    'circuits.notifDeleteErr': 'Delete Error',
    'circuits.notifDeleteErrMsg': 'Error deleting circuit',
    'circuits.excelSuccess': '{count} circuits exported to Excel successfully',
    'circuits.excelError': 'Error creating Excel file',
    'circuits.pdfSuccess': '{count} circuits exported to PDF successfully',
    'circuits.pdfError': 'Error creating PDF file',
    'circuits.excelSheet': 'Circuits',
    'circuits.pdfTitle': 'Circuits List',
    'circuits.pdfReportDate': 'Report Date: {date}',
    'circuits.pdfTotalCircuits': 'Total Circuits: {count}',
    'circuits.pdfSummaryTitle': 'Summary',
    'circuits.pdfActive': 'Active Circuits: {count}',
    'circuits.pdfTotalCost': 'Total Monthly Cost: {amount} TL',
    'circuits.excelSeqNo': 'No',
    'circuits.excelCircuitName': 'Circuit Name',
    'circuits.excelAddress': 'Address',
    'circuits.excelServiceProvider': 'Service Provider',
    'circuits.excelPackage': 'Package',
    'circuits.excelDownloadSpeed': 'Download Speed (Mbps)',
    'circuits.excelUploadSpeed': 'Upload Speed (Mbps)',
    'circuits.excelTotalSpeed': 'Speed (Total)',
    'circuits.excelInfrastructure': 'Infrastructure',
    'circuits.excelLocation': 'Location',
    'circuits.excelStatus': 'Status',
    'circuits.excelPrice': 'Price (TL)',
    'circuits.excelStartDate': 'Start Date',
    'circuits.excelEndDate': 'End Date',
    'circuits.excelNotes': 'Notes',
    'circuits.excelCreatedAt': 'Created At',
    'circuits.pdfColSeq': 'No',
    'circuits.pdfColCircuit': 'Circuit Name',
    'circuits.pdfColProvider': 'Service Provider',
    'circuits.pdfColPackage': 'Package',
    'circuits.pdfColSpeed': 'Speed',
    'circuits.pdfColInfrastructure': 'Infrastructure',
    'circuits.pdfColLocation': 'Location',
    'circuits.pdfColStatus': 'Status',
    'circuits.success': 'Success',
    'circuits.error': 'Error',

    // Assignment Forms Page
    'assignform.title': 'Assignment Forms',
    'assignform.subtitle': 'Manage device assignment forms',
    'assignform.tabMobile': 'Mobile Phone Assignments',
    'assignform.tabComputer': 'Computer Assignments',
    'assignform.tabMonitor': 'Monitor Assignments',
    'assignform.searchPlaceholder': 'Form number, inventory number, user name...',
    'assignform.filterAllStatuses': 'All Statuses',
    'assignform.statusPending': 'Pending',
    'assignform.statusSigned': 'Signed',
    'assignform.statusCompleted': 'Completed',
    'assignform.cardTotal': 'Total Forms',
    'assignform.cardAssignment': 'Assignment Forms (AF)',
    'assignform.cardReturn': 'Return Forms (RF)',
    'assignform.cardUnsigned': 'Unsigned',
    'assignform.sectionAssignment': 'ASSIGNMENT FORMS (AF) - {count} Forms',
    'assignform.sectionReturn': 'RETURN FORMS (RF) - {count} Forms',
    'assignform.colFormInfo': 'Form Info',
    'assignform.colMobile': 'Mobile Phone',
    'assignform.colComputer': 'Computer',
    'assignform.colMonitor': 'Monitor',
    'assignform.colUser': 'Assigned User',
    'assignform.colStatus': 'Status',
    'assignform.colDate': 'Date',
    'assignform.colActions': 'Actions',
    'assignform.createdBy': 'Created by: {name}',
    'assignform.actionDetails': 'View Details',
    'assignform.actionPDF': 'Generate PDF',
    'assignform.actionDownloadSigned': 'Download Wet-Signed Form',
    'assignform.actionSendEmail': 'Send Email ({email})',
    'assignform.actionUploadSigned': 'Upload Wet-Signed Form',
    'assignform.actionReuploadSigned': 'Re-Upload Wet-Signed Form',
    'assignform.actionDelete': 'Delete',
    'assignform.emptyAssignment': 'No assignment forms found',
    'assignform.emptyReturn': 'No return forms found',
    'assignform.emptySearch': 'No forms match your search criteria.',
    'assignform.emptyNoAssignment': 'No assignment forms created yet.',
    'assignform.emptyNoReturn': 'No return forms created yet.',
    'assignform.emptyAll': 'No forms found',
    'assignform.emptyAllSearch': 'No forms match your search criteria.',
    'assignform.emptyAllNone': 'No assignment forms created yet.',
    'assignform.paginationInfo': 'Total {total} forms - Page {page} / {totalPages}',
    'assignform.paginationPrev': 'Previous',
    'assignform.paginationNext': 'Next',
    'assignform.uploadTitle': 'Upload Wet-Signed Form',
    'assignform.reuploadTitle': 'Re-Upload Wet-Signed Form',
    'assignform.uploadWarning': '⚠️ A document is already uploaded for this form. Uploading a new file will automatically delete the old one.',
    'assignform.uploadFormNo': 'Form Number:',
    'assignform.uploadDevice': 'Device:',
    'assignform.uploadPreview': 'Preview',
    'assignform.uploadFileLabel': 'Wet-Signed Form (PDF, JPG, PNG)',
    'assignform.uploadCamera': 'Camera',
    'assignform.uploadChooseFile': 'Choose File',
    'assignform.uploadNotesLabel': 'Notes (Optional)',
    'assignform.uploadNotesPlaceholder': 'Additional notes...',
    'assignform.uploading': 'Uploading...',
    'assignform.detailsTitle': 'Assignment Form Details',
    'assignform.detailsFormInfo': 'Form Information',
    'assignform.detailsFormNumber': 'Form Number',
    'assignform.detailsStatus': 'Status',
    'assignform.detailsAssignmentDate': 'Assignment Date',
    'assignform.detailsCreatedAt': 'Created At',
    'assignform.detailsDeviceInfoMobile': 'Mobile Phone Information',
    'assignform.detailsDeviceInfoComputer': 'Computer Information',
    'assignform.detailsInventoryNo': 'Inventory Number',
    'assignform.detailsBrandModel': 'Brand/Model',
    'assignform.detailsColor': 'Color',
    'assignform.detailsStorage': 'Storage',
    'assignform.detailsSerialNo': 'Serial No',
    'assignform.detailsProcessor': 'Processor',
    'assignform.detailsGraphicsCard': 'Graphics Card',
    'assignform.detailsAssignedUser': 'Assigned User',
    'assignform.detailsFullName': 'Full Name',
    'assignform.detailsEmail': 'Email',
    'assignform.detailsPhone': 'Phone',
    'assignform.detailsDepartment': 'Department',
    'assignform.detailsCreatedBy': 'Form Created By',
    'assignform.detailsNotes': 'Notes',
    'assignform.emailHistory': 'Email Sending History',
    'assignform.emailSend': 'Send Email',
    'assignform.emailSending': 'Sending...',
    'assignform.emailHistoryLoading': 'Loading...',
    'assignform.emailHistoryEmpty': 'No emails sent yet',
    'assignform.emailSent': 'Sent',
    'assignform.emailFailed': 'Failed',
    'assignform.emailSentBy': 'Sent by: {name}',
    'assignform.close': 'Close',
    'assignform.errLoadForms': 'Could not load forms',
    'assignform.errFileProcess': 'Error processing file',
    'assignform.errFileUpload': 'Could not upload file',
    'assignform.errUploadTimeout': 'File upload timed out. Please try a smaller file.',
    'assignform.errDownloadFile': 'Could not download file',
    'assignform.errDownloadEmpty': 'Downloaded file is empty. Please re-upload the file.',
    'assignform.errDownloadGeneral': 'An error occurred while downloading the file',
    'assignform.errDeleteForm': 'Could not delete form',
    'assignform.errNoSignedForm': 'Wet-signed form not yet uploaded',
    'assignform.errSendEmail': 'Could not send email',
    'assignform.successUpload': 'Wet-signed form uploaded',
    'assignform.successDownload': 'File downloaded',
    'assignform.successDelete': 'Assignment form deleted',
    'assignform.confirmDelete': 'Are you sure you want to delete assignment form {formNo}?',
    'assignform.confirmSendEmail': 'Send assignment form ({formNo}) to {name} at {email} by email?',
    'assignform.notifError': 'Error',
    'assignform.notifSuccess': 'Success',

    // ProfilePage
    'profile.title': 'Profile Settings',
    'profile.subtitle': 'Manage your account information and preferences',
    'profile.tabProfile': 'Profile Info',
    'profile.tabSecurity': 'Security',
    'profile.tabNotifications': 'Notifications',
    'profile.tabPreferences': 'Preferences',
    'profile.tabPerformance': 'Performance',
    'profile.fieldName': 'Full Name *',
    'profile.fieldEmail': 'Email *',
    'profile.fieldPhone': 'Phone',
    'profile.fieldTitle': 'Title',
    'profile.fieldDepartment': 'Department',
    'profile.fieldLocation': 'Location *',
    'profile.selectLocation': 'Select location',
    'profile.fieldBirthDate': 'Birth Date',
    'profile.fieldEmergencyContact': 'Emergency Contact',
    'profile.fieldEmergencyPhone': 'Emergency Phone',
    'profile.fieldAddress': 'Address',
    'profile.save': 'Save',
    'profile.passwordChange': 'Change Password',
    'profile.fieldCurrentPassword': 'Current Password *',
    'profile.fieldNewPassword': 'New Password *',
    'profile.fieldConfirmPassword': 'Confirm New Password *',
    'profile.generatePassword': 'Generate',
    'profile.passwordRequirements': 'Password Requirements:',
    'profile.pwdReq1': 'At least 8 characters',
    'profile.pwdReq2': 'At least 1 uppercase letter',
    'profile.pwdReq3': 'At least 1 lowercase letter',
    'profile.pwdReq4': 'At least 1 digit',
    'profile.pwdReq5': 'At least 1 special character (!@#$%^&*)',
    'profile.changePassword': 'Change Password',
    'profile.notifTitle': 'Notification Settings',
    'profile.emailNotif': 'Email Notifications',
    'profile.emailNotifDesc': 'System updates and important notifications',
    'profile.prefsTitle': 'Application Preferences',
    'profile.fieldLanguage': 'Language',
    'profile.fieldTimezone': 'Timezone',
    'profile.fieldTheme': 'Theme',
    'profile.themeLight': 'Light',
    'profile.themeDark': 'Dark',
    'profile.themeAuto': 'Auto',
    'profile.fieldItemsPerPage': 'Items Per Page',
    'profile.sidebarAutoHide': 'Auto-hide Sidebar',
    'profile.sidebarAutoHideDesc': 'Keep sidebar closed by default',
    'profile.performanceTitle': 'Checklist Performance',
    'profile.rankLabel': 'Your Rank',
    'profile.rankAmong': '/ among {count} admins',
    'profile.today': 'Today',
    'profile.thisWeek': 'This Week',
    'profile.thisMonth': 'This Month',
    'profile.total': 'Total',
    'profile.points': 'points',
    'profile.pointSystem': 'Points System',
    'profile.pointSystemDesc': 'You earn +1 point for each completed checklist task. Points accumulate daily and rankings update in real-time. You can track other admins\' activities on the checklist page.',
    'profile.loadingPoints': 'Loading points data...',
    'profile.successProfile': 'Profile updated successfully',
    'profile.errLoad': 'Error loading data',
    'profile.errProfileSave': 'Error updating profile',
    'profile.errPasswordMismatch': 'New passwords do not match!',
    'profile.errPasswordLength': 'Password must be at least 8 characters!',
    'profile.successPassword': 'Password changed successfully',
    'profile.errPasswordChange': 'Error changing password',
    'profile.successAvatar': 'Profile photo updated successfully',
    'profile.errAvatar': 'Error uploading profile photo',

    // NotificationSettings
    'notifSettings.title': 'Notification Settings',
    'notifSettings.subtitle': 'Manage your notification preferences',
    'notifSettings.typesTitle': 'Notification Types',
    'notifSettings.emailNotif': 'Email Notifications',
    'notifSettings.emailNotifDesc': 'Important updates sent via email',
    'notifSettings.pushNotif': 'Push Notifications',
    'notifSettings.pushNotifDesc': 'Instant notifications to your mobile device',
    'notifSettings.desktopNotif': 'Desktop Notifications',
    'notifSettings.desktopNotifDesc': 'Browser notifications (requires permission)',
    'notifSettings.smsNotif': 'SMS Notifications',
    'notifSettings.smsNotifDesc': 'SMS for critical alerts',
    'notifSettings.categoriesTitle': 'Notification Categories',
    'notifSettings.catOrders': 'Orders',
    'notifSettings.catOrdersDesc': 'Order creation, approval, and delivery notifications',
    'notifSettings.catServices': 'Technical Service',
    'notifSettings.catServicesDesc': 'Service records, status updates, and completion notifications',
    'notifSettings.catCapex': 'CAPEX',
    'notifSettings.catCapexDesc': 'Budget alerts and expense notifications',
    'notifSettings.catSystem': 'System',
    'notifSettings.catSystemDesc': 'Server performance and system status alerts',
    'notifSettings.catBackup': 'Backup',
    'notifSettings.catBackupDesc': 'Backup success/failure notifications',
    'notifSettings.catSecurity': 'Security',
    'notifSettings.catSecurityDesc': 'Security alerts and login notifications',
    'notifSettings.quietHoursTitle': 'Quiet Hours',
    'notifSettings.quietHoursDesc': 'Do not receive notifications during specified hours',
    'notifSettings.quietStart': 'Start Time',
    'notifSettings.quietEnd': 'End Time',
    'notifSettings.digestTitle': 'Digest Notifications',
    'notifSettings.digestDesc': 'Receive a summary of notifications at set intervals',
    'notifSettings.digestFrequency': 'Digest Frequency',
    'notifSettings.digestNever': 'Never',
    'notifSettings.digestDaily': 'Daily',
    'notifSettings.digestWeekly': 'Weekly',
    'notifSettings.digestMonthly': 'Monthly',
    'notifSettings.saveBtn': 'Save Settings',

    // MenuManagementPage
    'menuMgmt.title': 'Menu Management',
    'menuMgmt.subtitle': 'Manage sidebar menus dynamically',
    'menuMgmt.backup': 'Backup',
    'menuMgmt.newMenu': 'New Menu',
    'menuMgmt.passive': 'Inactive',
    'menuMgmt.formEditTitle': 'Edit Menu',
    'menuMgmt.formNewTitle': 'Add New Menu',
    'menuMgmt.fieldNameTR': 'Menu Name (TR) *',
    'menuMgmt.fieldNameEN': 'Menu Name (EN)',
    'menuMgmt.fieldIcon': 'Icon',
    'menuMgmt.selectIcon': 'Select Icon',
    'menuMgmt.fieldParent': 'Parent Menu',
    'menuMgmt.mainMenu': 'Main Menu',
    'menuMgmt.fieldOrder': 'Order',
    'menuMgmt.fieldRoles': 'Roles',
    'menuMgmt.fieldActive': 'Active',
    'menuMgmt.save': 'Save',
    'menuMgmt.cancel': 'Cancel',
    'menuMgmt.successCreated': 'New menu added successfully',
    'menuMgmt.successUpdated': 'Menu updated successfully',
    'menuMgmt.errOperation': 'Operation failed',
    'menuMgmt.confirmDelete': 'Are you sure you want to delete this menu item?',
    'menuMgmt.successDeleted': 'Menu item deleted successfully',
    'menuMgmt.errDelete': 'Delete operation failed',
    'menuMgmt.successBackup': 'Menu structure downloaded successfully.',
    'menuMgmt.errBackup': 'An error occurred while backing up the menu.',
    'menuMgmt.successReorder': 'Menu order updated',
    'menuMgmt.bulkRoleUpdate': 'Roles updated for {count} menu items',
    'menuMgmt.errBulkRole': 'Bulk role update failed',

    // UsersPage
    'users.title': 'User Management',
    'users.subtitle': 'Manage system users and role permissions',
    'users.newUser': 'New User',
    'users.tabUsers': 'Users',
    'users.tabPermissions': 'Role Access Permissions',
    'users.statTotal': 'Total',
    'users.statActive': 'Active',
    'users.statOnline': 'Online',
    'users.statAdmin': 'Admin',
    'users.searchPlaceholder': 'Search users...',
    'users.filterAllRoles': 'All Roles',
    'users.filterAllStatuses': 'All Statuses',
    'users.filterAllLocations': 'All Locations',
    'users.filterActive': 'Active',
    'users.filterInactive': 'Inactive',
    'users.colUser': 'User',
    'users.colContact': 'Contact',
    'users.colRole': 'Role',
    'users.colLocation': 'Location',
    'users.colStatus': 'Status',
    'users.colLastLogin': 'Last Login',
    'users.colActions': 'Actions',
    'users.notFound': 'No users found',
    'users.notFoundDesc': 'Try changing your search criteria',
    'users.statusActive': 'Active',
    'users.statusInactive': 'Inactive',
    'users.unassigned': 'Unassigned',
    'users.never': 'Never',
    'users.lastLogin': 'Last login: {date}',
    'users.paginationInfo': 'Showing {start}-{end} of {total} users',
    'users.permissionsTitle': 'Role Access Permissions',
    'users.permissionsDesc': 'Set menu and operation permissions for each role',
    'users.permColMenu': 'Menu / Submenu',
    'users.permLegend': 'V: View, A: Add, E: Edit, D: Delete',
    'users.permEachBox': 'Each checkbox represents the corresponding permission',
    'users.savePermissions': 'Save Changes',
    'users.modalEditTitle': 'Edit User',
    'users.modalNewTitle': 'New User',
    'users.modalEditSubtitle': 'Update user information',
    'users.modalNewSubtitle': 'Enter new user information',
    'users.sectionBasic': 'Basic Information',
    'users.sectionPersonal': 'Personal Information',
    'users.sectionSecurity': 'Security',
    'users.sectionNotes': 'Notes',
    'users.fieldName': 'Full Name',
    'users.fieldEmail': 'Email',
    'users.fieldPhone': 'Phone',
    'users.fieldTitle': 'Title',
    'users.fieldDepartment': 'Department',
    'users.selectDepartment': 'Select Department',
    'users.fieldLocation': 'Location',
    'users.selectLocation': 'Select location',
    'users.fieldAuthorizedLocations': 'Authorized Locations',
    'users.selectedLocations': 'Selected locations: {names}',
    'users.fieldCompany': 'Company',
    'users.selectCompany': 'Select company (Optional)',
    'users.fieldRole': 'Role',
    'users.fieldBirthDate': 'Birth Date',
    'users.fieldHireDate': 'Hire Date',
    'users.optionalDate': '(Optional)',
    'users.fieldEmergencyContact': 'Emergency Contact',
    'users.fieldEmergencyPhone': 'Emergency Phone',
    'users.fieldAddress': 'Address',
    'users.fieldPassword': 'Password',
    'users.fieldNotes': 'User Notes',
    'users.generatePassword': 'Generate',
    'users.cancel': 'Cancel',
    'users.update': 'Update',
    'users.save': 'Save',
    'users.detailContactTitle': 'Contact Information',
    'users.detailWorkTitle': 'Work Information',
    'users.detailPersonalTitle': 'Personal Information',
    'users.detailAddressTitle': 'Address',
    'users.detailNotesTitle': 'Notes',
    'users.detailSystemTitle': 'System Information',
    'users.detailDepartment': 'Department:',
    'users.detailHireDate': 'Hire Date:',
    'users.detailStatus': 'Status:',
    'users.detailBirthDate': 'Birth Date:',
    'users.detailEmergencyContact': 'Emergency Contact:',
    'users.detailEmergencyPhone': 'Emergency Phone:',
    'users.detailCreatedAt': 'Created At:',
    'users.detailUpdatedAt': 'Last Updated:',
    'users.detailLastLogin': 'Last Login:',
    'users.detailEmailVerified': 'Email Verified:',
    'users.detailYes': 'Yes',
    'users.detailNo': 'No',
    'users.addDeptTitle': 'Add New Department',
    'users.deptNameLabel': 'Department Name',
    'users.addDept': 'Add',
    'users.detailBtn': 'Detail',
    'users.editBtn': 'Edit',
    'users.passwordBtn': 'Password',
    'users.labelBtn': 'Label',
    'users.deleteBtn': 'Delete',
    'users.errLoad': 'Error loading data',
    'users.errRequiredFields': 'Full name and email are required',
    'users.errInvalidEmail': 'Please enter a valid email address',
    'users.errNoLocation': 'Please select a location',
    'users.errNoCompany': 'Please select a company',
    'users.errSave': 'Error saving user',
    'users.errCannotDeleteSelf': 'You cannot delete your own account',
    'users.errDelete': 'Error deleting user',
    'users.errStatusChange': 'Error changing user status',
    'users.errPasswordReset': 'Error resetting password',
    'users.errPermSave': 'Error saving role permissions',
    'users.errDeptEmpty': 'Department name cannot be empty',
    'users.errDeptExists': 'This department already exists',
    'users.errDeptAdd': 'Error adding department',
    'users.errEmailSend': 'Error sending email',
    'users.successDeptAdded': 'Department added',
    'users.successPermSaved': 'Role permissions saved',
    'users.emailSent': 'Email Sent',
    'users.confirmExport': 'Are you sure you want to download the user list as an Excel file?',
    'users.exportSuccess': '{count} users exported successfully',
    'users.errExport': 'Error exporting users',

    // Users - Assigned Assets
    'users.detailAssetsTitle': 'Assigned Assets',
    'users.detailAssetsPrintBtn': 'Print Asset List',
    'users.detailAssetsItemCount': '{count} items',
    'users.printAssetsTitle': 'User Asset List',
    'users.printAssetsPrintedBy': 'Printed by',
    'users.printAssetsUser': 'Full Name',
    'users.printAssetsDepartment': 'Department',
    'users.printAssetsTitleField': 'Title',
    'users.printAssetsLocation': 'Location',
    'users.printAssetsColSerial': 'Serial No / IMEI',
    'users.printAssetsColDetail': 'Details',
    'users.printAssetsTotal': 'Total {count} items',
    'users.printAssetsPrintBtn': 'Print / Save PDF',
    'users.detailAssetsLoading': 'Loading...',
    'users.detailAssetsEmpty': 'No assets assigned to this user.',
    'users.detailAssetsGsm': 'GSM Lines',
    'users.detailAssetsComputers': 'Computers',
    'users.detailAssetsMobilePhones': 'Mobile Phones',
    'users.detailAssetsMonitors': 'Monitors',
    'users.detailAssetsEquipment': 'Equipment',
    'users.detailAssetsForms': 'Assignment Forms',
    'users.detailAssetsColLineNo': 'Line No',
    'users.detailAssetsColTariff': 'Tariff',
    'users.detailAssetsColOperator': 'Operator',
    'users.detailAssetsColStatus': 'Status',
    'users.detailAssetsColInventory': 'Inventory No',
    'users.detailAssetsColBrandModel': 'Brand / Model',
    'users.detailAssetsColSerial': 'Serial No',
    'users.detailAssetsColLocation': 'Location',
    'users.detailAssetsColImei': 'IMEI',
    'users.detailAssetsColCategory': 'Category',
    'users.detailAssetsColQty': 'Qty',
    'users.detailAssetsColAssignDate': 'Assignment Date',
    'users.detailAssetsColFormNo': 'Form No',
    'users.detailAssetsColType': 'Type',
    'users.detailAssetsColDevice': 'Device',
    'users.detailAssetsColDate': 'Date',
    'users.detailAssetsColDeliveredBy': 'Delivered By',
    'users.detailAssetsFormAssignment': 'Assignment',
    'users.detailAssetsFormReturn': 'Return',
    'users.detailAssetsReturnBtn': 'Return All Assets',

    // Users - Asset Return Modal
    'users.returnModalTitle': 'Asset Return',
    'users.returnModalWarning': 'All assets below will be removed from the user and a Return Form will be created.',
    'users.returnModalNotesLabel': 'Notes (optional)',
    'users.returnModalNotesPh': 'Reason for leaving, delivery notes, etc.',
    'users.returnModalCancelBtn': 'Cancel',
    'users.returnModalConfirmBtn': 'Return All Assets & Create Form',
    'users.returnModalLoadingBtn': 'Processing...',
    'users.returnModalSuccessMsg': 'All assets returned successfully.',
    'users.returnModalFormLabel': 'Return Form:',
    'users.returnModalCloseBtn': 'Close',
    'users.returnModalViewFormBtn': 'View Form',

    // CabinetsPage
    'cabinet.title': 'Cabinet Management',
    'cabinet.subtitle': 'IT cabinets, switch layout and cleaning tracking',
    'cabinet.newCabinet': 'New Cabinet',
    'cabinet.search': 'Search cabinets...',
    'cabinet.statTotal': 'Total Cabinets',
    'cabinet.statSwitches': 'Total Switches',
    'cabinet.statCleanedThisMonth': 'Cleaned This Month',
    'cabinet.statNeedsCleaning': 'Needs Cleaning',
    'cabinet.colName': 'Cabinet Name',
    'cabinet.colCompany': 'Company',
    'cabinet.colLocation': 'Location',
    'cabinet.colSwitchCount': 'Switch Count',
    'cabinet.colDescription': 'Description',
    'cabinet.colLastCleaning': 'Last Cleaning',
    'cabinet.colActions': 'Actions',
    'cabinet.notSpecified': 'Not specified',
    'cabinet.notFound': 'Cabinet Not Found',
    'cabinet.notFoundSearch': 'No cabinets found matching your search.',
    'cabinet.notFoundEmpty': 'No cabinets added yet.',
    'cabinet.noRecord': 'No records',
    'cabinet.firstCleaning': 'First cleaning not done',
    'cabinet.actionView': 'View',
    'cabinet.actionEdit': 'Edit',
    'cabinet.actionCopy': 'Copy',
    'cabinet.actionLabel': 'Label',
    'cabinet.actionDelete': 'Delete',
    'cabinet.newCleaning': 'Cleaning Record',
    'cabinet.addTitle': 'Add New Cabinet',
    'cabinet.editTitle': 'Edit Cabinet',
    'cabinet.fieldName': 'Cabinet Name *',
    'cabinet.fieldNamePlaceholder': 'Cabinet-A1',
    'cabinet.fieldCompany': 'Company',
    'cabinet.fieldLocation': 'Location',
    'cabinet.fieldLastCleaning': 'Last Cleaning Date',
    'cabinet.fieldDescription': 'Description',
    'cabinet.fieldDescPlaceholder': 'Details about the cabinet...',
    'cabinet.fieldPhoto': 'Photo',
    'cabinet.selectCompany': 'Select company',
    'cabinet.selectLocation': 'Select location',
    'cabinet.btnSave': 'Save',
    'cabinet.btnUpdate': 'Update',
    'cabinet.btnCancel': 'Cancel',
    'cabinet.successCreatedTitle': 'Success',
    'cabinet.successCreatedMsg': 'Cabinet added successfully',
    'cabinet.successUpdatedTitle': 'Success',
    'cabinet.successUpdatedMsg': 'Cabinet updated successfully',
    'cabinet.successDeletedTitle': 'Success',
    'cabinet.successDeletedMsg': 'Cabinet deleted successfully',
    'cabinet.successCleaningTitle': 'Success',
    'cabinet.successCleaningMsg': 'Cleaning record added',
    'cabinet.errTitle': 'Error',
    'cabinet.errLoadData': 'Error loading data',
    'cabinet.errLoadDetail': 'Error loading cabinet details',
    'cabinet.errSave': 'Error saving cabinet',
    'cabinet.errDelete': 'Error deleting cabinet',
    'cabinet.errCleaning': 'Error adding cleaning record',
    'cabinet.errNameRequired': 'Cabinet name is required',
    'cabinet.errNoPermission': 'You do not have permission for this action',
    'cabinet.errPrint': 'Error printing label',
    'cabinet.confirmDelete': 'Are you sure you want to delete this cabinet?',
    'cabinet.detailTitle': 'Cabinet Details',
    'cabinet.detailInfo': 'Cabinet Information',
    'cabinet.detailCompany': 'Company:',
    'cabinet.detailLocation': 'Location:',
    'cabinet.detailLastCleaning': 'Last Cleaning:',
    'cabinet.detailPhoto': 'Photo',
    'cabinet.detailHistory': 'History',
    'cabinet.switchesInCabinet': 'Switches in Cabinet',
    'cabinet.moreSwitches': '+ {count} more switches...',
    'cabinet.unknownCabinet': 'Unknown Cabinet',
    'cabinet.infoCopied': 'Cabinet info copied',
    'cabinet.infoTitle': 'Info',
    'cabinet.cleaningModalTitle': 'Add Cleaning Record',
    'cabinet.cleaningDate': 'Cleaning Date *',
    'cabinet.cleaningNotes': 'Notes',
    'cabinet.cleaningNotesPlaceholder': 'Notes about the cleaning...',
    'cabinet.labelModalTitle': 'Cabinet Label',
    'cabinet.labelOrientation': 'Orientation',
    'cabinet.labelHorizontal': 'Horizontal',
    'cabinet.labelVertical': 'Vertical',
    'cabinet.labelIncludeSwitches': 'Include switch list',
    'cabinet.labelWillPrint': 'Will print',
    'cabinet.statusActive': 'Active',
    'cabinet.statusInactive': 'Inactive',
    'cabinet.statusMaintenance': 'Maintenance',
    'cabinet.statusFaulty': 'Faulty',

    // PrintersPage
    'printer.title': 'Printer Management',
    'printer.loading': 'Loading...',
    'printer.btnNewPrinter': 'Add New Printer',
    'printer.btnNew': 'New Printer',
    'printer.btnImport': 'Bulk Import',
    'printer.btnImportShort': 'Import',
    'printer.btnBulkLabel': 'Print Bulk Labels',
    'printer.btnLabel': 'Print Labels',
    'printer.btnExcel': 'Export to Excel',
    'printer.btnExcelShort': 'Excel',
    'printer.tabPrinters': 'Printers',
    'printer.tabBrands': 'Brands',
    'printer.tabModels': 'Models',
    'printer.tabDrivers': 'Drivers',
    'printer.statTotal': 'Total Printers',
    'printer.statOffice': 'Office Printers',
    'printer.statIndustrial': 'Industrial Printers',
    'printer.searchPlaceholder': 'Printer name, brand, model, IP, serial no...',
    'printer.filters': 'Filters',
    'printer.clearFilters': 'Clear Filters',
    'printer.filterAll': 'All',
    'printer.filterCompany': 'Company',
    'printer.filterNoCompany': 'No Company',
    'printer.filterBrand': 'Brand',
    'printer.filterIp': 'IP Address',
    'printer.filterIpPlaceholder': 'Search IP...',
    'printer.filterSerial': 'Serial Number',
    'printer.filterSerialPlaceholder': 'Search serial no...',
    'printer.filterLocation': 'Location',
    'printer.filterCategory': 'Category',
    'printer.filterStatus': 'Status',
    'printer.catOffice': 'Office',
    'printer.catIndustrial': 'Industrial',
    'printer.catMobile': 'Mobile',
    'printer.colName': 'Name',
    'printer.colCompany': 'Company',
    'printer.colBrandModel': 'Brand / Model',
    'printer.colType': 'Type',
    'printer.colCategory': 'Category',
    'printer.colIp': 'IP Address',
    'printer.colMac': 'MAC Address',
    'printer.colSerial': 'Serial No',
    'printer.colLocation': 'Location',
    'printer.colDepartment': 'Department',
    'printer.colCounters': 'Counters',
    'printer.colStatus': 'Status',
    'printer.colActions': 'Actions',
    'printer.mobileCompany': 'Company',
    'printer.mobileType': 'Type',
    'printer.noData': 'No data',
    'printer.statusActive': 'Active',
    'printer.statusPassive': 'Passive',
    'printer.statusContractExpired': 'Contract Expired',
    'printer.statusFaulty': 'Faulty',
    'printer.actionEdit': 'Edit',
    'printer.actionCopy': 'Copy',
    'printer.actionCounter': 'Enter Counter',
    'printer.actionHistory': 'History',
    'printer.actionToner': 'Install Toner',
    'printer.actionQR': 'QR Code',
    'printer.actionContract': 'Contract',
    'printer.actionDelete': 'Delete',

    // MobilePhonesPage
    'mobilePhones.title': 'Mobile Phones',
    'mobilePhones.subtitle': 'Inventory, assignment and contract management',
    'mobilePhones.loading': 'Loading...',
    'mobilePhones.btnNewPhone': 'Add New Mobile Phone',
    'mobilePhones.btnBulkImport': 'Bulk Import',
    'mobilePhones.btnImport': 'Import',
    'mobilePhones.btnBulkLabel': 'Print Bulk Labels',
    'mobilePhones.btnLabel': 'Print Labels',
    'mobilePhones.searchPlaceholder': 'Inventory no, brand, model, IMEI, GSM no...',
    'mobilePhones.statTotal': 'Total',
    'mobilePhones.statActive': 'Active',
    'mobilePhones.statAssigned': 'Assigned',
    'mobilePhones.statUnassigned': 'Unassigned',
    'mobilePhones.statContractExpiring': 'Contract Expiring',
    'mobilePhones.filterAllLocations': 'All Locations',
    'mobilePhones.filterAllModels': 'All Models',
    'mobilePhones.filterAllStatuses': 'All Statuses',
    'mobilePhones.filterAllAssignments': 'All Assignments',
    'mobilePhones.filterContractStatus': 'Contract Status',
    'mobilePhones.filterExpired': 'Expired',
    'mobilePhones.filterExpires3Months': 'Expires in 3 Months',
    'mobilePhones.filterExpiresMonth': 'Expires in 1 Month',
    'mobilePhones.filterExpiresToday': 'Expires Today',
    'mobilePhones.filterExpiresWeek': 'Expires in 1 Week',
    'mobilePhones.filterNoContract': 'No Contract',
    'mobilePhones.colInventoryNo': 'Inventory No',
    'mobilePhones.colBrand': 'Brand',
    'mobilePhones.colModel': 'Model',
    'mobilePhones.colColor': 'Color',
    'mobilePhones.colStorage': 'Storage',
    'mobilePhones.colGsmNo': 'GSM No',
    'mobilePhones.colSerialNo': 'Serial No',
    'mobilePhones.colSubscriptionNo': 'Subscription No',
    'mobilePhones.subscriptionNumber': 'Subscription No (Contract No)',
    'mobilePhones.errRecordNotFound': 'Record not found. It may have been deleted.',
    // Archive
    'mobilePhones.archive.viewArchive': 'Archive ({count})',
    'mobilePhones.archive.backToActive': 'Active Phones',
    'mobilePhones.archive.archive': 'Archive',
    'mobilePhones.archive.restore': 'Restore from Archive',
    'mobilePhones.archive.bannerTitle': 'Archived phones ({count})',
    'mobilePhones.archive.bannerText': 'Archived phones are hidden from the main list, counts and assignment screens; their change and assignment history is kept. You can restore them at any time.',
    'mobilePhones.archive.selected': '{count} phones selected',
    'mobilePhones.archive.selectAllFiltered': 'Select all {count} filtered phones',
    'mobilePhones.archive.clearSelection': 'Clear selection',
    'mobilePhones.archive.selectPage': 'Select this page',
    'mobilePhones.archive.archiveSelected': 'Archive Selected ({count})',
    'mobilePhones.archive.restoreSelected': 'Restore Selected ({count})',
    'mobilePhones.archive.colArchiveInfo': 'Archived',
    'mobilePhones.archive.colReason': 'Archive Reason',
    'mobilePhones.archive.empty': 'No archived phones.',
    'mobilePhones.archive.noResults': 'No phones match the criteria.',
    'mobilePhones.archive.dialogArchiveTitle': 'Archive {count} phones',
    'mobilePhones.archive.dialogRestoreTitle': 'Restore {count} phones',
    'mobilePhones.archive.dialogArchiveText': 'These phones will be removed from the list; their history will not be deleted. You can restore them from the archive view at any time.',
    'mobilePhones.archive.dialogRestoreText': 'These phones will return to the active list with status "Available". Assignments are not restored automatically.',
    'mobilePhones.archive.warnAssigned': '{count} phones are assigned. Archiving will unassign them and record it in the assignment log.',
    'mobilePhones.archive.infoGsm': 'The GSM numbers of {count} phones will be moved to the archive record so the same line can be assigned to a new phone.',
    'mobilePhones.archive.reasonLabel': 'Archive reason (optional)',
    'mobilePhones.archive.reasonPlaceholder': 'e.g. Rental period ended, returned to vendor',
    'mobilePhones.archive.confirmArchive': 'Archive {count} Phones',
    'mobilePhones.archive.confirmRestore': 'Restore {count} Phones',
    'mobilePhones.archive.successArchived': '{count} phones archived.',
    'mobilePhones.archive.successUnassigned': '{count} phones were unassigned.',
    'mobilePhones.archive.successRestored': '{count} phones restored from archive.',
    'mobilePhones.archive.gsmConflict': 'GSM numbers of these phones were not restored because they are used by another phone: {list}',
    'mobilePhones.archive.errGeneric': 'An error occurred during the archive operation.',
    'mobilePhones.archive.gsmQuestion': 'What should happen to the GSM numbers of {count} phones?',
    'mobilePhones.archive.gsmKeep': 'Keep the GSM number on the phone',
    'mobilePhones.archive.gsmKeepHint': 'The number stays on the archived phone. If it is later entered on a new phone, you will be asked to transfer it.',
    'mobilePhones.archive.gsmRelease': 'Remove the GSM number from the phone',
    'mobilePhones.archive.gsmReleaseHint': 'The number is removed from the phone (kept in the archive record) and can be assigned to a new phone right away. Recorded in the GSM line history and notifications.',
    'mobilePhones.archive.gsmRemovedShort': 'removed from phone',
    'mobilePhones.archive.successGsmReleased': 'GSM numbers of {count} phones were removed.',
    'mobilePhones.archive.gsmTransferConfirm': '{gsm} is registered on the archived phone {device}.\n\nRemove the number from the archived phone and transfer it to this phone? This is recorded in the GSM line history and notifications.',
    'mobilePhones.archive.gsmOnArchivedHint': 'This number is registered on the archived phone {device}. You will be asked to transfer it when saving.',
    // Bildirim değişiklik detayları
    'notif.mobile.create.title': 'New Mobile Phone Added',
    'notif.mobile.update.title': 'Mobile Phone Updated',
    'notif.mobile.delete.title': 'Mobile Phone Deleted',
    'notif.mobile.create.message': '{device} ({inventory}) was added to the system',
    'notif.mobile.update.message': '{device} ({inventory}) was updated',
    'notif.mobile.delete.message': '{device} ({inventory}) was deleted',
    'notif.mobile.archive.title': 'Mobile Phones Archived',
    'notif.mobile.archive.message': '{count} mobile phones archived',
    'notif.mobile.unarchive.title': 'Mobile Phones Restored',
    'notif.mobile.unarchive.message': '{count} mobile phones restored from archive',
    'notif.change.reason': 'Reason',
    'notif.change.unassigned': '{count} phones were unassigned',
    'notif.change.gsmReleased': 'GSM numbers of {count} phones were removed',
    'notif.gsm.deviceChange.title': 'GSM Line Device Change',
    'notif.gsm.deviceChange.message': 'The phone of line {number} changed',
    'notif.gsm.phone': 'Phone',
    'notif.gsm.removed': 'Removed from phone',
    'notif.change.updated': 'updated',
    'notif.change.more': '+{count} more changes',
    'notif.change.open': 'Open record',
    'notif.change.field.inventory_number': 'Inventory No',
    'notif.change.field.brand': 'Brand',
    'notif.change.field.model': 'Model',
    'notif.change.field.color': 'Color',
    'notif.change.field.storage': 'Storage',
    'notif.change.field.imei1': 'IMEI 1',
    'notif.change.field.imei2': 'IMEI 2',
    'notif.change.field.serial_number': 'Serial No',
    'notif.change.field.subscription_number': 'Subscription No',
    'notif.change.field.gsm_number': 'GSM No',
    'notif.change.field.status': 'Status',
    'notif.change.field.assigned_user_id': 'Assigned User',
    'notif.change.field.location_id': 'Location',
    'notif.change.field.company_id': 'Company',
    'notif.change.field.supplier_id': 'Supplier',
    'notif.change.field.ownership': 'Ownership',
    'notif.change.field.creation_date': 'Creation Date',
    'notif.change.field.agreement_year': 'Agreement Year',
    'notif.change.field.currency': 'Currency',
    'notif.change.field.exchange_rate': 'Exchange Rate',
    'notif.change.field.contract_start_date': 'Contract Start',
    'notif.change.field.contract_end_date': 'Contract End',
    'notif.change.field.contract_price': 'Contract Price',
    'notif.change.field.monthly_payment': 'Monthly Payment',
    'notif.change.field.notes': 'Notes',
    'notif.change.status.active': 'Active',
    'notif.change.status.inactive': 'Inactive',
    'notif.change.status.available': 'Available',
    'notif.change.status.assigned': 'Assigned',
    'notif.change.status.reserved': 'Reserved',
    'notif.change.status.maintenance': 'In Maintenance',
    'notif.change.status.lost': 'Lost',
    'notif.change.status.stolen': 'Stolen',
    'notif.change.status.damaged': 'Damaged',
    'notif.change.ownership.company': 'Company',
    'notif.change.ownership.rental': 'Rental',
    'notif.change.ownership.employee': 'Employee',
    'mobilePhones.colLocation': 'Location',
    'mobilePhones.colCompany': 'Company',
    'mobilePhones.colSupplier': 'Supplier',
    'mobilePhones.colAssignedUser': 'Assigned User',
    'mobilePhones.colContractStart': 'Contract Start',
    'mobilePhones.colContractEnd': 'Contract End',
    'mobilePhones.colContractPrice': 'Contract Price',
    'mobilePhones.colMonthlyPayment': 'Monthly Payment',
    'mobilePhones.colStatus': 'Status',
    'mobilePhones.colNotes': 'Notes',
    'mobilePhones.colCreatedAt': 'Created At',
    'mobilePhones.colActions': 'Actions',
    'mobilePhones.colDeviceInfo': 'Device Info',
    'mobilePhones.colLocationCompany': 'Location / Company',
    'mobilePhones.sectionDeviceInfo': 'Device Information',
    'mobilePhones.modalNewTitle': 'New Mobile Phone',
    'mobilePhones.modalEditTitle': 'Edit Mobile Phone',
    'mobilePhones.labelInventoryNo': 'Inventory No *',
    'mobilePhones.labelBrand': 'Brand',
    'mobilePhones.labelCreationDate': 'Record Date',
    'mobilePhones.labelCurrency': 'Currency',
    'mobilePhones.labelExchangeRate': 'Exchange Rate',
    'mobilePhones.labelAgreementYear': 'Agreement Year',
    'mobilePhones.currencyTRY': 'TRY',
    'mobilePhones.currencyUSD': 'USD',
    'mobilePhones.currencyGBP': 'GBP',
    'mobilePhones.optSelect': 'Select',
    'mobilePhones.available': 'Available',
    'mobilePhones.inventoryInUse': 'This inventory number is already in use',
    'mobilePhones.statusActive': 'Active',
    'mobilePhones.statusInactive': 'Inactive',
    'mobilePhones.statusLost': 'Lost',
    'mobilePhones.statusDamaged': 'Damaged',
    'mobilePhones.statusAssigned': 'Assigned',
    'mobilePhones.statusAvailable': 'Available',
    'mobilePhones.statusReserved': 'Reserved',
    'mobilePhones.year': 'year',
    'mobilePhones.titleDelete': 'Delete Phone',
    'mobilePhones.titleEdit': 'Edit',
    'mobilePhones.titleHistory': 'History',
    'mobilePhones.titlePrintLabel': 'Print Label',
    'mobilePhones.titleQuickAssign': 'Quick Assign',
    'mobilePhones.titleQuickCopy': 'Quick Copy',
    'mobilePhones.titleUnassign': 'Remove Assignment',
    'mobilePhones.titleContractExpiredNoAssign': 'Contract Expired',
    'mobilePhones.assignedToUser': 'Assigned to User',
    'mobilePhones.unassignedSuccess': 'Assignment Removed',
    'mobilePhones.phoneAdded': 'Phone added',
    'mobilePhones.phoneUpdated': 'Phone updated',
    'mobilePhones.phoneDeleted': 'Phone deleted',
    'mobilePhones.phoneCopied': 'Phone copied',
    'mobilePhones.phoneAssigned': 'Phone assigned',
    'mobilePhones.phoneAssignedWithForm': 'Phone assigned and form created',
    'mobilePhones.exportedToExcel': 'Exported to Excel',
    'mobilePhones.importedSuccessfully': 'Successfully imported',
    'mobilePhones.importFailedRows': 'failed rows',
    'mobilePhones.importSummary': '{created} records added, {updated} records updated',
    'mobilePhones.importCreated': 'Added',
    'mobilePhones.importUpdated': 'Updated',
    'mobilePhones.importUnchangedSkipped': 'Unchanged / Skipped',
    'mobilePhones.importFailed': 'Failed',
    'mobilePhones.importPreviewTitle': 'Differences in Existing Records',
    'mobilePhones.importPreviewDesc': '{count} records whose Inventory No already exists differ from the Excel data. Select the records you approve to update; no new records are created for them.',
    'mobilePhones.importPreviewStats': 'To add: {create} · Unchanged: {unchanged} · Errors: {failed}',
    'mobilePhones.importPreviewErrors': 'Rows that cannot be processed',
    'mobilePhones.importSelectAll': 'Select all',
    'mobilePhones.importArchivedBadge': 'Archived',
    'mobilePhones.importRow': 'Row {row}',
    'mobilePhones.importCancel': 'Cancel',
    'mobilePhones.importConfirm': 'Confirm (update {updated}, add {created})',
    'mobilePhones.assignmentFormCreated': 'Assignment form created',
    'mobilePhones.returnFormCreated': 'Return form created',
    'mobilePhones.formNo': 'Form No',
    'mobilePhones.paginationPrev': 'Previous',
    'mobilePhones.paginationNext': 'Next',
    'mobilePhones.paginationOf': 'of',
    'mobilePhones.paginationPage': 'Page {current} of {total}',
    'mobilePhones.emptyTitle': 'No Mobile Phones Found',
    'mobilePhones.emptyDesc': 'No mobile phones have been added yet or no results match your search criteria.',
    'mobilePhones.notifSuccess': 'Success',
    'mobilePhones.notifError': 'Error',
    'mobilePhones.notifWarning': 'Warning',
    'mobilePhones.notifInfo': 'Info',
    'mobilePhones.errLoadData': 'Error loading data',
    'mobilePhones.errDeleteFailed': 'Delete failed',
    'mobilePhones.errAssignFailed': 'Assignment failed',
    'mobilePhones.errUnassignFailed': 'Unassignment failed',
    'mobilePhones.errSelectUser': 'Please select a user',
    'mobilePhones.errAlreadyAssigned': 'This phone is already assigned to a user',
    'mobilePhones.errCannotAssign': 'Phone cannot be assigned',
    'mobilePhones.errNotAssigned': 'Phone is not assigned',
    'mobilePhones.errContractExpired': 'Contract has expired',
    'mobilePhones.errExpiredCannotAssign': 'Contract expired, cannot assign',
    'mobilePhones.errHistoryLoad': 'Error loading history',
    'mobilePhones.errImportFailed': 'Import failed',
    'mobilePhones.errSelectFile': 'Please select a file',
    'mobilePhones.errSelectExcelFile': 'Please select an Excel file',
    'mobilePhones.errNoValidData': 'No valid data found',
    'mobilePhones.errPasteData': 'Data paste error',
    'mobilePhones.errOperationFailed': 'Operation failed',
    'mobilePhones.errAssignmentFormFailed': 'Assignment form creation failed',
    'mobilePhones.errReturnFormFailed': 'Return form creation failed',

    // SystemSettingsPage
    'sysSettings.title': 'System Settings',
    'sysSettings.tabGeneral': 'General Settings',
    'sysSettings.tabRecovery': 'Backup Recovery',
    'sysSettings.tabEmail': 'Email',
    'sysSettings.tabCron': 'Cron Jobs',
    'sysSettings.tabOrders': 'Order Settings',
    'sysSettings.tabSecurity': 'Security',
    'sysSettings.tabLogs': 'System Logs',
    'sysSettings.tabLoginLogs': 'Login Logs',
    'sysSettings.tabApi': 'API Management',
    'sysSettings.tabBulkPrint': 'Bulk Label Printing',
    'sysSettings.tabSounds': 'Sound Settings',
    'sysSettings.soundsTitle': 'Notification Sound Settings',
    'sysSettings.soundEnabled': 'Sound Notifications',
    'sysSettings.soundEnabledDesc': 'Play sound when a new message arrives',
    'sysSettings.soundVolume': 'Volume',
    'sysSettings.soundVolumeLow': 'Silent',
    'sysSettings.soundVolumeHigh': 'High',
    'sysSettings.soundStyle': 'Notification Sound Style',
    'sysSettings.soundStyleDesc': 'Click to preview',
    'sysSettings.soundTest': 'Test Sound',
    'sysSettings.soundTestDesc': 'Test the notification sound',
    'sysSettings.soundTyping': 'Keyboard Typing Sound',
    'sysSettings.soundTypingDesc': 'Play keystroke sound while typing in chat',
    'sysSettings.soundTypingTest': 'Test Typing Sound',
    'sysSettings.soundTip': 'You may need to allow sound in your browser for notifications to work.',
    'sysSettings.soundCustomFiles': 'Custom Sound Files',
    'sysSettings.soundCustomFilesDesc': 'MP3, OGG or WAV format, maximum 2MB',
    'sysSettings.soundUpload': 'Upload Sound File',
    'sysSettings.soundUploading': 'Uploading...',
    'sysSettings.soundUploadSuccess': 'Sound file uploaded successfully',
    'sysSettings.soundUploadError': 'Error uploading sound file',
    'sysSettings.soundNoFiles': 'No custom sound files uploaded yet',
    'sysSettings.soundSetActive': 'Set Active',
    'sysSettings.soundActive': 'Active',
    'sysSettings.soundSetDefault': 'Reset to Default',
    'sysSettings.soundDelete': 'Delete',
    'sysSettings.soundDeleteConfirm': 'Are you sure you want to delete this sound file?',
    'sysSettings.soundDeleteSuccess': 'Sound file deleted',
    'sysSettings.soundActivated': 'Active sound updated',
    'sysSettings.soundPreview': 'Preview',
    'sysSettings.soundFileSize': 'Size',
    'sysSettings.save': 'Save',
    'sysSettings.cancel': 'Cancel',
    'sysSettings.add': 'Add',
    'sysSettings.update': 'Update',
    'sysSettings.active': 'Active',
    'sysSettings.passive': 'Inactive',
    // API Tab display
    'sysSettings.apiKeysTitle': 'API Keys',
    'sysSettings.newApiKey': 'New API Key',
    'sysSettings.apiKey': 'API Key:',
    'sysSettings.apiRateLimit': 'Rate Limit:',
    'sysSettings.apiRateLimitValue': '{count}/hr',
    'sysSettings.apiUsage': 'Usage:',
    'sysSettings.apiLastUsed': 'Last Used:',
    'sysSettings.apiNeverUsed': 'Never',
    'sysSettings.apiPermissions': 'Permissions:',
    'sysSettings.apiExpiry': 'Expires:',
    'sysSettings.noApiKeys': 'No API keys found',
    // Modal titles
    'sysSettings.modalEditSetting': 'Edit Setting',
    'sysSettings.modalNewSetting': 'New Setting',
    'sysSettings.modalEditBackup': 'Edit Backup',
    'sysSettings.modalNewBackup': 'New Backup',
    'sysSettings.modalEditEmail': 'Edit Email Config',
    'sysSettings.modalNewEmail': 'New Email Config',
    'sysSettings.modalEditCron': 'Edit Cron Job',
    'sysSettings.modalNewCron': 'New Cron Job',
    'sysSettings.modalEditApi': 'Edit API Key',
    'sysSettings.modalNewApi': 'New API Key',
    // Email modal fields
    'sysSettings.emailConfigName': 'Configuration Name *',
    'sysSettings.emailConfigPlaceholder': 'Main SMTP Server',
    'sysSettings.emailSmtpHost': 'SMTP Host *',
    'sysSettings.emailSmtpPort': 'SMTP Port *',
    'sysSettings.emailSmtpEncryption': 'Encryption *',
    'sysSettings.emailEncryptionNone': 'None',
    'sysSettings.emailUsername': 'Username *',
    'sysSettings.emailPassword': 'Password *',
    'sysSettings.emailPasswordPlaceholder': 'SMTP password',
    'sysSettings.emailFromAddress': 'From Email *',
    'sysSettings.emailFromName': 'From Name *',
    'sysSettings.emailDailyLimitField': 'Daily Limit',
    'sysSettings.emailMonthlyLimitField': 'Monthly Limit',
    'sysSettings.emailIsDefault': 'Default configuration',
    'sysSettings.emailIsActive': 'Active',
    // Cron modal fields
    'sysSettings.cronJobName': 'Job Name *',
    'sysSettings.cronJobNamePlaceholder': 'Database Backup',
    'sysSettings.cronExpressionField': 'Cron Expression *',
    'sysSettings.cronExpressionHint': 'Example: "0 2 * * *" (Every day at 02:00)',
    'sysSettings.cronCommandField': 'Script to Run *',
    'sysSettings.cronSelectScript': 'Select a script',
    'sysSettings.cronKeepCommand': 'Keep current command',
    'sysSettings.cronDescField': 'Description',
    'sysSettings.cronEmailNotif': 'Email Notifications',
    'sysSettings.cronEmailNotifHint': 'Select admin/superadmin users to receive email notifications for this cron job. You can select different users for each cron job.',
    'sysSettings.cronAdminLoading': 'Loading admin users...',
    'sysSettings.cronIsActive': 'Active',
    'sysSettings.cronHelp': 'Cron Expression Help',
    'sysSettings.cronHelpFields': 'Minute Hour Day Month DayOfWeek',
    'sysSettings.cronHelpEx1': 'Every day at 02:00',
    'sysSettings.cronHelpEx2': 'Every 6 hours',
    'sysSettings.cronHelpEx3': 'Every Sunday at 00:00',
    'sysSettings.cronHelpEx4': "1st of each month at 00:00",
    // API modal fields
    'sysSettings.apiName': 'API Name *',
    'sysSettings.apiRateLimitField': 'Rate Limit (Hourly) *',
    'sysSettings.apiExpiryDate': 'Expiry Date',
    'sysSettings.apiIsActive': 'Active',
    'sysSettings.apiPermissionsField': 'Permissions',
    'sysSettings.apiAddPermission': '+ Add Permission',
    'sysSettings.apiAllowedIps': 'Allowed IPs',
    'sysSettings.apiAddIp': '+ Add IP',
    'sysSettings.apiAutoGenerate': 'API Key will be auto-generated',
    'sysSettings.apiPreview': 'Preview',
    // Error/confirm messages
    'sysSettings.deleteConfirm': 'Are you sure you want to delete this record?',
    'sysSettings.saveError': 'Error saving record',
    'sysSettings.deleteError': 'Error deleting record',
    // General tab
    'sysSettings.generalTitle': 'General System Settings',
    'sysSettings.newSetting': 'New Setting',
    'sysSettings.systemAppearance': 'System Appearance',
    'sysSettings.systemTitle': 'System Title',
    'sysSettings.systemLogo': 'System Logo',
    'sysSettings.logoHint': 'PNG, JPG, SVG, GIF, WebP supported (Max: 2MB) - Auto-uploaded when selected',
    'sysSettings.favicon': 'Favicon',
    'sysSettings.faviconHint': 'ICO, PNG format recommended (32x32px) - Auto-uploaded when selected',
    'sysSettings.currentView': 'Current View',
    'sysSettings.currentLogo': 'Current Logo:',
    'sysSettings.removeLogo': 'Remove Logo',
    'sysSettings.removeLogoConfirm': 'Are you sure you want to remove the logo?',
    'sysSettings.logoUploaded': 'Logo uploaded successfully!',
    'sysSettings.logoDeleted': 'Logo deleted successfully!',
    'sysSettings.logoDeleteError': 'Error deleting logo',
    'sysSettings.faviconUploaded': 'Favicon uploaded successfully!',
    'sysSettings.loginBackground': 'Login Page Background',
    'sysSettings.loginBgImage': 'Login Background Image',
    'sysSettings.loginBgHint': 'JPG, PNG, WebP supported (Max: 5MB) - Auto-uploaded when selected',
    'sysSettings.currentLoginBg': 'Current Login Background:',
    'sysSettings.removeLoginBg': 'Remove Background',
    'sysSettings.removeLoginBgConfirm': 'Are you sure you want to remove the login background?',
    'sysSettings.loginBgUploaded': 'Login background uploaded successfully!',
    'sysSettings.loginBgRemoved': 'Login background removed!',
    'sysSettings.loginBgDeleteError': 'Error deleting login background',
    'sysSettings.settingValue': 'Value:',
    'sysSettings.settingType': 'Type:',
    'sysSettings.noSettings': 'No system settings defined yet',
    'sysSettings.errFileTooLarge2MB': 'File size cannot exceed 2MB',
    'sysSettings.errFileTooLarge5MB': 'File size cannot exceed 5MB',
    'sysSettings.errInvalidImageType': 'Only image files (JPG, PNG, SVG, GIF, WebP) can be uploaded',
    'sysSettings.errInvalidBgType': 'Only image files (JPG, PNG, WebP) can be uploaded',
    'sysSettings.titleUpdateError': 'Error updating title!',
    'sysSettings.titleUpdated': 'System title updated successfully!',
    'sysSettings.loadingSettings': 'Loading system settings...',
    'sysSettings.pageSubtitle': 'System configuration and backup management',
    'sysSettings.settingsListTitle': 'System Settings',
    'sysSettings.settingKey': 'Setting Key *',
    'sysSettings.settingDesc': 'Description *',
    'sysSettings.settingDescPlaceholder': 'Setting description',
    'sysSettings.settingDataType': 'Data Type *',
    'sysSettings.settingCategory': 'Category *',
    'sysSettings.settingValuePlaceholder': 'Setting value',
    'sysSettings.settingEncrypted': 'Encrypted value',
    'sysSettings.settingUpdated': 'Updated:',
    'sysSettings.catGeneral': 'General',
    'sysSettings.catSecurity': 'Security',
    'sysSettings.catEmail': 'Email',
    'sysSettings.catNotification': 'Notification',
    'sysSettings.catBackup': 'Backup',
    'sysSettings.catIntegration': 'Integration',
    // Backup/Recovery tab
    'sysSettings.recoveryTitle': 'Backup Recovery',
    'sysSettings.selectBackupSource': 'Select Backup Source',
    'sysSettings.step1Upload': '1. Upload Backup File',
    'sysSettings.step1ServerBackup': '1. Select Server Backup',
    'sysSettings.step2Tables': '2. Tables',
    'sysSettings.step3Recovery': '3. Recovery',
    'sysSettings.backupFileLabel': 'Backup File (.sql.gz)',
    'sysSettings.onlySqlGz': 'Only .sql.gz backup files are supported',
    'sysSettings.uploadFile': 'Upload File',
    'sysSettings.fileUploading': 'Uploading backup file to server...',
    'sysSettings.fileSize': 'File size: {size} MB',
    'sysSettings.analyze': 'Analyze',
    'sysSettings.analyzing': 'Analyzing...',
    'sysSettings.backupFileAnalyzing': 'Analyzing backup file...',
    'sysSettings.backupAnalyzed': 'Backup analysis completed',
    'sysSettings.tablesFound': '{count} tables found',
    'sysSettings.tablesFoundCount': '{count} tables found',
    'sysSettings.tableNotExists': 'Table does not exist',
    'sysSettings.currentRecords': 'Current:',
    'sysSettings.dataEqual': 'Data is equal',
    'sysSettings.backupRecords': 'Backup:',
    'sysSettings.selectAll': 'Select All',
    'sysSettings.deselectAll': 'Deselect All',
    'sysSettings.tablesSelected': '{count} tables selected. This operation may overwrite existing data!',
    'sysSettings.restore': 'Restore',
    'sysSettings.restoring': 'Restoring...',
    'sysSettings.dbProcessing': 'Performing database operations...',
    'sysSettings.recoveryStarting': 'Starting recovery process...',
    'sysSettings.tablesRestored': '{tables} tables restored',
    'sysSettings.recordsProcessed': '{records} records processed',
    'sysSettings.completedAt': 'Completed at: {time}',
    'sysSettings.recoverySuccess': 'Recovery completed successfully!',
    'sysSettings.recoverySuccessAlert': 'Recovery Successful!',
    'sysSettings.recoverySuccessMsg': '{tables} tables and {records} records restored successfully.',
    'sysSettings.reloadConfirm': 'Reload page to show updated data?',
    'sysSettings.serverBackup': 'Server Backup',
    'sysSettings.serverBackupAnalyzed': 'Server backup analysis completed',
    'sysSettings.serverBackupAnalyzing': 'Analyzing server backup file...',
    'sysSettings.serverBackupListError': 'Could not get server backup list:',
    'sysSettings.serverBackupListLoadError': 'Error loading server backup list:',
    'sysSettings.serverBackupProcessing': 'Processing server backup...',
    'sysSettings.recentBackupLogs': 'Recent Backup Logs',
    'sysSettings.backupPlans': 'Backup Plans',
    'sysSettings.noBackupPlans': 'No backup plans defined yet',
    'sysSettings.noBackupLogs': 'No backup logs found yet',
    'sysSettings.backupName': 'Backup Name *',
    'sysSettings.backupNamePlaceholder': 'Daily Database Backup',
    'sysSettings.backupTypeSel': 'Backup Type *',
    'sysSettings.backupTypeDatabase': 'Database',
    'sysSettings.backupTypeFiles': 'Files',
    'sysSettings.backupTypeFull': 'Full Backup',
    'sysSettings.backupTypeSystem': 'System',
    'sysSettings.backupSourcePath': 'Source Path *',
    'sysSettings.backupDestPath': 'Destination Path *',
    'sysSettings.backupCronSchedule': 'Cron Schedule *',
    'sysSettings.backupRetentionDaysSel': 'Retention Period (Days) *',
    'sysSettings.backupNotifEmails': 'Notification Emails',
    'sysSettings.backupAddEmail': '+ Add Email',
    'sysSettings.backupEncryption': 'Encryption',
    'sysSettings.backupCompression': 'Compression',
    'sysSettings.backupRunNow': 'Run Now',
    'sysSettings.backupStarted': 'Backup started:',
    'sysSettings.backupRunError': 'Error starting backup',
    'sysSettings.backupType': 'Type:',
    'sysSettings.backupSchedule': 'Schedule:',
    'sysSettings.backupLast': 'Last Backup:',
    'sysSettings.backupNever': 'Never',
    'sysSettings.backupRetention': 'Retention:',
    'sysSettings.backupRetentionDays': '{days} days',
    'sysSettings.backupSize': 'Size:',
    'sysSettings.backupSuccess': 'Success:',
    'sysSettings.backupStatusActive': 'Active',
    'sysSettings.backupStatusDisabled': 'Disabled',
    'sysSettings.backupStatusPaused': 'Paused',
    // Security tab
    'sysSettings.securityTitle': 'Security Settings',
    'sysSettings.apiSecurity': 'API Security',
    'sysSettings.apiKeyExpiry': 'API Key Expiry',
    'sysSettings.apiKeyExpiryValue': '1 year',
    'sysSettings.maxLoginAttempts': 'Maximum Login Attempts',
    'sysSettings.sessionSettings': 'Session Settings',
    'sysSettings.sessionTimeout': 'Session Timeout',
    'sysSettings.sessionTimeoutValue': '60 minutes',
    'sysSettings.rateLimit': 'Rate Limit',
    'sysSettings.rateLimitValue': '1000/hour',
    'sysSettings.ipRestriction': 'IP Restriction',
    'sysSettings.twoFactor': 'Two-Factor Authentication',
    // System Logs tab
    'sysSettings.systemLogsTitle': 'System Logs',
    'sysSettings.operationLogs': 'Operation Logs',
    'sysSettings.noSystemLogs': 'No system logs found yet',
    'sysSettings.logStatusCompleted': 'Completed',
    'sysSettings.logStatusRunning': 'Running',
    'sysSettings.logStatusFailed': 'Failed',
    'sysSettings.logStatusCancelled': 'Cancelled',
    'sysSettings.logStart': 'Start:',
    'sysSettings.logEnd': 'End:',
    'sysSettings.logDuration': 'Duration:',
    'sysSettings.logDurationMin': '{min} min',
    'sysSettings.logSizeGb': 'Size:',
    'sysSettings.logUnknown': 'Unknown',
    'sysSettings.logError': 'Error:',
    'sysSettings.logCategory': 'Category:',
    'sysSettings.logUser': 'User:',
    'sysSettings.searchLogs': 'Search logs...',
    'sysSettings.refresh': 'Refresh',
    'sysSettings.showAll': 'Show All',
    'sysSettings.totalRecords': 'Total {count} records - Showing last 10',
    'sysSettings.showing110': '1-10 / {count} records',
    'sysSettings.prev': 'Previous',
    // Login Logs tab
    'sysSettings.loginLogsTitle': 'Login Logs and Blocked Accounts',
    'sysSettings.loginLogsSubtitle': 'Login Logs',
    'sysSettings.noLoginLogs': 'No login logs found yet',
    'sysSettings.blockedAccounts': 'Blocked Accounts',
    'sysSettings.noBlockedAccounts': 'No blocked accounts at the moment',
    'sysSettings.statusSuccess': 'SUCCESS',
    'sysSettings.statusFailed': 'FAILED',
    'sysSettings.statusBlocked': 'BLOCKED',
    'sysSettings.csvSuccess': 'Success',
    'sysSettings.csvFailed': 'Failed',
    'sysSettings.csvBlocked': 'Blocked',
    'sysSettings.blocked': 'Blocked',
    'sysSettings.failedAttempts': 'Failed Attempts:',
    'sysSettings.lastAttempt': 'Last Attempt:',
    'sysSettings.blockedUntil': 'Blocked Until:',
    'sysSettings.engagedUntil': 'Blocked Until:',
    'sysSettings.unblock': 'Unblock',
    'sysSettings.unblockConfirm': 'Are you sure you want to unblock the {email} account?',
    'sysSettings.clearLogs': 'Clear Logs',
    'sysSettings.clearLogsConfirm': 'Are you sure you want to delete all login logs?',
    'sysSettings.exportExcel': 'Export Excel',
    'sysSettings.progress': 'Progress',
    // Orders tab
    'sysSettings.ordersTitle': 'Order Settings',
    'sysSettings.capexTitle': 'CAPEX Requirement',
    'sysSettings.capexDesc': 'Require CAPEX selection for orders above a certain amount.',
    'sysSettings.capexMinAmount': 'Minimum Order Amount (USD)',
    'sysSettings.capexSaved': 'CAPEX limit updated successfully!',
    'sysSettings.capexSaveError': 'Error updating CAPEX limit',
    'sysSettings.capexNotes': 'Important Notes:',
    'sysSettings.capexNote1': 'All order amounts are converted to USD for checking',
    'sysSettings.capexNote2': 'Limit check is performed when creating orders',
    'sysSettings.capexNote3': 'Users see a warning when limit is exceeded and cannot create orders without selecting CAPEX',
    'sysSettings.capexHint': 'CAPEX selection will be required for orders at or above this amount. For example: entering 200 USD means CAPEX is required for all orders of 200 USD or more.',
    // Bulk Print tab
    'sysSettings.bulkPrintTitle': 'Bulk Label Printing',
    'sysSettings.bulkPrintLoadError': 'Error loading bulk print data',
    'sysSettings.bulkPrintError': 'Error during bulk label printing',
    'sysSettings.locationSelect': 'Location Selection *',
    'sysSettings.selectLocation': 'Select location',
    'sysSettings.selectLocationFirst': 'Select location',
    'sysSettings.labelType': 'Label Type *',
    'sysSettings.includeSwitches': 'Include network switches',
    'sysSettings.itemsToPrint': 'Items to Print ({count})',
    'sysSettings.printSettings': 'Print Settings',
    'sysSettings.labelDimensions': 'Label Dimensions',
    'sysSettings.labelWidth': 'Width (mm)',
    'sysSettings.labelHeight': 'Height (mm)',
    'sysSettings.labelOrientation': 'Label Orientation',
    'sysSettings.horizontal': 'Horizontal',
    'sysSettings.vertical': 'Vertical',
    'sysSettings.margins': 'Margins (mm)',
    'sysSettings.marginTop': 'Top',
    'sysSettings.marginBottom': 'Bottom',
    'sysSettings.marginLeft': 'Left',
    'sysSettings.marginRight': 'Right',
    'sysSettings.printLabels': 'Print Bulk Labels ({count})',
    'sysSettings.noPrintItems': 'No items found for printing',
    'sysSettings.cabinetLabel': 'IT Cabinet Label',
    'sysSettings.switchLabel': 'Network Switch Label',
    'sysSettings.cabinetType': 'cabinet',
    'sysSettings.switchType': 'switch',
    'sysSettings.noItemsInLocation': 'No {type} found in this location',
    'sysSettings.noLocation': 'No location',
    'sysSettings.noCompany': 'No company',
    'sysSettings.selected': 'selected',
    // Email tab
    'sysSettings.emailConfigs': 'Email Configurations',
    'sysSettings.noEmailConfigs': 'No email configuration defined yet',
    'sysSettings.newSmtp': 'New SMTP',
    'sysSettings.emailSmtp': 'SMTP:',
    'sysSettings.emailEncryption': 'Encryption:',
    'sysSettings.emailFrom': 'From:',
    'sysSettings.emailDailyLimit': 'Daily Limit:',
    'sysSettings.emailMonthlyLimit': 'Monthly Limit:',
    'sysSettings.emailDefault': 'Default',
    'sysSettings.emailLastTest': 'Last Test:',
    'sysSettings.emailNeverTested': 'Never tested',
    'sysSettings.emailTestTitle': 'Test',
    'sysSettings.emailTestPrompt': 'Enter the email address to send a test email:',
    // Cron tab
    'sysSettings.cronTitle': 'Cron Jobs Management',
    'sysSettings.newCronJob': 'New Cron Job',
    'sysSettings.noCronJobs': 'No cron jobs defined yet',
    'sysSettings.cronCommand': 'Command:',
    'sysSettings.cronDescription': 'Description:',
    'sysSettings.cronExpression': 'Cron:',
    'sysSettings.cronLastRun': 'Last Run:',
    'sysSettings.cronNever': 'Never',
    'sysSettings.cronNextRun': 'Next:',
    'sysSettings.cronRunCount': 'Run Count:',
    'sysSettings.cronRunCountValue': '{count} times',
    'sysSettings.cronCreatedBy': 'Created By:',
    'sysSettings.cronSystem': 'System',
    'sysSettings.cronSuccess': 'Success:',
    'sysSettings.cronUnknown': 'Unknown',
    'sysSettings.cronRunNow': 'Run now',
    'sysSettings.cronPause': 'Pause',
    'sysSettings.cronActivate': 'Activate',
    'sysSettings.cronToggleError': 'Error changing cron job status',
    'sysSettings.cronDeleteError': 'Error deleting cron job',
    'sysSettings.unknownError': 'Unknown error',
    // ChecklistPage & ChecklistPopup
    'checklist.pageTitle': 'Checklist Management',
    'checklist.pageSubtitle': 'Manage your daily, weekly or monthly task lists',
    'checklist.newChecklist': 'New Checklist',
    'checklist.tabMyChecklists': 'My Checklists',
    'checklist.tabHistory': 'History',
    'checklist.loading': 'Loading...',
    'checklist.empty': 'No checklists created yet',
    'checklist.emptyHint': 'Click New Checklist to get started',
    'checklist.inactive': 'Inactive',
    'checklist.today': 'Today',
    'checklist.editTitle': 'Edit',
    'checklist.deleteTitle': 'Delete',
    'checklist.deactivate': 'Deactivate',
    'checklist.activate': 'Activate',
    'checklist.saving': 'Saving...',
    'checklist.filterAll': 'All Checklists',
    'checklist.historyEmpty': 'No history records yet',
    'checklist.completed': 'Completed',
    'checklist.notCompleted': 'Not Completed',
    'checklist.prevPage': 'Previous',
    'checklist.nextPage': 'Next',
    'checklist.rightTabLeaderboard': 'Leaderboard',
    'checklist.rightTabActivity': 'Activity',
    'checklist.rightTabOthers': 'Others',
    'checklist.leaderboardTitle': 'Total Points Ranking',
    'checklist.leaderboardEmpty': 'No points recorded yet',
    'checklist.leaderboardThisWeek': 'This week:',
    'checklist.leaderboardToday': 'today',
    'checklist.leaderboardPoints': 'pts',
    'checklist.leaderboardFooter': 'Each completed task =',
    'checklist.activityTitle': 'Recent Activity',
    'checklist.activityRefresh': 'Refresh',
    'checklist.activityEmpty': 'No activity yet',
    'checklist.activityCompleted': 'completed:',
    'checklist.activityPoint': '+1 pt',
    'checklist.othersTitle': "Today's Checklists",
    'checklist.othersEmpty': 'No active checklists today',
    'checklist.modalCreateTitle': 'New Checklist',
    'checklist.modalEditTitle': 'Edit Checklist',
    'checklist.labelTitle': 'Title',
    'checklist.labelDescription': 'Description',
    'checklist.labelFrequency': 'Repeat Frequency',
    'checklist.labelStartDate': 'Start Date',
    'checklist.labelEndDate': 'End Date',
    'checklist.labelItems': 'Task Items',
    'checklist.addItem': 'Add Item',
    'checklist.titlePlaceholder': 'e.g. Daily Morning Routine',
    'checklist.descriptionPlaceholder': 'Optional description...',
    'checklist.itemPlaceholder': 'Item',
    'checklist.frequencyWeeklyHint': 'Shown on the same day each week as the start date',
    'checklist.frequencyMonthlyHint': 'Shown on the same day each month as the start date',
    'checklist.frequencyMonthlyDay': 'th',
    'checklist.btnCancel': 'Cancel',
    'checklist.btnSave': 'Save',
    'checklist.errTitleRequired': 'Title is required',
    'checklist.errItemRequired': 'Add at least one item',
    'checklist.successCreated': 'Checklist created',
    'checklist.successUpdated': 'Checklist updated',
    'checklist.successDeleted': 'Checklist deleted',
    'checklist.errLoad': 'Error loading checklists',
    'checklist.errHistoryLoad': 'Error loading history',
    'checklist.errSave': 'Error saving',
    'checklist.errDelete': 'Delete failed',
    'checklist.errUpdate': 'Update failed',
    'checklist.confirmDelete': 'Delete this checklist? All related history records will also be deleted.',
    'checklist.freqDaily': 'Daily',
    'checklist.freqWeekly': 'Weekly',
    'checklist.freqMonthly': 'Monthly',
    'checklist.justNow': 'Just now',
    'checklist.minutesAgo': 'm ago',
    'checklist.hoursAgo': 'h ago',
    'checklist.popupHeader': 'Daily Checklist',
    'checklist.popupProgress': 'completed',
    'checklist.popupSkip': 'Skip',
    'checklist.popupSaveClose': 'Save & Close',
    'checklist.popupCompleted': 'Completed!',
    'checklist.popupSaving': 'Saving...',

    // NotepadPage
    'notepad.sidebarTitle': 'Notepad',
    'notepad.newNote': 'New Note',
    'notepad.categories': 'Categories',
    'notepad.newCategoryTitle': 'New category',
    'notepad.allNotes': 'All Notes',
    'notepad.uncategorized': 'Uncategorized',
    'notepad.searchPlaceholder': 'Search notes...',
    'notepad.noResults': 'No search results found',
    'notepad.empty': 'No notes yet',
    'notepad.createFirst': 'Create first note',
    'notepad.errLoadCategories': 'Could not load categories',
    'notepad.errLoadNotes': 'Could not load notes',
    'notepad.historyEmpty': 'No history yet',
    'notepad.unknown': 'Unknown',
    'notepad.actionCreated': 'Created',
    'notepad.actionUpdated': 'Updated',
    'notepad.contentUpdated': 'content updated',
    'notepad.copyLink': 'Copy link',
    'notepad.copied': 'Copied',
    'notepad.share': 'Share',
    'notepad.edit': 'Edit',
    'notepad.delete': 'Delete',
    'notepad.preview': 'Preview',
    'notepad.images': 'Images',
    'notepad.addReaction': 'Add reaction',
    'notepad.addEmoji': 'Add',
    'notepad.catEditTitle': 'Edit Category',
    'notepad.catNewTitle': 'New Category',
    'notepad.catNameLabel': 'Category Name *',
    'notepad.catColorLabel': 'Color',
    'notepad.cancel': 'Cancel',
    'notepad.save': 'Save',
    'notepad.errCatNameRequired': 'Category name is required',
    'notepad.errGeneral': 'An error occurred',
    'notepad.noteEditTitle': 'Edit Note',
    'notepad.noteNewTitle': 'New Note',
    'notepad.tabNote': 'Note',
    'notepad.tabHistory': 'History',
    'notepad.titleLabel': 'Title *',
    'notepad.titlePlaceholder': 'Note title...',
    'notepad.categoryLabel': 'Category',
    'notepad.quickCreate': 'Quick Create',
    'notepad.uncategorizedOption': 'Uncategorized',
    'notepad.newCategoryQuick': 'New Category',
    'notepad.catNamePlaceholder': 'Category name...',
    'notepad.contentLabel': 'Content',
    'notepad.contentPlaceholder': 'Write note content...',
    'notepad.imagesLabel': 'Images',
    'notepad.pasteTitle': 'Paste from clipboard (Ctrl+V)',
    'notepad.paste': 'Paste',
    'notepad.uploading': 'Uploading...',
    'notepad.selectFile': 'Select File',
    'notepad.ctrlVHint': 'You can also click the form and press Ctrl+V to paste.',
    'notepad.maxImagesReached': 'Maximum image limit reached.',
    'notepad.youtubeLabel': 'YouTube Links',
    'notepad.youtubePlaceholder': 'Paste YouTube link...',
    'notepad.errMaxImages': 'Maximum {count} images allowed',
    'notepad.errMaxImagesPartial': '{uploaded} uploaded (maximum {count})',
    'notepad.errImageUpload': 'Error uploading image',
    'notepad.errNoImageClipboard': 'No image found in clipboard',
    'notepad.errClipboardDenied': 'Clipboard access denied or no image',
    'notepad.errInvalidYoutube': 'Enter a valid YouTube link',
    'notepad.errYoutubeDuplicate': 'This link is already added',
    'notepad.errTitleRequired': 'Note title is required',
    'notepad.errCatCreate': 'Could not create category',
    'notepad.deleteCatTitle': 'Delete Category',
    'notepad.deleteNoteTitle': 'Delete Note',
    'notepad.deleteCatMsg': 'Are you sure you want to delete the category? Notes inside will become uncategorized.',
    'notepad.deleteNoteMsg': 'Are you sure you want to permanently delete this note?',

    // UserActivityPage
    'activity.title': 'User Activities',
    'activity.subtitle': 'View and manage all user activities in the system',
    'activity.export': 'Export',
    'activity.exportCSV': 'Download as CSV',
    'activity.exportExcel': 'Download as Excel',
    'activity.searchPlaceholder': 'Description, username...',
    'activity.allUsers': 'All Users',
    'activity.allActions': 'All Actions',
    'activity.totalActivities': 'Total Activities',
    'activity.activeUsers': 'Active Users',
    'activity.today': 'Today',
    'activity.page': 'Page',
    'activity.list': 'Activity List',
    'activity.collapseAll': 'Collapse All',
    'activity.expandAll': 'Expand All',
    'activity.categorizedView': 'Categorized View',
    'activity.normalView': 'Normal View',
    'activity.refresh': 'Refresh',
    'activity.loading': 'Loading...',
    'activity.notFound': 'No activities found',
    'activity.unknownAction': 'Unknown Action',
    'activity.mobile': 'Mobile',
    'activity.desktop': 'Desktop',
    'activity.previous': 'Previous',
    'activity.next': 'Next',
    'activity.col.date': 'Date',
    'activity.col.user': 'User',
    'activity.col.action': 'Action',
    'activity.col.description': 'Description',
    'activity.col.ip': 'IP Address',
    'activity.col.device': 'Device',
    'activity.exportTitle': 'User Activities',
    'activity.cat.all': 'All Categories',
    'activity.cat.auth': 'Login / Logout',
    'activity.cat.capex': 'CAPEX Operations',
    'activity.cat.printer': 'Printer Operations',
    'activity.cat.consumable': 'Consumable Operations',
    'activity.cat.network': 'Network Operations',
    'activity.cat.industrial': 'Industrial Operations',
    'activity.cat.order': 'Order Operations',
    'activity.cat.technical': 'Technical Service Operations',
    'activity.cat.nvr_camera': 'NVR & Camera Operations',
    'activity.cat.gsm_telefon': 'GSM & Phone Operations',
    'activity.cat.arac_gerec': 'Equipment & Tools',
    'activity.cat.server': 'Server Operations',
    'activity.cat.storage': 'Storage Operations',
    'activity.cat.meeting': 'Meeting Operations',
    'activity.cat.zimmet': 'Assignment Operations',
    'activity.cat.settings': 'Settings Operations',
    'activity.cat.other': 'Other Operations',

    // AnnouncementsPage
    'announce.title': 'Announcement Management',
    'announce.subtitle': 'Manage site announcements and development notices',
    'announce.newBtn': 'New Announcement',
    'announce.searchPlaceholder': 'Search announcements...',
    'announce.allTypes': 'All Types',
    'announce.allStatuses': 'All Statuses',
    'announce.statusActive': 'Active',
    'announce.statusInactive': 'Inactive',
    'announce.count': '{count} announcements',
    'announce.colTitle': 'Announcement',
    'announce.colType': 'Type',
    'announce.colStatus': 'Status',
    'announce.colDates': 'Dates',
    'announce.colStats': 'Stats',
    'announce.colActions': 'Actions',
    'announce.statusPending': 'Pending',
    'announce.statusExpired': 'Expired',
    'announce.live': '• Live',
    'announce.noAnnouncements': 'No announcements found.',
    'announce.titleToggleActive': 'Click to deactivate',
    'announce.titleToggleInactive': 'Click to activate',
    'announce.editTitle': 'Edit Announcement',
    'announce.createTitle': 'Create New Announcement',
    'announce.fieldTitle': 'Title *',
    'announce.fieldContent': 'Content *',
    'announce.fieldType': 'Type',
    'announce.fieldPriority': 'Priority (1-5)',
    'announce.fieldRoles': 'Target Roles (leave empty for all roles)',
    'announce.fieldStartDate': 'Start Date',
    'announce.fieldEndDate': 'End Date',
    'announce.fieldActive': 'Active',
    'announce.fieldShowDashboard': 'Show on dashboard',
    'announce.fieldShowPopup': 'Show as popup',
    'announce.cancel': 'Cancel',
    'announce.update': 'Update',
    'announce.create': 'Create',
    'announce.viewStart': 'Start:',
    'announce.viewEnd': 'End:',
    'announce.close': 'Close',
    'announce.type.info': 'Info',
    'announce.type.success': 'Success',
    'announce.type.warning': 'Warning',
    'announce.type.danger': 'Danger',
    'announce.type.feature': 'Feature',
    'announce.type.maintenance': 'Maintenance',
    'announce.role.superadmin': 'Super Admin',
    'announce.role.user': 'User',
    'announce.role.technician': 'Technician',
    'announce.errLoad': 'Error loading announcements',
    'announce.successUpdate': 'Announcement updated successfully',
    'announce.successCreate': 'Announcement created successfully',
    'announce.errSave': 'Error saving announcement',
    'announce.successDelete': 'Announcement deleted successfully',
    'announce.errDelete': 'Error deleting announcement',
    'announce.errToggle': 'Error updating status',
    'announce.titlePlaceholder': 'Announcement title',
    'announce.contentPlaceholder': 'Write announcement content. Images, videos and rich text formats are supported...',

    // AssignmentDefinitionsPage
    'zimmetDef.title': 'Assignment Management',
    'zimmetDef.addDef': 'Add New Definition',
    'zimmetDef.addTemplate': 'Add New Template',
    'zimmetDef.tabDefs': 'Assignment Definitions',
    'zimmetDef.tabTemplates': 'Assignment Templates',
    'zimmetDef.loading': 'Loading...',
    'zimmetDef.active': 'Active',
    'zimmetDef.default': 'Default',
    'zimmetDef.key': 'Key:',
    'zimmetDef.file': 'File:',
    'zimmetDef.download': 'Download',
    'zimmetDef.activate': 'Activate',
    'zimmetDef.delete': 'Delete',
    'zimmetDef.noTemplates': 'No templates added yet',
    'zimmetDef.all': 'All',
    'zimmetDef.statusActive': 'Active',
    'zimmetDef.statusInactive': 'Inactive',
    'zimmetDef.edit': 'Edit',
    'zimmetDef.save': 'Save',
    'zimmetDef.cancel': 'Cancel',
    'zimmetDef.noDefs': 'No definitions found in this category',
    'zimmetDef.noDefs2': 'No definitions added yet',
    'zimmetDef.newTemplateTitle': 'New Assignment Template',
    'zimmetDef.templateName': 'Template Name',
    'zimmetDef.templateKey': 'Template Key',
    'zimmetDef.templateKeyHint': 'Unique key in lowercase, dash-separated',
    'zimmetDef.templateDesc': 'Description',
    'zimmetDef.templateFile': 'Reference File',
    'zimmetDef.templateFileHint': 'This file is stored as a visual reference for the assignment form and can be downloaded',
    'zimmetDef.templateFileLabel': 'DOCX or PDF, optional',
    'zimmetDef.newDefTitle': 'New Assignment Definition',
    'zimmetDef.fieldCategory': 'Category',
    'zimmetDef.fieldTitle': 'Title',
    'zimmetDef.fieldContent': 'Content',
    'zimmetDef.fieldStatus': 'Status',
    'zimmetDef.selectCategory': 'Select category',
    'zimmetDef.titlePlaceholder': 'Enter title',
    'zimmetDef.contentPlaceholder': 'Enter content',
    'zimmetDef.add': 'Add',
    'zimmetDef.saving': 'Saving...',
    'zimmetDef.successActivate': 'Template activated',
    'zimmetDef.errActivate': 'Activation failed',
    'zimmetDef.successDeleteTemplate': 'Template deleted',
    'zimmetDef.confirmDeleteTemplate': 'Are you sure you want to delete this template?',
    'zimmetDef.successAddTemplate': 'Template added',
    'zimmetDef.successUpdate': 'Assignment definition updated',
    'zimmetDef.errUpdate': 'Update failed',
    'zimmetDef.successDelete': 'Assignment definition deleted',
    'zimmetDef.confirmDelete': 'Are you sure you want to delete this assignment definition?',
    'zimmetDef.successAdd': 'Assignment definition added',
    'zimmetDef.errTitleContent': 'Title and content are required',
    'zimmetDef.errCategory': 'Please select a category',
    'zimmetDef.errTemplateFields': 'Name and template key are required',
    'zimmetDef.success': 'Success',
    'zimmetDef.error': 'Error',
  }
} as const;

export type TranslationKey = keyof typeof translations.tr;
